import "./index.css";
import {jsx as $lt6Ts$jsx, Fragment as $lt6Ts$Fragment, jsxs as $lt6Ts$jsxs} from "react/jsx-runtime";
import {useState as $lt6Ts$useState, useEffect as $lt6Ts$useEffect, useRef as $lt6Ts$useRef, useLayoutEffect as $lt6Ts$useLayoutEffect} from "react";
import $lt6Ts$reactdomclient from "react-dom/client";
import {BrowserRouter as $lt6Ts$BrowserRouter, Routes as $lt6Ts$Routes, Route as $lt6Ts$Route, useNavigate as $lt6Ts$useNavigate, NavLink as $lt6Ts$NavLink, useParams as $lt6Ts$useParams} from "react-router-dom";
import {Provider as $lt6Ts$Provider, useSelector as $lt6Ts$useSelector, useDispatch as $lt6Ts$useDispatch} from "react-redux";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import {configureStore as $lt6Ts$configureStore} from "@reduxjs/toolkit";
import {combineReducers as $lt6Ts$combineReducers} from "redux";
import {createStore as $lt6Ts$createStore} from "polotno/model/store";
import $lt6Ts$styledcomponents, {createGlobalStyle as $lt6Ts$createGlobalStyle} from "styled-components";
import $lt6Ts$reactselect, {components as $lt6Ts$components} from "react-select";
import {Tooltip as $lt6Ts$Tooltip} from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import {PolotnoContainer as $lt6Ts$PolotnoContainer, WorkspaceWrap as $lt6Ts$WorkspaceWrap, SidePanelWrap as $lt6Ts$SidePanelWrap} from "polotno";
import {Toolbar as $lt6Ts$Toolbar} from "polotno/toolbar/toolbar";
import {ZoomButtons as $lt6Ts$ZoomButtons} from "polotno/toolbar/zoom-buttons";
import {Workspace as $lt6Ts$Workspace} from "polotno/canvas/workspace";
import {setGoogleFonts as $lt6Ts$setGoogleFonts} from "polotno/config";
import {DEFAULT_SECTIONS as $lt6Ts$DEFAULT_SECTIONS, SidePanel as $lt6Ts$SidePanel, SectionTab as $lt6Ts$SectionTab, ImagesGrid as $lt6Ts$ImagesGrid, UploadSection as $lt6Ts$UploadSection} from "polotno/side-panel";
import {observer as $lt6Ts$observer} from "mobx-react-lite";
import {getImageSize as $lt6Ts$getImageSize, getCrop as $lt6Ts$getCrop} from "polotno/utils/image";
import $lt6Ts$qrcode from "qrcode";
import {svgToURL as $lt6Ts$svgToURL} from "polotno/utils/svg";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}





// redux/store.ts


/* eslint-disable no-case-declarations */ // Snakbar Actions
const $e496cac0faa1ff17$export$bcebd1097d6619a3 = "SET_SUCCESS_SNACKBAR";
const $e496cac0faa1ff17$export$be1c2eafe8725e5f = "SET_ERROR_SNACKBAR";
const $e496cac0faa1ff17$export$5a5bdcd828e4c856 = "CLEAR_SNACKBAR";
const $e496cac0faa1ff17$export$1c6648626b31f20d = "GET_ONE_TEMPLATE";
const $e496cac0faa1ff17$export$a3d810d0d7a98880 = "TEMPLATE_LOADING";
const $e496cac0faa1ff17$export$eb7fa4eb60116c93 = "TEMPLATE_PAGINATION_CHANGE";
const $e496cac0faa1ff17$export$1aa600adfd3dface = "TEMPLATE_SEARCH";
const $e496cac0faa1ff17$export$855a5c0ee315c6e1 = "SET_UPLOADED_IMAGES";
const $e496cac0faa1ff17$export$ec8156c566eb37cd = "SET_ROS_OFFER_PERCENTAGE";
const $e496cac0faa1ff17$export$4510d670c403c89e = "CLEAR_ALL_TEMPLATE";
const $e496cac0faa1ff17$export$b3e9fd1c7999b338 = "CLEAR_TEMPLATE_FIELDS";
const $e496cac0faa1ff17$export$900a7683e99e6e7a = "LOAD_DATA_FROM_LOCAL_STORAGE";
const $e496cac0faa1ff17$export$71c26416d85db4e1 = "CLEAR_TEMPLATE";
const $e496cac0faa1ff17$export$297d4370f10479f0 = "SELECT_PRODUCT";
const $e496cac0faa1ff17$export$81c9af5ba79ed4c2 = "SELECT_POSTCARD";
const $e496cac0faa1ff17$export$958a4de996e717f9 = "SET_CUSTOM_FIELDS";
const $e496cac0faa1ff17$export$1586317d794739fb = "SET_CUSTOM_FIELDS_V2";
const $e496cac0faa1ff17$export$ecdfc6694e0b4b09 = "SET_PLATFORM_FIELDS";
const $e496cac0faa1ff17$export$3a35067669e6b265 = "SET_HIRE_DESIGNER_FORM_FIELDS";
const $e496cac0faa1ff17$export$fa8acf33f5748d2a = "CLEAR_HIRE_DESIGNER_FORM_FIELDS";
const $e496cac0faa1ff17$export$1ea993b3d44cc7c7 = "SET_QR_URL";
const $e496cac0faa1ff17$export$a7a0ed74e75b0309 = "SET_UTM_SOURCE";
const $e496cac0faa1ff17$export$fd009ec8add63610 = "SET_UTM_MEDIUM";
const $e496cac0faa1ff17$export$c650fbc46a12623c = "SET_UTM_CAMPAIGN_NAME";
const $e496cac0faa1ff17$export$7a4dd71569e99a02 = "SET_CUSTOM_UTMS";
const $e496cac0faa1ff17$export$6738fe01c6ac3583 = "CLEAR_QR_FIELDS";
const $e496cac0faa1ff17$export$1dca10819ac70fdd = "SET_IS_QR";
const $e496cac0faa1ff17$export$f632fb3a4986e34d = "CLEAR_REDUX";


const $d60d8816d76b2b02$export$92e44ea1079b9ec6 = [
    {
        id: "9",
        title: "Bi-Fold Self-Mailers",
        productType: "Bi-Fold Self-Mailers",
        hasEnvelope: false,
        paper: "80# Glossy Coverstock",
        size: [
            {
                id: "9",
                size: "6x18"
            }
        ]
    },
    {
        id: "5",
        title: "Personal Letters",
        productType: "Personal Letters",
        hasEnvelope: true,
        paper: "60# Statement",
        envelope: "A6 White / A6 Grey Herringbone",
        ink: "Full color or black & white",
        size: [
            {
                id: "5",
                size: "8.5x5.5"
            }
        ]
    },
    {
        id: "13",
        title: "Postcards",
        productType: "Postcards",
        hasEnvelope: false,
        paper: "100# - 120# Glossy Coverstock",
        size: [
            {
                id: "13",
                size: "4x6"
            },
            {
                id: "15",
                size: "6x11"
            },
            {
                id: "14",
                size: "6x9"
            }
        ]
    },
    {
        id: "16",
        title: "Real Penned Letter",
        productType: "Real Penned Letter",
        hasEnvelope: true,
        paper: "60# Statement",
        envelope: "A6 Lavender / A6 Navy Blue",
        ink: "Blue or black ink options",
        size: [
            {
                id: "16",
                size: "8.5x5.5"
            }
        ]
    },
    {
        id: "11",
        title: "Tri-Fold Self-Mailers",
        productType: "Tri-Fold Self-Mailers",
        hasEnvelope: false,
        paper: "80# Glossy Coverstock",
        size: [
            {
                id: "11",
                size: "12x9"
            }
        ]
    },
    {
        id: "2",
        title: "Professional Letters - Windowed Envelope",
        productType: "Professional Letters",
        hasEnvelope: true,
        paper: "60# Statement",
        envelope: "#10 Double-Window",
        nonEnvelope: "#10 Grey",
        ink: "Full color or black & white",
        size: [
            {
                id: "2",
                size: "11x8.5"
            }
        ],
        windowed: true
    },
    {
        id: "4",
        title: "Professional Letters - Non-windowed Envelope",
        productType: "Professional Letters",
        hasEnvelope: true,
        paper: "60# Statement",
        envelope: "#10 Grey",
        ink: "",
        size: [
            {
                id: "4",
                size: "11x8.5"
            }
        ],
        windowed: false
    },
    {
        id: "18",
        title: "Snap Pack Mailers",
        productType: "Snap Pack Mailers",
        hasEnvelope: false,
        paper: "No Paper Type",
        size: [
            {
                id: "18",
                size: "11x8.5"
            }
        ]
    }
];


const $65bf2ecf319e656d$var$initialState = {
    title: "",
    product: null,
    dynamicField: "",
    dynamicFields: {},
    defaultDynamicFieldsHashMap: {
        "{{C.FIRST_NAME}}": {
            value: "First Name",
            key: "{{C.FIRST_NAME}}",
            defaultValue: "John"
        },
        "{{C.LAST_NAME}}": {
            value: "Last Name",
            key: "{{C.LAST_NAME}}",
            defaultValue: "Doe"
        },
        "{{C.FIRST_NAME}} {{C.LAST_NAME}}": {
            value: "Full Name",
            key: "{{C.FIRST_NAME}} {{C.LAST_NAME}}",
            defaultValue: "John Doe"
        },
        "{{C.COMPANY_NAME}}": {
            value: "Company Name",
            key: "{{C.COMPANY_NAME}}",
            defaultValue: "ABC Company, Inc."
        },
        "{{C.ADDRESS_1}}": {
            value: "Mailing Address 1",
            key: "{{C.ADDRESS_1}}",
            defaultValue: "123 Main Street"
        },
        "{{C.ADDRESS_2}}": {
            value: "Mailing Address 2",
            key: "{{C.ADDRESS_2}}",
            defaultValue: "Suite 2"
        },
        "{{C.CITY}}": {
            value: "Mailing City",
            key: "{{C.CITY}}",
            defaultValue: "Lawrence"
        },
        "{{C.STATE}}": {
            value: "Mailing State",
            key: "{{C.STATE}}",
            defaultValue: "MA"
        },
        "{{C.ZIP_CODE}}": {
            value: "Mailing Zip Code",
            key: "{{C.ZIP_CODE}}",
            defaultValue: "01843"
        },
        "{{C.PHONE_NUMBER}}": {
            value: "Contact Phone Number",
            key: "{{C.PHONE_NUMBER}}",
            defaultValue: "(555) 278-9389"
        },
        "{{C.EMAIL}}": {
            value: "Contact Email",
            key: "{{C.EMAIL}}",
            defaultValue: "johndoe@gmail.com"
        }
    },
    defaultDynamicFields: [
        {
            value: "First Name",
            key: "{{C.FIRST_NAME}}",
            defaultValue: "John"
        },
        {
            value: "Last Name",
            key: "{{C.LAST_NAME}}",
            defaultValue: "Doe"
        },
        {
            value: "Full Name",
            key: "{{C.FIRST_NAME}} {{C.LAST_NAME}}",
            defaultValue: "John Doe"
        },
        {
            value: "Company Name",
            key: "{{C.COMPANY_NAME}}",
            defaultValue: "ABC Company, Inc."
        },
        {
            value: "Address 1",
            key: "{{C.ADDRESS_1}}",
            defaultValue: "123 Main Street"
        },
        {
            value: "Address 2",
            key: "{{C.ADDRESS_2}}",
            defaultValue: "Suite 2"
        },
        {
            value: "City",
            key: "{{C.CITY}}",
            defaultValue: "Lawrence"
        },
        {
            value: "State",
            key: "{{C.STATE}}",
            defaultValue: "MA"
        },
        {
            value: "Zip Code",
            key: "{{C.ZIP_CODE}}",
            defaultValue: "01843"
        },
        {
            value: "Phone Number",
            key: "{{C.PHONE_NUMBER}}",
            defaultValue: "(555) 278-9389"
        },
        {
            value: "Email",
            key: "{{C.EMAIL}}",
            defaultValue: "johndoe@gmail.com"
        }
    ],
    defaultSenderFields: [
        {
            value: "Sender First Name",
            key: "{{SPF.FIRST_NAME}}",
            defaultValue: "John"
        },
        {
            value: "Sender Last Name",
            key: "{{SPF.LAST_NAME}}",
            defaultValue: "Doe"
        },
        {
            value: "Sender Company Name",
            key: "{{SPF.COMPANY_NAME}}",
            defaultValue: "ABC Company, Inc."
        },
        {
            value: "Sender Phone Number",
            key: "{{SPF.PHONE_NUMBER}}",
            defaultValue: "(555) 278-9389"
        },
        {
            value: "Sender Email",
            key: "{{SPF.EMAIL}}",
            defaultValue: "johndoe@gmail.com"
        },
        {
            value: "Sender Website",
            key: "{{SPF.WEBSITE}}",
            defaultValue: "www.example.com"
        }
    ],
    defaultPropertyFields: [
        {
            value: "Property Address",
            key: "{{C.PROPERTY_ADDRESS}}",
            defaultValue: "912 Main Street"
        },
        {
            value: "Property City",
            key: "{{C.PROPERTY_CITY}}",
            defaultValue: "New York"
        },
        {
            value: "Property State",
            key: "{{C.PROPERTY_STATE}}",
            defaultValue: "NY"
        },
        {
            value: "Property Zip Code",
            key: "{{C.PROPERTY_ZIP_CODE}}",
            defaultValue: "10008"
        },
        {
            value: "Property Offer",
            key: "{{C.PROPERTY_OFFER}}",
            defaultValue: "$123,456.00"
        },
        {
            value: "Property Written Offer",
            key: "{{ROS.WRITTEN_OFFER}}",
            defaultValue: "One hundred twenty three thousand four hundred and fifty-six and 00/100"
        }
    ],
    defaultMiscFields: [
        {
            value: "Mailing Date",
            key: "{{MISC.MAILED_DATE}}",
            defaultValue: "12/13/2025"
        }
    ],
    products: (0, $d60d8816d76b2b02$export$92e44ea1079b9ec6),
    productDetailByTemplate: [],
    templates: {
        count: 0,
        rows: [],
        currentPage: 1,
        lastPage: 1,
        from: 0,
        to: 0,
        perPage: 20,
        total: 0,
        loading: true,
        totalRecordsInDB: null
    },
    templatesPagination: {
        page: 0,
        pageSize: 20,
        loading: false
    },
    template: null,
    totalRecordsInDB: null,
    search: "",
    searchProductIds: "",
    searchCreator: "",
    templateType: "json",
    envelopeType: "",
    templateLoading: null,
    uploadedImages: [],
    offerPercentage: "",
    hireDesignerForm: {
        queryTitle: "",
        queryEmail: "",
        queryFiles: [],
        queryVideoUrl: "",
        queryComments: ""
    }
};
// @ts-ignore
const $65bf2ecf319e656d$export$31b16dea7c94293 = (state = $65bf2ecf319e656d$var$initialState, { type: type, payload: payload })=>{
    switch(type){
        case 0, $e496cac0faa1ff17$export$1c6648626b31f20d:
            return {
                ...state,
                template: payload.data,
                title: payload.type === "copy" ? state.title : payload.data.title,
                product: payload.data.product,
                templateType: payload.data.templateType
            };
        case 0, $e496cac0faa1ff17$export$71c26416d85db4e1:
            return {
                ...state,
                template: null
            };
        case 0, $e496cac0faa1ff17$export$a3d810d0d7a98880:
            return {
                ...state,
                templateLoading: payload
            };
        case 0, $e496cac0faa1ff17$export$eb7fa4eb60116c93:
            return {
                ...state,
                templatesPagination: {
                    ...payload.data
                }
            };
        case 0, $e496cac0faa1ff17$export$1aa600adfd3dface:
            return {
                ...state,
                [payload.name]: payload.value
            };
        case 0, $e496cac0faa1ff17$export$297d4370f10479f0:
            return {
                ...state,
                product: {
                    ...payload.product,
                    selectedSize: payload.product.size[0].size,
                    ...!payload.productType && payload.product.productType !== "Postcards" ? {
                        selectedSize: payload.product.size[0].size
                    } : {},
                    ...payload.productType ? {
                        productType: payload.productType
                    } : {}
                }
            };
        case 0, $e496cac0faa1ff17$export$81c9af5ba79ed4c2:
            return {
                ...state,
                product: {
                    ...payload.product,
                    productType: payload.productType
                }
            };
        case 0, $e496cac0faa1ff17$export$3a35067669e6b265:
            return {
                ...state,
                hireDesignerForm: {
                    ...state.hireDesignerForm,
                    ...payload
                }
            };
        case 0, $e496cac0faa1ff17$export$855a5c0ee315c6e1:
            return {
                ...state,
                uploadedImages: payload
            };
        case 0, $e496cac0faa1ff17$export$4510d670c403c89e:
            return {
                ...state,
                templates: {
                    ...$65bf2ecf319e656d$var$initialState.templates
                }
            };
        case 0, $e496cac0faa1ff17$export$b3e9fd1c7999b338:
            return {
                ...state,
                title: "",
                product: null,
                dynamicField: "",
                dynamicFields: {},
                templateType: "json",
                envelopeType: ""
            };
        case 0, $e496cac0faa1ff17$export$900a7683e99e6e7a:
            return {
                ...state,
                title: payload.data.title,
                product: payload.data.product,
                templateType: payload.data.templateType,
                envelopeType: payload.data.envelopeType
            };
        case 0, $e496cac0faa1ff17$export$fa8acf33f5748d2a:
            return {
                ...state,
                hireDesignerForm: {
                    queryTitle: "",
                    queryEmail: "",
                    queryFiles: [],
                    queryVideoUrl: "",
                    queryComments: ""
                }
            };
        case 0, $e496cac0faa1ff17$export$ec8156c566eb37cd:
            return {
                ...state,
                offerPercentage: payload
            };
        case 0, $e496cac0faa1ff17$export$f632fb3a4986e34d:
            return $65bf2ecf319e656d$var$initialState;
        default:
            return state;
    }
};



const $8ff7322b52eb864f$var$initialState = {
    customFields: [],
    customFieldsV2: [],
    platformFields: [],
    defaultDynamicFields: [
        {
            value: "First Name",
            key: "{{C.FIRST_NAME}}",
            defaultValue: "John"
        },
        {
            value: "Last Name",
            key: "{{C.LAST_NAME}}",
            defaultValue: "Doe"
        },
        {
            value: "Full Name",
            key: "{{C.FIRST_NAME}} {{C.LAST_NAME}}",
            defaultValue: "John Doe"
        },
        {
            value: "Company Name",
            key: "{{C.COMPANY_NAME}}",
            defaultValue: "ABC Company, Inc."
        },
        {
            value: "Mailing Address 1",
            key: "{{C.ADDRESS_1}}",
            defaultValue: "123 Main Street"
        },
        {
            value: "Mailing Address 2",
            key: "{{C.ADDRESS_2}}",
            defaultValue: "Suite 2"
        },
        {
            value: "Mailing City",
            key: "{{C.CITY}}",
            defaultValue: "Lawrence"
        },
        {
            value: "Mailing State",
            key: "{{C.STATE}}",
            defaultValue: "MA"
        },
        {
            value: "Mailing Zip Code",
            key: "{{C.ZIP_CODE}}",
            defaultValue: "01843"
        },
        {
            value: "Contact Phone Number",
            key: "{{C.PHONE_NUMBER}}",
            defaultValue: "(555) 278-9389"
        },
        {
            value: "Contact Email",
            key: "{{C.EMAIL}}",
            defaultValue: "johndoe@gmail.com"
        }
    ]
};
const $8ff7322b52eb864f$export$a0d06350fe28ec97 = (state = $8ff7322b52eb864f$var$initialState, action)=>{
    switch(action.type){
        case 0, $e496cac0faa1ff17$export$958a4de996e717f9:
            return {
                ...state,
                customFields: action.payload
            };
        case 0, $e496cac0faa1ff17$export$1586317d794739fb:
            return {
                ...state,
                customFieldsV2: action.payload
            };
        case 0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09:
            return {
                ...state,
                platformFields: action.payload
            };
        default:
            return state;
    }
};


//Actions

const $3c96dc3274620372$var$initialState = {
    snackbar: {
        open: false,
        status: "success",
        heading: "",
        message: ""
    }
};
const $3c96dc3274620372$export$6321c972101ab773 = (state = $3c96dc3274620372$var$initialState, { type: type, payload: payload })=>{
    switch(type){
        case 0, $e496cac0faa1ff17$export$bcebd1097d6619a3:
            return {
                ...state,
                snackbar: {
                    ...state.snackbar,
                    ...payload,
                    open: true,
                    status: "success"
                }
            };
        case 0, $e496cac0faa1ff17$export$be1c2eafe8725e5f:
            return {
                ...state,
                snackbar: {
                    ...state.snackbar,
                    ...payload,
                    open: true,
                    status: "error"
                }
            };
        case 0, $e496cac0faa1ff17$export$5a5bdcd828e4c856:
            return {
                ...state,
                snackbar: {
                    ...state.snackbar,
                    open: false,
                    status: "success",
                    message: "",
                    heading: ""
                }
            };
        default:
            return state;
    }
};



const $8cb36eda978437a8$var$initialState = {
    url: "",
    utmSource: "direct mail",
    utmMedium: "QR Code",
    utmCampaignName: "",
    customUtms: {},
    isQR: false
};
const $8cb36eda978437a8$export$22a954d13bdf6c53 = (state = $8cb36eda978437a8$var$initialState, action)=>{
    switch(action.type){
        case 0, $e496cac0faa1ff17$export$1ea993b3d44cc7c7:
            return {
                ...state,
                url: action.payload
            };
        case 0, $e496cac0faa1ff17$export$a7a0ed74e75b0309:
            return {
                ...state,
                utmSource: action.payload
            };
        case 0, $e496cac0faa1ff17$export$fd009ec8add63610:
            return {
                ...state,
                utmMedium: action.payload
            };
        case 0, $e496cac0faa1ff17$export$c650fbc46a12623c:
            return {
                ...state,
                utmCampaignName: action.payload
            };
        case 0, $e496cac0faa1ff17$export$7a4dd71569e99a02:
            return {
                ...state,
                customUtms: action.payload
            };
        case 0, $e496cac0faa1ff17$export$1dca10819ac70fdd:
            return {
                ...state,
                isQR: action.payload
            };
        case 0, $e496cac0faa1ff17$export$6738fe01c6ac3583:
            return {
                ...$8cb36eda978437a8$var$initialState
            };
        default:
            return state;
    }
};


const $bb98721f7ed2b5f6$var$rootReducer = (0, $lt6Ts$combineReducers)({
    templates: (0, $65bf2ecf319e656d$export$31b16dea7c94293),
    customFields: (0, $8ff7322b52eb864f$export$a0d06350fe28ec97),
    snackbarReducers: $3c96dc3274620372$export$6321c972101ab773,
    customQRCode: (0, $8cb36eda978437a8$export$22a954d13bdf6c53)
});
var $bb98721f7ed2b5f6$export$2e2bcd8739ae039 = $bb98721f7ed2b5f6$var$rootReducer;


const $ad568a7ac4136873$var$store = (0, $lt6Ts$configureStore)({
    reducer: (0, $bb98721f7ed2b5f6$export$2e2bcd8739ae039),
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            thunk: true,
            serializableCheck: false,
            immutableCheck: false
        })
});
var $ad568a7ac4136873$export$2e2bcd8739ae039 = $ad568a7ac4136873$var$store;










const $7ad22e5ca6c288ca$export$fa671cbd439de11d = "https://qrforward.org/api/v1/sdk";
const $7ad22e5ca6c288ca$export$9878c63741f482ec = "https://demo.qrforward.org/api/v1/sdk";
const $7ad22e5ca6c288ca$export$7a8d8aa81a0d4f3a = "https://staging.qrforward.org/api/v1/sdk";
const $7ad22e5ca6c288ca$export$a29f56a0abcec6b0 = "http://localhost:8089/api/v1/sdk";
const $7ad22e5ca6c288ca$export$3c5eb5b1ae66c970 = "http://localhost:8089/api/v1/download/s3/sdk-images";
const $7ad22e5ca6c288ca$export$dc8c2e2c228d4170 = `https://staging.qrforward.org/api/v1/download/s3/sdk-images`;
const $7ad22e5ca6c288ca$export$31ebffddc71c8253 = `https://demo.qrforward.org/api/v1/download/s3/sdk-images`;
const $7ad22e5ca6c288ca$export$79361813a10e9e28 = `https://qrforward.org/api/v1/download/s3/sdk-images`;
const $7ad22e5ca6c288ca$export$66a57f3cad8824dd = "https://demo.offer-generator.com/property-offers";
const $7ad22e5ca6c288ca$export$a8a46befcad8f726 = "https://staging.offer-generator.com/property-offers";
const $7ad22e5ca6c288ca$export$7f8ff6b96b8eb54b = "https://offer-generator.com/property-offers";
const $7ad22e5ca6c288ca$export$6032165a31897610 = 96;
const $7ad22e5ca6c288ca$export$7a42bc549c2355e6 = `/assets/preview/one-barcode.png`;
const $7ad22e5ca6c288ca$export$75535718f1551e4f = `/default_images/dummyGSV.png`;
const $7ad22e5ca6c288ca$export$b14103b5b94712c4 = "https://help.openletterconnect.com/draft-help-doc/product-and-order-guide/creating-a-template";
const $7ad22e5ca6c288ca$export$3e994a540f8ee57 = [
    "Postcards",
    "Tri-Fold Self-Mailers",
    "Bi-Fold Self-Mailers",
    "Snap Pack Mailers"
];
const $7ad22e5ca6c288ca$export$668f6b29ff2ac480 = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{2300}-\u{23FF}]|[\u{2B50}\u{2B55}]|[\u{1F004}\u{1F0CF}]/u;
const $7ad22e5ca6c288ca$export$abbaea9002634c0c = [
    "image/jpeg",
    "image/png",
    "image/svg+xml"
];
const $7ad22e5ca6c288ca$export$683d22caccc9d465 = [
    {
        id: "1",
        label: "My Templates",
        value: "my_templates"
    },
    {
        id: "2",
        label: "Team Templates",
        value: "team_templates"
    }
];
const $7ad22e5ca6c288ca$export$e75e577b199ead61 = [
    "Postcards",
    "Personal Letters",
    "Professional Letters",
    "Snap Pack Mailers",
    "Bi-Fold Self-Mailers",
    "Tri-Fold Self-Mailers",
    "Real Penned Letter"
];
const $7ad22e5ca6c288ca$export$7b7637218245c8a = /^[a-z0-9](\.?[a-z0-9_\-\+])*@[a-z0-9](\.?[a-z0-9-])*\.[a-z]{2,}$/i;
const $7ad22e5ca6c288ca$export$ace9493ddb576805 = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
const $7ad22e5ca6c288ca$export$f2ea9ed4b68e82d5 = [
    "qrforward.org",
    "demo-qrforward.org",
    "staging-qrforward.org"
];
const $7ad22e5ca6c288ca$export$30a03ee31713ef75 = [
    {
        key: "{{C.FIRST_NAME}}",
        value: "firstname"
    },
    {
        key: "{{C.LAST_NAME}}",
        value: "lastname"
    },
    {
        key: "{{C.EMAIL}}",
        value: "email"
    },
    {
        key: "{{C.PHONE_NUMBER}}",
        value: "phone"
    }
];


let $717432aee8737b76$export$cf3b58100ed4cf89 = "";
let $717432aee8737b76$export$897b44b3e27fa56d = false;
let $717432aee8737b76$export$d1418d82198b4abb = false;
const $717432aee8737b76$export$2cdf1b96a9f86d16 = (text)=>{
    navigator.clipboard.writeText(text).then(()=>{}).catch((err)=>{
        console.error("Failed to copy text: ", err);
    });
};
const $717432aee8737b76$export$46af023db2483081 = ()=>{
    return $717432aee8737b76$export$cf3b58100ed4cf89;
};
const $717432aee8737b76$export$527e3e4d00b88329 = (key)=>{
    $717432aee8737b76$export$cf3b58100ed4cf89 = key;
};
const $717432aee8737b76$export$d97320b3491da14 = ()=>{
    return $717432aee8737b76$export$897b44b3e27fa56d;
};
const $717432aee8737b76$export$4bd44a2aa29d3d6e = ()=>{
    return $717432aee8737b76$export$d1418d82198b4abb;
};
const $717432aee8737b76$export$ba225133fb4a45c3 = (sandbox)=>{
    $717432aee8737b76$export$897b44b3e27fa56d = sandbox;
};
const $717432aee8737b76$export$84bc02d3c7a6b55f = (env)=>{
    $717432aee8737b76$export$d1418d82198b4abb = env;
};
const $717432aee8737b76$export$c5a6b7b1e4535d31 = (input)=>{
    // Check if the string contains exactly one '0' or one '1'
    const containsExactlyOneOne = /^.*\b1\b(?!\d).*$/g.test(input) && !input.match(/1\d/);
    if (containsExactlyOneOne) return input.endsWith("s") ? input.slice(0, -1) : input;
    return input;
};
const $717432aee8737b76$export$c6f1a4382426409f = (str)=>{
    var pattern = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
    return !!pattern.test(str);
};
const $717432aee8737b76$export$9665a07d9187b414 = (hex, opacity)=>{
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, "");
    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGBA string
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const $717432aee8737b76$export$e2b5c5db9e2009fd = (file)=>{
    const { type: type } = file;
    if (type.indexOf("svg") >= 0) return "svg";
    if (type.indexOf("image") >= 0) return "image";
    if (type.indexOf("video") >= 0) return "video";
    return "image";
};
const $717432aee8737b76$export$cb0bbc88c7f09596 = (input)=>{
    var output = "";
    for(var i = 0; i < input.length; i++)if (input.charCodeAt(i) <= 127) output += input.charAt(i);
    return output;
};
const $717432aee8737b76$export$d0f8ccadd3e82b0a = (id, x, y, width, height, rotation, color = "rgba(48,155,95,1)")=>({
        id: id,
        type: "line",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        x: x,
        y: y,
        width: width,
        height: height,
        rotation: rotation,
        color: color,
        dash: [
            4,
            1
        ],
        draggable: false,
        resizable: false
    });
const $717432aee8737b76$export$95d1eb3b83c09bfc = (id, x, y, width, text, rotation = 0, fontSize = 9)=>{
    return {
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        x: x,
        y: y,
        width: width,
        height: 12,
        rotation: rotation,
        animations: [],
        blurEnabled: false,
        blurRadius: 10,
        brightnessEnabled: false,
        brightness: 0,
        sepiaEnabled: false,
        grayscaleEnabled: false,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "black",
        shadowOpacity: 1,
        draggable: false,
        resizable: false,
        contentEditable: false,
        styleEditable: false,
        text: text,
        fontSize: fontSize,
        fontFamily: "Noto Sans JP",
        fontStyle: "italic",
        fontWeight: "normal",
        fill: "rgba(74,74,74,1)",
        align: "center",
        verticalAlign: "top",
        strokeWidth: 0,
        stroke: "black",
        lineHeight: 1.2,
        letterSpacing: 0,
        backgroundEnabled: false,
        backgroundColor: "#7ED321",
        backgroundOpacity: 1,
        backgroundCornerRadius: 0.5,
        backgroundPadding: 0.5
    };
};
const $717432aee8737b76$export$76324c20bce07fe1 = (dataURL, type)=>{
    // Extract the Base64 data by removing the prefix
    const base64Index = dataURL.indexOf(";base64,") + 8;
    const base64String = dataURL.substring(base64Index);
    try {
        const byteString = atob(base64String);
        const arrayBuffer = new Uint8Array(byteString.length);
        for(let i = 0; i < byteString.length; i++)arrayBuffer[i] = byteString.charCodeAt(i);
        return new Blob([
            arrayBuffer
        ], {
            type: type
        });
    } catch (error) {
        console.error("Failed to decode Base64 string:", error);
        throw new Error("Invalid Base64 string");
    }
};


const $f081c02ac731d950$var$getHeaders = (additionalHeaders = {})=>({
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${(0, $717432aee8737b76$export$46af023db2483081)()}`,
        ...additionalHeaders
    });
const $f081c02ac731d950$var$fetchWrapper = async (endpoint, options)=>{
    const baseUrl = (()=>{
        const env = (0, $717432aee8737b76$export$4bd44a2aa29d3d6e)();
        if (env === "local") return 0, $7ad22e5ca6c288ca$export$a29f56a0abcec6b0;
        if (env === "staging") return 0, $7ad22e5ca6c288ca$export$7a8d8aa81a0d4f3a;
        return (0, $717432aee8737b76$export$d97320b3491da14)() ? (0, $7ad22e5ca6c288ca$export$9878c63741f482ec) : (0, $7ad22e5ca6c288ca$export$fa671cbd439de11d);
    })();
    const url = new URL(`${baseUrl}${endpoint}`);
    if (options.method === "GET" && options.params) Object.entries(options.params).forEach(([key, value])=>{
        url.searchParams.append(key, value);
    });
    const fetchOptions = {
        method: options.method,
        headers: $f081c02ac731d950$var$getHeaders(options.headers)
    };
    if (options.method !== "GET" && options.body) fetchOptions.body = JSON.stringify(options.body);
    // Add body to fetchOptions if present
    if (options.body) {
        if (options.body instanceof FormData) {
            fetchOptions.body = options.body;
            // @ts-ignore
            delete fetchOptions?.headers["Content-Type"];
        } else fetchOptions.headers = $f081c02ac731d950$var$getHeaders(options.headers);
    }
    try {
        const response = await fetch(url.toString(), fetchOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "An error occurred");
        }
        if (response.status === 204) return null;
        const data = await response.json();
        return {
            status: response.status,
            data: data
        };
    } catch (error) {
        return error;
    }
};
var $f081c02ac731d950$export$2e2bcd8739ae039 = $f081c02ac731d950$var$fetchWrapper;


const $77d971be1e6bcd7c$export$3988ae62b71be9a3 = async (endpoint, params)=>{
    return await (0, $f081c02ac731d950$export$2e2bcd8739ae039)(endpoint, {
        method: "GET",
        params: params
    });
};
const $77d971be1e6bcd7c$export$299ba2dee77727e9 = async (endpoint, body)=>{
    return await (0, $f081c02ac731d950$export$2e2bcd8739ae039)(endpoint, {
        method: "POST",
        body: body
    });
};
const $77d971be1e6bcd7c$export$327f7b26ebf455db = async (endpoint, body)=>{
    return await (0, $f081c02ac731d950$export$2e2bcd8739ae039)(endpoint, {
        method: "PUT",
        body: body
    });
};
const $77d971be1e6bcd7c$export$b76953f99ab2be78 = async (endpoint, body)=>{
    return await (0, $f081c02ac731d950$export$2e2bcd8739ae039)(endpoint, {
        method: "PATCH",
        body: body
    });
};
const $77d971be1e6bcd7c$export$1d2f21e549771e67 = async (endpoint, params)=>{
    return await (0, $f081c02ac731d950$export$2e2bcd8739ae039)(endpoint, {
        method: "DELETE",
        params: params
    });
};



/**
 * Uploads a template using the provided template form data.
 *
 * @param {FormData} templateFormData - The form data containing the template files to upload.
 * @returns {Promise<any>} - A promise that resolves with the response from the server.
 * @throws {Error} - If an error occurs during the upload process.
 */ const $dbaee5ca78364d67$export$bbcabe93832383b3 = async (templateFormData)=>{
    try {
        const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/templates/upload", templateFormData);
        return response;
    } catch (error) {
        return error.response;
    }
};
const $dbaee5ca78364d67$export$99fb2aa3c6b824c3 = async (payload)=>{
    try {
        const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/templates/by-tab", payload);
        return response?.data?.data;
    } catch (error) {
        return error.response;
    }
};
/**
 * Loads form data to the store.
 *
 * @param {string} data - The form data in JSON format.
 * @returns {void} - Dispatches an action to the Redux store.
 */ const $dbaee5ca78364d67$export$e90ab51a767ad1d0 = (data)=>(dispatch)=>{
        try {
            const parsedData = JSON.parse(data);
            dispatch({
                type: (0, $e496cac0faa1ff17$export$900a7683e99e6e7a),
                payload: {
                    data: parsedData
                }
            });
        } catch (error) {
            console.error(error);
        }
    };
/**
 * Downloads the proof for the provided data.
 *
 * @param {object} data - The data for which the proof is requested.
 * @returns {Promise<any>} - The response object from the POST request.
 * @throws {object} - The error response if there is an error.
 */ const $dbaee5ca78364d67$export$a2500560a97e8dba = async (data)=>{
    try {
        const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/view-proof-cloud", data);
        return response;
    } catch (error) {
        return error.response;
    }
};
/**
 * Downloads the envelope for the provided data.
 *
 * @param {object} data - The data for which the proof is requested.
 * @returns {Promise<any>} - The response object from the POST request.
 * @throws {object} - The error response if there is an error.
 */ const $dbaee5ca78364d67$export$3242b03125b539ed = async (data)=>{
    try {
        const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/download-envelope-proof", data);
        return response;
    } catch (error) {
        return error.response;
    }
};
/**
 * Uploads a file.
 *
 * @param {File} file - The file to upload.
 * @returns {Promise<string>} - The file path of the uploaded file.
 * @throws {object} - The error response if there is an error.
 */ const $dbaee5ca78364d67$export$a5575dbeeffdad98 = async (file)=>{
    try {
        const formData = new FormData();
        formData.append("image", file);
        const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/uploadFile", formData);
        return response?.data?.data?.filePath;
    } catch (error) {
        return error?.response;
    }
};
/**
 * Clears template fields.
 *
 * @returns {Function} - The thunk function.
 */ const $dbaee5ca78364d67$export$df7b8ffccf8fe273 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$b3e9fd1c7999b338)
        });
    };
/**
 * Selects a product.
 *
 * @param {any} product - The selected product.
 * @param {string} [productType=''] - The type of the selected product.
 * @returns {Function} - The thunk function.
 */ const $dbaee5ca78364d67$export$f8e6fdbf45160f24 = (product, productType = "")=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$297d4370f10479f0),
            payload: {
                product: product,
                productType: productType
            }
        });
    };
/**
 * Selects a postcard.
 *
 * @param {any} product - The selected product.
 * @param {string} productType - The type of the selected product.
 * @returns {Function} - The thunk function.
 */ const $dbaee5ca78364d67$export$6689c052aee06540 = (product, productType)=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$81c9af5ba79ed4c2),
            payload: {
                product: product,
                productType: productType
            }
        });
    };
/**
 * Clears all templates.
 *
 * @returns {Function} - The thunk function.
 */ const $dbaee5ca78364d67$export$1e6ea60acfeb7da4 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$4510d670c403c89e)
        });
    };
/**
 * Searches and advances change.
 *
 * @param {string} name - The name of the field.
 * @param {any} value - The value of the field.
 * @returns {Function} - The thunk function.
 */ const $dbaee5ca78364d67$export$c7c994d6f1f97f07 = (name, value)=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$1aa600adfd3dface),
            payload: {
                name: name,
                value: value
            }
        });
    };
/**
 * Retrieves all template categories from the server using an HTTP GET request.
 *
 * @returns {Promise<any>} - A promise that resolves with the response from the server.
 * @throws {object} - The error response if there is an error.
 */ const $dbaee5ca78364d67$export$202033b5492f87a7 = async ()=>{
    try {
        const response = await (0, $77d971be1e6bcd7c$export$3988ae62b71be9a3)("/categories");
        return response;
    } catch (error) {
        return error.response;
    }
};




const $bbef8ecdaaf79b6e$export$ff1a9ff6320ab5ac = (isQR)=>({
        type: (0, $e496cac0faa1ff17$export$1dca10819ac70fdd),
        payload: isQR
    });
const $bbef8ecdaaf79b6e$export$c48cc906ecded6a0 = (url)=>({
        type: (0, $e496cac0faa1ff17$export$1ea993b3d44cc7c7),
        payload: url
    });
const $bbef8ecdaaf79b6e$export$8903335f45df5147 = (utmSource)=>({
        type: (0, $e496cac0faa1ff17$export$a7a0ed74e75b0309),
        payload: utmSource
    });
const $bbef8ecdaaf79b6e$export$7c509f1febbfc2e0 = (utmMedium)=>({
        type: (0, $e496cac0faa1ff17$export$fd009ec8add63610),
        payload: utmMedium
    });
const $bbef8ecdaaf79b6e$export$2b7a28e427492e80 = (utmCampaignName)=>({
        type: (0, $e496cac0faa1ff17$export$c650fbc46a12623c),
        payload: utmCampaignName
    });
const $bbef8ecdaaf79b6e$export$428b90966bc4ddbf = (customUtms)=>({
        type: (0, $e496cac0faa1ff17$export$7a4dd71569e99a02),
        payload: customUtms
    });
const $bbef8ecdaaf79b6e$export$7cdbec44919c75ac = ()=>({
        type: (0, $e496cac0faa1ff17$export$6738fe01c6ac3583)
    });



const $b66d61b9e6770b52$export$8a8216c44337cd5 = (key, value)=>{
    localStorage.setItem(key, value);
};
const $b66d61b9e6770b52$export$f92dfeb71e9bb569 = (key)=>{
    return localStorage.getItem(key);
};
const $b66d61b9e6770b52$export$fe2d9b4e03920b4c = (key)=>{
    localStorage.removeItem(key);
};
const $b66d61b9e6770b52$export$d7a0b846d036443e = ()=>{
    localStorage.clear();
};


// Default messages and Typography
const $0b51cdcdcd2b1339$export$af7faffe10421f14 = {
    TEMPLATE_MESSAGE_ON_SMALL_SCREEN: "Template Builder is available on tablet and web view only.",
    GENERAL_ERROR: "Internal Server Error",
    DOWNLOAD_ERROR: "Something went wrong. Please try again.",
    CLONE_ERROR: "We are currently unable to clone the template. Please try again later.",
    TEMPLATE: {
        SEARCH_PLACE_HOLDER: "Search by template name or template ID",
        NAME_REQUIRED: "Template Name is required",
        TYPE_REQUIRED: "Template Type is required",
        DESIGN_NEW: "Design Your Own",
        NO_MY_TEMPLATES: "No Templates to show",
        LOADING_TEMPLATE: "Loading Templates...",
        NO_TEAM_TEMPLATES: "No Team Templates to show",
        NO_OLC_TEMPLATES: "No OLC Templates to show",
        PRODUCT_TYPE_REQUIRED: "Product Type is required",
        ENVELOPE_TYPE_REQUIRED: "Envelope Type is required",
        POSTCARD_SIZE_REQUIRED: "Postcard Size is required",
        NAME_LESS_50: "Template Name should be less than or equal to 50 characters",
        GSV_RESTRICT_ONE_PER_PAGE: "Only one GSV image is allowed per page.",
        EMOJI_NOT_ALLOWED: "Emojis are not allowed in the template. Please remove them before saving.",
        EMPTY_QR_NOT_ALLOWED: "Please add a URL to your QR code in order to save the template.",
        SIZE_LIMIT_EXCEED: "Template size should be less than 7MB. Please remove custom fonts or unnecessary assets.",
        CREATE: {
            TITLE: "Create New Template",
            TEMPLATE_LABEL: "Template Name*",
            PRODUCT_LABEL: "Product Type*",
            LEARN_TEXT: "Learn More",
            CANCEL_BUTTON: "Cancel",
            SUBMIT_BUTTON: "Next"
        },
        LIMIT_MODAL: {
            TITLE: "Limit Reached",
            HEADING: "You've reached your template limit",
            SUB_HEADING: "Please Upgrade your subscription to add more templates",
            CANCEL_BUTTON: "Cancel",
            SUBMIT_BUTTON: "View Plans"
        },
        DELETE: {
            TITLE: "Delete Template",
            HEADING: "Are you sure you want to delete this Template?",
            PARAGRAPH: "This template will be deleted from your Templates list but will still be included in associated orders."
        },
        SAVE: {
            TITLE: "Confirm Save Template",
            HEADING: "Are you sure you want to save this template?",
            PARAGRAPH: "The updates provided will be used right away for any orders referencing this template.",
            CANCEL_BUTTON: "Cancel",
            SUBMIT_BUTTON: "Save"
        },
        CANCEL: {
            TITLE: "Confirm Cancel Template",
            HEADING: "Are you sure you want to cancel this Template?",
            PARAGRAPH: "You will lose your changes after canceling.",
            BACK_BUTTON: "Go Back",
            CANCEL_BUTTON: "Cancel Template"
        },
        DESIGN_YOUR_OWN: {
            TITLE: "Confirm",
            HEADING: "Are you sure you want to discard these changes?",
            PARAGRAPH: "You will lose your changes. Please save your changes or click ok to proceed."
        },
        SELECT_TEMPLATE: {
            TITLE: "Confirm",
            HEADING: "Are you sure you want to change current template with this one?",
            PARAGRAPH: "You will lose your changes. Please save your changes or click ok to proceed.",
            SUBMIT_BUTTON: "OK",
            CANCEL_BUTTON: "Cancel"
        },
        CUSTOM_UPLOAD_SECTION: {
            HEADING: "Do you want to upload your own images?",
            ACCEPTED_FORMATS: "Accepted File Formats: JPEG, PNG, SVG",
            MAX_SIZE: "Max File Size Limits: 5MB",
            UPLOAD_BTN_TEXT: "Upload Image",
            TYPE_VALIDATION: "Only image files with extensions jpeg, png, or svg are allowed.",
            SIZE_VALIDATION: "File size must be under 5MB."
        },
        QR_SECTION: {
            EMPTY_QR: "Please add a URL to your QR code.",
            QR_PLACEHOLDER: "Enter QR URL",
            INVALID_URL: "Please add a valid URL to your QR code.",
            SUBMIT_BUTTON: "Add new QR code",
            UPDATE_BUTTON: "Update QR code"
        },
        HIRE_DESIGNER: {
            TITLE: "Custom Design Form",
            UPLOAD_HEADING: "Upload Design Files",
            UPLOADED_TEXT: "Uploaded",
            FILE_VALLIDATION: "One or more files have unsupported formats. Please upload only .png, .jpg, .jpeg, .pdf, .doc, or .docx files.",
            FILE_NUMBER: "You can only upload up to 5 files.",
            TITLE_REQUIRED: "Template Name is required",
            URL_REQUIRED: "Video URL is required",
            URL_VAIDATION: "Video URL is not valid",
            COMMENT_REQUIRED: "Comments are required",
            EMAIL_REQUIRED: "Email is required",
            EMAIL_VALIDATION: "Email is not valid",
            SUBMIT_BUTTON: "Next"
        },
        DUPLICATE_MODAL: {
            TITLE: "Clone Template",
            NAME_PLACEHOLDER: "Enter new template name",
            CANCEL_BUTTON: "Cancel",
            SUBMIT_BUTTON: "Clone",
            SUB_HEADING: "Enter a New Name for Your Template",
            DESCRIPTION: "Create a clone of an existing template. Please provide a new name for the template to proceed.",
            NOTE: " Note: Only saved changes will appear in the cloned template."
        },
        CUSTOM_ADD_ONS: {
            TITLE: `Optional Add-On's`,
            NO_RESULT: "Add-ons are unavailable because the property address is excluded. Please update your settings to enable these features.",
            DESCRIPTION: `Optional add-ons are additional services that user can choose to include with their template, enhancing their overall experience.`,
            GSV: {
                TITLE: "Street View Property Image",
                DESCRIPTION: "+$0.02 per mail piece"
            },
            PROPERTY_OFFER: {
                TITLE: "Add an Offer",
                DESCRIPTION: "(generated using Property Info)",
                PRICE: "+$0.03 per mail piece",
                CUSTOM: {
                    TITLE: "Add an Offer (+$0.03 per mail piece)",
                    DESCRIPTION: "Unsure of your offer %?",
                    PRICE: "+$0.03 per mail piece",
                    CLICK: "Click here",
                    CSV_IMPORT: "to import a CSV to determine the best offer % for you!",
                    CUSTOM_PRICE: "Enter Offer Percentage*"
                }
            }
        },
        DOWNLOAD_PROOF_BUTTON: "Download View Proof",
        DOWNLOAD_ENVELOPE_BUTTON: "Download Envelope Proof",
        CANCEL_BUTTON: "Cancel",
        SUBMIT_BUTTON: "Save"
    },
    SNACKBAR: {
        HEADING: "Notifications"
    }
};


/* eslint-disable no-useless-catch */ // Utils



const $9d201cd516e32817$export$5f13a51c7a156d51 = (store, size, barcodeSrc)=>{
    const page = store.pages[0];
    const elements = [
        {
            id: "figure-1",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 9 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            height: size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "return-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5 - 9 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 20,
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "YOUR RETURN ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 8,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "indicia",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - 111 - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 9 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            width: 111,
            height: 40,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: `POSTAGE\nINDICIA`,
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "barcode",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            y: store.height - 28 - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 100,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 9 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 23,
            height: 15,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            src: barcodeSrc,
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderSize: 0,
            keepRatio: false
        },
        {
            id: "recipient-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5 - 9 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 120,
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "RECIPIENT ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 13,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};



const $58150108dfd76800$export$485ca3438dfa1819 = (store, size, barcodeSrc)=>{
    const page = store.pages[1];
    const elements = [
        {
            id: "figure-1",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            height: size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "return-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 20,
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "YOUR RETURN ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 8,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "indicia",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - 111 - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            width: 111,
            height: 40,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: `POSTAGE\nINDICIA`,
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "barcode",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            y: store.height - 28 - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 100,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 23,
            height: 15,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            brightnessEnabled: false,
            brightness: 100,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            src: barcodeSrc,
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderSize: 0,
            keepRatio: true
        },
        {
            id: "recipient-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 120,
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "RECIPIENT ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 13,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};



const $11132e13d1f7bacf$export$fe83566325f1e1e8 = (store, barcodeSrc)=>{
    const page = store.pages[0];
    const position = [
        0.6,
        0.84
    ];
    const position1 = [
        0.63,
        1.71
    ];
    const elements = [
        {
            id: "figure-2",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 0.63 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: 0.5 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: 3.25 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            height: 0.875 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "figure-3",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 0.63 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: 1.71 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            height: 1 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "return-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: position[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            y: position[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 10,
            width: 200,
            height: 18,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "YOUR RETURN ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "barcode",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: position1[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            y: position1[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 70,
            width: 230,
            height: 15,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            src: barcodeSrc,
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderSize: 0,
            keepRatio: false
        },
        {
            id: "recipient-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: position1[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            y: position1[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10,
            width: 165,
            height: 21,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "RECIPIENT ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
const $563d98d6370280e4$export$e15fac5e99e10d2e = (store)=>{
    const page = store.pages[0];
    const elements = [];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
const $3daa42fe982b7b66$export$64e7783251b1b98f = (store)=>{
    const page = store.pages[0];
    const elements = [];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};



const $61207d508899f18f$export$c3fe419eb223f4c8 = (store, size, barcodeSrc)=>{
    const page = store.pages[0];
    const elements = [
        {
            id: "figure-1",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            height: size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "return-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 20 - 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "YOUR RETURN ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 8,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "indicia",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - 111 - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 10 - 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: 111,
            height: 40,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: `POSTAGE\nINDICIA`,
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "barcode",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            y: store.height - 28 - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 100 - 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            width: size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 23,
            height: 15,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            src: barcodeSrc,
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderSize: 0,
            keepRatio: false
        },
        {
            id: "recipient-address",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: store.width - size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.15 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 5,
            y: store.height - size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610) - 0.125 * (0, $7ad22e5ca6c288ca$export$6032165a31897610) + 120 - 4 * (0, $7ad22e5ca6c288ca$export$6032165a31897610),
            width: 240,
            height: 20,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "RECIPIENT ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 13,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
const $c79c0a196e41fb4d$export$b246bdddcbce0297 = (store, barcodeSrc)=>{
    const page = store.pages[0];
    const pageTwo = store.pages[1];
    const elements = [
        {
            id: "left-p1",
            type: "figure",
            name: "left-p1",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 2.930e-14,
            y: -0.0000000000000142,
            width: 23.83,
            height: 1062.31,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "right-p1",
            type: "figure",
            name: "right-p1",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 792.166,
            y: 11.809,
            width: 23.83,
            height: 1062.31,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "top-p1",
            type: "figure",
            name: "top-p1",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 938.95,
            y: -0.1065,
            width: 23.833,
            height: 1062.31,
            rotation: 90,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "bottom-p1",
            type: "figure",
            name: "bottom-p1",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 920.867,
            y: 1031.583,
            width: 23.83,
            height: 1062.31,
            rotation: 90,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "mailing-address-window-box-1",
            type: "figure",
            name: "mailing-address-window-box-1",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 60,
            y: 375,
            width: 360,
            height: 185,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(233,233,233,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 16,
            custom: {
                replaceBg: true
            }
        },
        {
            id: "mailing-address-window-text-1",
            type: "text",
            name: "mailing-address",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: false,
            x: 35,
            y: 455,
            width: 408,
            height: 31,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "Mailing Address Window",
            placeholder: "",
            fontSize: 25,
            fontFamily: "Roboto",
            fontStyle: "italic",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "recipient-address-area",
            type: "figure",
            name: "recipient-address-area",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            custom: {
                replaceBg: true
            },
            x: 96.48,
            y: 893.82,
            width: 286.86,
            height: 97.13,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            subType: "rect",
            fill: "rgba(193,193,193,1)",
            dash: [],
            strokeWidth: 1,
            stroke: "#0c0c0c",
            cornerRadius: 16
        },
        {
            id: "recipient-address-box",
            type: "figure",
            name: "recipient-address-box",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 107,
            y: 917,
            width: 255,
            height: 63,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "white",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "recipient-address",
            type: "text",
            name: "recipient-address-text",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 112,
            y: 920.08,
            width: 250,
            height: 63,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: true,
            styleEditable: true,
            text: "RECIPIENT ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#FFFFFF",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    const elementsForSecondPage = [
        {
            id: "left-p2",
            type: "figure",
            name: "left-p2",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 1,
            y: -6.3,
            width: 21.83,
            height: 1062.31,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "right-p2",
            type: "figure",
            name: "right-p2",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 792.16,
            y: -0.00000000000001421,
            width: 23.83,
            height: 1062.31,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "top-p2",
            type: "figure",
            name: "top-p2",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 913.84,
            y: -0.1065,
            width: 23.83,
            height: 1062.31,
            rotation: 90,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "bottom-p2",
            type: "figure",
            name: "bottom-p2",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 895.68,
            y: 1030,
            width: 25.99,
            height: 1062.31,
            rotation: 90,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(255,255,255,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "return-address-box",
            type: "figure",
            name: "return-address-box",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            custom: {
                replaceBg: true
            },
            x: 720,
            y: 690,
            width: 284.86,
            height: 76.09,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(242,242,242,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 12
        },
        {
            id: "return-address",
            type: "text",
            name: "return-address",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 710,
            y: 680,
            width: 250,
            height: 63,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "YOUR RETURN ADDRESS \nWILL AUTOMATICALLY \nBE PRINTED IN THIS \nPOSITION",
            placeholder: "",
            fontSize: 10,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#FFFFFF",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "postage-indicia-box",
            type: "figure",
            name: "postage-indicia-box",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            custom: {
                replaceBg: true
            },
            x: 192,
            y: 685,
            width: 137,
            height: 74.8,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(243,243,243,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 12
        },
        {
            id: "indicia",
            type: "text",
            name: "indicia",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 175,
            y: 668,
            width: 111,
            height: 40,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: `POSTAGE\nINDICIA`,
            placeholder: "",
            fontSize: 18,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "mailing-address-window-box-2",
            type: "figure",
            name: "mailing-address-window-box-2",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 400,
            y: 365,
            width: 360,
            height: 185,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(240,240,240,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 16,
            custom: {
                replaceBg: true
            }
        },
        {
            id: "mailing-address-window-text-2",
            type: "text",
            name: "mailing-address",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: false,
            x: 780,
            y: 475,
            width: 408,
            height: 31,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "Mailing Address Window",
            placeholder: "",
            fontSize: 25,
            fontFamily: "Roboto",
            fontStyle: "italic",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "barcode-box",
            type: "figure",
            name: "barcode-box",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            custom: {
                replaceBg: true
            },
            x: 375,
            y: 435,
            width: 319,
            height: 65,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "rgba(244,244,244,1)",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 12
        },
        {
            id: "barcode",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: 375,
            y: 410,
            width: 315,
            height: 15,
            rotation: 180,
            animations: [],
            blurEnabled: false,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            src: barcodeSrc,
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderSize: 0,
            keepRatio: false
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    elementsForSecondPage.forEach((element)=>pageTwo.addElement(element));
    store.history.clear();
};



const $7ebf274b17417b89$export$2978a94ed9e6116d = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -21, 3.6, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 18.19, 14.7, 539.61, 1.97, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 18.19, 367.32, 539.61, 1.97, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 17.21, 368.31, 352.62, 1.97, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 556.82, 368.31, 352.62, 1.97, -90)
        ]
    };
    const safetyBordersTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-2-${randomizedId}`, -21, 3.6, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 18.19, 14.7, 539.61, 1.97, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 18.19, 367.32, 539.61, 1.97, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 17.21, 368.31, 352.62, 1.97, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 556.82, 368.31, 352.62, 1.97, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store.pages[1]?.addElement(secondPageBorders);
    store.pages[1]?.addElement(safetyBordersTextSecond);
    // Clear history
    store.history.clear();
};
const $7ebf274b17417b89$export$8817d1032c829c5a = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -8.29, 5.8, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 28, 22.5, 808, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 28, 550, 808, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 26.5, 552, 528, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 834.5, 552, 528, 2.94, -90)
        ]
    };
    const safetyBordersTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-2-${randomizedId}`, -8.6, 5.09, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 28, 22.5, 808, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 28, 550, 808, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 26.5, 552, 528, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 834.5, 552, 528, 2.94, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store.pages[1]?.addElement(secondPageBorders);
    store.pages[1]?.addElement(safetyBordersTextSecond);
    // Clear history
    store.history.clear();
};
const $7ebf274b17417b89$export$bfb27578a2deeca5 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -8.29, 5.8, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 25.5, 23.8, 1005, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 25.5, 549, 1005, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 24, 550, 525, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 1028, 550, 525, 2.94, -90)
        ]
    };
    const safetyBordersTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-2-${randomizedId}`, -8.6, 5.09, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 25.5, 23.8, 1005, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 25.5, 549, 1005, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 24, 550, 525, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 1028, 550, 525, 2.94, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store.pages[1]?.addElement(secondPageBorders);
    store.pages[1]?.addElement(safetyBordersTextSecond);
    // Clear history
    store.history.clear();
};



const $8abd9ca5a7d3f40b$export$8802baeb156c27d4 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -15, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 24, 22, 480, 3, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 24, 792, 480, 3, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 22, 793, 770, 3, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 503, 793, 770, 3, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    // Clear history
    store.history.clear();
};



const $90f2930e9440f799$export$b0f0628dd0adaff9 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -15, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 24, 22, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 24, 1028, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 22, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 790, 1030, 1006, 3.85, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    // Clear history
    store.history.clear();
};
const $90f2930e9440f799$export$8fcd3c8cb76a6cd6 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -15, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 24, 23, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 24, 1030, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 22, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 790, 1030, 1006, 3.85, -90)
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    // Clear history
    store.history.clear();
};



const $379854e433b85d91$export$836bdd749e55e830 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -8.29, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const safetyLineTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-1-${randomizedId}`, 880, -10.5, 600, "Fold Line", 90);
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 25.96, 24.58, 1676, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 25.96, 551.74, 1676, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 24.5, 553.349, 527.167, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 1700.5, 555.22, 528, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-1-${randomizedId}`, 863, 580, 580, 2, -90, "rgba(208,2,27,1)")
        ]
    };
    const safetyBordersTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-2-${randomizedId}`, -8.616, 5.09, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const safetyLineTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-2-${randomizedId}`, 880, -10.5, 600, "Fold Line", 90);
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 25.96, 24.58, 1676, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 25.96, 551.74, 1676, 2.94, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 24.5, 553.349, 527.167, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 1700.5, 555.22, 528, 2.94, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-2-${randomizedId}`, 863, 580, 580, 2, -90, "rgba(208,2,27,1)")
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store?.pages[0]?.addElement(safetyLineTextFirst);
    store.pages[1]?.addElement(secondPageBorders);
    store.pages[1]?.addElement(safetyBordersTextSecond);
    store?.pages[1]?.addElement(safetyLineTextSecond);
    // Clear history
    store.history.clear();
};



const $1199e4569f08e8c9$export$38e08353ae08f443 = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -8.29, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const safetyLineTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-1-${randomizedId}`, -2, 366, 866, "Fold Line", 0);
    const safetySecondLineTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-2-${randomizedId}`, -2, 744, 866, "Fold Line", 0);
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 26, 23.5, 811, 4, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 26, 1123.6, 811, 4, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 24.16, 1125, 1100, 4, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 835, 1125, 1100, 4, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-1-${randomizedId}`, 866, 384, 866, 2, 180, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-2-${randomizedId}`, 866, 763, 866, 2, 180, "rgba(208,2,27,1)")
        ]
    };
    const safetyBordersTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-2-${randomizedId}`, -8.29, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const safetyLineTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-2-1-${randomizedId}`, -2, 366, 866, "Fold Line", 0);
    const safetySecondLineTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-2-2-${randomizedId}`, -2, 744, 866, "Fold Line", 0);
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 26, 23.5, 811, 4, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 26, 1123.6, 811, 4, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 24.16, 1125, 1100, 4, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 835, 1125, 1100, 4, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-2-1-${randomizedId}`, 866, 384, 866, 2, 180, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-2-2-${randomizedId}`, 866, 763, 866, 2, 180, "rgba(208,2,27,1)")
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store?.pages[0]?.addElement(safetyLineTextFirst);
    store?.pages[0]?.addElement(safetySecondLineTextFirst);
    store.pages[1]?.addElement(secondPageBorders);
    store.pages[1]?.addElement(safetyBordersTextSecond);
    store.pages[1]?.addElement(safetyLineTextSecond);
    store.pages[1]?.addElement(safetySecondLineTextSecond);
    // Clear history
    store.history.clear();
};



const $80373c44f2430393$export$a788c6c6398866cf = (store)=>{
    const randomizedId = Math.random().toString(36).substring(2, 7);
    const safetyBordersTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-text-1-${randomizedId}`, -15, 5.81, 543, "Keep important text/images inside the green line. Content beyond this line may be trimmed during production.");
    const safetyBordersInsidePanel = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`inside-panel-${randomizedId}`, 817, 663.72, 410, "Inside Panel", 90, 18);
    const safetyBordersOutsideFrontPanel = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`outside-front-panel-${randomizedId}`, 817, 321, 410, "Outside Front Panel", 90, 18);
    const safetyBordersOutsideBackPanel = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`outside-back-panel-${randomizedId}`, 817, 20.2, 410, "Outside Back Panel", 90, 18);
    const safetyLineTextFirst = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-4-${randomizedId}`, -25.2, 334.9, 866, "Fold Line", 0, 14);
    const safetyLineTextSecond = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-5-${randomizedId}`, -25.2, 685, 866, "Fold Line", 0, 14);
    const safetyLineTextThird = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-6-${randomizedId}`, -25.2, 745, 866, "Perforated Fold Line (Detachable Section)", 0, 14);
    const safetyLineTextFourth = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-1-${randomizedId}`, 840, 783, 866, "Perforated Fold Line (Detachable Section)", 180, 14);
    const safetyLineTextFifth = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-2-${randomizedId}`, 840, 721, 866, "Fold Line", 180, 14);
    const safetyLineTextSixth = (0, $717432aee8737b76$export$95d1eb3b83c09bfc)(`safety-line-3-${randomizedId}`, 840, 365, 866, "Fold Line", 180, 14);
    const firstPageBorders = {
        id: `safety-border-1-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-1-${randomizedId}`, 24, 22, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-1-${randomizedId}`, 24, 1028, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-1-${randomizedId}`, 22, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-1-${randomizedId}`, 790, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-1-${randomizedId}`, 840.8, 353.92, 866, 2, 180, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-2-${randomizedId}`, 840.8, 703, 866, 2, 180, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-3-${randomizedId}`, 840.8, 765.4, 866, 2, 180, "rgba(208,2,27,1)")
        ]
    };
    const secondPageBorders = {
        id: `safety-border-2-${randomizedId}`,
        type: "group",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: false,
        children: [
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`top-2-${randomizedId}`, 24, 22, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`bottom-2-${randomizedId}`, 24, 1028, 768, 3.85, 0),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`left-2-${randomizedId}`, 22, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`right-2-${randomizedId}`, 790, 1030, 1006, 3.85, -90),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-4-${randomizedId}`, -25, 765.4, 866, 2, 0, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-5-${randomizedId}`, -25, 703, 866, 2, 0, "rgba(208,2,27,1)"),
            (0, $717432aee8737b76$export$d0f8ccadd3e82b0a)(`fold-line-6-${randomizedId}`, -25, 347, 866, 2, 0, "rgba(208,2,27,1)")
        ]
    };
    // Add elements to the pages
    store.pages[0]?.addElement(firstPageBorders);
    store?.pages[0]?.addElement(safetyBordersTextFirst);
    store?.pages[0]?.addElement(safetyLineTextFirst);
    store?.pages[0]?.addElement(safetyLineTextSecond);
    store?.pages[0]?.addElement(safetyLineTextThird);
    store.pages[1]?.addElement(secondPageBorders);
    store?.pages[1]?.addElement(safetyBordersTextFirst);
    store?.pages[1]?.addElement(safetyBordersInsidePanel);
    store?.pages[1]?.addElement(safetyBordersOutsideFrontPanel);
    store?.pages[1]?.addElement(safetyBordersOutsideBackPanel);
    store?.pages[1]?.addElement(safetyLineTextFourth);
    store?.pages[1]?.addElement(safetyLineTextFifth);
    store?.pages[1]?.addElement(safetyLineTextSixth);
    // Clear history
    store.history.clear();
};


const $39231ae325c5aacf$export$b8070c2bd9d59c10 = (productId, store)=>{
    if (!productId) return;
    if (+productId === 13) (0, $7ebf274b17417b89$export$2978a94ed9e6116d)(store);
    else if (+productId === 14) (0, $7ebf274b17417b89$export$8817d1032c829c5a)(store);
    else if (+productId === 15) (0, $7ebf274b17417b89$export$bfb27578a2deeca5)(store);
    else if (+productId === 5) (0, $8abd9ca5a7d3f40b$export$8802baeb156c27d4)(store);
    else if (+productId === 4) (0, $90f2930e9440f799$export$b0f0628dd0adaff9)(store);
    else if (+productId === 2) (0, $90f2930e9440f799$export$8fcd3c8cb76a6cd6)(store);
    else if (+productId === 9) (0, $379854e433b85d91$export$836bdd749e55e830)(store);
    else if (+productId === 11) (0, $1199e4569f08e8c9$export$38e08353ae08f443)(store);
    else if (+productId === 18) (0, $80373c44f2430393$export$a788c6c6398866cf)(store);
};


const $ad01ab85e9f42d02$export$c957b57e52c8dfb1 = {
    "Postcards-": true,
    "Tri-Fold Self-Mailers-": true,
    "Bi-Fold Self-Mailers-": true,
    "Personal Letters-": true,
    "Snap Pack Mailers-": true,
    "Professional Letters-#10 Double-Window": true,
    "Professional Letters-#10 Grey": true
};
const $ad01ab85e9f42d02$export$dc2daac47827fb7f = [
    "Postcards",
    "Snap Pack Mailers",
    "Tri-Fold Self-Mailers",
    "Bi-Fold Self-Mailers"
];
const $ad01ab85e9f42d02$export$dcaac635f59e4181 = [
    {
        id: 1,
        label: "Windowed Envelope",
        type: "#10 Double-Window",
        productId: 2
    },
    {
        id: 2,
        label: "Non-Windowed Envelope",
        type: "#10 Grey",
        productId: 4
    }
];
const $ad01ab85e9f42d02$export$c706fc9cfb842dce = async (url, returnType = "json")=>{
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return returnType === "json" ? $ad01ab85e9f42d02$var$blobToJSON(blob) : $ad01ab85e9f42d02$export$c6adc95df13c8b9e(blob);
    } catch (error) {
        throw error; // Optionally rethrow the error for further handling
    }
};
const $ad01ab85e9f42d02$var$blobToJSON = (jsonBlob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function() {
            try {
                // Parse the result as JSON
                const parsedData = JSON.parse(reader.result);
                // Resolve the promise with the parsed JSON data
                resolve(parsedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = function(error) {
            reject(error);
        };
        reader.readAsText(jsonBlob);
    });
};
const $ad01ab85e9f42d02$export$c6adc95df13c8b9e = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = function() {
            // The result property contains the data as a string
            const blobString = reader.result;
            // Resolve the Promise with the blobString
            resolve(blobString);
        };
        reader.onerror = function(error) {
            reject(error);
        };
        reader.readAsText(blob);
    });
};
const $ad01ab85e9f42d02$export$3c4ee5ffa62bdd4b = (title, url)=>{
    const link = document.createElement("a");
    link.href = url;
    link.download = title + ".pdf";
    // Append the link to the document
    document.body.appendChild(link);
    // Trigger a click on the link
    link.click();
    // Remove the link from the document
    document.body.removeChild(link);
};
const $ad01ab85e9f42d02$export$8029e38c28541a = (store, product, envelopeType)=>{
    const barcodeSrc = ((0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "local" || (0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "staging" ? (0, $7ad22e5ca6c288ca$export$dc8c2e2c228d4170) : (0, $717432aee8737b76$export$d97320b3491da14)() ? (0, $7ad22e5ca6c288ca$export$31ebffddc71c8253) : (0, $7ad22e5ca6c288ca$export$79361813a10e9e28)) + (0, $7ad22e5ca6c288ca$export$7a42bc549c2355e6);
    if ($ad01ab85e9f42d02$export$c957b57e52c8dfb1[`${product.productType}-${envelopeType}`]) {
        if (product.productType === "Professional Letters" && envelopeType === "#10 Double-Window") (0, $11132e13d1f7bacf$export$fe83566325f1e1e8)(store, barcodeSrc);
        else if (product.productType === "Professional Letters" && envelopeType === "#10 Grey") (0, $563d98d6370280e4$export$e15fac5e99e10d2e)(store);
        else if (product.productType === "Personal Letters") (0, $3daa42fe982b7b66$export$64e7783251b1b98f)(store);
        else if (product.productType === (0, $7ad22e5ca6c288ca$export$3e994a540f8ee57)[0]) (0, $58150108dfd76800$export$485ca3438dfa1819)(store, [
            3.2835,
            2.375
        ], barcodeSrc);
        else if (product.productType === (0, $7ad22e5ca6c288ca$export$3e994a540f8ee57)[1]) (0, $61207d508899f18f$export$c3fe419eb223f4c8)(store, [
            3.2835,
            2.375
        ], barcodeSrc);
        else if (product.productType === (0, $7ad22e5ca6c288ca$export$3e994a540f8ee57)[2]) (0, $9d201cd516e32817$export$5f13a51c7a156d51)(store, [
            3.2835,
            2.375
        ], barcodeSrc);
        else if (product.productType === (0, $7ad22e5ca6c288ca$export$3e994a540f8ee57)[3]) (0, $c79c0a196e41fb4d$export$b246bdddcbce0297)(store, barcodeSrc);
        (0, $39231ae325c5aacf$export$b8070c2bd9d59c10)(product?.id, store);
    }
};
const $ad01ab85e9f42d02$export$464e4dcbf779d16c = (jsonData)=>{
    const fontFamilies = [];
    // Iterate through each object in the JSON data
    jsonData.forEach((obj)=>{
        if (obj.children) obj.children.forEach((child)=>{
            if (child.type === "text" && child.fontFamily) // Extract font family from text objects
            fontFamilies.push(child.fontFamily);
        });
    });
    return fontFamilies;
};
const $ad01ab85e9f42d02$export$d5a1fddcf19adead = (jsonData)=>{
    let clonedData = JSON.parse(JSON.stringify(jsonData));
    const updatedJson = clonedData.pages.map((obj)=>{
        if (obj.children) obj.children = obj.children.map((child)=>{
            if (child.type === "text" && typeof child.text === "string") {
                const cleanedText = (0, $717432aee8737b76$export$cb0bbc88c7f09596)(child.text);
                child.text = cleanedText.replace(/[{}\[\]]/g, "");
            }
            return child;
        });
        return obj;
    });
    clonedData.pages = updatedJson;
    return clonedData;
};
const $ad01ab85e9f42d02$export$12a8f0948c807d25 = (jsonData)=>{
    let clonedData = JSON.parse(JSON.stringify(jsonData));
    const updatedJson = clonedData.pages.map((obj)=>{
        if (obj.children) obj.children = obj.children.map((child)=>{
            if (child?.custom?.replaceBg) {
                child.fill = "white";
                child.strokeWidth = 0;
            }
            return child;
        });
        return obj;
    });
    clonedData.pages = updatedJson;
    return clonedData;
};
const $ad01ab85e9f42d02$export$235f8e1ceb01c6a5 = (pages)=>{
    const hasMultipleGSV = (children)=>children.filter(({ custom: custom })=>custom?.elementType === "GOOGLE_STREET_VIEW").length > 1;
    for (const page of pages){
        if (hasMultipleGSV(page.children)) return false;
    }
    return true;
};
const $ad01ab85e9f42d02$export$a1da92a5104ba69f = (pages)=>{
    const textElements = (children)=>children.filter(({ type: type, text: text })=>type === "text" && (0, $7ad22e5ca6c288ca$export$668f6b29ff2ac480).test(text));
    for (const page of pages){
        if (textElements(page.children).length) return true;
    }
    return false;
};
const $ad01ab85e9f42d02$export$fc87fb251908c0d1 = (pages)=>{
    const QRElements = (children)=>children.filter(({ name: name, custom: custom })=>name === "qr" && custom.value === "");
    for (const page of pages){
        if (QRElements(page.children).length) return false;
    }
    return true;
};


// src/components/Grid.js



const $d020db196be2fc6a$var$breakpoints = {
    xs: "0px",
    sm: "600px",
    md: "960px",
    lg: "1280px",
    xl: "1920px"
};
const $d020db196be2fc6a$var$Container = (0, $lt6Ts$styledcomponents).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;
const $d020db196be2fc6a$var$Col = (0, $lt6Ts$styledcomponents).div`
  padding: 0 8px;
  box-sizing: border-box;
  ${(props)=>props.xs && `flex: 0 0 ${props.xs / 12 * 100}%; 
    max-width: ${props.xs / 12 * 100}%;`}
  @media (min-width: ${$d020db196be2fc6a$var$breakpoints.sm}) {
    ${(props)=>props.sm && `flex: 0 0 ${props.sm / 12 * 100}%; 
      max-width: ${props.sm / 12 * 100}%;`}
  }
  @media (min-width: ${$d020db196be2fc6a$var$breakpoints.md}) {
    ${(props)=>props.md && `flex: 0 0 ${props.md / 12 * 100}%; 
      max-width: ${props.md / 12 * 100}%;`}
  }
  @media (min-width: ${$d020db196be2fc6a$var$breakpoints.lg}) {
    ${(props)=>props.lg && `flex: 0 0 ${props.lg / 12 * 100}%; 
      max-width: ${props.lg / 12 * 100}%;`}
  }
  @media (min-width: ${$d020db196be2fc6a$var$breakpoints.xl}) {
    ${(props)=>props.xl && `flex: 0 0 ${props.xl / 12 * 100}%; 
      max-width: ${props.xl / 12 * 100}%;`}
  }
`;
const $d020db196be2fc6a$export$cc55614734af2d87 = ({ children: children, style: style = {} })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)($d020db196be2fc6a$var$Container, {
        style: style,
        children: children
    });
};
const $d020db196be2fc6a$export$9eb849b9b922d396 = ({ xs: xs, sm: sm, md: md, lg: lg, xl: xl, children: children })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)($d020db196be2fc6a$var$Col, {
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        children: children
    });
};





const $5a8c8921b86c6a58$var$Typography = ({ children: children = "", style: style = {}, variant: variant = "p", className: className = "" })=>{
    const Tag = variant || "p";
    return /*#__PURE__*/ (0, $lt6Ts$jsx)(Tag, {
        className: className,
        style: style,
        children: children
    });
};
var $5a8c8921b86c6a58$export$2e2bcd8739ae039 = $5a8c8921b86c6a58$var$Typography;





const $468b2e43c10c77f3$var$Button = ({ children: children = "", style: style = {}, onClick: onClick, className: className = "", disabled: disabled = false, backdrop: backdrop = true })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: `basic-button ${className} ${disabled ? "disabled" : ""}`,
            onClick: disabled ? undefined : onClick,
            style: style,
            children: [
                children,
                backdrop && /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                    className: "backdrop"
                })
            ]
        })
    });
};
var $468b2e43c10c77f3$export$2e2bcd8739ae039 = $468b2e43c10c77f3$var$Button;







const $30b6a7f5fffc5164$var$selectCancel = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 -960 960 960",
        width: "24px",
        fill: "#44424180",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
        })
    });
};
var $30b6a7f5fffc5164$export$2e2bcd8739ae039 = $30b6a7f5fffc5164$var$selectCancel;




const $3f4ef87f7a4a530a$var$colourStyles = {
    dropdownIndicator: (styles, { isFocused: isFocused, selectProps: selectProps })=>({
            ...styles,
            color: isFocused && selectProps.menuIsOpen ? "var(--primary-color)" : "grey",
            transform: !isFocused && !selectProps.menuIsOpen ? "rotate(0deg)" : "rotate(180deg)"
        }),
    option: (styles, { isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        return {
            ...styles,
            backgroundColor: isDisabled ? undefined : isSelected && isFocused ? "var(--secondary-color)" : isFocused && !isSelected ? "var(--secondary-color)" : undefined
        };
    }
};
const $3f4ef87f7a4a530a$var$errorStyles = {
    color: "var(--error-color)",
    fontWeight: "400"
};
const $3f4ef87f7a4a530a$var$ClearIndicator = (props)=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$components).ClearIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $30b6a7f5fffc5164$export$2e2bcd8739ae039), {})
    });
};
const $3f4ef87f7a4a530a$var$GeneralSelect = ({ options: options, placeholder: placeholder, error: error, label: label, isError: isError, selectedValue: selectedValue, setSelectedValue: setSelectedValue, builderSelect: builderSelect, gallerySelect: gallerySelect = false, clearField: clearField, qrField: qrField = false, search: search = false })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: "select-layout",
        style: {
            display: gallerySelect ? "block" : "flex"
        },
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                children: label && label
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$reactselect), {
                value: selectedValue,
                options: options,
                onChange: setSelectedValue,
                styles: $3f4ef87f7a4a530a$var$colourStyles,
                className: `generic-select-container ${builderSelect && "template-select"} ${gallerySelect && "gallery-select"} ${qrField && "qr-select"}`,
                classNamePrefix: "generic-select",
                placeholder: placeholder,
                blurInputOnSelect: true,
                isClearable: clearField,
                components: {
                    ClearIndicator: $3f4ef87f7a4a530a$var$ClearIndicator
                },
                isSearchable: search
            }),
            isError && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                variant: "p",
                style: $3f4ef87f7a4a530a$var$errorStyles,
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("sup", {
                        children: "*"
                    }),
                    error
                ]
            })
        ]
    });
};
var $3f4ef87f7a4a530a$export$2e2bcd8739ae039 = $3f4ef87f7a4a530a$var$GeneralSelect;









const $fb8d63cd819e9d3d$var$Cross = (props)=>{
    const { toast: toast } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.11597 10.866C2.11597 8.40681 3.09286 6.04839 4.83173 4.30951C6.57061 2.57064 8.92903 1.59375 11.3882 1.59375C13.8473 1.59375 16.2057 2.57064 17.9446 4.30951C19.6835 6.04839 20.6604 8.40681 20.6604 10.866C20.6604 13.3251 19.6835 15.6835 17.9446 17.4224C16.2057 19.1613 13.8473 20.1382 11.3882 20.1382C8.92903 20.1382 6.57061 19.1613 4.83173 17.4224C3.09286 15.6835 2.11597 13.3251 2.11597 10.866ZM11.3882 2.92375C9.28176 2.92375 7.26164 3.76052 5.77218 5.24997C4.28273 6.73942 3.44597 8.75955 3.44597 10.866C3.44597 12.9724 4.28273 14.9925 5.77218 16.4819C7.26164 17.9714 9.28176 18.8082 11.3882 18.8082C13.4946 18.8082 15.5147 17.9714 17.0042 16.4819C18.4936 14.9925 19.3304 12.9724 19.3304 10.866C19.3304 8.75955 18.4936 6.73942 17.0042 5.24997C15.5147 3.76052 13.4946 2.92375 11.3882 2.92375ZM14.6838 7.57175C14.815 7.70302 14.8887 7.88104 14.8887 8.06665C14.8887 8.25227 14.815 8.43028 14.6838 8.56155L12.378 10.866L14.6838 13.1704C14.8152 13.3018 14.8891 13.4801 14.8891 13.666C14.8891 13.8518 14.8152 14.0301 14.6838 14.1616C14.5523 14.293 14.3741 14.3668 14.1882 14.3668C14.0023 14.3668 13.824 14.293 13.6926 14.1616L11.3882 11.8558L9.08377 14.1616C9.01868 14.2266 8.94142 14.2783 8.85638 14.3135C8.77135 14.3487 8.68021 14.3668 8.58817 14.3668C8.49613 14.3668 8.40499 14.3487 8.31995 14.3135C8.23492 14.2783 8.15765 14.2266 8.09257 14.1616C8.02748 14.0965 7.97586 14.0192 7.94063 13.9342C7.90541 13.8491 7.88728 13.758 7.88728 13.666C7.88728 13.5739 7.90541 13.4828 7.94063 13.3977C7.97586 13.3127 8.02748 13.2354 8.09257 13.1704L10.3984 10.866L8.09257 8.56155C7.96113 8.43011 7.88728 8.25184 7.88728 8.06595C7.88728 7.88006 7.96113 7.70179 8.09257 7.57035C8.22401 7.43891 8.40228 7.36507 8.58817 7.36507C8.77405 7.36507 8.95233 7.43891 9.08377 7.57035L11.3882 9.87615L13.6926 7.57035C13.7576 7.50516 13.8348 7.45344 13.9199 7.41815C14.0049 7.38286 14.0961 7.3647 14.1882 7.3647C14.2802 7.3647 14.3714 7.38286 14.4565 7.41815C14.5415 7.45344 14.6187 7.50656 14.6838 7.57175Z",
            fill: toast ? `#fff` : `var(--text-color)`
        })
    });
};
var $fb8d63cd819e9d3d$export$2e2bcd8739ae039 = $fb8d63cd819e9d3d$var$Cross;



const $49857baad0b39325$var$GenericSnackbar = ()=>{
    const open = (0, $lt6Ts$useSelector)((state)=>state.snackbarReducers.snackbar.open);
    const heading = (0, $lt6Ts$useSelector)((state)=>state.snackbarReducers.snackbar.heading);
    const message = (0, $lt6Ts$useSelector)((state)=>state.snackbarReducers.snackbar.message);
    const dispatch = (0, $lt6Ts$useDispatch)();
    const snackbar = (0, $lt6Ts$useSelector)((state)=>state.snackbarReducers.snackbar); // Adjust this based on your root reducer
    const Toast = ({ snackMessage: snackMessage, snackHeading: snackHeading, type: type, onClose: onClose, onPauseHover: onPauseHover })=>{
        const [animateOut, setAnimateOut] = (0, $lt6Ts$useState)(false); // Control when to start exit animation
        (0, $lt6Ts$useEffect)(()=>{
            // Automatically trigger exit after 3 seconds
            const autoCloseTimer = setTimeout(()=>{
                setAnimateOut(true); // Start exit animation
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$5a5bdcd828e4c856)
                });
            }, 3000);
            // Fully remove the toast after exit animation finishes
            const removeTimer = setTimeout(()=>{
                onClose();
            }, 3500); // 3.5s allows the exit animation to complete
            return ()=>{
                clearTimeout(autoCloseTimer);
                clearTimeout(removeTimer);
            };
        }, [
            open,
            onClose
        ]);
        return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: `toast ${type} ${animateOut ? "slideOut" : "slideIn"}`,
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "toastContent",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                            children: snackHeading || "Notifications"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("p", {
                            children: snackMessage || (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).GENERAL_ERROR
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("button", {
                    className: "closeIcon",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $fb8d63cd819e9d3d$export$2e2bcd8739ae039), {
                        toast: true
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: `toast-container ${!open && "noToast"}`,
            children: open && /*#__PURE__*/ (0, $lt6Ts$jsx)(Toast, {
                snackMessage: message,
                snackHeading: heading,
                type: snackbar.status,
                onClose: ()=>dispatch({
                        type: (0, $e496cac0faa1ff17$export$5a5bdcd828e4c856)
                    }),
                onPauseHover: true
            })
        })
    });
};
var $49857baad0b39325$export$2e2bcd8739ae039 = $49857baad0b39325$var$GenericSnackbar;







const $7d1ce187c1ab3d01$var$GeneralTooltip = ({ anchorSelect: anchorSelect, place: place, title: title, className: className })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Tooltip), {
        className: `basic-tooltip ${className}`,
        anchorSelect: anchorSelect,
        place: place,
        children: title
    });
};
var $7d1ce187c1ab3d01$export$2e2bcd8739ae039 = $7d1ce187c1ab3d01$var$GeneralTooltip;




const $a3dccc8cd7537679$var$postcard = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "61",
        height: "46",
        viewBox: "0 0 61 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1099_4254)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M3.01993 0.916016C1.35375 0.916016 -0.0231934 2.28696 -0.0231934 3.95313V42.4514C-0.0231934 44.1176 1.35375 45.4865 3.01993 45.4865H57.723C59.3892 45.4865 60.7602 44.1176 60.7602 42.4514V3.95313C60.7602 2.28696 59.3892 0.916016 57.723 0.916016H3.01993ZM3.01993 2.94403H57.723C58.3018 2.94403 58.7341 3.3744 58.7341 3.95313V42.4514C58.7341 43.0301 58.3018 43.4605 57.723 43.4605H3.01993C2.4412 43.4605 2.00292 43.0301 2.00292 42.4514V3.95313C2.00292 3.3744 2.4412 2.94403 3.01993 2.94403ZM29.3594 8.00542V38.3971C29.3284 39.7785 31.4165 39.7785 31.3855 38.3971V8.00542C31.3855 6.68607 29.3594 6.6253 29.3594 8.00542ZM42.5272 6.98838C41.9646 6.98623 41.508 7.44284 41.5102 8.00542V11.3691C40.2276 10.9301 39.0104 10.9747 38.0713 11.2148C36.7206 11.5601 35.8196 12.2753 35.8196 12.2753C34.6686 13.1009 36.0084 14.7932 37.0761 13.8622C37.0761 13.8622 37.6472 13.418 38.5719 13.1816C39.4966 12.9453 40.6592 12.9059 42.0345 13.8919C43.8966 15.2272 45.7767 15.2731 47.0899 14.9227C48.4031 14.5724 49.2585 13.8385 49.2585 13.8385C50.4446 12.9828 48.9866 11.2668 47.9506 12.2991C47.9506 12.2991 47.4328 12.7325 46.5656 12.9639C45.7673 13.1768 44.7699 13.2196 43.5383 12.4534V9.01464H52.6617V21.1753H43.5383V18.7573C44.872 19.27 46.1322 19.2325 47.0899 18.9771C48.4031 18.6268 49.2585 17.8929 49.2585 17.8929C50.4247 17.0348 48.9871 15.3406 47.9506 16.3515C47.9506 16.3515 47.4328 16.7869 46.5656 17.0183C45.6983 17.2495 44.5986 17.2916 43.2157 16.3C41.346 14.9593 39.422 14.9219 38.0713 15.2672C36.7206 15.6125 35.8196 16.3297 35.8196 16.3297C34.6411 17.1513 36.0073 18.8746 37.0761 17.9146C37.0761 17.9146 37.6472 17.4704 38.5719 17.234C39.3769 17.0284 40.3614 16.9744 41.5102 17.6138V22.1845C41.508 22.747 41.9646 23.2035 42.5272 23.2014H53.6708C54.2303 23.1991 54.682 22.7439 54.6799 22.1845V8.00554C54.682 7.44606 54.2303 6.99083 53.6708 6.98861L42.5272 6.98838ZM11.1185 17.121C9.76639 17.121 9.76639 19.149 11.1185 19.149H24.2882C25.6402 19.149 25.6402 17.121 24.2882 17.121H11.1185ZM7.07414 22.1842C5.6931 22.1536 5.6931 24.241 7.07414 24.2104H17.1988C18.5199 24.1797 18.5199 22.2136 17.1988 22.1842H7.07414ZM21.253 22.1842C19.8719 22.1536 19.8719 24.241 21.253 24.2104H24.2882C25.6093 24.1797 25.6093 22.2136 24.2882 22.1842H21.253ZM7.07414 29.2816H24.2882C25.6693 29.3122 25.6693 27.2248 24.2882 27.2556H7.02171C5.64946 27.3532 5.75127 29.3209 7.07414 29.2816ZM36.4488 29.2816H53.6708C55.0519 29.3122 55.0519 27.2248 53.6708 27.2556H36.4004C35.0327 27.3486 35.1268 29.3151 36.4488 29.2816ZM36.4488 32.3168C35.0968 32.3168 35.0968 34.3448 36.4488 34.3448H53.6708C55.0229 34.3448 55.0229 32.3168 53.6708 32.3168H36.4488ZM36.4488 37.3801C35.1277 37.4107 35.1277 39.3769 36.4488 39.4062H53.6708C54.9919 39.3756 54.9919 37.4094 53.6708 37.3801H36.4488Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M52.6578 9.01953H43.5403V21.1762H52.6578V9.01953Z",
                        fill: fill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1099_4254",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "61",
                        height: "46",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $a3dccc8cd7537679$export$2e2bcd8739ae039 = $a3dccc8cd7537679$var$postcard;




const $46ab710e0dcc7cb7$var$PersonalLetter = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "54",
        height: "53",
        viewBox: "0 0 54 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1099_4261)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M20.6226 12.4552L16.0639 14.4813L11.5051 12.9617L9.479 10.429L8.46594 8.90945L7.45288 5.87028L7.95941 3.84417L8.97247 1.81805L10.4921 1.31152H12.5182L14.5443 2.32458L16.0639 3.33764L17.0769 2.32458L19.103 1.81805L21.1292 1.31152L23.1553 2.83111L24.1683 6.37681L23.1553 9.41598L20.6226 12.4552Z",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M47.1776 24.1329L4.18954 15.8659C3.86133 15.8026 3.51449 15.9689 3.35789 16.2642C3.2013 16.5594 3.2583 16.9397 3.49463 17.1761L10.713 24.3944V40.6188C10.713 41.1689 11.298 41.5508 11.802 41.3283L23.8394 36.0093L25.8519 37.8781C26.102 38.1103 26.4857 38.1503 26.7786 37.9749L37.8497 31.3323C38.217 31.1118 38.3361 30.6355 38.1157 30.2681C37.8953 29.9007 37.4189 29.7816 37.0517 30.0021L26.4804 36.3448L16.6705 27.2357L43.998 25.8343L40.1438 28.1467C39.7764 28.3672 39.6573 28.8434 39.8778 29.2108C40.0232 29.4532 40.2801 29.5874 40.5436 29.5874C40.6794 29.5874 40.817 29.5517 40.942 29.4769L47.4609 25.5656C48.0658 25.2044 47.8866 24.2342 47.1776 24.1329ZM22.6021 34.8601L12.6006 39.2794L15.2474 28.0306L22.6021 34.8601ZM14.758 25.7803C14.4174 25.8004 14.1216 26.0442 14.0427 26.3772L12.2641 33.9362V24.8669L26.2348 25.1918L14.758 25.7803ZM11.8173 23.305L6.37891 17.8665L37.8009 23.9091L11.8173 23.305Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M49.6958 36.6144C48.9136 36.0813 46.1967 34.6911 42.7717 38.0372C39.3468 34.6911 36.63 36.0813 35.8476 36.6144C33.587 38.1551 32.9008 41.5309 34.2854 44.3C36.7978 49.3251 42.2937 51.2052 42.5264 51.2826C42.6847 51.3355 42.8587 51.3355 43.0169 51.2826C43.2495 51.205 48.7454 49.325 51.258 44.3C52.6426 41.5309 51.9563 38.1551 49.6958 36.6144ZM49.8707 43.6062C47.9319 47.4839 43.815 49.3088 42.7709 49.7196C41.7251 49.3104 37.6179 47.4968 35.6727 43.6062C34.5221 41.3049 35.321 38.8505 36.7211 37.8962C37.1979 37.5711 37.7206 37.4113 38.2737 37.4113C39.4897 37.4113 40.8522 38.1845 42.195 39.6765C42.4985 40.0138 43.0445 40.0138 43.348 39.6765C45.3018 37.5057 47.2972 36.8567 48.822 37.8962C50.2224 38.8505 51.0213 41.3049 49.8707 43.6062Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M22.7034 1.04121C21.9211 0.50804 19.2042 -0.882088 15.7793 2.46395C12.3542 -0.882088 9.63734 0.508143 8.85518 1.04121C6.59462 2.58186 5.90835 5.95774 7.29292 8.72678C9.80536 13.7519 15.3013 15.6319 15.534 15.7094C15.6922 15.7623 15.8662 15.7623 16.0245 15.7094C16.2571 15.6318 21.753 13.7518 24.2655 8.72678C25.6501 5.95774 24.9638 2.58186 22.7034 1.04121ZM22.8782 8.03301C20.9393 11.9107 16.8225 13.7356 15.7785 14.1464C14.7327 13.7372 10.6255 11.9236 8.68027 8.03301C7.52967 5.7317 8.3286 3.27729 9.72871 2.323C10.2055 1.99787 10.7283 1.83808 11.2814 1.83808C12.4973 1.83808 13.8599 2.61129 15.2027 4.10328C15.5062 4.44055 16.0521 4.44055 16.3557 4.10328C18.3094 1.93253 20.3048 1.28361 21.8296 2.323C23.23 3.27729 24.0289 5.7317 22.8782 8.03301Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M11.8118 44.2896C10.8738 43.6502 9.3821 43.5235 7.82611 44.8817C6.27002 43.5235 4.77845 43.6505 3.84041 44.2896C2.4615 45.2294 2.03502 47.2727 2.86935 48.9415C4.30825 51.8191 7.44789 52.8933 7.58093 52.9377C7.73917 52.9905 7.91315 52.9905 8.0714 52.9377C8.20443 52.8933 11.3441 51.8192 12.783 48.9415C13.6172 47.2727 13.1906 45.2294 11.8118 44.2896ZM11.3954 48.2478C10.4554 50.1278 8.50857 51.083 7.82457 51.3706C7.13943 51.0851 5.20214 50.139 4.2566 48.2478C3.7119 47.1585 4.06985 46.0103 4.71373 45.5715C4.91158 45.4366 5.13074 45.3704 5.36584 45.3704C5.93101 45.3704 6.58682 45.7538 7.24942 46.4902C7.55294 46.8274 8.09887 46.8274 8.40239 46.4902C9.34073 45.4476 10.2652 45.1126 10.9381 45.5715C11.5823 46.0103 11.9401 47.1584 11.3954 48.2478Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M46.5577 8.71538C45.6196 8.07603 44.128 7.94917 42.572 9.30751C41.0159 7.94927 39.5243 8.07634 38.5863 8.71538C37.2073 9.65517 36.7809 11.6985 37.6152 13.3673C39.054 16.245 42.1937 17.3192 42.3267 17.3635C42.4849 17.4164 42.6589 17.4164 42.8171 17.3635C42.9502 17.3191 46.0899 16.245 47.5287 13.3673C48.3631 11.6985 47.9366 9.65517 46.5577 8.71538ZM46.1414 12.6737C45.2014 14.5537 43.2546 15.5089 42.5705 15.7965C41.8854 15.511 39.9481 14.5649 39.0025 12.6737C38.4578 11.5844 38.8157 10.4362 39.4597 9.99737C39.6575 9.86249 39.8767 9.79633 40.1118 9.79633C40.677 9.79633 41.3328 10.1797 41.9954 10.9161C42.2989 11.2533 42.8448 11.2533 43.1483 10.9161C44.0867 9.87339 45.011 9.53849 45.684 9.99737C46.3281 10.4362 46.6861 11.5843 46.1414 12.6737Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1099_4261",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "52.679",
                        height: "52.679",
                        fill: "white",
                        transform: "translate(0.868164 0.297852)"
                    })
                })
            })
        ]
    });
};
var $46ab710e0dcc7cb7$export$2e2bcd8739ae039 = $46ab710e0dcc7cb7$var$PersonalLetter;




const $4da602e86842d002$var$ProfessionalLetter = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "51",
        height: "51",
        viewBox: "0 0 51 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1435_1353)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M48.0905 22.6074L43.9147 18.4315V5.74449C43.9147 5.20902 43.4806 4.77496 42.9451 4.77496H30.2581L26.1792 0.69606C25.8006 0.317459 25.1867 0.317459 24.808 0.69606L20.7291 4.77496H8.04215C7.50668 4.77496 7.07262 5.20902 7.07262 5.74449V18.4314L2.89677 22.6073C2.71498 22.7892 2.61279 23.0358 2.61279 23.2929V49.0824C2.61279 49.6178 3.04685 50.0519 3.58232 50.0519H21.1308C21.6662 50.0519 22.1003 49.6178 22.1003 49.0824C22.1003 48.5469 21.6662 48.1128 21.1308 48.1128H5.92305L25.4936 28.5421L45.0643 48.1128H29.8565C29.321 48.1128 28.887 48.5469 28.887 49.0824C28.887 49.6178 29.321 50.0519 29.8565 50.0519H47.405C47.9404 50.0519 48.3745 49.6178 48.3745 49.0824V23.2929C48.3745 23.0358 48.2723 22.7892 48.0905 22.6074ZM46.4354 25.6337V46.7417L35.8814 36.1876L46.4354 25.6337ZM46.0339 23.2929L43.9147 25.4121V21.1738L46.0339 23.2929ZM25.4936 2.75272L27.5159 4.77496H23.4714L25.4936 2.75272ZM4.55185 25.6337L15.1058 36.1876L4.55185 46.7417V25.6337ZM7.07262 25.4121L4.95343 23.2929L7.07262 21.1738V25.4121ZM24.8081 26.4855L16.477 34.8165L9.01167 27.3512V6.71401H41.9756V27.3511L34.5102 34.8164L26.1792 26.4854C25.8006 26.1069 25.1867 26.1069 24.8081 26.4855Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M25.4935 48.1123C25.2385 48.1123 24.9883 48.216 24.808 48.3964C24.6277 48.5767 24.5239 48.8268 24.5239 49.0818C24.5239 49.3368 24.6277 49.587 24.808 49.7673C24.9883 49.9476 25.2385 50.0514 25.4935 50.0514C25.7484 50.0514 25.9986 49.9476 26.1789 49.7673C26.3592 49.587 26.463 49.3368 26.463 49.0818C26.463 48.8268 26.3592 48.5767 26.1789 48.3964C25.9986 48.216 25.7484 48.1123 25.4935 48.1123Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M16.7356 12.1432H34.2518C34.7873 12.1432 35.2213 11.7091 35.2213 11.1736C35.2213 10.6382 34.7873 10.2041 34.2518 10.2041H16.7356C16.2002 10.2041 15.7661 10.6382 15.7661 11.1736C15.7661 11.7091 16.2002 12.1432 16.7356 12.1432Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M35.2213 16.6033C35.2213 16.0678 34.7873 15.6338 34.2518 15.6338H16.7356C16.2002 15.6338 15.7661 16.0678 15.7661 16.6033C15.7661 17.1388 16.2002 17.5728 16.7356 17.5728H34.2518C34.7873 17.5728 35.2213 17.1388 35.2213 16.6033Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M30.6323 21.0625H20.3553C19.8198 21.0625 19.3857 21.4966 19.3857 22.032C19.3857 22.5675 19.8198 23.0016 20.3553 23.0016H30.6323C31.1677 23.0016 31.6018 22.5675 31.6018 22.032C31.6018 21.4966 31.1677 21.0625 30.6323 21.0625Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M5.73926 48.0261L25.4939 28.2715L45.2485 48.0261H5.73926Z",
                        fill: fill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1435_1353",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "49.6398",
                        height: "49.6398",
                        fill: "white",
                        transform: "translate(0.673828 0.412109)"
                    })
                })
            })
        ]
    });
};
var $4da602e86842d002$export$2e2bcd8739ae039 = $4da602e86842d002$var$ProfessionalLetter;




const $d228491c12a2f715$var$realPennedLetters = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "46",
        height: "45",
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M43.6083 11.0674C31.4516 13.4987 26.0486 23.5618 24.8667 28.2894L26.8928 29.8089L27.3993 31.8351L31.9581 32.3416C31.5529 29.9102 39.556 17.1457 43.6083 11.0674Z",
                fill: fill
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M37.5168 25.0229V37.2527C37.5168 37.6095 37.812 37.8987 38.176 37.8987C38.54 37.8987 38.8351 37.6095 38.8351 37.2527V25.0229C38.8351 24.6662 38.54 24.377 38.176 24.377C37.812 24.377 37.5168 24.6662 37.5168 25.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M45.109 39.3245H14.6038C14.2398 39.3245 13.9447 39.6137 13.9447 39.9704C13.9447 41.4874 12.6853 42.7216 11.1374 42.7216C9.58938 42.7216 8.32993 41.4875 8.32993 39.9704V3.28095C8.32993 2.77152 8.1843 2.29482 7.93182 1.88856H36.7895C37.1906 1.88856 37.517 2.20835 37.517 2.60151V9.39587C37.517 9.7526 37.8121 10.0418 38.1761 10.0418C38.5401 10.0418 38.8352 9.7526 38.8352 9.39587V2.60151C38.8352 1.49609 37.9176 0.59668 36.7895 0.59668H5.59096C4.0806 0.59668 2.8519 1.8008 2.8519 3.28095V9.39587C2.8519 10.1636 2.21458 10.7883 1.4311 10.7883C1.06708 10.7883 0.771973 11.0775 0.771973 11.4342C0.771973 11.7909 1.06708 12.0801 1.4311 12.0801H4.89756C5.26157 12.0801 5.55669 11.7909 5.55669 11.4342C5.55669 11.0775 5.26157 10.7883 4.89756 10.7883H3.77204C4.02453 10.3821 4.17006 9.9053 4.17006 9.39587V3.28095C4.17006 2.51314 4.80739 1.88856 5.59087 1.88856C6.37435 1.88856 7.01168 2.51323 7.01168 3.28095V39.9704C7.01168 42.1998 8.86241 44.0135 11.1373 44.0135H41.6425C43.9173 44.0135 45.7681 42.1998 45.7681 39.9704C45.7682 39.6137 45.4731 39.3245 45.109 39.3245ZM41.6426 42.7217H14.1578C14.7013 42.1491 15.0777 41.4222 15.2103 40.6165H44.3718C44.0745 41.8228 42.9635 42.7217 41.6426 42.7217Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M27.03 22.5099C26.8501 22.82 26.9608 23.2144 27.2773 23.3907C27.5936 23.5669 27.9961 23.4585 28.176 23.1484C31.5365 17.3553 35.7787 14.4709 38.7457 13.0714C40.3955 12.2931 41.8463 11.874 42.8719 11.6501C40.4314 14.8036 34.3024 23.1773 31.4647 31.1717H27.9788C29.8509 26.8906 31.8826 23.5876 33.4692 21.3322C35.9437 17.8146 37.8972 16.0158 37.931 15.985C38.198 15.7425 38.2138 15.3337 37.9663 15.0721C37.7188 14.8105 37.3017 14.795 37.0348 15.0376C36.9519 15.113 34.9735 16.9252 32.4124 20.5584C30.9781 22.5932 29.1901 25.4605 27.4727 29.1092L25.8109 28.1399C26.1592 27.2304 26.5372 26.346 26.9375 25.5043C27.0913 25.181 26.9485 24.7967 26.6186 24.6459C26.2886 24.4952 25.8965 24.6353 25.7427 24.9585C25.2528 25.9888 24.7953 27.0799 24.3833 28.2017C24.2764 28.4928 24.3951 28.8174 24.6664 28.9756L26.9297 30.2958C26.0231 32.3327 25.1493 34.5901 24.3735 37.0634C24.2666 37.4043 24.4619 37.7657 24.8098 37.8706C24.8744 37.8901 24.9396 37.8993 25.0037 37.8993C25.2856 37.8993 25.5464 37.7208 25.6336 37.443C26.1901 35.6686 26.7981 34.0088 27.4319 32.4636H31.9366C32.2202 32.4636 32.4721 32.2857 32.5618 32.022C35.9494 22.0627 44.8382 11.2704 44.9275 11.1626C45.0918 10.9644 45.1216 10.69 45.0034 10.4625C44.8852 10.2348 44.641 10.0968 44.3813 10.1103C44.2727 10.1159 41.6828 10.266 38.2386 11.8772C35.0826 13.3533 30.5763 16.3965 27.03 22.5099Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M11.8306 8.00308C12.2327 8.00308 12.4129 8.16224 12.7505 8.49322C13.1245 8.85977 13.6366 9.36188 14.6027 9.36188C15.5688 9.36188 16.081 8.85977 16.455 8.49313C16.7926 8.16215 16.9728 8.00299 17.3748 8.00299C17.777 8.00299 17.9571 8.16215 18.2948 8.49313C18.6688 8.85977 19.1809 9.3618 20.147 9.3618C21.113 9.3618 21.6251 8.8596 21.999 8.49305C22.3365 8.16207 22.5166 8.00299 22.9184 8.00299C23.3204 8.00299 23.5006 8.16215 23.8381 8.49313C24.212 8.85977 24.7242 9.36188 25.6902 9.36188C26.6564 9.36188 27.1685 8.85977 27.5426 8.49322C27.8803 8.16215 28.0605 8.00308 28.4626 8.00308C28.8662 8.00308 29.0468 8.16232 29.3853 8.49365C29.7598 8.86011 30.2726 9.36197 31.2396 9.36197C32.2065 9.36197 32.7193 8.86011 33.0938 8.49365C33.4323 8.16232 33.6129 8.00308 34.0165 8.00308C34.3805 8.00308 34.6756 7.71387 34.6756 7.35714C34.6756 7.00041 34.3805 6.7112 34.0165 6.7112C33.0495 6.7112 32.5367 7.21305 32.1622 7.57951C31.8237 7.91084 31.6431 8.07008 31.2396 8.07008C30.836 8.07008 30.6554 7.91084 30.3169 7.57951C29.9424 7.21305 29.4296 6.7112 28.4626 6.7112C27.4964 6.7112 26.9843 7.21331 26.6102 7.57986C26.2725 7.91092 26.0923 8.07 25.6902 8.07C25.2882 8.07 25.1081 7.91092 24.7706 7.57986C24.3967 7.21322 23.8845 6.71111 22.9185 6.71111C21.9525 6.71111 21.4405 7.21322 21.0666 7.57986C20.7292 7.91084 20.549 8.06991 20.1472 8.06991C19.7451 8.06991 19.565 7.91075 19.2273 7.57977C18.8534 7.21314 18.3412 6.71102 17.3751 6.71102C16.409 6.71102 15.8969 7.21314 15.523 7.57969C15.1853 7.91075 15.0052 8.06983 14.6031 8.06983C14.201 8.06983 14.0209 7.91067 13.6832 7.57969C13.3093 7.21305 12.7971 6.71094 11.831 6.71094C11.467 6.71094 11.1719 7.00015 11.1719 7.35688C11.1719 7.71361 11.4666 8.00308 11.8306 8.00308Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M11.8306 12.7597C12.2327 12.7597 12.4129 12.9188 12.7505 13.2498C13.1245 13.6164 13.6366 14.1185 14.6027 14.1185C15.5688 14.1185 16.081 13.6164 16.455 13.2498C16.7926 12.9188 16.9728 12.7597 17.3748 12.7597C17.777 12.7597 17.9571 12.9188 18.2948 13.2498C18.6688 13.6164 19.1809 14.1185 20.147 14.1185C21.113 14.1185 21.6251 13.6163 21.999 13.2497C22.3365 12.9187 22.5166 12.7597 22.9184 12.7597C23.3204 12.7597 23.5006 12.9188 23.8381 13.2498C24.212 13.6164 24.7242 14.1185 25.6902 14.1185C26.6564 14.1185 27.1685 13.6164 27.5426 13.2499C27.8803 12.9188 28.0605 12.7597 28.4626 12.7597C28.8662 12.7597 29.0468 12.919 29.3853 13.2503C29.7598 13.6168 30.2726 14.1186 31.2396 14.1186C32.2065 14.1186 32.7193 13.6168 33.0938 13.2503C33.4323 12.919 33.6129 12.7597 34.0165 12.7597C34.3805 12.7597 34.6756 12.4705 34.6756 12.1138C34.6756 11.7571 34.3805 11.4679 34.0165 11.4679C33.0495 11.4679 32.5367 11.9697 32.1622 12.3362C31.8237 12.6675 31.6431 12.8267 31.2396 12.8267C30.836 12.8267 30.6554 12.6675 30.3169 12.3362C29.9424 11.9697 29.4296 11.4679 28.4626 11.4679C27.4964 11.4679 26.9843 11.97 26.6102 12.3365C26.2725 12.6676 26.0923 12.8267 25.6902 12.8267C25.2882 12.8267 25.1081 12.6675 24.7706 12.3366C24.3967 11.97 23.8845 11.4679 22.9185 11.4679C21.9525 11.4679 21.4405 11.97 21.0666 12.3366C20.7292 12.6676 20.549 12.8267 20.1472 12.8267C19.7451 12.8267 19.565 12.6675 19.2273 12.3365C18.8534 11.9699 18.3412 11.4678 17.3751 11.4678C16.409 11.4678 15.8969 11.9699 15.523 12.3364C15.1853 12.6675 15.0052 12.8266 14.6031 12.8266C14.201 12.8266 14.0209 12.6674 13.6832 12.3364C13.3093 11.9699 12.7971 11.4678 11.831 11.4678C11.467 11.4678 11.1719 11.757 11.1719 12.1137C11.1719 12.4704 11.4666 12.7597 11.8306 12.7597Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M11.8306 17.5157C12.2327 17.5157 12.4129 17.6748 12.7505 18.0058C13.1245 18.3725 13.6366 18.8746 14.6027 18.8746C15.5688 18.8746 16.081 18.3725 16.455 18.0058C16.7926 17.6748 16.9728 17.5157 17.3748 17.5157C17.7769 17.5157 17.957 17.6748 18.2947 18.0058C18.6687 18.3725 19.1808 18.8745 20.1469 18.8745C21.113 18.8745 21.625 18.3723 21.9989 18.0057C22.3364 17.6748 22.5165 17.5157 22.9183 17.5157C23.3203 17.5157 23.5005 17.6748 23.838 18.0058C24.2119 18.3725 24.7241 18.8746 25.6901 18.8746C26.6563 18.8746 27.1685 18.3725 27.5425 18.0059C27.7222 17.8297 27.8775 17.6775 28.0566 17.5952C28.3862 17.4436 28.5279 17.059 28.3732 16.736C28.2186 16.413 27.826 16.2743 27.4965 16.4257C27.1084 16.6041 26.8438 16.8636 26.6103 17.0926C26.2726 17.4236 26.0924 17.5827 25.6902 17.5827C25.2882 17.5827 25.1081 17.4236 24.7706 17.0926C24.3967 16.7259 23.8845 16.2238 22.9185 16.2238C21.9525 16.2238 21.4405 16.7259 21.0666 17.0926C20.7292 17.4235 20.549 17.5826 20.1472 17.5826C19.7451 17.5826 19.565 17.4234 19.2273 17.0925C18.8534 16.7258 18.3412 16.2237 17.3751 16.2237C16.409 16.2237 15.8969 16.7258 15.523 17.0924C15.1853 17.4234 15.0052 17.5825 14.6031 17.5825C14.201 17.5825 14.0209 17.4234 13.6832 17.0924C13.3093 16.7257 12.7971 16.2236 11.831 16.2236C11.467 16.2236 11.1719 16.5128 11.1719 16.8696C11.1719 17.2263 11.4666 17.5157 11.8306 17.5157Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M25.6016 23.1182C25.7561 22.7952 25.6143 22.4106 25.2846 22.2591C25.1054 22.1768 24.9501 22.0245 24.7703 21.8482C24.3964 21.4816 23.8843 20.9795 22.9183 20.9795C21.9523 20.9795 21.4403 21.4816 21.0664 21.8482C20.7289 22.1792 20.5488 22.3383 20.147 22.3383C19.7449 22.3383 19.5647 22.1791 19.2271 21.8482C18.8531 21.4815 18.341 20.9795 17.3749 20.9795C16.4088 20.9795 15.8967 21.4816 15.5227 21.8482C15.1851 22.1791 15.0049 22.3383 14.6029 22.3383C14.2008 22.3383 14.0206 22.1791 13.683 21.8482C13.309 21.4815 12.7969 20.9795 11.8308 20.9795C11.4667 20.9795 11.1716 21.2687 11.1716 21.6254C11.1716 21.9822 11.4667 22.2714 11.8308 22.2714C12.2328 22.2714 12.413 22.4305 12.7506 22.7615C13.1246 23.1282 13.6368 23.6302 14.6029 23.6302C15.569 23.6302 16.0811 23.1281 16.4551 22.7615C16.7927 22.4305 16.9729 22.2714 17.375 22.2714C17.7771 22.2714 17.9572 22.4305 18.2949 22.7615C18.6689 23.1282 19.181 23.6302 20.1471 23.6302C21.1132 23.6302 21.6252 23.1281 21.9991 22.7614C22.3366 22.4304 22.5166 22.2714 22.9185 22.2714C23.3205 22.2714 23.5007 22.4305 23.8382 22.7615C24.0719 22.9906 24.3368 23.2504 24.7253 23.4288C25.0545 23.5804 25.4471 23.4411 25.6016 23.1182Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M11.8305 27.0274C12.2326 27.0274 12.4127 27.1866 12.7504 27.5175C13.1243 27.8842 13.6365 28.3863 14.6026 28.3863C15.5687 28.3863 16.0809 27.8842 16.4548 27.5175C16.7925 27.1866 16.9726 27.0274 17.3747 27.0274C17.7768 27.0274 17.9569 27.1866 18.2947 27.5175C18.6686 27.8842 19.1808 28.3862 20.1469 28.3862C21.1129 28.3862 21.6249 27.884 21.9988 27.5175C22.3363 27.1865 22.5165 27.0274 22.9183 27.0274C23.2823 27.0274 23.5774 26.7382 23.5774 26.3815C23.5774 26.0247 23.2823 25.7355 22.9183 25.7355C21.9523 25.7355 21.4403 26.2376 21.0664 26.6043C20.7289 26.9353 20.5488 27.0943 20.147 27.0943C19.7449 27.0943 19.5647 26.9352 19.2271 26.6042C18.8531 26.2376 18.341 25.7354 17.3749 25.7354C16.4088 25.7354 15.8967 26.2376 15.5227 26.6041C15.1851 26.9352 15.0049 27.0942 14.6029 27.0942C14.2008 27.0942 14.0206 26.9351 13.683 26.6041C13.309 26.2375 12.7969 25.7354 11.8308 25.7354C11.4667 25.7354 11.1716 26.0246 11.1716 26.3813C11.1716 26.738 11.4665 27.0274 11.8305 27.0274Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M11.8305 31.7842C12.2326 31.7842 12.4127 31.9434 12.7504 32.2744C13.1243 32.641 13.6365 33.1431 14.6026 33.1431C15.5687 33.1431 16.0809 32.641 16.4548 32.2744C16.7925 31.9434 16.9726 31.7842 17.3746 31.7842C17.7768 31.7842 17.9568 31.9434 18.2946 32.2744C18.6685 32.641 19.1807 33.143 20.1468 33.143C21.1128 33.143 21.6248 32.6408 21.9988 32.2743C22.3362 31.9433 22.5164 31.7842 22.9182 31.7842C23.0809 31.7842 23.2127 31.8108 23.3328 31.8677C23.6604 32.0231 24.0547 31.8887 24.2132 31.5676C24.3718 31.2465 24.2347 30.8602 23.907 30.7048C23.6055 30.5619 23.2821 30.4924 22.9183 30.4924C21.9523 30.4924 21.4403 30.9945 21.0664 31.3611C20.7289 31.6921 20.5488 31.8512 20.147 31.8512C19.7449 31.8512 19.5647 31.692 19.2271 31.361C18.8531 30.9944 18.341 30.4923 17.3749 30.4923C16.4088 30.4923 15.8967 30.9944 15.5227 31.3609C15.1851 31.692 15.0049 31.8511 14.6029 31.8511C14.2008 31.8511 14.0206 31.6919 13.683 31.3609C13.309 30.9943 12.7969 30.4922 11.8308 30.4922C11.4667 30.4922 11.1716 30.7814 11.1716 31.1381C11.1716 31.4949 11.4665 31.7842 11.8305 31.7842Z",
                fill: "black"
            })
        ]
    });
};
var $d228491c12a2f715$export$2e2bcd8739ae039 = $d228491c12a2f715$var$realPennedLetters;




const $cf616f1351ec93fa$var$triFoldSelfMailers = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "51",
        height: "50",
        viewBox: "0 0 51 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1099_4325)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M19.8213 11.696L31.3583 3.59668V38.0406L19.8213 46.793V11.696Z",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M48.021 0.912109H33.1005C32.3616 0.916084 31.4555 1.16302 30.7474 1.73281L19.8355 10.3917C19.4949 10.6476 19.0493 10.8769 18.3851 10.8973H3.46447C2.06302 10.8973 0.922852 12.0374 0.922852 13.4389V46.1798C0.922852 47.5813 2.06302 48.7214 3.46447 48.7214H18.385C18.8391 48.7214 19.2839 48.6409 19.7032 48.4835C20.0761 48.346 20.4243 48.1499 20.7382 47.9006L31.6501 39.2418C31.8441 39.0885 32.058 38.9682 32.2858 38.8841C32.4975 38.7981 32.7679 38.5699 32.7612 38.202V2.39335C32.873 2.37687 32.986 2.3664 33.1005 2.3664H48.0211C48.6207 2.3664 49.1085 2.85417 49.1085 3.45373V36.1947C49.1085 36.7942 48.6207 37.282 48.0211 37.282H35.5104C35.1087 37.282 34.7832 37.6076 34.7832 38.0091C34.7832 38.4107 35.1087 38.7363 35.5104 38.7363H48.0211C49.4226 38.7363 50.5627 37.5961 50.5627 36.1947V3.45373C50.5627 2.05227 49.4225 0.912109 48.021 0.912109ZM3.46447 47.2672C2.86491 47.2672 2.37714 46.7794 2.37714 46.1798V34.1823C3.05426 34.5532 3.75591 34.8786 4.47481 35.1535C4.74948 35.2502 5.19808 35.1869 5.4137 34.734C5.5571 34.3589 5.36939 33.9385 4.99428 33.7951C4.08593 33.4478 3.20735 33.0129 2.37724 32.5006V13.4389C2.37724 12.8393 2.86501 12.3516 3.46456 12.3516H18.385C18.4988 12.3516 18.612 12.3465 18.7243 12.3364V32.5306C16.2755 34.0292 13.4681 34.8213 10.5774 34.8213C9.84667 34.8213 9.11225 34.7705 8.39422 34.6702C7.9971 34.6145 7.62898 34.892 7.57352 35.2897C7.51796 35.6875 7.79535 36.055 8.19314 36.1104C8.97739 36.22 9.77958 36.2755 10.5774 36.2755C13.4419 36.2755 16.2328 35.5649 18.7243 34.211V47.2402C18.6125 47.2567 18.4995 47.2672 18.385 47.2672H3.46447ZM20.1786 46.4881V11.8995C20.3975 11.7595 20.1581 11.9495 20.7381 11.5318L31.3068 3.14542V37.7341C31.088 37.8741 31.3273 37.6841 30.7473 38.1017L20.1786 46.4881Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M7.0275 24.684C7.18156 24.7848 7.12901 25.5061 7.12261 25.738C7.04854 27.0322 8.46763 28.1678 9.80093 27.6838C10.2931 27.3994 10.9358 27.3855 11.4942 27.6838C11.7131 27.7617 11.9405 27.8 12.1667 27.7999C13.1408 27.8332 14.228 26.8904 14.1724 25.7379C14.0541 25.182 14.2393 24.5663 14.6957 24.1275C15.5174 23.1278 15.0307 21.3578 13.6725 20.9791C13.1072 20.9198 12.579 20.5534 12.3027 19.9838C11.6018 18.8931 9.78648 18.8086 8.99215 19.9838C8.76111 20.5031 8.2493 20.8922 7.62211 20.9791C6.35377 21.3151 5.73376 23.0077 6.59916 24.1275L7.0275 24.684ZM7.66438 22.7331C7.69143 22.6499 7.7816 22.4483 8.03348 22.374C8.92506 22.2357 9.73888 21.6707 10.1919 20.8059C10.4662 20.5367 10.6834 20.4292 11.1032 20.8059C11.5102 21.6112 12.299 22.2104 13.2615 22.374C13.6023 22.5516 13.7716 22.725 13.5432 23.2407C12.9129 23.8687 12.5777 24.7997 12.7187 25.7779C12.6551 26.157 12.5425 26.3716 11.9815 26.3136C11.1896 25.9083 10.2006 25.8769 9.31364 26.3136C8.9333 26.3702 8.6947 26.3295 8.57642 25.7779C8.71709 24.8996 8.44117 23.9492 7.75203 23.2407C7.59176 23.0324 7.63743 22.8163 7.66438 22.7331Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M8.3226 40.9592H12.779C13.1807 40.9592 13.5062 40.6336 13.5062 40.232C13.5062 39.8305 13.1807 39.5049 12.779 39.5049H8.3226C7.92093 39.5049 7.59546 39.8305 7.59546 40.232C7.59546 40.6336 7.92103 40.9592 8.3226 40.9592Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M15.6462 42.54H5.45566C5.05399 42.54 4.72852 42.8656 4.72852 43.2672C4.72852 43.6688 5.05399 43.9943 5.45566 43.9943H15.6462C16.0478 43.9943 16.3733 43.6688 16.3733 43.2672C16.3733 42.8656 16.0478 42.54 15.6462 42.54Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.2465 11.3871L22.804 15.7058C22.4895 15.9555 22.4367 16.4128 22.6864 16.7274C22.8299 16.9083 23.0422 17.0026 23.2565 17.0026C23.4148 17.0026 23.5743 16.9511 23.708 16.845L29.1505 12.5263C29.465 12.2766 29.5178 11.8193 29.2681 11.5047C29.0186 11.1901 28.5611 11.1374 28.2465 11.3871Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.2465 15.4105L22.804 19.7293C22.4895 19.9789 22.4367 20.4363 22.6864 20.7509C22.8299 20.9318 23.0422 21.026 23.2565 21.026C23.4148 21.026 23.5743 20.9746 23.708 20.8685L29.1505 16.5497C29.465 16.3001 29.5178 15.8428 29.2681 15.5281C29.0186 15.2136 28.5611 15.1608 28.2465 15.4105Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.2465 19.433L22.804 23.7517C22.4895 24.0014 22.4367 24.4587 22.6864 24.7733C22.8299 24.9542 23.0422 25.0485 23.2565 25.0485C23.4148 25.0485 23.5743 24.997 23.708 24.8909L29.1505 20.5722C29.465 20.3225 29.5178 19.8652 29.2681 19.5506C29.0186 19.236 28.5611 19.1833 28.2465 19.433Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.2465 27.8597L22.804 32.1785C22.4895 32.4282 22.4367 32.8855 22.6864 33.2001C22.8299 33.381 23.0422 33.4752 23.2565 33.4752C23.4148 33.4752 23.5743 33.4238 23.708 33.3177L29.1505 28.9989C29.465 28.7493 29.5178 28.292 29.2681 27.9773C29.0186 27.6627 28.5611 27.6101 28.2465 27.8597Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.2465 31.8832L22.804 36.2019C22.4895 36.4516 22.4367 36.9089 22.6864 37.2235C22.8299 37.4044 23.0422 37.4987 23.2565 37.4987C23.4148 37.4987 23.5743 37.4472 23.708 37.3411L29.1505 33.0223C29.465 32.7727 29.5178 32.3154 29.2681 32.0008C29.0186 31.6862 28.5611 31.6335 28.2465 31.8832Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M37.1872 12.3216H44.6898C45.6642 12.3216 46.4569 11.5289 46.4569 10.5546V7.4194C46.4569 6.44503 45.6642 5.65234 44.6898 5.65234H37.1872C36.2128 5.65234 35.4202 6.44503 35.4202 7.4194V10.5546C35.4202 11.5289 36.2128 12.3216 37.1872 12.3216ZM36.8745 7.4194C36.8745 7.24693 37.0147 7.10663 37.1872 7.10663H44.6898C44.8622 7.10663 45.0026 7.24693 45.0026 7.4194V10.5546C45.0026 10.727 44.8623 10.8673 44.6898 10.8673H37.1872C37.0148 10.8673 36.8745 10.727 36.8745 10.5546V7.4194Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M35.4202 19.3182C35.4202 20.2926 36.2128 21.0853 37.1872 21.0853H44.6898C45.6642 21.0853 46.4569 20.2926 46.4569 19.3182V16.1831C46.4569 15.2087 45.6642 14.416 44.6898 14.416H37.1872C36.2128 14.416 35.4202 15.2087 35.4202 16.1831V19.3182ZM36.8745 16.1831C36.8745 16.0106 37.0147 15.8703 37.1872 15.8703H44.6898C44.8622 15.8703 45.0026 16.0106 45.0026 16.1831V19.3182C45.0026 19.4907 44.8623 19.631 44.6898 19.631H37.1872C37.0148 19.631 36.8745 19.4907 36.8745 19.3182V16.1831Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M36.8587 25.5879C36.4658 25.5879 36.1472 25.9064 36.1472 26.2993C36.1472 26.6923 36.4657 27.0108 36.8587 27.0108C37.2516 27.0108 37.5701 26.6923 37.5701 26.2993C37.5701 25.9064 37.2515 25.5879 36.8587 25.5879Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M45.7296 25.5732H40.3277C39.9261 25.5732 39.6006 25.8988 39.6006 26.3004C39.6006 26.702 39.9261 27.0275 40.3277 27.0275H45.7296C46.1313 27.0275 46.4568 26.702 46.4568 26.3004C46.4568 25.8988 46.1313 25.5732 45.7296 25.5732Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M36.8587 29.4902C36.4658 29.4902 36.1472 29.8087 36.1472 30.2017C36.1472 30.5945 36.4657 30.9131 36.8587 30.9131C37.2516 30.9131 37.5701 30.5946 37.5701 30.2017C37.5701 29.8087 37.2515 29.4902 36.8587 29.4902Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M45.7296 29.4746H40.3277C39.9261 29.4746 39.6006 29.8002 39.6006 30.2018C39.6006 30.6033 39.9261 30.9289 40.3277 30.9289H45.7296C46.1313 30.9289 46.4568 30.6033 46.4568 30.2018C46.4568 29.8002 46.1313 29.4746 45.7296 29.4746Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1099_4325",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "49.6398",
                        height: "49.6398",
                        fill: "white",
                        transform: "translate(0.922852 -0.00292969)"
                    })
                })
            })
        ]
    });
};
var $cf616f1351ec93fa$export$2e2bcd8739ae039 = $cf616f1351ec93fa$var$triFoldSelfMailers;




const $439af3dad161fcd7$var$biFoldSelfMailers = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "55",
        height: "56",
        viewBox: "0 0 55 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1099_4296)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M27.443 14.6807L29.8068 18.871L34.5344 20.0683L31.5796 23.66V27.8504H30.9887L27.443 26.6532L23.3063 27.8504V23.66L20.3516 19.4697L24.4882 18.871L27.443 14.6807Z",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M12.0318 55.2031H42.8545C43.8508 55.2031 44.6612 54.3927 44.6612 53.3965V8.43434C44.6612 7.43822 43.8508 6.62769 42.8545 6.62769H41.1125V2.30513C41.1125 1.30869 40.303 0.498047 39.3079 0.498047C39.1787 0.498047 39.0488 0.512044 38.9218 0.539717L30.9667 2.27051C30.5343 2.36464 30.26 2.79139 30.3541 3.2239C30.4481 3.6562 30.8741 3.93068 31.3075 3.83655L39.2626 2.10576C39.2781 2.10244 39.2933 2.10073 39.308 2.10073C39.4051 2.10073 39.51 2.17884 39.51 2.30513V6.62779H18.4789L27.6533 4.6317C28.0857 4.53757 28.3599 4.11083 28.2658 3.67831C28.1717 3.2458 27.7453 2.97132 27.3124 3.06566L10.8664 6.64382C10.8651 6.64403 10.8637 6.64436 10.8624 6.64468L10.856 6.64607C10.486 6.72705 10.2251 7.05518 10.2251 7.42914V39.9622C10.2251 40.4048 10.5838 40.7636 11.0264 40.7636C11.4691 40.7636 11.8278 40.4048 11.8278 39.9622V8.23038H42.8545C42.9671 8.23038 43.0585 8.32184 43.0585 8.43434V53.3965C43.0585 53.509 42.9671 53.6004 42.8545 53.6004H12.0318C11.9192 53.6004 11.8278 53.509 11.8278 53.3965V43.7017C11.8278 43.2592 11.4691 42.9004 11.0264 42.9004C10.5838 42.9004 10.2251 43.2592 10.2251 43.7017V53.3965C10.2251 54.3927 11.0355 55.2031 12.0318 55.2031Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M40.7989 30.0602V12.8045C40.7989 11.8913 40.056 11.1484 39.1428 11.1484H15.7435C14.8303 11.1484 14.0874 11.8913 14.0874 12.8045V30.0602C14.0874 30.9734 14.8303 31.7163 15.7435 31.7163H39.1428C40.056 31.7163 40.7989 30.9733 40.7989 30.0602ZM39.1962 30.0602C39.1962 30.0896 39.1721 30.1136 39.1428 30.1136H15.7435C15.7141 30.1136 15.6901 30.0896 15.6901 30.0602V12.8045C15.6901 12.7751 15.7141 12.7511 15.7435 12.7511H39.1428C39.1721 12.7511 39.1962 12.7751 39.1962 12.8045V30.0602Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M14.0874 48.9162C14.0874 49.8896 14.8793 50.6815 15.8527 50.6815H39.0335C40.0068 50.6815 40.7988 49.8896 40.7988 48.9162V41.6891C40.7988 40.7158 40.0068 39.9238 39.0335 39.9238H15.8527C14.8793 39.9238 14.0874 40.7158 14.0874 41.6891V48.9162ZM15.6901 41.6891C15.6901 41.5995 15.7631 41.5265 15.8527 41.5265H39.0335C39.1232 41.5265 39.1961 41.5995 39.1961 41.6891V48.9162C39.1961 49.0058 39.1231 49.0788 39.0335 49.0788H15.8527C15.763 49.0788 15.6901 49.0058 15.6901 48.9162V41.6891Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M39.2459 33.4033H29.3695C28.9268 33.4033 28.5681 33.7621 28.5681 34.2047C28.5681 34.6472 28.9268 35.006 29.3695 35.006H39.2459C39.6885 35.006 40.0472 34.6472 40.0472 34.2047C40.0472 33.7621 39.6884 33.4033 39.2459 33.4033Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M39.2459 36.7344H29.3695C28.9268 36.7344 28.5681 37.0932 28.5681 37.5357C28.5681 37.9783 28.9268 38.3371 29.3695 38.3371H39.2459C39.6885 38.3371 40.0472 37.9783 40.0472 37.5357C40.0472 37.0932 39.6884 36.7344 39.2459 36.7344Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M25.5169 33.4033H15.6405C15.1978 33.4033 14.8391 33.7621 14.8391 34.2047C14.8391 34.6472 15.1978 35.006 15.6405 35.006H25.5169C25.9595 35.006 26.3182 34.6472 26.3182 34.2047C26.3182 33.7621 25.9594 33.4033 25.5169 33.4033Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M25.5169 36.7344H15.6405C15.1978 36.7344 14.8391 37.0932 14.8391 37.5357C14.8391 37.9783 15.1978 38.3371 15.6405 38.3371H25.5169C25.9595 38.3371 26.3182 37.9783 26.3182 37.5357C26.3182 37.0932 25.9594 36.7344 25.5169 36.7344Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M33.3283 18.4721L30.4624 18.0557C30.4558 18.0547 30.4503 18.0506 30.4474 18.0449L29.1657 15.4478C28.8397 14.7872 28.1796 14.377 27.4431 14.377C26.7066 14.377 26.0465 14.7872 25.7205 15.4478L24.4389 18.0447C24.436 18.0506 24.4304 18.0547 24.424 18.0557L21.5579 18.4721C20.829 18.578 20.2347 19.079 20.0071 19.7796C19.7795 20.4801 19.9657 21.2346 20.4932 21.7488L22.5672 23.7704C22.5718 23.7749 22.5739 23.7813 22.5729 23.7878L22.0832 26.6422C21.9587 27.3682 22.2516 28.0882 22.8474 28.5211C23.4432 28.9538 24.2182 29.01 24.8705 28.6673L27.4338 27.3196C27.4399 27.3165 27.4468 27.3166 27.4523 27.3196L30.0157 28.6673C30.2993 28.8163 30.6061 28.8899 30.9114 28.8899C31.308 28.8899 31.702 28.7657 32.0388 28.5211C32.6346 28.0882 32.9275 27.3682 32.8029 26.6422L32.3134 23.7877C32.3123 23.7813 32.3144 23.7749 32.3191 23.7703L34.393 21.7488C34.9205 21.2346 35.1067 20.4801 34.8791 19.7796C34.6515 19.0791 34.0572 18.5781 33.3283 18.4721ZM33.2742 20.6012L31.2004 22.6226C30.8179 22.9954 30.6435 23.5323 30.7338 24.0587L31.2233 26.9131C31.2524 27.0827 31.1565 27.181 31.0967 27.2244C31.0369 27.2678 30.9141 27.3288 30.7615 27.2487L28.198 25.9009C27.9616 25.7768 27.7023 25.7146 27.4431 25.7146C27.1839 25.7146 26.9245 25.7768 26.6881 25.9009L24.1247 27.2486C23.9722 27.3287 23.8493 27.2678 23.7895 27.2243C23.7297 27.1808 23.6338 27.0826 23.6628 26.913L24.1524 24.0586C24.2427 23.532 24.0683 22.9951 23.6859 22.6225L21.612 20.6009C21.4887 20.4807 21.5086 20.3449 21.5314 20.2746C21.5543 20.2043 21.6181 20.0827 21.7883 20.0579L24.6544 19.6415C25.1827 19.5646 25.6394 19.233 25.876 18.754L27.1577 16.1569C27.2339 16.0025 27.3692 15.9794 27.4431 15.9794C27.517 15.9794 27.6523 16.0025 27.7285 16.1569L29.0103 18.7542C29.2468 19.233 29.7034 19.5646 30.2319 19.6415L33.0979 20.0579C33.2682 20.0827 33.3319 20.2043 33.3548 20.2746C33.3776 20.3449 33.3975 20.481 33.2742 20.6012Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1099_4296",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "54.7051",
                        height: "54.7051",
                        fill: "white",
                        transform: "translate(0.0905762 0.498047)"
                    })
                })
            })
        ]
    });
};
var $439af3dad161fcd7$export$2e2bcd8739ae039 = $439af3dad161fcd7$var$biFoldSelfMailers;




function $9c48558216468543$var$SnapPack(props) {
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 60.8 77.6",
        height: 55,
        width: 56,
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("style", {
                    children: `
                    .st0 {
                        fill: none;
                        stroke: #000;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 2px;
                    }

                    .st1 {
                        fill: #fff;
                    }

                    .st2 {
                        fill: ${fill};
                    }
                    `
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("polygon", {
                className: "st2",
                points: "57.3 51.3 1 51.3 3.5 26.3 59.8 26.3 57.3 51.3"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M59.8,27.3c-.5,0-.9-.4-1-.9l-2.2-22.8c0-.9-.8-1.6-1.8-1.6H4c-.5,0-1,.2-1.3.6-.3.4-.5.9-.4,1.4l2.2,22.2c0,.5-.3,1-.9,1.1-.6,0-1-.3-1.1-.9L.3,4.1c-.1-1.1.2-2.1,1-2.9.7-.8,1.7-1.2,2.8-1.2h50.7c1.9,0,3.6,1.5,3.7,3.4l2.2,22.8c0,.5-.3,1-.9,1.1,0,0,0,0,0,0Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M56.7,77.6H6c-1.9,0-3.5-1.5-3.7-3.4L0,51.4c0-.5.3-1,.9-1.1.5,0,1,.3,1.1.9l2.2,22.8c0,.9.8,1.6,1.7,1.6h50.7c.5,0,1-.2,1.3-.6.3-.4.5-.8.4-1.3l-1.7-17.8c0-.5.3-1,.9-1.1.6,0,1,.3,1.1.9l1.7,17.8c.1,1.1-.2,2.1-1,2.9-.7.8-1.7,1.2-2.8,1.2Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M57.3,52.3s0,0,0,0c-.5,0-1-.5-.9-1.1l2.4-24H4.4l-2.4,24.2c0,.6-.5,1-1.1.9-.5,0-1-.5-.9-1.1l2.5-25.1c0-.5.5-.9,1-.9h56.3c.3,0,.6.1.7.3.2.2.3.5.3.8l-2.5,25.1c0,.5-.5.9-1,.9Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        className: "st1",
                        d: "M28.8,40.3H10.8c-1.1,0-2-.9-2-2l.4-4.1c0-1.1.9-2,2-2h17.9c1.1,0,2,.9,2,2l-.4,4.1c0,1.1-.9,2-2,2Z"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M28.8,41.3H10.8c-1.7,0-3-1.3-3-3l.4-4.2c0-1.6,1.3-2.9,3-2.9h17.9c1.7,0,3,1.3,3,3l-.4,4.2c0,1.6-1.3,2.9-3,2.9ZM11.2,33.2c-.5,0-1,.4-1,1l-.4,4.2c0,.5.5.9,1,.9h17.9c.5,0,1-.4,1-1l.4-4.2c0-.5-.5-.9-1-.9H11.2Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M54.8,35.7h-17.9c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M54.5,39.8h-17.9c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M28.9,46.3H11c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M27.2,9.3H9.3c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M51.1,14.6H9.9c-.6,0-1-.4-1-1s.4-1,1-1h41.2c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M51.5,19.8H10.3c-.6,0-1-.4-1-1s.4-1,1-1h41.2c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M51.1,64.9h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M51.5,70h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M30.1,64.9c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M30.6,70c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M50.6,59.7h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M29.7,59.7c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M2.5,52.3H1C.4,52.3,0,51.9,0,51.3s.4-1,1-1h1.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M52.6,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM46.4,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM40.1,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM33.8,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM27.6,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM21.3,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM15,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM8.8,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M57.3,52.3h-1.5c-.6,0-1-.4-1-1s.4-1,1-1h1.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M31.8,70.5"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M14.6,71.3c-.5,0-1.1-.2-1.5-.4,0,0,0,0,0,0-.8-.6-1.2-1.5-1.2-2.5v-2.2c.1,0-1.7-1.6-1.7-1.6-.8-.6-1.1-1.7-.9-2.7.2-1,1-1.7,2.1-1.8l2-.3.7-1.9c.4-1,1.3-1.6,2.3-1.6s1.9.5,2.4,1.4l1.2,2.1,2.3.3c1,.2,1.7.8,2.2,1.6.4,1,.3,2.1-.4,2.8l-1.4,1.5.6,2.1c.3,1,0,2-.8,2.6,0,0,0,0-.1,0-.8.5-1.8.6-2.7.2l-2.1-1-1.8,1c-.4.2-.8.3-1.2.3ZM14.1,69.2c.2.1.5.1.6,0l2.3-1.3c.3-.2.6-.2.9,0l2.5,1.3c.2,0,.4.1.7,0,0-.1.2-.2,0-.5l-.8-2.7c0-.3,0-.7.2-.9l1.7-1.9c.2-.2,0-.5,0-.6,0-.1-.3-.4-.7-.5l-2.7-.4c-.3,0-.6-.2-.7-.5l-1.5-2.5c-.3-.5-.9-.6-1.1-.2l-.9,2.4c-.1.3-.4.6-.8.6l-2.6.4c-.2,0-.3.2-.4.3,0,.3,0,.5.2.7l2.2,1.9c.2.2.4.5.3.8l-.2,2.7c0,.2.1.5.4.7Z"
            })
        ]
    });
}
var $9c48558216468543$export$2e2bcd8739ae039 = $9c48558216468543$var$SnapPack;




const $10fe05b81a81fb3f$var$infoIcon = (props)=>{
    const { className: className = {}, fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "12",
        className: className,
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                clipPath: "url(#clip0_1555_2219)",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M6.80169 8.45472C6.67902 8.46615 6.55586 8.43847 6.44987 8.37562C6.37243 8.29612 6.33531 8.18575 6.34897 8.07562C6.35183 7.98393 6.36278 7.89266 6.38169 7.8029C6.4 7.69991 6.42364 7.59796 6.45259 7.49744L6.77441 6.39015C6.8076 6.28087 6.82954 6.16846 6.83987 6.05469C6.83987 5.93197 6.85623 5.84741 6.85623 5.79833C6.86307 5.57959 6.76968 5.36969 6.60259 5.22833C6.39707 5.07055 6.14113 4.993 5.88259 5.01015C5.69732 5.01294 5.51347 5.04327 5.33713 5.10015C5.1444 5.16015 4.94167 5.23197 4.72895 5.31562L4.63623 5.67561C4.69895 5.65379 4.77533 5.62926 4.86259 5.60197C4.94584 5.57732 5.03214 5.56445 5.11895 5.56379C5.24073 5.5506 5.36331 5.58051 5.46531 5.64833C5.53459 5.731 5.5671 5.83839 5.55531 5.94562C5.555 6.03733 5.54495 6.12876 5.52531 6.21833C5.50621 6.3138 5.48167 6.41469 5.45167 6.52105L5.12713 7.63377C5.10097 7.7372 5.08004 7.84187 5.06441 7.94741C5.05166 8.03776 5.04529 8.12889 5.04531 8.22013C5.04397 8.44037 5.14468 8.64883 5.31803 8.78467C5.52672 8.94491 5.78631 9.02434 6.04893 9.00831C6.23385 9.01211 6.41814 8.98539 6.59439 8.92921C6.74893 8.87647 6.9553 8.80103 7.21349 8.70285L7.30077 8.35921C7.23083 8.38822 7.15881 8.41192 7.08531 8.43011C6.99236 8.45134 6.89692 8.45959 6.80169 8.45472Z",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M7.14277 3.20479C6.99434 3.06848 6.79878 2.99514 6.59731 3.00025C6.39596 2.9957 6.20059 3.06897 6.05185 3.20479C5.77923 3.43987 5.74878 3.85145 5.98388 4.1241C6.00484 4.14841 6.02755 4.17112 6.05185 4.19207C6.36244 4.46988 6.83218 4.46988 7.14275 4.19207C7.41537 3.95467 7.44394 3.54123 7.20655 3.26861C7.18681 3.2459 7.16548 3.22457 7.14277 3.20479Z",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 11.4545C2.98753 11.4545 0.545461 9.01247 0.545461 6C0.545461 2.98753 2.98753 0.545461 6 0.545461C9.01247 0.545461 11.4545 2.98753 11.4545 6C11.4545 9.01247 9.01247 11.4545 6 11.4545Z",
                        fill: fill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                    id: "clip0_1555_2219",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $10fe05b81a81fb3f$export$2e2bcd8739ae039 = $10fe05b81a81fb3f$var$infoIcon;




function $40b9cb0f42773a1d$var$sizeImage() {
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "107",
        height: "80",
        viewBox: "0 0 107 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M5.3507 0.988281C2.42107 0.988281 0 3.399 0 6.32862V74.0196C0 76.9492 2.42107 79.3563 5.3507 79.3563H101.535C104.464 79.3563 106.875 76.9492 106.875 74.0196V6.32862C106.875 3.399 104.464 0.988281 101.535 0.988281H5.3507ZM74.816 11.6655H94.4097C95.3934 11.6694 96.1878 12.47 96.184 13.4537V38.3842C96.1878 39.3679 95.3934 40.1685 94.4097 40.1725H74.816C73.8268 40.1762 73.024 39.3734 73.0278 38.3842V30.3477C71.0078 29.2236 69.2768 29.3179 67.8614 29.6798C66.2356 30.0952 65.2313 30.8766 65.2313 30.8766C63.3521 32.5645 60.95 29.5344 63.0222 28.0898C63.0222 28.0898 64.6063 26.8288 66.9813 26.2216C69.3563 25.6144 72.7392 25.6803 76.0267 28.0376C78.4581 29.7811 80.3918 29.7074 81.9166 29.3005C83.4415 28.8939 84.3519 28.1282 84.3519 28.1282C86.1742 26.3506 88.7021 29.3296 86.6515 30.8383C86.6515 30.8383 85.1476 32.1287 82.8386 32.7447C81.1547 33.1938 78.9388 33.2597 76.5938 32.3583V36.6097H92.6354V15.2278H76.5938V21.2741C78.7594 22.6212 80.5131 22.5462 81.9166 22.1717C83.4415 21.7651 84.3519 21.0029 84.3519 21.0029C86.1735 19.1878 88.737 22.205 86.6515 23.7095C86.6515 23.7095 85.1476 24.9999 82.8386 25.6159C80.5295 26.2319 77.2238 26.1512 73.9497 23.8034C71.5316 22.0695 69.4874 22.1388 67.8614 22.5545C66.2356 22.9699 65.2313 23.7512 65.2313 23.7512C63.3541 25.3883 60.9982 22.4127 63.0222 20.961C63.0222 20.961 64.6063 19.7034 66.9813 19.0963C68.6324 18.6742 70.7727 18.5962 73.0278 19.3677V13.4533C73.0242 12.4641 73.8268 11.6617 74.816 11.6655ZM53.4444 11.672C54.3351 11.6855 55.2257 12.2936 55.2257 13.4535V66.891C55.2802 69.3199 51.6094 69.3199 51.6632 66.891V13.4535C51.6632 12.2402 52.5538 11.6587 53.4444 11.672ZM19.5903 29.4813H42.7465C45.1238 29.4813 45.1238 33.0474 42.7465 33.0474H19.5903C17.213 33.0474 17.213 29.4813 19.5903 29.4813ZM12.4792 38.3842H30.2812C32.6042 38.4381 32.6042 41.8953 30.2812 41.9468H12.4792C10.0508 42.0006 10.0508 38.3304 12.4792 38.3842ZM37.4097 38.3842H42.7465C45.0694 38.4381 45.0694 41.8953 42.7465 41.9468H37.4097C34.9814 42.0006 34.9814 38.3304 37.4097 38.3842ZM12.3887 47.3009H42.7465C45.1749 47.247 45.1749 50.9171 42.7465 50.8632H12.4792C10.1532 50.9326 9.97596 47.4723 12.3887 47.3009ZM64.045 47.3009H94.4097C96.8381 47.247 96.8381 50.9171 94.4097 50.8632H64.1285C61.8043 50.9238 61.6402 47.4643 64.045 47.3009ZM64.1284 56.2001H94.4097C96.7871 56.2001 96.7871 59.7661 94.4097 59.7661H64.1284C61.7511 59.7661 61.7511 56.2001 64.1284 56.2001ZM64.1284 65.103H94.4097C96.7326 65.1568 96.7326 68.6137 94.4097 68.6655H64.1284C61.8055 68.6117 61.8055 65.1548 64.1284 65.103Z",
            fill: "#FDECD3"
        })
    });
}
var $40b9cb0f42773a1d$export$2e2bcd8739ae039 = $40b9cb0f42773a1d$var$sizeImage;




const $2a03e2090a94ae64$var$sizeImageMid = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "149",
        height: "111",
        viewBox: "0 0 149 111",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M7.45968 0.988281C3.37535 0.988281 0 4.34919 0 8.43353V102.805C0 106.889 3.37535 110.245 7.45968 110.245H141.555C145.639 110.245 149 106.889 149 102.805V8.43353C149 4.34919 145.639 0.988281 141.555 0.988281H7.45968ZM104.305 15.8739H131.622C132.993 15.8793 134.1 16.9956 134.095 18.367V53.1239C134.1 54.4954 132.993 55.6115 131.622 55.617H104.305C102.926 55.6222 101.807 54.503 101.812 53.1239V41.9198C98.9957 40.3526 96.5824 40.484 94.6092 40.9886C92.3425 41.5677 90.9424 42.6571 90.9424 42.6571C88.3224 45.0104 84.9735 40.7859 87.8625 38.7719C87.8625 38.7719 90.071 37.0139 93.382 36.1674C96.6932 35.3208 101.409 35.4127 105.993 38.6992C109.383 41.1299 112.078 41.027 114.204 40.4599C116.33 39.893 117.599 38.8255 117.599 38.8255C120.14 36.3472 123.664 40.5003 120.805 42.6038C120.805 42.6038 118.709 44.4028 115.49 45.2616C113.142 45.8876 110.053 45.9796 106.783 44.7228V50.65H129.148V20.8404H106.783V29.2698C109.803 31.1479 112.248 31.0433 114.204 30.5212C116.33 29.9543 117.599 28.8917 117.599 28.8917C120.139 26.3612 123.713 30.5676 120.805 32.6652C120.805 32.6652 118.709 34.4642 115.49 35.323C112.27 36.1818 107.662 36.0692 103.097 32.7961C99.7259 30.3787 96.876 30.4754 94.6092 31.0548C92.3425 31.6339 90.9424 32.7233 90.9424 32.7233C88.3252 35.0056 85.0408 30.8572 87.8625 28.8333C87.8625 28.8333 90.071 27.08 93.382 26.2336C95.684 25.6451 98.6678 25.5364 101.812 26.612V18.3664C101.807 16.9874 102.926 15.8686 104.305 15.8739ZM74.5097 15.8831C75.7514 15.9018 76.993 16.7496 76.993 18.3667V92.8667C77.069 96.2529 71.9513 96.2529 72.0264 92.8667V18.3667C72.0264 16.6751 73.268 15.8645 74.5097 15.8831ZM27.3118 40.7119H59.5951C62.9095 40.7119 62.9095 45.6835 59.5951 45.6835H27.3118C23.9975 45.6835 23.9975 40.7119 27.3118 40.7119ZM17.3979 53.1239H42.2167C45.4552 53.199 45.4552 58.0188 42.2167 58.0906H17.3979C14.0124 58.1657 14.0124 53.0488 17.3979 53.1239ZM52.1548 53.1239H59.5951C62.8336 53.199 62.8336 58.0188 59.5951 58.0906H52.1548C48.7695 58.1657 48.7695 53.0488 52.1548 53.1239ZM17.2718 65.5551H59.5951C62.9807 65.48 62.9807 70.5966 59.5951 70.5215H17.3979C14.1552 70.6182 13.908 65.794 17.2718 65.5551ZM89.2884 65.5551H131.622C135.007 65.48 135.007 70.5966 131.622 70.5215H89.4048C86.1646 70.606 85.9358 65.7829 89.2884 65.5551ZM89.4048 77.9619H131.621C134.936 77.9619 134.936 82.9335 131.621 82.9335H89.4048C86.0905 82.9335 86.0905 77.9619 89.4048 77.9619ZM89.4048 90.3739H131.621C134.86 90.449 134.86 95.2684 131.621 95.3406H89.4048C86.1663 95.2656 86.1663 90.4462 89.4048 90.3739Z",
            fill: "#FDECD3"
        })
    });
};
var $2a03e2090a94ae64$export$2e2bcd8739ae039 = $2a03e2090a94ae64$var$sizeImageMid;




const $e3c98ae575b9bdc0$var$sizeImageLg = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "199",
        height: "147",
        viewBox: "0 0 199 147",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M9.92523 0.988281C4.49095 0.988281 0 5.46002 0 10.8943V136.457C0 141.891 4.49095 146.356 9.92523 146.356H188.341C193.775 146.356 198.247 141.891 198.247 136.457V10.8943C198.247 5.46002 193.775 0.988281 188.341 0.988281H9.92523ZM138.779 20.7938H175.124C176.949 20.8011 178.423 22.2862 178.416 24.111V70.3555C178.423 72.1803 176.949 73.6653 175.124 73.6727H138.779C136.944 73.6795 135.455 72.1904 135.462 70.3555V55.4483C131.715 53.3632 128.504 53.538 125.879 54.2093C122.863 54.9798 121 56.4293 121 56.4293C117.514 59.5604 113.059 53.9396 116.902 51.26C116.902 51.26 119.841 48.9209 124.246 47.7946C128.652 46.6682 134.927 46.7905 141.025 51.1632C145.535 54.3973 149.122 54.2605 151.95 53.5058C154.779 52.7515 156.468 51.3312 156.468 51.3312C159.848 48.0339 164.537 53.5597 160.733 56.3584C160.733 56.3584 157.944 58.752 153.661 59.8946C150.537 60.7276 146.427 60.8499 142.077 59.1778V67.0639H171.833V27.4018H142.077V38.6173C146.094 41.1161 149.347 40.9769 151.95 40.2823C154.779 39.528 156.468 38.1142 156.468 38.1142C159.847 34.7473 164.602 40.344 160.733 43.1349C160.733 43.1349 157.944 45.5285 153.661 46.6711C149.377 47.8138 143.246 47.664 137.172 43.309C132.687 40.0927 128.895 40.2213 125.879 40.9923C122.863 41.7628 121 43.2122 121 43.2122C117.518 46.2488 113.148 40.7294 116.902 38.0365C116.902 38.0365 119.841 35.7037 124.246 34.5776C127.309 33.7946 131.279 33.6499 135.462 35.081V24.1102C135.456 22.2753 136.944 20.7868 138.779 20.7938ZM99.1363 20.806C100.788 20.831 102.44 21.959 102.44 24.1106V123.234C102.542 127.739 95.7323 127.739 95.8322 123.234V24.1106C95.8322 21.8599 97.4842 20.7813 99.1363 20.806ZM36.3388 53.8412H79.2922C83.702 53.8412 83.702 60.456 79.2922 60.456H36.3388C31.929 60.456 31.929 53.8412 36.3388 53.8412ZM23.1482 70.3555H56.1699C60.4788 70.4554 60.4788 76.8683 56.1699 76.9639H23.1482C18.6437 77.0638 18.6437 70.2556 23.1482 70.3555ZM69.3928 70.3555H79.2922C83.6011 70.4554 83.6011 76.8683 79.2922 76.9639H69.3928C64.8885 77.0638 64.8885 70.2556 69.3928 70.3555ZM22.9803 86.8954H79.2922C83.7968 86.7955 83.7968 93.6033 79.2922 93.5034H23.1482C18.8337 93.632 18.5048 87.2133 22.9803 86.8954ZM118.8 86.8954H175.124C179.629 86.7955 179.629 93.6033 175.124 93.5034H118.955C114.643 93.6157 114.339 87.1985 118.8 86.8954ZM118.954 103.403H175.124C179.534 103.403 179.534 110.018 175.124 110.018H118.954C114.545 110.018 114.545 103.403 118.954 103.403ZM118.954 119.917H175.124C179.433 120.017 179.433 126.429 175.124 126.526H118.954C114.646 126.426 114.646 120.013 118.954 119.917Z",
            fill: "#FDECD3"
        })
    });
};
var $e3c98ae575b9bdc0$export$2e2bcd8739ae039 = $e3c98ae575b9bdc0$var$sizeImageLg;









const $16b7d54b1866db79$var$ToolArrow = (props)=>{
    const { style: style, className: className } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "19",
            height: "17",
            viewBox: "0 0 19 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: style,
            className: className,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M10.5699 15.6341C10.0247 16.569 8.67178 16.5631 8.1347 15.6235L0.801114 2.79264C0.264037 1.85297 0.945586 0.684273 2.0279 0.688985L16.8065 0.753326C17.8888 0.758038 18.5602 1.93262 18.0149 2.86758L10.5699 15.6341Z",
                fill: "white"
            })
        })
    });
};
var $16b7d54b1866db79$export$2e2bcd8739ae039 = $16b7d54b1866db79$var$ToolArrow;



const $7df0aa657b3610ff$var$CustomTooltip = ({ place: place, children: children, open: open, handleClose: handleClose })=>{
    const tooltipRef = (0, $lt6Ts$useRef)(null);
    const handleClickAway = (event)=>{
        if (tooltipRef.current && !tooltipRef.current.contains(event.target)) handleClose?.();
    };
    (0, $lt6Ts$useEffect)(()=>{
        if (open) document.addEventListener("mousedown", handleClickAway);
        else document.removeEventListener("mousedown", handleClickAway);
        return ()=>{
            document.removeEventListener("mousedown", handleClickAway);
        };
    }, [
        open
    ]);
    //  positions
    const positions = (place)=>{
        switch(place){
            case "top":
                return {
                    inset: "-98px 0px auto 10%"
                };
            case "bottom":
                return {
                    inset: "auto 0px -17px 9.3%"
                };
            default:
                return {
                    top: "0",
                    left: "0"
                };
        }
    };
    const arrowPosition = (place)=>{
        switch(place){
            case "top":
                return {
                    inset: "auto auto -8px 15px"
                };
            case "bottom":
                return {
                    inset: "-10px auto auto 15px",
                    transform: "rotate(180deg)"
                };
            default:
                return {
                    top: "0",
                    left: "0"
                };
        }
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: open && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "custom-tooltip",
            ref: tooltipRef,
            style: positions(place),
            children: [
                children,
                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $16b7d54b1866db79$export$2e2bcd8739ae039), {
                    className: "arrow",
                    style: arrowPosition(place)
                })
            ]
        })
    });
};
var $7df0aa657b3610ff$export$2e2bcd8739ae039 = $7df0aa657b3610ff$var$CustomTooltip;





const $94c98f5504771208$var$Search = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "24px",
            viewBox: "0 -960 960 960",
            width: "24px",
            fill: fill,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"
            })
        })
    });
};
var $94c98f5504771208$export$2e2bcd8739ae039 = $94c98f5504771208$var$Search;




const $d1daedf6fbcf28dd$var$Cancel = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "24px",
            viewBox: "0 -960 960 960",
            width: "24px",
            fill: fill,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
            })
        })
    });
};
var $d1daedf6fbcf28dd$export$2e2bcd8739ae039 = $d1daedf6fbcf28dd$var$Cancel;




const $23a5f5a70e647bba$var$VideoInfo = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 13 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("mask", {
                    id: "mask0_8102_4109",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "13",
                    height: "13",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M0.0117188 0.5H12.0117V12.5H0.0117188V0.5Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("g", {
                    mask: "url(#mask0_8102_4109)",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M6.01172 12.5C2.70341 12.5 0.0117188 9.8083 0.0117188 6.5C0.0117188 3.1917 2.70341 0.5 6.01172 0.5C9.31988 0.5 12.0117 3.1917 12.0117 6.5C12.0117 9.8083 9.31988 12.5 6.01172 12.5ZM6.01172 1.36994C3.18229 1.36994 0.880932 3.67057 0.880932 6.5C0.880932 9.32856 3.18229 11.6301 6.01172 11.6301C8.84028 11.6301 11.1424 9.32856 11.1424 6.5C11.1424 3.67057 8.84028 1.36994 6.01172 1.36994Z",
                        fill: "var(--primary-color)"
                    })
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M6.13339 9.61305C6.08724 9.59555 6.03747 9.56705 6.03747 9.44624C6.03747 9.39633 6.04528 9.3386 6.06293 9.26815L6.82075 5.59425C6.83767 5.50802 6.84635 5.4176 6.84635 5.32761C6.84635 5.09019 6.77315 4.90949 6.62876 4.78985C6.30512 4.52393 5.73886 4.57616 4.79688 4.89445L4.70544 4.92526L4.66797 5.39922H4.8261C5.30584 5.39922 5.42159 5.43669 5.4456 5.44841C5.47786 5.46375 5.49552 5.48212 5.49552 5.53609C5.49552 5.56603 5.49175 5.59989 5.48394 5.63736C5.47454 5.68727 5.46325 5.745 5.4524 5.80721L4.75796 9.18149C4.72569 9.35133 4.70877 9.49717 4.70877 9.61349C4.70877 9.88229 4.78646 10.09 4.93793 10.2304C5.08637 10.3672 5.29008 10.437 5.54282 10.437C5.83869 10.437 6.23582 10.3548 6.75622 10.1865L6.84925 10.1565L6.88672 9.67613H6.7296C6.37384 9.67613 6.20949 9.64155 6.13339 9.61305Z",
                    fill: "var(--primary-color)"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M7.13064 2.76837C6.9877 2.63223 6.80396 2.5625 6.58492 2.5625C6.35807 2.5625 6.16609 2.63715 6.01505 2.78371C5.8627 2.93113 5.78516 3.12948 5.78516 3.37399C5.78516 3.59896 5.85894 3.78574 6.00405 3.93056C6.14931 4.07639 6.33521 4.15017 6.5557 4.15017C6.78067 4.15017 6.97092 4.0719 7.12269 3.91884C7.27344 3.76591 7.34968 3.56713 7.34968 3.32784C7.34968 3.09418 7.27648 2.90596 7.13064 2.76837Z",
                    fill: "var(--primary-color)"
                })
            ]
        })
    });
};
var $23a5f5a70e647bba$export$2e2bcd8739ae039 = $23a5f5a70e647bba$var$VideoInfo;




const $d3482aca521aca80$var$ToolCancel = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "11",
            height: "11",
            viewBox: "0 0 11 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.75 5.35076C0.75 4.03939 1.26845 2.78174 2.19131 1.85446C3.11417 0.927188 4.36583 0.40625 5.67094 0.40625C6.97605 0.40625 8.22772 0.927188 9.15057 1.85446C10.0734 2.78174 10.5919 4.03939 10.5919 5.35076C10.5919 6.66212 10.0734 7.91978 9.15057 8.84705C8.22772 9.77433 6.97605 10.2953 5.67094 10.2953C4.36583 10.2953 3.11417 9.77433 2.19131 8.84705C1.26845 7.91978 0.75 6.66212 0.75 5.35076ZM5.67094 1.11549C4.55303 1.11549 3.48091 1.5617 2.69043 2.35597C1.89995 3.15024 1.45586 4.22749 1.45586 5.35076C1.45586 6.47402 1.89995 7.55128 2.69043 8.34555C3.48091 9.13981 4.55303 9.58603 5.67094 9.58603C6.78885 9.58603 7.86097 9.13981 8.65145 8.34555C9.44193 7.55128 9.88602 6.47402 9.88602 5.35076C9.88602 4.22749 9.44193 3.15024 8.65145 2.35597C7.86097 1.5617 6.78885 1.11549 5.67094 1.11549ZM7.41998 3.59409C7.48963 3.66409 7.52875 3.75902 7.52875 3.858C7.52875 3.95698 7.48963 4.05191 7.41998 4.12191L6.19625 5.35076L7.41998 6.57961C7.48974 6.6497 7.52893 6.74476 7.52893 6.84389C7.52893 6.94302 7.48974 7.03808 7.41998 7.10817C7.35022 7.17827 7.25561 7.21764 7.15696 7.21764C7.0583 7.21764 6.96369 7.17827 6.89393 7.10817L5.67094 5.87858L4.44795 7.10817C4.41341 7.14288 4.3724 7.17041 4.32727 7.18919C4.28214 7.20798 4.23377 7.21764 4.18492 7.21764C4.13608 7.21764 4.08771 7.20798 4.04258 7.18919C3.99745 7.17041 3.95644 7.14288 3.9219 7.10817C3.88736 7.07347 3.85996 7.03227 3.84127 6.98692C3.82257 6.94157 3.81295 6.89297 3.81295 6.84389C3.81295 6.79481 3.82257 6.74621 3.84127 6.70086C3.85996 6.65551 3.88736 6.61431 3.9219 6.57961L5.14563 5.35076L3.9219 4.12191C3.85214 4.05182 3.81295 3.95675 3.81295 3.85763C3.81295 3.7585 3.85214 3.66343 3.9219 3.59334C3.99166 3.52325 4.08627 3.48387 4.18492 3.48387C4.28358 3.48387 4.37819 3.52325 4.44795 3.59334L5.67094 4.82294L6.89393 3.59334C6.92844 3.55858 6.96944 3.531 7.01457 3.51218C7.0597 3.49336 7.10809 3.48368 7.15696 3.48368C7.20582 3.48368 7.25421 3.49336 7.29934 3.51218C7.34447 3.531 7.38547 3.55932 7.41998 3.59409Z",
                fill: "black"
            })
        })
    });
};
var $d3482aca521aca80$export$2e2bcd8739ae039 = $d3482aca521aca80$var$ToolCancel;



const $ec73244cd7283520$var$errorStyles = {
    color: "var(--error-color)",
    fontWeight: "400",
    fontSize: "14px",
    margin: "0"
};
const $ec73244cd7283520$var$Input = ({ variant: variant = "input", type: type, value: value, onChange: onChange, placeholder: placeholder, label: label, error: error, inputIcon: inputIcon = false, onClick: onClick, searchApplied: searchApplied, removeSearchInput: removeSearchInput, onKeyDown: onKeyDown, builderInput: builderInput, gellerySearch: gellerySearch = false, videoTooltip: videoTooltip = false, handleFileRemove: handleFileRemove, qrField: qrField = false })=>{
    const InputVariant = variant || "input";
    const [showTooltip, setShowTooltip] = (0, $lt6Ts$useState)(false);
    const loomButtonStyles = {
        backgroundColor: "var(--primary-color)",
        fontSize: "12px",
        padding: "10px 20px",
        borderRadius: "4px",
        maxHeight: "25px"
    };
    const URLTooltip = /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: "videoUrlTooltip",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("p", {
                children: "You can use Loom to create this video. Create your free Loom account now."
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                style: loomButtonStyles,
                onClick: (e)=>{
                    e.stopPropagation();
                    window.open("https://www.loom.com/", "_blank");
                },
                children: "Open Loom"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d3482aca521aca80$export$2e2bcd8739ae039), {
                onClick: ()=>setShowTooltip(false)
            })
        ]
    });
    const handleClose = ()=>{
        setShowTooltip(false);
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: `input-layout ${gellerySearch && "gallery-input-layout"} ${qrField && "qr-input-layout"}`,
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("label", {
                className: "basic-label",
                children: [
                    label ? label : "",
                    videoTooltip && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                className: "urlTooltip",
                                onMouseOver: ()=>setShowTooltip(true),
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $23a5f5a70e647bba$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7df0aa657b3610ff$export$2e2bcd8739ae039), {
                                children: URLTooltip,
                                open: showTooltip,
                                handleClose: handleClose,
                                place: "top"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                className: `input-with-icon ${searchApplied && "focused"} ${error ? "errorBorder" : ""} ${gellerySearch && "galleryInput"} ${qrField && "qrInputDiv"}`,
                children: [
                    type === "file" ? /*#__PURE__*/ (0, $lt6Ts$jsx)("input", {
                        type: "file",
                        onChange: (e)=>onChange(e),
                        accept: ".png, .jpg, .jpeg, .pdf, .doc, .docx",
                        multiple: true,
                        className: `basic-input ${builderInput && "builder-input"}`
                    }) : /*#__PURE__*/ (0, $lt6Ts$jsx)(InputVariant, {
                        type: type,
                        value: value,
                        onChange: onChange,
                        placeholder: placeholder,
                        className: `basic-input ${builderInput && "builder-input"}`,
                        onKeyDown: onKeyDown
                    }),
                    inputIcon && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                        children: [
                            searchApplied && value?.length > 0 ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                className: "cancel-input-button",
                                onClick: removeSearchInput,
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d1daedf6fbcf28dd$export$2e2bcd8739ae039), {
                                    fill: "var(--border-color)"
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                className: "search-input-button",
                                onClick: value?.length > 0 ? onClick : ()=>{},
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $94c98f5504771208$export$2e2bcd8739ae039), {
                                    fill: "var(--primary-color)"
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                variant: "p",
                style: $ec73244cd7283520$var$errorStyles,
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("sup", {
                        children: "*"
                    }),
                    error
                ]
            })
        ]
    });
};
var $ec73244cd7283520$export$2e2bcd8739ae039 = $ec73244cd7283520$var$Input;





const $234cc960d2851879$var$Divider = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
        className: "basic-divider"
    });
};
var $234cc960d2851879$export$2e2bcd8739ae039 = $234cc960d2851879$var$Divider;



const $dd071d7635be500b$var$templateHeadingStyles = {
    color: `var(--primary-color)`,
    fontSize: `24px`,
    fontStyle: `normal`,
    fontWeight: `600`,
    lineHeight: `normal`,
    marginBottom: `20px`
};
const $dd071d7635be500b$var$templateTextStyles = {
    color: `var(--text-color)`,
    fontSize: `14px`,
    fontStyle: `normal`,
    fontWeight: `400`,
    lineHeight: `normal`,
    marginBottom: `16px`
};
const $dd071d7635be500b$var$footerButtonStyles = {
    width: "100%",
    maxWidth: "100px",
    height: "100%",
    minHeight: "40px",
    textTransform: "capitalize",
    borderRadius: "3px",
    backgroundColor: "transparent",
    color: `var(--text-color)`,
    fontSize: `14px`,
    fontWeight: `500`
};
const $dd071d7635be500b$var$Images = {
    Postcards: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $a3dccc8cd7537679$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Professional Letters": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $4da602e86842d002$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Personal Letters": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $46ab710e0dcc7cb7$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Real Penned Letter": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d228491c12a2f715$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Tri-Fold Self-Mailers": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $cf616f1351ec93fa$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Bi-Fold Self-Mailers": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $439af3dad161fcd7$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    }),
    "Snap Pack Mailers": /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $9c48558216468543$export$2e2bcd8739ae039), {
        fill: "var(--svg-color)"
    })
};
const $dd071d7635be500b$var$CreateTemplate = ({ onReturnAndNavigate: onReturnAndNavigate, createTemplateRoute: createTemplateRoute, templateBuilderRoute: templateBuilderRoute, restrictedProducts: restrictedProducts })=>{
    const [isError, setIsError] = (0, $lt6Ts$useState)(false);
    const [envelopeType, setEnvelopeType] = (0, $lt6Ts$useState)([]);
    const [inputValue, setInputValue] = (0, $lt6Ts$useState)("");
    const title = (0, $lt6Ts$useSelector)((state)=>state.templates.title) || "";
    const product = (0, $lt6Ts$useSelector)((state)=>state.templates.product);
    const products = (0, $lt6Ts$useSelector)((state)=>state.templates.products);
    const templateType = (0, $lt6Ts$useSelector)((state)=>state.templates.templateType);
    const dispatch = (0, $lt6Ts$useDispatch)();
    const navigate = (0, $lt6Ts$useNavigate)();
    const restrictedSet = new Set((restrictedProducts ?? []).map((id)=>String(id)));
    const sortedProducts = products?.sort((a, b)=>{
        const indexA = (0, $7ad22e5ca6c288ca$export$e75e577b199ead61).indexOf(a.productType);
        const indexB = (0, $7ad22e5ca6c288ca$export$e75e577b199ead61).indexOf(b.productType);
        return indexA - indexB;
    }).filter((product)=>{
        return !restrictedSet.has(String(product.id)); // Convert product.id to string before checking
    });
    const filteredEnvelopeTypes = (0, $ad01ab85e9f42d02$export$dcaac635f59e4181).filter((type)=>{
        return !restrictedProducts?.includes(type.productId);
    });
    const handleNext = ()=>{
        const trimedTitle = title.trim();
        if (!trimedTitle || trimedTitle?.length > 50 || !templateType || !product || product && product.productType === "Postcards" && !product?.selectedSize || product && product.productType === "Professional Letters" && !Object.keys(envelopeType).length) setIsError(true);
        else {
            let envelope = "";
            if (product.productType === "Professional Letters") //@ts-ignore
            envelope = (0, $ad01ab85e9f42d02$export$dcaac635f59e4181).find(//@ts-ignore
            (envelope)=>envelope?.label === envelopeType.label)?.type;
            dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("title", trimedTitle));
            dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("envelopeType", envelope));
            navigate(templateBuilderRoute ? templateBuilderRoute : "/template-builder");
        }
    };
    const ProductTooltipContent = ({ product: product })=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "productTooltipContent",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                    className: "heading",
                    children: product?.productType
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "contentWrapper",
                    children: [
                        product?.size && product?.size.map((size, idx)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                        children: "Size:"
                                    }),
                                    " ",
                                    size.size
                                ]
                            }, idx)),
                        product?.paper && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                    children: "Paper: "
                                }),
                                " ",
                                product?.paper,
                                " "
                            ]
                        }),
                        +product?.id !== 2 && product?.envelope && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                    children: "Envelope: "
                                }),
                                " ",
                                product?.envelope,
                                " "
                            ]
                        }),
                        +product?.id === 2 && product?.envelope && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                    children: "Windowed Envelope: "
                                }),
                                " ",
                                product?.envelope,
                                " "
                            ]
                        }),
                        +product?.id === 2 && product?.nonEnvelope && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                    children: "Non-Windowed Envelope: "
                                }),
                                " ",
                                product?.nonEnvelope,
                                " "
                            ]
                        })
                    ]
                })
            ]
        });
    (0, $lt6Ts$useEffect)(()=>{
        dispatch((0, $dbaee5ca78364d67$export$df7b8ffccf8fe273)());
        dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
        (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("formData");
        dispatch({
            type: (0, $e496cac0faa1ff17$export$71c26416d85db4e1)
        });
    }, []);
    (0, $lt6Ts$useEffect)(()=>{
        if (sortedProducts?.length) dispatch((0, $dbaee5ca78364d67$export$f8e6fdbf45160f24)(sortedProducts[0]));
    }, [
        products
    ]);
    (0, $lt6Ts$useEffect)(()=>{
        if (product && product?.productType === "Professional Letters") {
            if (Object.keys(envelopeType).length) setIsError(false);
            //@ts-ignore
            if (envelopeType?.label === "Non-Windowed Envelope") dispatch((0, $dbaee5ca78364d67$export$f8e6fdbf45160f24)(sortedProducts.find((item)=>item.windowed === false)));
            else if (envelopeType?.label === "Windowed Envelope") dispatch((0, $dbaee5ca78364d67$export$f8e6fdbf45160f24)(sortedProducts.find((item)=>item.windowed === true)));
        }
    }, [
        envelopeType
    ]);
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                className: "hideTemplateBuilder",
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE_MESSAGE_ON_SMALL_SCREEN
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                className: "createTemplateMaindiv",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$cc55614734af2d87), {
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                                    lg: 6,
                                    md: 6,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        className: "createTemplateHeader",
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                style: $dd071d7635be500b$var$templateHeadingStyles,
                                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.TITLE
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                className: "templateInputWrapper",
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    value: inputValue,
                                                    onChange: (e)=>{
                                                        setInputValue(e.target.value);
                                                        dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("title", e.target.value));
                                                    },
                                                    placeholder: "Template Name",
                                                    inputIcon: false,
                                                    error: !title.trim() && isError ? (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NAME_REQUIRED : title.length > 50 && isError ? (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NAME_LESS_50 : "",
                                                    label: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.TEMPLATE_LABEL
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $234cc960d2851879$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$cc55614734af2d87), {
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                                    lg: 12,
                                    md: 12,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        className: "productTypeWrapper",
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                className: "productHeading",
                                                children: [
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                        style: {
                                                            ...$dd071d7635be500b$var$templateTextStyles,
                                                            marginBottom: "0px"
                                                        },
                                                        children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.PRODUCT_LABEL
                                                    }),
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$NavLink), {
                                                        to: (0, $7ad22e5ca6c288ca$export$b14103b5b94712c4),
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                            children: [
                                                                " ",
                                                                (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.LEARN_TEXT
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                className: "productsWrapper",
                                                style: {
                                                    marginBottom: product && (product.productType.includes("Postcards") || product.productType.includes("Professional Letters")) ? undefined : "100px"
                                                },
                                                children: sortedProducts && sortedProducts?.filter((prod)=>{
                                                    if (restrictedSet.has("2") || restrictedSet.has("4")) return true;
                                                    else return prod.windowed !== false;
                                                }).map((prod, index)=>{
                                                    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                        className: `productCard ${prod.productType === (product && product.productType) ? "active" : ""} ${isError && !product ? "error" : ""} `,
                                                        onClick: ()=>dispatch((0, $dbaee5ca78364d67$export$f8e6fdbf45160f24)(prod)),
                                                        children: [
                                                            $dd071d7635be500b$var$Images[prod.productType],
                                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                                children: prod.productType
                                                            }),
                                                            /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                                className: `productTooltip productTooltip-${index}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                                        fill: "var(--primary-color)",
                                                                        className: `productTooltipIcon-${index} olc-hidden`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                                        anchorSelect: `.productTooltipIcon-${index}`,
                                                                        place: "right",
                                                                        className: "customTooltipClass olc-hidden",
                                                                        title: /*#__PURE__*/ (0, $lt6Ts$jsx)(ProductTooltipContent, {
                                                                            product: prod
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            isError && !product && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                className: "error-field",
                                                children: [
                                                    "*",
                                                    (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.PRODUCT_TYPE_REQUIRED
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            product?.productType?.includes("Postcards") || product?.productType?.includes("Professional Letters") ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $234cc960d2851879$export$2e2bcd8739ae039), {}) : null,
                            product && product.productType === "Professional Letters" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$cc55614734af2d87), {
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                                    lg: 6,
                                    md: 6,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                        className: "templateSelectWrapper",
                                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f4ef87f7a4a530a$export$2e2bcd8739ae039), {
                                            className: "",
                                            //@ts-ignore
                                            selectedValue: envelopeType,
                                            //@ts-ignore
                                            setSelectedValue: setEnvelopeType,
                                            //@ts-ignore
                                            options: filteredEnvelopeTypes,
                                            placeholder: "Envelope Type",
                                            error: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.ENVELOPE_TYPE_REQUIRED,
                                            isError: isError && !Object.keys(envelopeType).length,
                                            label: "Envelope Type*"
                                        })
                                    })
                                })
                            }),
                            product && product?.productType === "Postcards" && product?.size && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$cc55614734af2d87), {
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                                    lg: 12,
                                    md: 12,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        className: "postCardSizeWrapper",
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                className: "postCardHeading",
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                    style: $dd071d7635be500b$var$templateTextStyles,
                                                    children: "Postcard Size*"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                className: "postCardWrapper",
                                                children: product?.size.sort((a, b)=>a.id.localeCompare(b.id)).map((type, index)=>{
                                                    const size = type.size.split("x");
                                                    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                        onClick: ()=>dispatch((0, $dbaee5ca78364d67$export$6689c052aee06540)({
                                                                ...type,
                                                                size: product.size,
                                                                selectedSize: type.size
                                                            }, "Postcards")),
                                                        className: index === 0 ? `postCard postCard-small ${product.selectedSize === type.size ? "active" : ""}` : index === 1 ? `postCard postCard-mid ${product.selectedSize === type.size ? "active" : ""}` : index === 2 ? `postCard postCard-large ${product.selectedSize === type.size ? "active" : ""}` : `postCard ${product.selectedSize === type.size ? "active" : ""}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                                children: [
                                                                    size[0],
                                                                    "\u201D x ",
                                                                    size[1],
                                                                    '"'
                                                                ]
                                                            }),
                                                            index === 0 ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $40b9cb0f42773a1d$export$2e2bcd8739ae039), {}) : index === 1 ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $2a03e2090a94ae64$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e3c98ae575b9bdc0$export$2e2bcd8739ae039), {})
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            isError && product && product.productType === "Postcards" && !product.selectedSize && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                                className: "error-field",
                                                children: [
                                                    "*",
                                                    (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.POSTCARD_SIZE_REQUIRED
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                        className: "footerBtns",
                        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            className: "createTemplateBtns",
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                    style: {
                                        ...$dd071d7635be500b$var$footerButtonStyles,
                                        border: "0.5px solid var(--border-color)"
                                    },
                                    onClick: ()=>onReturnAndNavigate ? onReturnAndNavigate() : navigate(createTemplateRoute || "/create-template"),
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.CANCEL_BUTTON
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                    style: {
                                        ...$dd071d7635be500b$var$footerButtonStyles,
                                        color: "#ffffff",
                                        backgroundColor: "var(--primary-color)"
                                    },
                                    onClick: handleNext,
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CREATE.SUBMIT_BUTTON
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $49857baad0b39325$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $dd071d7635be500b$export$2e2bcd8739ae039 = $dd071d7635be500b$var$CreateTemplate;













const $6ca040a325a745aa$export$fe7c49d056ea1d88 = (message, heading = "")=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$bcebd1097d6619a3),
            payload: {
                message: message,
                heading: heading
            }
        });
    };
const $6ca040a325a745aa$export$af2dba6db4e9e1f0 = (message, heading = "")=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$be1c2eafe8725e5f),
            payload: {
                message: message,
                heading: heading
            }
        });
    };
const $6ca040a325a745aa$export$823cdc5238933767 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $e496cac0faa1ff17$export$5a5bdcd828e4c856)
        });
    };





// Define the type for the element being added
// Reusable function to create text elements
const $768744b4722fb808$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: true,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $768744b4722fb808$export$f5707e68f180b61d = (store)=>{
    const page = store.pages[1];
    const elements = [
        $768744b4722fb808$var$createTextElement("cont-id-placeholder", "C:", 434.8965200108928, 358.75, 11),
        $768744b4722fb808$var$createTextElement("contId", "0000001", 437.87147997910796, 358.75, 30),
        $768744b4722fb808$var$createTextElement("sequence-id-placeholder", "| S:", 461.87147998410796, 358.75, 12),
        $768744b4722fb808$var$createTextElement("sequence", "0000001", 467.8714799891078, 358.75, 29),
        $768744b4722fb808$var$createTextElement("template-id-placeholder", "| T:", 491.5271239974538, 358.75, 14),
        $768744b4722fb808$var$createTextElement("templateId", "0001034", 498.5271240024538, 358.75, 29),
        $768744b4722fb808$var$createTextElement("order-id-placeholder", "| O:", 523.3714799941077, 358.75, 11),
        $768744b4722fb808$var$createTextElement("orderId", "0000127", 528.8714799991075, 358.75, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};
const $768744b4722fb808$export$899209a621893be4 = (store)=>{
    const page = store.pages[1];
    const elements = [
        $768744b4722fb808$var$createTextElement("cont-id-placeholder", "C:", 707.8534189829551, 542, 11),
        $768744b4722fb808$var$createTextElement("contId", "0000001", 711.2754448793503, 542, 30),
        $768744b4722fb808$var$createTextElement("sequence-id-placeholder", "| S:", 737.1400149293197, 542, 12),
        $768744b4722fb808$var$createTextElement("sequence", "0000001", 743.1400149343198, 542, 29),
        $768744b4722fb808$var$createTextElement("template-id-placeholder", "| T:", 767.506110379385, 542, 14),
        $768744b4722fb808$var$createTextElement("templateId", "0001034", 774.5061103843851, 542, 29),
        $768744b4722fb808$var$createTextElement("order-id-placeholder", "| O:", 801.4538896665712, 542, 11),
        $768744b4722fb808$var$createTextElement("orderId", "0000127", 806.9538896715718, 542, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};
const $768744b4722fb808$export$66ae5fd335496bc4 = (store)=>{
    const page = store.pages[1];
    const elements = [
        $768744b4722fb808$var$createTextElement("cont-id-placeholder", "C:", 909.5172787002037, 540, 11),
        $768744b4722fb808$var$createTextElement("contId", "0000001", 912.032892116843, 540, 30),
        $768744b4722fb808$var$createTextElement("sequence-id-placeholder", "| S:", 936.0328921218431, 540, 12),
        $768744b4722fb808$var$createTextElement("sequence", "0000001", 942.032892126843, 540, 29),
        $768744b4722fb808$var$createTextElement("template-id-placeholder", "| T:", 964.0328921318434, 540, 14),
        $768744b4722fb808$var$createTextElement("templateId", "0001034", 971.032892136843, 540, 29),
        $768744b4722fb808$var$createTextElement("order-id-placeholder", "| O:", 996.7496765011042, 540, 11),
        $768744b4722fb808$var$createTextElement("orderId", "0000127", 1002.2496765061048, 540, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
// Reusable function to create text elements
const $51508741c150f786$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: false,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $51508741c150f786$export$5954736cf3fbdf78 = (store)=>{
    const page = store.pages[0];
    const elements = [
        $51508741c150f786$var$createTextElement("cont-id-placeholder", "C:", 310.99252000089285, 246.16, 11),
        $51508741c150f786$var$createTextElement("contId", "0000001", 313.96747996910744, 246.16, 30),
        $51508741c150f786$var$createTextElement("sequence-id-placeholder", "| S:", 337.9674799741075, 246.16, 12),
        $51508741c150f786$var$createTextElement("sequence", "0000001", 343.9674799791074, 246.16, 29),
        $51508741c150f786$var$createTextElement("template-id-placeholder", "| T:", 367.6231239874537, 246.16, 14),
        $51508741c150f786$var$createTextElement("templateId", "0001034", 374.6231239924535, 246.16, 29),
        $51508741c150f786$var$createTextElement("order-id-placeholder", "| O:", 399.4674799841078, 246.16, 11),
        $51508741c150f786$var$createTextElement("orderId", "0000127", 404.9674799891071, 246.16, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};
const $51508741c150f786$export$ce295e98442f9ea4 = (store)=>{
    const page = store.pages[0];
    const elements = [
        $51508741c150f786$var$createTextElement("cont-id-placeholder", "C:", 3.8581732170865024, 1040, 11),
        $51508741c150f786$var$createTextElement("contId", "0000001", 6.833133185301714, 1040, 30),
        $51508741c150f786$var$createTextElement("sequence-id-placeholder", "| S:", 30.83313319030166, 1040, 12),
        $51508741c150f786$var$createTextElement("sequence", "0000001", 36.833133195301436, 1040, 29),
        $51508741c150f786$var$createTextElement("template-id-placeholder", "| T:", 60.48877720364756, 1040, 14),
        $51508741c150f786$var$createTextElement("templateId", "0001034", 67.48877720864735, 1040, 29),
        $51508741c150f786$var$createTextElement("order-id-placeholder", "| O:", 92.33313320030143, 1040, 11),
        $51508741c150f786$var$createTextElement("orderId", "0000127", 97.8331332053007, 1040, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
// Reusable function to create text elements
const $485d56f548def85d$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: true,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $485d56f548def85d$export$a29cc4742dc0ae55 = (store)=>{
    const page = store.pages[0];
    const elements = [
        $485d56f548def85d$var$createTextElement("cont-id-placeholder", "C:", 3.8581732170865024, 803, 11),
        $485d56f548def85d$var$createTextElement("contId", "0000001", 6.833133185301714, 803, 30),
        $485d56f548def85d$var$createTextElement("sequence-id-placeholder", "| S:", 30.83313319030166, 803, 12),
        $485d56f548def85d$var$createTextElement("sequence", "0000001", 36.833133195301436, 803, 29),
        $485d56f548def85d$var$createTextElement("template-id-placeholder", "| T:", 60.48877720364756, 803, 14),
        $485d56f548def85d$var$createTextElement("templateId", "0001034", 67.48877720864735, 803, 29),
        $485d56f548def85d$var$createTextElement("order-id-placeholder", "| O:", 92.33313320030143, 803, 11),
        $485d56f548def85d$var$createTextElement("orderId", "0000127", 97.8331332053007, 803, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
// Reusable function to create text elements
const $d9e2cab277ae8df0$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: true,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $d9e2cab277ae8df0$export$f9ad0aa59cab1535 = (store)=>{
    const page = store.pages[0];
    const elements = [
        $d9e2cab277ae8df0$var$createTextElement("cont-id-placeholder", "C:", 726.6250400017847, 541.5, 11),
        $d9e2cab277ae8df0$var$createTextElement("contId", "0000001", 729.5999999700006, 541.5, 30),
        $d9e2cab277ae8df0$var$createTextElement("sequence-id-placeholder", "| S:", 753.5999999750006, 541.5, 12),
        $d9e2cab277ae8df0$var$createTextElement("sequence", "0000001", 759.5999999800002, 541.5, 29),
        $d9e2cab277ae8df0$var$createTextElement("template-id-placeholder", "| T:", 783.2556439883459, 541.5, 14),
        $d9e2cab277ae8df0$var$createTextElement("templateId", "0001034", 790.2556439933462, 541.5, 29),
        $d9e2cab277ae8df0$var$createTextElement("order-id-placeholder", "| O:", 815.0999999850002, 541.5, 11),
        $d9e2cab277ae8df0$var$createTextElement("orderId", "0000127", 820.59999999, 541.5, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
// Reusable function to create text elements
const $677d0745145b4a1a$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: true,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $677d0745145b4a1a$export$8775983e2ec5c695 = (store)=>{
    const page = store.pages[0];
    const elements = [
        $677d0745145b4a1a$var$createTextElement("cont-id-placeholder", "C:", 711.5154278092572, 741.6, 11),
        $677d0745145b4a1a$var$createTextElement("contId", "0000001", 714.4903877774723, 741.6, 30),
        $677d0745145b4a1a$var$createTextElement("sequence-id-placeholder", "| S:", 738.4903877824727, 741.6, 12),
        $677d0745145b4a1a$var$createTextElement("sequence", "0000001", 744.4903877874724, 741.6, 29),
        $677d0745145b4a1a$var$createTextElement("template-id-placeholder", "| T:", 768.1460317958182, 741.6, 14),
        $677d0745145b4a1a$var$createTextElement("templateId", "0001034", 775.1460318008185, 741.6, 29),
        $677d0745145b4a1a$var$createTextElement("order-id-placeholder", "| O:", 799.9903877924726, 741.6, 11),
        $677d0745145b4a1a$var$createTextElement("orderId", "0000127", 805.4903877974713, 741.6, 29)
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};


// Define the type for the element being added
// Reusable function to create text elements
const $62aa2fc1a3ef221a$var$createTextElement = (id, text, x, y, width)=>({
        id: id,
        type: "text",
        name: "",
        opacity: 1,
        visible: true,
        selectable: false,
        removable: false,
        alwaysOnTop: true,
        showInExport: true,
        x: x,
        y: y,
        width: width,
        height: 11,
        rotation: 0,
        draggable: false,
        resizable: true,
        contentEditable: true,
        styleEditable: false,
        text: text,
        fontSize: 5,
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fill: "grey",
        align: "center",
        verticalAlign: "top",
        lineHeight: 1.2,
        letterSpacing: 0
    });
const $62aa2fc1a3ef221a$export$6a35d731d8b116a5 = (store)=>{
    const pages = [
        store.pages[0],
        store.pages[1]
    ];
    const elements = [
        $62aa2fc1a3ef221a$var$createTextElement("cont-id-placeholder", "C:", 3.8581732170865024, 1040, 11),
        $62aa2fc1a3ef221a$var$createTextElement("contId", "0000001", 6.833133185301714, 1040, 30),
        $62aa2fc1a3ef221a$var$createTextElement("sequence-id-placeholder", "| S:", 30.83313319030166, 1040, 12),
        $62aa2fc1a3ef221a$var$createTextElement("sequence", "0000001", 36.833133195301436, 1040, 29),
        $62aa2fc1a3ef221a$var$createTextElement("template-id-placeholder", "| T:", 60.48877720364756, 1040, 14),
        $62aa2fc1a3ef221a$var$createTextElement("templateId", "0001034", 67.48877720864735, 1040, 29),
        $62aa2fc1a3ef221a$var$createTextElement("order-id-placeholder", "| O:", 92.33313320030143, 1040, 11),
        $62aa2fc1a3ef221a$var$createTextElement("orderId", "0000127", 97.8331332053007, 1040, 29)
    ];
    elements.forEach((element)=>pages.forEach((page)=>page.addElement(element)));
    store.history.clear();
};


const $729142c3e2d905ee$export$4e7e1f53e01e76b7 = (productId, store)=>{
    if (!productId) return;
    if (+productId === 13) (0, $768744b4722fb808$export$f5707e68f180b61d)(store);
    else if (+productId === 14) (0, $768744b4722fb808$export$899209a621893be4)(store);
    else if (+productId === 15) (0, $768744b4722fb808$export$66ae5fd335496bc4)(store);
    else if (+productId === 2) (0, $51508741c150f786$export$5954736cf3fbdf78)(store);
    else if (+productId === 4) (0, $51508741c150f786$export$ce295e98442f9ea4)(store);
    else if (+productId === 5) (0, $485d56f548def85d$export$a29cc4742dc0ae55)(store);
    else if (+productId === 9) (0, $d9e2cab277ae8df0$export$f9ad0aa59cab1535)(store);
    else if (+productId === 11) (0, $677d0745145b4a1a$export$8775983e2ec5c695)(store);
    else if (+productId === 18) (0, $62aa2fc1a3ef221a$export$6a35d731d8b116a5)(store);
};


// Define the type for the element being added
const $14dc1102dd22ee0f$export$fac40f04596fc189 = (store)=>{
    const page = store.pages[0];
    const elements = [
        {
            id: "content",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: false,
            alwaysOnTop: false,
            showInExport: true,
            x: 26.500000000000114,
            y: 130,
            width: 477,
            height: 456,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: true,
            styleEditable: false,
            text: "Hi ((C.FIRST_NAME)), \n\n We are interested in purchasing your property at ((C.PROPERTY_ADDRESS)). \n  \n     I am a serious buyer with CASH. \n\n Please call me at  ((SPF.PHONE_NUMBER)) to discuss my offer.\n                  \n\n                  Thanks! \n                    ((SPF.FIRST_NAME))",
            fontSize: 20,
            fontFamily: "lexi Regular",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "blue",
            align: "start",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.75,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        },
        {
            id: "safety-box",
            type: "figure",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: true,
            x: -0.000000000011429403222173616,
            y: 595.3928042183522,
            width: 527.9999999999511,
            height: 220.60719578157597,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            subType: "rect",
            fill: "#FFFFFF",
            dash: [],
            strokeWidth: 0,
            stroke: "#0c0c0c",
            cornerRadius: 0
        },
        {
            id: "safety-note",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: false,
            removable: false,
            alwaysOnTop: true,
            showInExport: false,
            x: 4.999999999999986,
            y: 610.8462884505318,
            width: 518,
            height: 22,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: false,
            resizable: false,
            contentEditable: false,
            styleEditable: false,
            text: "**Pen-written area ends here. Keep your message above this line.",
            placeholder: "",
            fontSize: 17,
            fontFamily: "Roboto",
            fontStyle: "italic",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5
        }
    ];
    elements.forEach((element)=>page.addElement(element));
    store.history.clear();
};






var $6095227f2f4b1a81$exports = {};
$6095227f2f4b1a81$exports = JSON.parse('["Roboto","Noto Sans JP","Montserrat","Poppins","Lato","Roboto Condensed","Inter","Oswald","Noto Sans","Roboto Mono","Raleway","Nunito Sans","Rubik","Nunito","Ubuntu","Playfair Display","Merriweather","Noto Sans KR","Roboto Slab","PT Sans","Noto Sans TC","Kanit","Work Sans","Lora","DM Sans","Fira Sans","IBM Plex Sans","Quicksand","Mulish","Barlow","Manrope","Heebo","Titillium Web","PT Serif","Karla","Noto Serif","Libre Franklin","Mukta","Nanum Gothic","Noto Sans SC","Inconsolata","Hind Siliguri","Josefin Sans","Arimo","Archivo","Libre Baskerville","Bebas Neue","Dosis","Cairo","Abel","Space Grotesk","Jost","Source Code Pro","PT Sans Narrow","EB Garamond","Oxygen","Anton","Outfit","Dancing Script","Bitter","Teko","Cabin","Overpass","Noto Sans HK","Barlow Condensed","Noto Serif JP","Exo 2","Pacifico","Hind","Prompt","Assistant","Comfortaa","Lobster","Crimson Text","Signika Negative","Sora","Fjalla One","M PLUS Rounded 1c","Zilla Slab","IBM Plex Mono","Noto Sans Arabic","Rajdhani","Inria Sans","Play","Chakra Petch","Public Sans","Maven Pro","Figtree","Source Sans 3","Varela Round","Archivo Black","Caveat","IBM Plex Sans Arabic","Cormorant Garamond","Red Hat Display","Asap","Permanent Marker","DM Serif Display","Slabo 27px","Arvo","Abril Fatface","Shadows Into Light","Barlow Semi Condensed","Fira Sans Condensed","Almarai","Tajawal","Lilita One","Plus Jakarta Sans","Lexend","Nanum Gothic Coding","Hind Madurai","Questrial","M PLUS 1p","Nanum Myeongjo","Indie Flower","IBM Plex Serif","Yanone Kaffeesatz","Domine","Rowdies","Merriweather Sans","Concert One","Asap Condensed","Orbitron","Source Serif 4","Catamaran","Russo One","Satisfy","Didact Gothic","Archivo Narrow","Signika","Chivo","Cinzel","Sarabun","Vollkorn","Acme","Noto Kufi Arabic","Oleo Script","Urbanist","Roboto Flex","Philosopher","Marcellus","Saira Condensed","Exo","Frank Ruhl Libre","Alegreya","Bree Serif","Alfa Slab One","Amatic SC","Silkscreen","Montserrat Alternates","Black Ops One","Readex Pro","Kalam","Cormorant","Amiri","Alegreya Sans","ABeeZee","Rubik Bubbles","Libre Caslon Text","Be Vietnam Pro","Tinos","Noto Sans Thai","Spectral","Neuton","Great Vibes","Changa","Passion One","Lobster Two","Righteous","Prata","Courgette","Patua One","PT Sans Caption","Arsenal","Lexend Deca","Sawarabi Mincho","Ubuntu Mono","Mate","Martel","Noto Serif KR","Noticia Text","Alice","Ubuntu Condensed","Cardo","Noto Sans Display","Zen Kaku Gothic New","Noto Serif TC","Cantarell","Alata","Fraunces","Yellowtail","Bodoni Moda","Khand","Sacramento","Luckiest Guy","Yantramanav","Francois One","Old Standard TT","Kaushan Script","Space Mono","Crete Round","Sawarabi Gothic","DM Serif Text","El Messiri","Encode Sans","Josefin Slab","Gruppo","Saira","Cuprum","Bungee","Encode Sans Condensed","Noto Naskh Arabic","Inter Tight","Gothic A1","Zeyada","Noto Sans Mono","Crimson Pro","Antic Slab","Pathway Gothic One","Advent Pro","Quattrocento","Quattrocento Sans","Paytone One","Unbounded","Architects Daughter","Mate SC","Gloria Hallelujah","IBM Plex Sans Condensed","Alegreya Sans SC","Commissioner","Unna","Special Elite","Yeseva One","Literata","League Spartan","Rokkitt","Gelasio","Noto Sans Bengali","Tangerine","Yatra One","Roboto Serif","Rubik Mono One","Itim","Cookie","Poiret One","Libre Barcode 39","Unica One","Tenor Sans","Merienda","Carter One","Fira Sans Extra Condensed","Sen","Abhaya Libre","Taviraj","News Cycle","Kosugi Maru","Playfair Display SC","Aleo","Mitr","Sanchez","Bangers","Mukta Malar","Amaranth","Courier Prime","Adamina","Titan One","Noto Sans Devanagari","Staatliches","Allura","Red Hat Text","Baloo 2","Handlee","Patrick Hand","Viga","Ultra","Faustina","Gudea","JetBrains Mono","Sofia","Voltaire","DM Mono","Vidaloka","Zen Maru Gothic","Albert Sans","Epilogue","Petrona","Hammersmith One","Ropa Sans","Bad Script","Neucha","Lalezar","Parisienne","Marck Script","Comic Neue","Pridi","Press Start 2P","Hind Vadodara","Baskervville","PT Mono","Saira Semi Condensed","Six Caps","Monda","Shippori Mincho","Castoro","Volkhov","Audiowide","Cousine","Antonio","Forum","Homemade Apple","Sorts Mill Goudy","Mandali","Krub","Blinker","Fredoka","Mada","Actor","Electrolize","Monoton","Secular One","Reenie Beanie","STIX Two Text","Noto Serif SC","Lusitana","Alex Brush","Noto Sans Tamil","Playball","Ruda","Noto Serif Bengali","Quantico","Alexandria","Jura","Bai Jamjuree","Nanum Pen Script","Pragati Narrow","Share Tech Mono","Mr Dafoe","Julius Sans One","Istok Web","Nothing You Could Do","Rock Salt","Sriracha","Londrina Solid","Eczar","Laila","Varela","Kumbh Sans","League Gothic","BIZ UDPGothic","Armata","Fira Mono","Fugaz One","Pangolin","Geologica","Cabin Condensed","Koulen","Syne","Anonymous Pro","Gilda Display","VT323","Sansita","BenchNine","Italianno","Jaldi","Cutive Mono","Shrikhand","Newsreader","Alef","Libre Bodoni","Creepster","Niramit","Macondo","Pinyon Script","Khula","Days One","Basic","Black Han Sans","Pontano Sans","Playfair","Damion","Saira Extra Condensed","Calistoga","Rufina","GFS Didot","Leckerli One","Kurale","Sarala","Alatsi","Short Stack","Graduate","Sofia Sans Condensed","Holtwood One SC","Amita","Rammetto One","Kreon","Economica","Martel Sans","Quintessential","Covered By Your Grace","Alumni Sans","Dela Gothic One","Changa One","Julee","Noto Sans Hebrew","Atkinson Hyperlegible","Palanquin","Charm","Averia Serif Libre","Racing Sans One","PT Serif Caption","Noto Sans Malayalam","Ramabhadra","Anuphan","Lemonada","Cabin Sketch","Berkshire Swash","Big Shoulders Display","K2D","Aclonica","Karma","Just Me Again Down Here","Suez One","Caveat Brush","Chewy","Glegoo","Pathway Extreme","Coda","Yrsa","Trocchi","Cormorant Infant","Candal","Andika","IBM Plex Sans Thai","Cinzel Decorative","Lustria","Hanken Grotesk","Arapey","Antic","Hind Guntur","Reem Kufi","Athiti","Salsa","Belleza","Michroma","Sintony","Fredericka the Great","Zen Old Mincho","Kiwi Maru","Baloo Bhaijaan 2","Gochi Hand","Rozha One","Syncopate","Pattaya","Sofia Sans","Mali","Nanum Brush Script","Oxanium","Marmelad","Just Another Hand","Balsamiq Sans","Scada","Allerta Stencil","Arizonia","Seaweed Script","Cantata One","Rubik Moonrocks","Jua","Judson","Squada One","Noto Serif Display","Do Hyeon","Shadows Into Light Two","Annie Use Your Telescope","Irish Grover","Oranienbaum","Pirata One","Marcellus SC","Palanquin Dark","Akshar","Brygada 1918","Bevan","Boogaloo","Vazirmatn","BioRhyme","Wallpoet","Mrs Saint Delafield","Radio Canada","Maitree","Averia Libre","Contrail One","M PLUS 1","Podkova","Bellefair","Darker Grotesque","Grandstander","David Libre","Nobile","Telex","Delius","Golos Text","Aldrich","Allerta","Monsieur La Doulaise","Rye","Herr Von Muellerhoff","Coming Soon","Biryani","Lateef","Alike","Hanuman","Limelight","Big Shoulders Text","Baloo Da 2","Bowlby One SC","Caudex","Rancho","Gayathri","Grand Hotel","Aladin","Arbutus Slab","Kristi","Cedarville Cursive","Metrophobic","Krona One","Georama","Corben","Trirong","Henny Penny","La Belle Aurore","Yesteryear","Markazi Text","Bowlby One","Rambla","Ephesis","Average Sans","Spinnaker","Livvic","Vollkorn SC","UnifrakturMaguntia","Chonburi","Sigmar One","Zen Antique","Overlock","Niconne","Gurajada","Kdam Thmor Pro","Mallanna","Manjari","Overpass Mono","B612 Mono","Arya","Nixie One","Knewave","Kosugi","IM Fell English SC","Encode Sans Semi Condensed","Amethysta","Kameron","Ibarra Real Nova","Ovo","Odibee Sans","Halant","Allison","Klee One","Miriam Libre","Grenze Gotisch","Coustard","Bungee Inline","Magra","Glory","Cormorant Upright","Jockey One","Alegreya SC","Amiko","B612","IBM Plex Sans KR","Shippori Mincho B1","Aboreto","Bubblegum Sans","Rochester","Average","Enriqueta","Fanwood Text","Petit Formal Script","Protest Revolution","Homenaje","Calligraffitti","Rasa","Croissant One","Turret Road","IM Fell English","Mina","Fjord One","Gabriela","Italiana","Rosario","Noto Nastaliq Urdu","Kufam","Della Respira","Mansalva","Poller One","Montserrat Subrayada","Love Ya Like A Sister","Stardos Stencil","Tomorrow","Noto Sans Khmer","IM Fell DW Pica","Sniglet","Inria Serif","Nova Square","Brawler","Spectral SC","Thasadith","Waiting for the Sunrise","RocknRoll One","Zen Kaku Gothic Antique","Oxygen Mono","Chivo Mono","Noto Sans Kannada","Bungee Shade","Kaisei Decol","Lemon","Molengo","Young Serif","Carrois Gothic","M PLUS 2","Dawning of a New Day","Elsie","Chelsea Market","NTR","Quando","Fahkwang","Noto Serif Devanagari","Kelly Slab","Style Script","Schoolbell","DotGothic16","Bentham","Sofia Sans Extra Condensed","Cambay","Goudy Bookletter 1911","Azeret Mono","Instrument Sans","ZCOOL XiaoWei","Gabarito","Proza Libre","Vesper Libre","Hahmlet","Antic Didone","Copse","Ma Shan Zheng","Noto Sans Sinhala","Gloock","MuseoModerno","Fondamento","Trykker","Wix Madefor Text","Schibsted Grotesk","Radley","Sue Ellen Francisco","Tillana","Cormorant SC","Federo","Fauna One","Goblin One","Cutive","Meddon","Baloo Paaji 2","Slabo 13px","Ms Madi","Jomhuria","Alike Angular","Zen Kurenaido","Aref Ruqaa","Norican","Modak","Rakkas","Sansita Swashed","Oleo Script Swash Caps","Capriola","Baloo Thambi 2","Kadwa","KoHo","Lexend Zetta","Baloo Tamma 2","Marvel","Share","Headland One","Noto Sans Gujarati","Hepta Slab","Bellota Text","Oregano","Germania One","Nova Mono","Amarante","Oooh Baby","Gravitas One","Qwigley","BIZ UDGothic","Ruslan Display","Padauk","Rouge Script","Prosto One","Dongle","Noto Sans Telugu","Mouse Memoirs","Cambo","Metamorphous","Sedgwick Ave","Gafata","Supermercado One","Notable","Inknut Antiqua","Noto Sans Myanmar","Lexend Exa","Caladea","Shantell Sans","Mountains of Christmas","Yusei Magic","Kodchasan","Freehand","Sumana","Duru Sans","Anaheim","Hurricane","Besley","Meie Script","Megrim","Delius Unicase","Give You Glory","Flamenco","Coiny","Montez","Onest","Hi Melody","Poly","Averia Sans Libre","Mako","Syne Mono","Red Rose","ZCOOL QingKe HuangYou","Saira Stencil One","Happy Monkey","Skranji","Encode Sans Semi Expanded","Walter Turncoat","Fuggles","Over the Rainbow","Noto Sans NKo Unjoined","Vina Sans","Sulphur Point","Noto Serif Malayalam","Spline Sans","Goldman","Fresca","Original Surfer","Abyssinica SIL","Asul","Noto Sans Oriya","Tenali Ramakrishna","Pompiere","Aguafina Script","Mukta Vaani","Wix Madefor Display","Loved by the King","Crafty Girls","Mirza","Gotu","Euphoria Script","Andada Pro","Mr De Haviland","Bungee Hairline","Suranna","Allan","Carme","Sail","Expletus Sans","Baloo Chettan 2","IBM Plex Sans JP","Lekton","Geo","Shalimar","Ledger","BhuTuka Expanded One","IM Fell Double Pica","Inder","Familjen Grotesk","Trade Winds","Puritan","Bigshot One","Galada","Mukta Mahee","Libre Caslon Display","Rampart One","Buenard","Codystar","Clicker Script","Bakbak One","Esteban","Hina Mincho","Gugi","Bayon","Kranky","Xanh Mono","Battambang","Wendy One","Frijole","Murecho","Convergence","Flow Circular","Barriecito","Farro","Whisper","Numans","Kenia","Artifika","Dokdo","Kaisei Opti","Sarpanch","Baloo Bhai 2","Vast Shadow","Lily Script One","BIZ UDPMincho","Libre Barcode 39 Text","Anek Malayalam","Noto Sans Meetei Mayek","Noto Sans Armenian","McLaren","Noto Sans Gurmukhi","Montaga","League Script","Gantari","Gaegu","Noto Serif Georgian","Timmana","Manuale","Fontdiner Swanky","Gluten","Poltawski Nowy","Harmattan","Noto Sans Georgian","Almendra","Vibur","Marhey","Orelega One","Encode Sans Expanded","Mochiy Pop One","Sevillana","Finger Paint","Solway","Zen Antique Soft","Ceviche One","Mogra","Cormorant Unicase","WindSong","Baumans","Overlock SC","Noto Serif Hebrew","Share Tech","Medula One","Reggae One","Slackey","Anta","MedievalSharp","Eater","Road Rage","Akaya Kanadaka","Bricolage Grotesque","Cherry Cream Soda","Major Mono Display","Atma","Kalnia","Comforter Brush","Potta One","Unkempt","Protest Riot","Scope One","Bellota","Birthstone","Emilys Candy","Gamja Flower","IBM Plex Sans Hebrew","Nova Round","Noto Sans Symbols","The Girl Next Door","Balthazar","Tienne","Tilt Warp","Stick","Smooch Sans","Pavanam","Corinthia","Wire One","Bilbo Swash Caps","Doppio One","Charmonman","Fragment Mono","Scheherazade New","Monomaniac One","Macondo Swash Caps","Freckle Face","Shanti","Noto Serif Thai","Kode Mono","Patrick Hand SC","Nokora","Chango","ZCOOL KuaiLe","Madimi One","Mochiy Pop P One","Delius Swash Caps","Kaisei Tokumin","Imprima","Shojumaru","Fasthand","Londrina Outline","Libre Barcode 128","Life Savers","Modern Antiqua","Galdeano","Instrument Serif","Dynalight","Ribeye","Hachi Maru Pop","Gowun Dodum","Belgrano","Libre Barcode 39 Extended Text","ADLaM Display","Orienta","Tiro Kannada","Meera Inimai","Chau Philomene One","Ruthie","Baloo Bhaina 2","Agbalumo","Varta","Anek Tamil","Rubik Dirt","Voces","Recursive","Ranga","Gowun Batang","Spicy Rice","Katibeh","Rosarivo","Peralta","REM","Rhodium Libre","Square Peg","Anek Bangla","Redressed","Prociono","Miniver","Faster One","Pixelify Sans","Monofett","Qwitcher Grypen","Rum Raisin","Anek Latin","Cherry Swash","Song Myung","Namdhinggo","Asar","Gulzar","Stalemate","Suwannaphum","Sofia Sans Semi Condensed","Libre Barcode 128 Text","Ranchers","Engagement","Raleway Dots","Kaisei HarunoUmi","Dorsa","Noto Serif HK","IM Fell French Canon","Smooch","East Sea Dokdo","Edu SA Beginner","Tauri","Crushed","Gemunu Libre","Iceberg","Nosifer","Zilla Slab Highlight","Spline Sans Mono","Swanky and Moo Moo","Tiro Devanagari Hindi","Alkalami","Zen Dots","IM Fell DW Pica SC","Tektur","Arima","Iceland","Denk One","Montagu Slab","Jomolhari","Nova Flat","Kite One","Maiden Orange","Strait","Akaya Telivigala","Alkatra","Stylish","MonteCarlo","Ojuju","IM Fell Great Primer","IBM Plex Sans Thai Looped","Port Lligat Sans","Lovers Quarrel","Fenix","Barrio","Bona Nova","Uncial Antiqua","Train One","Bruno Ace SC","Noto Sans Adlam","Sancreek","Meow Script","Vujahday Script","Metal Mania","Shippori Antique","Sree Krushnadevaraya","Stick No Bills","Cute Font","Milonga","Karantina","Habibi","Stint Ultra Condensed","Ramaraja","Sonsie One","Gorditas","Lexend Mega","Dekko","Jolly Lodger","Yuji Syuku","Viaoda Libre","Sunshiney","Kotta One","Akronim","Baloo Tammudu 2","Paprika","Farsan","Rationale","Girassol","Mystery Quest","Donegal One","Anybody","Beth Ellen","Anek Devanagari","Carrois Gothic SC","Cantora One","Red Hat Mono","Moul","Port Lligat Slab","Caprasimo","Piazzolla","Asset","IM Fell French Canon SC","Yomogi","Genos","Eagle Lake","Kulim Park","Martian Mono","Passions Conflict","Smythe","Kavivanar","Kantumruy Pro","Redacted","Stoke","IM Fell Great Primer SC","Tiro Bangla","Nova Slim","Angkor","Sarina","Delicious Handrawn","Alumni Sans Inline One","Margarine","Keania One","Zhi Mang Xing","Grape Nuts","Offside","Caesar Dressing","Lexend Giga","Moon Dance","Bubbler One","Unlock","Protest Strike","Khmer","IM Fell Double Pica SC","Nova Cut","Sura","Shippori Antique B1","Astloch","Chicle","Carattere","Beau Rivage","Nova Oval","Noto Sans Lao","Nova Script","Srisakdi","Trispace","AR One Sans","Underdog","Text Me One","Cagliostro","Miltonian Tattoo","Long Cang","Averia Gruesa Libre","New Tegomin","Content","Inika","Licorice","Comforter","Englebert","Vampiro One","Finlandica","Aoboshi One","Miltonian","Fascinate","Marko One","Junge","Tilt Prism","Tulpen One","New Rocker","Arbutus","Sirin Stencil","Sahitya","Libre Barcode 39 Extended","Liu Jian Mao Cao","Plaster","Poor Story","Simonetta","Glass Antiqua","Jacques Francois","Anek Telugu","Noto Serif Armenian","Praise","Texturina","Bilbo","Spirax","Black And White Picture","Wellfleet","Mohave","Kirang Haerang","Ravi Prakash","Stint Ultra Expanded","Fuzzy Bubbles","BIZ UDMincho","Seymour One","Nerko One","M PLUS 1 Code","Romanesco","Bahiana","Linden Hill","The Nautigal","Condiment","Noto Sans Math","Bonheur Royale","Noto Sans Lao Looped","Tilt Neon","Ysabeau Office","Anek Gujarati","Birthstone Bounce","Akatab","Autour One","Piedra","Carlito","Lexend Peta","Mrs Sheppards","Belanosima","Joti One","Rubik Doodle Shadow","Charis SIL","Imbue","Koh Santepheap","Elsie Swash Caps","Kumar One","Sedgwick Ave Display","Yeon Sung","Princess Sofia","Gentium Book Plus","Noto Serif Khojki","Noto Serif Sinhala","Lexend Tera","Kumar One Outline","Noto Sans Symbols 2","Noto Serif Telugu","Ruluko","Smokum","Yaldevi","Benne","Oldenburg","Atomic Age","Kavoon","Fascinate Inline","Afacad","Waterfall","Lakki Reddy","Playpen Sans","Bahianita","Sono","Water Brush","Ysabeau","Chela One","Londrina Shadow","Felipa","Micro 5","Zen Tokyo Zoo","Bungee Spice","Noto Sans Khojki","Gupter","Risque","Flavors","Preahvihear","Chathura","Dhurjati","Noto Sans Thai Looped","Ribeye Marrow","Imperial Script","Hanalei Fill","Noto Sans Anatolian Hieroglyphs","Qahiri","Jacques Francois Shadow","Lancelot","Galindo","Braah One","Grenze","Emblema One","Ewert","Diplomata SC","Festive","Anek Gurmukhi","Encode Sans SC","DynaPuff","Griffy","Rethink Sans","Labrada","Chilanka","Bungee Outline","Amiri Quran","Flow Rounded","Noto Sans Cham","Noto Sans Osmanya","Solitreo","Almendra SC","Climate Crisis","Phudu","Ysabeau Infant","Mea Culpa","IBM Plex Sans Devanagari","Gentium Plus","Castoro Titling","Dangrek","Noto Sans Samaritan","BioRhyme Expanded","Odor Mean Chey","Noto Sans Gothic","Annapurna SIL","Revalia","Noto Sans Ethiopic","Snippet","Gidugu","Big Shoulders Stencil Text","Anek Kannada","Hedvig Letters Sans","Lacquer","Metal","Joan","Erica One","Agdasima","Gasoek One","Combo","Almendra Display","Dr Sugiyama","Federant","Stalinist One","Peddana","Luxurious Script","Flow Block","Alumni Sans Collegiate One","Noto Sans Lepcha","Ruge Boogie","Slackside One","Borel","Londrina Sketch","Rubik Glitch","Big Shoulders Inline Text","Foldit","Chenla","Konkhmer Sleokchher","Victor Mono","Comme","Jim Nightshade","Mr Bedfort","Aubrey","Inspiration","Hubballi","Edu TAS Beginner","GFS Neohellenic","Jacquarda Bastarda 9","Noto Sans Syloti Nagri","Butcherman","Single Day","Noto Serif Khmer","Noto Sans Javanese","Libre Barcode EAN13 Text","Neonderthaw","Big Shoulders Stencil Display","Tiro Telugu","Rubik Iso","Tiro Devanagari Marathi","Siemreap","Noto Serif Kannada","Bigelow Rules","Bokor","Passero One","Caramel","Cairo Play","Gideon Roman","Sometype Mono","Diplomata","Lumanosimo","Ballet","Truculenta","Rubik Wet Paint","Send Flowers","Yuji Mai","Gwendolyn","Luxurious Roman","Mooli","Reem Kufi Fun","Noto Rashi Hebrew","Anek Odia","Babylonica","Love Light","Trochut","Ysabeau SC","Bagel Fat One","Lavishly Yours","Devonshire","Bruno Ace","Sofadi One","Fruktur","Noto Sans Tai Viet","Suravaram","Aref Ruqaa Ink","Miss Fajardose","Noto Serif Vithkuqi","Mynerve","Purple Purse","Inclusive Sans","Blaka","Island Moments","Hedvig Letters Serif","Uchen","Butterfly Kids","Tai Heritage Pro","Yuji Boku","Tiro Tamil","Rubik Distressed","Nuosu SIL","Noto Serif Gujarati","Rock 3D","Tourney","Protest Guerrilla","Moulpali","Handjet","Honk","Snowburst One","Vibes","Bonbon","Tsukimi Rounded","Nabla","Taprom","My Soul","Rubik Vinyl","Fleur De Leah","Syne Tactile","Tiro Devanagari Sanskrit","Bacasime Antique","Updock","Noto Serif Tamil","Langar","Explora","Dai Banna SIL","Cherry Bomb One","Darumadrop One","Rubik Beastly","Redacted Script","Edu NSW ACT Foundation","Splash","Noto Sans Tangsa","Moirai One","Oi","Reem Kufi Ink","Noto Serif Tangut","Edu VIC WA NT Beginner","Kolker Brush","Grechen Fuemen","Geostar","Sassy Frass","Noto Serif Balinese","Geostar Fill","Petemoss","Alumni Sans Pinstripe","Sigmar","Big Shoulders Inline Display","Sixtyfour","Noto Sans Buhid","Noto Sans Coptic","Noto Sans Tagalog","Noto Serif Tibetan","Gajraj One","Rubik Maps","Are You Serious","Edu QLD Beginner","Zen Loop","Noto Serif Toto","Grey Qo","Orbit","Noto Sans Canadian Aboriginal","Lisu Bosa","Palette Mosaic","Diphylleia","Rubik Glitch Pop","Noto Sans Glagolitic","Tiro Gurmukhi","Noto Serif NP Hmong","Noto Sans Egyptian Hieroglyphs","Noto Sans Mongolian","Ruwudu","Noto Music","Noto Serif Lao","Kablammo","Noto Sans Sora Sompeng","Noto Serif Ethiopic","Noto Sans Imperial Aramaic","Rubik Pixels","Rubik 80s Fade","Wavefont","Rubik Microbe","Lugrasimo","Twinkle Star","Warnes","Rubik Spray Paint","Shizuru","Rubik Scribble","Blaka Hollow","Ole","Estonia","Tapestry","Cherish","Noto Sans Thaana","M PLUS Code Latin","Moo Lah Lah","Workbench","Rubik Burned","Hanalei","Kings","Noto Sans Phags Pa","Rubik Puddles","Noto Traditional Nushu","Noto Sans Carian","Noto Sans Old Italic","Noto Sans Linear A","Noto Serif Ahom","Noto Serif Myanmar","Noto Serif Ottoman Siyaq","Grandiflora One","Blaka Ink","Rubik Storm","Noto Sans Vithkuqi","Noto Sans Duployan","Lunasima","Noto Sans Cypriot","Noto Sans Deseret","Rubik Gemstones","Noto Sans Bamum","Noto Sans Old Hungarian","Rubik Broken Fax","Rubik Marker Hatch","Noto Sans Marchen","Noto Sans Tamil Supplement","Ingrid Darling","Noto Sans Adlam Unjoined","Noto Sans Miao","Noto Sans Batak","Yuji Hentaigana Akari","Noto Sans Nandinagari","Noto Sans Cypro Minoan","Noto Sans Chorasmian","Noto Sans Cherokee","Noto Serif Oriya","Noto Sans Bassa Vah","Noto Sans Ol Chiki","Noto Serif Grantha","Noto Sans Mende Kikakui","Noto Sans Indic Siyaq Numbers","Noto Sans Nushu","Noto Sans Warang Citi","Noto Sans Ugaritic","Noto Sans Ogham","Noto Sans New Tai Lue","Noto Sans Old Persian","Noto Serif Dogra","Noto Serif Old Uyghur","Noto Sans Pau Cin Hau","Noto Sans Old Sogdian","Noto Sans Phoenician","Noto Sans Kharoshthi","Rubik Lines","Puppies Play","Noto Sans Avestan","Rubik Maze","Noto Sans Brahmi","Rubik Doodle Triangles","Noto Sans Kaithi","Noto Sans Hanunoo","Kay Pho Du","Noto Sans Cuneiform","Noto Serif Yezidi","Noto Sans Tifinagh","Noto Sans Khudawadi","Linefont","Noto Sans Kawi","Noto Sans Inscriptional Pahlavi","Narnoor","Noto Sans Lydian","Noto Serif Makasar","Noto Sans Runic","Noto Sans Mandaic","Noto Serif Khitan Small Script","Noto Sans Multani","Noto Sans Balinese","Noto Sans Tagbanwa","Noto Sans Kayah Li","Noto Serif Gurmukhi","Noto Sans Lisu","Noto Sans Limbu","Noto Sans Pahawh Hmong","Chokokutai","Noto Sans Sundanese","Noto Sans Medefaidrin","Noto Sans Vai","Mingzat","Noto Sans Nag Mundari","Noto Sans Siddham","Noto Sans Lycian","Noto Sans Yi","Noto Sans Sharada","Yuji Hentaigana Akebono","Padyakke Expanded One","Noto Sans Zanabazar Square","Noto Sans Inscriptional Parthian","Noto Sans Chakma","Noto Sans Saurashtra","Noto Sans Old Turkic","Noto Sans Palmyrene","Noto Sans Tai Tham","Noto Sans Grantha","Noto Sans Osage","Noto Sans Psalter Pahlavi","Noto Sans Old North Arabian","Noto Sans Newa","Noto Sans Syriac Eastern","Noto Sans Tai Le","Noto Sans Old South Arabian","Noto Sans Nabataean","Noto Sans Tirhuta","Noto Sans Wancho","Noto Sans Bhaiksuki","Noto Sans Mayan Numerals","Noto Sans Hatran","Noto Sans Buginese","Noto Sans Masaram Gondi","Noto Sans Rejang","Noto Sans Hanifi Rohingya","Noto Sans Takri","Noto Sans Old Permic","Noto Sans Sogdian","Noto Sans Mro","Noto Sans Modi","Noto Sans Caucasian Albanian","Noto Sans Syriac","Noto Sans Meroitic","Noto Sans Gunjala Gondi","Noto Sans SignWriting","Noto Sans Linear B","Noto Sans Shavian","Noto Sans Elymaic","Noto Sans Mahajani","Noto Sans NKo","Noto Sans Manichaean","Noto Sans Soyombo","Noto Sans Elbasan"]');


var $a2deb1c64dec179a$exports = {};
$a2deb1c64dec179a$exports = new URL("Lexi-Regular.d52bd030.ttf", import.meta.url).toString();


















const $9d3950b100c0523a$var$CircularProgress = ({ style: style = {} })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
        className: "basic-progress",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: "loader",
            style: style
        })
    });
};
var $9d3950b100c0523a$export$2e2bcd8739ae039 = $9d3950b100c0523a$var$CircularProgress;




const $c8f7718e9f3db339$var$buttonStyles = {
    color: "#fff",
    backgroundColor: "var(--primary-color)",
    maxWidth: "100px",
    minHeight: "40px",
    border: "0.5px solid var(--border-color)",
    fontSize: "14px"
};
const $c8f7718e9f3db339$var$heading = {
    color: "var(--primary-color)",
    fontWeight: "600",
    textAlign: "center"
};
const $c8f7718e9f3db339$var$subHeadingStyle = {
    fontSize: "16px",
    color: "var(--text-color)",
    fontWeight: "600",
    textAlign: "center"
};
const $c8f7718e9f3db339$var$progressStyles = {
    width: "20px",
    height: "20px",
    border: "2px solid #fff"
};
const $c8f7718e9f3db339$var$Dialog = ({ icon: icon = null, customStyles: customStyles = {}, open: open, handleClose: handleClose, loading: loading = false, title: title = "", subHeading: subHeading = "", description: description = "", onSubmit: onSubmit, onCancel: onCancel, cancelText: cancelText = "", submitText: submitText = "", children: children = [], isGallery: isGallery = false })=>{
    const contentAdjust = submitText.length > 6 ? "fit-content" : "100px";
    const modalRef = (0, $lt6Ts$useRef)(null);
    const handleClickOutside = (event)=>{
        if (modalRef.current && !modalRef.current.contains(event.target)) handleClose();
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Escape" && !loading) handleClose();
    };
    (0, $lt6Ts$useEffect)(()=>{
        if (open) // document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        else // document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener("keydown", handleKeyDown);
        return ()=>{
            // document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open
    ]);
    (0, $lt6Ts$useEffect)(()=>{
        const handleCopy = (event)=>{
            if ((event.metaKey || event.ctrlKey) && event.key === "c") event.stopPropagation();
        };
        document.addEventListener("keydown", handleCopy, true);
        return ()=>{
            document.removeEventListener("keydown", handleCopy, true);
        };
    }, []);
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
        id: "myModal",
        className: `modal ${isGallery && "galleryModal"}`,
        style: {
            display: open ? "flex" : "none"
        },
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "modal-content",
            style: customStyles,
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "modal-header",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                        className: "close",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $fb8d63cd819e9d3d$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "modal-body",
                    style: {
                        padding: isGallery ? "0px" : "2px 16px"
                    },
                    children: [
                        icon && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "modal-icon",
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            variant: "p",
                            style: {
                                ...$c8f7718e9f3db339$var$heading,
                                fontSize: isGallery ? "26px" : "22px"
                            },
                            children: title
                        }),
                        subHeading && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            variant: "p",
                            style: $c8f7718e9f3db339$var$subHeadingStyle,
                            children: subHeading
                        }),
                        description && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            variant: "p",
                            style: {
                                ...$c8f7718e9f3db339$var$subHeadingStyle,
                                fontWeight: "400",
                                fontSize: "14px"
                            },
                            children: description
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "modal-footer",
                    children: !isGallery && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                onClick: onCancel,
                                style: {
                                    ...$c8f7718e9f3db339$var$buttonStyles,
                                    color: "var(--text-color)",
                                    backgroundColor: "#fff"
                                },
                                children: cancelText
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                style: {
                                    ...$c8f7718e9f3db339$var$buttonStyles,
                                    border: "none",
                                    maxWidth: contentAdjust
                                },
                                onClick: onSubmit,
                                disabled: loading,
                                children: loading ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $9d3950b100c0523a$export$2e2bcd8739ae039), {
                                    style: $c8f7718e9f3db339$var$progressStyles
                                }) : submitText
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $c8f7718e9f3db339$export$2e2bcd8739ae039 = $c8f7718e9f3db339$var$Dialog;




const $1cce2f1e40edb11b$var$Save = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "69",
            height: "62",
            viewBox: "0 0 69 62",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M68.25 53.4688V42.2188C68.25 41.4728 67.9537 40.7575 67.4262 40.23C66.8988 39.7026 66.1834 39.4062 65.4375 39.4062C64.6916 39.4062 63.9762 39.7026 63.4488 40.23C62.9213 40.7575 62.625 41.4728 62.625 42.2188V53.4688C62.625 54.2147 62.3287 54.93 61.8012 55.4575C61.2738 55.9849 60.5584 56.2812 59.8125 56.2812H9.1875C8.44158 56.2812 7.72621 55.9849 7.19876 55.4575C6.67132 54.93 6.375 54.2147 6.375 53.4688V42.2188C6.375 41.4728 6.07868 40.7575 5.55124 40.23C5.02379 39.7026 4.30842 39.4062 3.5625 39.4062C2.81658 39.4062 2.10121 39.7026 1.57376 40.23C1.04632 40.7575 0.75 41.4728 0.75 42.2188V53.4688C0.75 55.7065 1.63895 57.8526 3.22129 59.435C4.80363 61.0173 6.94974 61.9062 9.1875 61.9062H59.8125C62.0503 61.9062 64.1964 61.0173 65.7787 59.435C67.3611 57.8526 68.25 55.7065 68.25 53.4688ZM50.3063 38.7875L36.2438 50.0375C35.7472 50.4299 35.1329 50.6433 34.5 50.6433C33.8671 50.6433 33.2528 50.4299 32.7562 50.0375L18.6938 38.7875C18.1814 38.3038 17.8692 37.6455 17.819 36.9426C17.7688 36.2398 17.9842 35.5438 18.4226 34.9922C18.8611 34.4406 19.4906 34.0737 20.1866 33.964C20.8826 33.8544 21.5945 34.0099 22.1812 34.4L31.6875 41.9938V2.84375C31.6875 2.09783 31.9838 1.38246 32.5113 0.855013C33.0387 0.327567 33.7541 0.03125 34.5 0.03125C35.2459 0.03125 35.9613 0.327567 36.4887 0.855013C37.0162 1.38246 37.3125 2.09783 37.3125 2.84375V41.9938L46.8187 34.4C47.102 34.1327 47.4376 33.9271 47.8044 33.7962C48.1713 33.6654 48.5613 33.6122 48.9497 33.6399C49.3382 33.6677 49.7167 33.7758 50.0612 33.9574C50.4057 34.1391 50.7087 34.3903 50.951 34.6952C51.1934 35.0001 51.3697 35.352 51.469 35.7286C51.5682 36.1052 51.5882 36.4983 51.5275 36.883C51.4669 37.2677 51.3271 37.6356 51.1169 37.9635C50.9066 38.2913 50.6306 38.5719 50.3063 38.7875Z",
                fill: fill
            })
        })
    });
};
var $1cce2f1e40edb11b$export$2e2bcd8739ae039 = $1cce2f1e40edb11b$var$Save;



/**
 * Renders a modal dialog for deleting a template.
 *
 * @param {function} handleSave - Callback function to handle the save action.
 * @param {function} handleClose - Callback function to handle the close action.
 * @param {boolean} open - Boolean value indicating whether the modal is open or not.
 * @returns {JSX.Element} The delete template modal component.
 */ const $f8816ee2d46ac0fb$var$saveDialogStyles = {
    maxWidth: "433px",
    minHeight: "280px"
};
const $f8816ee2d46ac0fb$var$SaveTemplateModel = ({ handleSave: handleSave, handleClose: handleClose, open: open, loading: loading })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $1cce2f1e40edb11b$export$2e2bcd8739ae039), {
            fill: "var(--primary-color)"
        }),
        open: open,
        loading: loading,
        handleClose: handleClose,
        title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.TITLE,
        subHeading: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.HEADING,
        description: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.PARAGRAPH,
        cancelText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.CANCEL_BUTTON,
        submitText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.SUBMIT_BUTTON,
        customStyles: $f8816ee2d46ac0fb$var$saveDialogStyles,
        onSubmit: handleSave,
        onCancel: handleClose
    });
};
var $f8816ee2d46ac0fb$export$2e2bcd8739ae039 = $f8816ee2d46ac0fb$var$SaveTemplateModel;








const $8c59b172071542b8$var$ModalCross = (props)=>{
    const { disabled: disabled, fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("mask", {
                id: "mask0_1992_577",
                maskUnits: "userSpaceOnUse",
                x: "2",
                y: "2",
                width: "22",
                height: "22",
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M13 2L23.9519 12.9519L13.0144 23.8893L2.06256 12.9374L13 2Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("g", {
                mask: "url(#mask0_1992_577)",
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M19.5433 16.4305C18.2305 15.1176 16.9176 13.8047 15.6047 12.4919C15.6046 12.7834 15.6044 13.0749 15.6043 13.3664C16.9186 12.052 18.2331 10.7375 19.5475 9.42317C19.786 9.18463 19.7861 8.78667 19.548 8.54854C18.8237 7.82426 18.0994 7.09998 17.3752 6.3757C17.1369 6.13743 16.7391 6.13769 16.5005 6.37623C15.1862 7.69058 13.8717 9.00507 12.5573 10.3194C12.8488 10.3193 13.1403 10.3191 13.4318 10.319C12.119 9.00613 10.8061 7.69325 9.4932 6.38037C9.25493 6.1421 8.85723 6.14223 8.6187 6.38077C7.89348 7.10598 7.1684 7.83106 6.44319 8.55628C6.20492 8.79455 6.20452 9.19251 6.44279 9.43078C7.75567 10.7437 9.06856 12.0565 10.3814 13.3694C10.3816 13.0779 10.3817 12.7864 10.3818 12.4949C9.06749 13.8093 7.753 15.1238 6.43865 16.4381C6.20025 16.6765 6.19998 17.0743 6.43825 17.3126C7.16253 18.0369 7.88681 18.7612 8.61109 19.4854C8.84923 19.7236 9.24719 19.7234 9.48559 19.485C10.7999 18.1707 12.1144 16.8562 13.4288 15.5419C13.1373 15.542 12.8458 15.5421 12.5543 15.5423C13.8672 16.8551 15.18 18.168 16.4929 19.4809C16.7311 19.719 17.1289 19.7188 17.3673 19.4804C18.0924 18.7553 18.8176 18.0301 19.5427 17.305C20.107 16.7407 19.2332 15.8668 18.6688 16.4312C17.9438 17.1563 17.2185 17.8815 16.4935 18.6065C16.785 18.6064 17.0763 18.6061 17.3678 18.606C16.0549 17.2931 14.7421 15.9802 13.4292 14.6674C13.191 14.4292 12.7932 14.4295 12.5548 14.6679C11.2403 15.9824 9.92598 17.2967 8.61149 18.6112C8.90313 18.6109 9.19436 18.6108 9.48599 18.6105C8.76171 17.8863 8.03743 17.162 7.31315 16.4377C7.31289 16.7293 7.31275 17.0206 7.31249 17.3122C8.62697 15.9977 9.94132 14.6834 11.2558 13.3689C11.4942 13.1305 11.4946 12.7328 11.2563 12.4945C9.94345 11.1816 8.63057 9.86876 7.31769 8.55588C7.31742 8.84724 7.31729 9.13874 7.31716 9.43024C8.04224 8.70516 8.76745 7.97995 9.49253 7.25487C9.20103 7.255 8.90953 7.25513 8.61816 7.2554C9.93105 8.56828 11.2439 9.88117 12.5568 11.194C12.7951 11.4323 13.1926 11.4321 13.4312 11.1935C14.7457 9.87903 16.0601 8.56455 17.3745 7.2502C17.083 7.25033 16.7916 7.2506 16.5001 7.25073C17.2244 7.97501 17.9487 8.69929 18.673 9.42357C18.6731 9.13207 18.6734 8.8407 18.6735 8.5492C17.3592 9.86355 16.0447 11.178 14.7302 12.4925C14.4917 12.7311 14.4917 13.1289 14.7297 13.3669C16.0425 14.6798 17.3554 15.9927 18.6683 17.3055C19.2318 17.8691 20.1069 16.994 19.5433 16.4305Z",
                    fill: disabled ? "grey" : fill
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("circle", {
                cx: "13",
                cy: "13",
                r: "12",
                strokeWidth: "2"
            })
        ]
    });
};
var $8c59b172071542b8$export$2e2bcd8739ae039 = $8c59b172071542b8$var$ModalCross;



/**
 * ConfirmNavigateDialog Component
 * A modal for duplicating a template.
 *
 * @param {boolean} open - Boolean indicating whether the modal is open.
 * @param {Function} handleClose - Function to handle the closing of the modal.
 * @returns {JSX.Element} The duplicate template modal component.
 *
 */ const $b3fd558411fcaf23$var$cancelDialogStyles = {
    maxWidth: "407px",
    minHeight: "258px"
};
const $b3fd558411fcaf23$var$ConfirmNavigateDialog = ({ open: open, handleClose: handleClose, handleNavigateAction: handleNavigateAction })=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $8c59b172071542b8$export$2e2bcd8739ae039), {}),
        customStyles: $b3fd558411fcaf23$var$cancelDialogStyles,
        open: open,
        handleClose: handleClose,
        title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL.TITLE,
        subHeading: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL.HEADING,
        description: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL.PARAGRAPH,
        onSubmit: handleNavigateAction,
        onCancel: handleClose,
        cancelText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL.BACK_BUTTON,
        submitText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL.CANCEL_BUTTON
    });
};
var $b3fd558411fcaf23$export$2e2bcd8739ae039 = $b3fd558411fcaf23$var$ConfirmNavigateDialog;











const $706ecd46c5fca617$var$editDialogStyles = {
    maxWidth: "630px",
    minHeight: "210px"
};
const $706ecd46c5fca617$var$EditTemplateNameModel = ({ open: open, handleClose: handleClose })=>{
    const [title, setTitle] = (0, $lt6Ts$useState)("");
    const dispatch = (0, $lt6Ts$useDispatch)();
    const templateTitle = (0, $lt6Ts$useSelector)((state)=>state.templates.title) || "";
    (0, $lt6Ts$useEffect)(()=>{
        setTitle(templateTitle);
    }, []);
    // Handle the duplication of the template
    const handleEditName = async ()=>{
        let errorText = "";
        if (!title) errorText = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NAME_REQUIRED;
        else if (title.length > 50) errorText = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NAME_LESS_50;
        if (errorText) {
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(errorText));
            return;
        }
        dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("title", title.trim()));
        handleClose();
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
        open: open,
        loading: false,
        handleClose: handleClose,
        title: "Edit Template Name",
        cancelText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.CANCEL_BUTTON,
        submitText: "Save",
        customStyles: $706ecd46c5fca617$var$editDialogStyles,
        onSubmit: handleEditName,
        onCancel: handleClose,
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
            variant: "input",
            type: "text",
            label: "Template Name",
            placeholder: "Holidays",
            value: title,
            onChange: (e)=>setTitle(e.target.value)
        })
    });
};
var $706ecd46c5fca617$export$2e2bcd8739ae039 = $706ecd46c5fca617$var$EditTemplateNameModel;

















const $3f778f8c6113c048$var$DuplicateTemplateModal = ({ open: open, value: value, setIsDuplication: setIsDuplication, onChange: onChange, onCancel: onCancel, onDuplicateTemplate: onDuplicateTemplate, title: title, submitButtonText: submitButtonText, icon: icon, error: error })=>{
    if (!open) return null;
    const saveDialogStyles = {
        maxWidth: "480px",
        minHeight: error ? "350px" : "329px"
    };
    const noteStyle = {
        fontSize: "12px",
        color: "#000",
        fontWeight: "400",
        marginTop: "7px"
    };
    const [loader, setLoader] = (0, $lt6Ts$useState)(false);
    const dispatch = (0, $lt6Ts$useDispatch)();
    const duplicateTemplate = async ()=>{
        try {
            setLoader(true);
            if (onDuplicateTemplate) {
                setIsDuplication(true);
                await onDuplicateTemplate(value);
                onCancel();
            }
        } catch (error) {
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).CLONE_ERROR));
            return error;
        } finally{
            setLoader(false);
        }
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
        icon: icon,
        loading: loader,
        open: open,
        handleClose: onCancel,
        title: title,
        cancelText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SAVE.CANCEL_BUTTON,
        submitText: submitButtonText,
        customStyles: saveDialogStyles,
        onSubmit: duplicateTemplate,
        onCancel: onCancel,
        subHeading: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.SUB_HEADING,
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                    type: "text",
                    placeholder: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.NAME_PLACEHOLDER,
                    value: value,
                    error: error,
                    onChange: (e)=>onChange(e.target.value)
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    style: noteStyle,
                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.NOTE
                })
            ]
        })
    });
};
var $3f778f8c6113c048$export$2e2bcd8739ae039 = $3f778f8c6113c048$var$DuplicateTemplateModal;





const $6612202931a08516$var$editPencilIcon = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M12.4991 0.704746C12.2767 0.481379 12.0124 0.304137 11.7213 0.183197C11.4302 0.062257 11.1181 0 10.8029 0C10.4877 0 10.1756 0.062257 9.88452 0.183197C9.59344 0.304137 9.32911 0.481379 9.10671 0.704746L0.495914 9.33755C0.426952 9.40785 0.383571 9.49926 0.372714 9.59715L0.00311381 12.7079C-0.00472373 12.7735 0.00228003 12.8399 0.0236062 12.9024C0.0449324 12.9648 0.0800346 13.0217 0.126314 13.0687C0.167582 13.1109 0.216892 13.1442 0.271313 13.1669C0.325735 13.1896 0.384158 13.2011 0.443114 13.2007H0.491514L3.62871 12.8751C3.72871 12.864 3.82189 12.819 3.89271 12.7475L12.4991 4.11035C12.9489 3.65777 13.2014 3.04562 13.2014 2.40755C13.2014 1.76948 12.9489 1.15732 12.4991 0.704746ZM3.38231 12.0083L0.944714 12.2679L1.22631 9.85235L8.02872 3.03235L10.1803 5.18835L3.38231 12.0083ZM10.8007 4.56795L8.64911 2.40755L9.72711 1.32075C10.0166 1.04167 10.403 0.885735 10.8051 0.885735C11.2072 0.885735 11.5936 1.04167 11.8831 1.32075C12.1685 1.60694 12.3287 1.9946 12.3287 2.39875C12.3287 2.80289 12.1685 3.19055 11.8831 3.47675L10.8007 4.56795Z",
            fill: fill
        })
    });
};
var $6612202931a08516$export$2e2bcd8739ae039 = $6612202931a08516$var$editPencilIcon;




const $788118b6d825ecfe$var$OrderDownload = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "25",
            height: "24",
            viewBox: "0 0 25 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("g", {
                    clipPath: "url(#clip0_431_77)",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                            d: "M12.0369 15.1756C11.9243 15.1757 11.8128 15.1536 11.7088 15.1105C11.6047 15.0675 11.5102 15.0044 11.4306 14.9248C11.351 14.8451 11.2879 14.7506 11.2448 14.6466C11.2018 14.5426 11.1797 14.4311 11.1797 14.3185V1.49972C11.1797 1.27239 11.2701 1.05437 11.4308 0.893629C11.5915 0.732884 11.8096 0.642578 12.0369 0.642578C12.2642 0.642578 12.4822 0.732884 12.643 0.893629C12.8037 1.05437 12.894 1.27239 12.894 1.49972V14.3185C12.894 14.5458 12.8037 14.7638 12.643 14.9246C12.4822 15.0853 12.2642 15.1756 12.0369 15.1756Z",
                            fill: "#545454"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                            d: "M12.0369 15.5608C11.7488 15.5613 11.4635 15.5048 11.1973 15.3947C10.9311 15.2845 10.6893 15.1229 10.4858 14.919L5.85653 10.2897C5.69586 10.1291 5.60559 9.91115 5.60559 9.68392C5.60559 9.45669 5.69586 9.23877 5.85653 9.07809C6.01721 8.91742 6.23513 8.82715 6.46236 8.82715C6.68959 8.82715 6.90751 8.91742 7.06819 9.07809L11.6974 13.7073C11.742 13.7519 11.7949 13.7873 11.8532 13.8114C11.9114 13.8355 11.9738 13.848 12.0369 13.848C12.0999 13.848 12.1623 13.8355 12.2206 13.8114C12.2788 13.7873 12.3317 13.7519 12.3763 13.7073L17.0056 9.07809C17.1672 8.92191 17.3837 8.83545 17.6084 8.83734C17.8331 8.83923 18.0482 8.92931 18.2071 9.08819C18.3661 9.24707 18.4563 9.46202 18.4583 9.68676C18.4603 9.9115 18.374 10.128 18.2179 10.2897L13.588 14.919C13.3844 15.1228 13.1426 15.2844 12.8764 15.3946C12.6102 15.5047 12.3249 15.5612 12.0369 15.5608Z",
                            fill: "#545454"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                            d: "M21.593 23.3577H2.48077C1.8783 23.357 1.30071 23.1173 0.874702 22.6913C0.448691 22.2653 0.209039 21.6877 0.208313 21.0852V15.0935C0.208313 14.8661 0.298619 14.6481 0.459364 14.4874C0.62011 14.3266 0.838127 14.2363 1.06546 14.2363C1.29278 14.2363 1.5108 14.3266 1.67155 14.4874C1.83229 14.6481 1.9226 14.8661 1.9226 15.0935V21.0852C1.92278 21.2332 1.98165 21.3751 2.08628 21.4797C2.19092 21.5844 2.33279 21.6432 2.48077 21.6434H21.593C21.741 21.6432 21.8828 21.5844 21.9875 21.4797C22.0921 21.3751 22.151 21.2332 22.1512 21.0852V15.0935C22.1512 14.8661 22.2415 14.6481 22.4022 14.4874C22.563 14.3266 22.781 14.2363 23.0083 14.2363C23.2356 14.2363 23.4537 14.3266 23.6144 14.4874C23.7752 14.6481 23.8655 14.8661 23.8655 15.0935V21.0852C23.8647 21.6877 23.6251 22.2653 23.1991 22.6913C22.7731 23.1173 22.1955 23.357 21.593 23.3577Z",
                            fill: "#545454"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("defs", {
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("clipPath", {
                        id: "clip0_431_77",
                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white",
                            transform: "translate(0.0368652)"
                        })
                    })
                })
            ]
        })
    });
};
var $788118b6d825ecfe$export$2e2bcd8739ae039 = $788118b6d825ecfe$var$OrderDownload;




const $850382ceb18dc2bd$var$MailIcon = (props)=>/*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        version: "1.0",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "25",
        height: "24",
        viewBox: "0 0 64 64",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            fill: "#231F20",
            d: "M60,8H4c-2.211,0-4,1.789-4,4v40c0,2.211,1.789,4,4,4h56c2.211,0,4-1.789,4-4V12C64,9.789,62.211,8,60,8z M4,10h56c1.104,0,2,0.896,2,2v2.469L32,36.754L2,14.469V12C2,10.896,2.896,10,4,10z M60,54H4c-1.104,0-2-0.896-2-2v-2.808 l18.584-13.381c0.448-0.322,0.55-0.947,0.228-1.396c-0.322-0.447-0.946-0.549-1.396-0.228L2,46.729V16.961l29.403,21.842 C31.581,38.935,31.79,39,32,39s0.419-0.065,0.597-0.197L62,16.961v29.768l-17.416-12.54c-0.448-0.322-1.074-0.221-1.396,0.228 c-0.322,0.448-0.221,1.073,0.228,1.396L62,49.192V52C62,53.104,61.104,54,60,54z"
        })
    });
var $850382ceb18dc2bd$export$2e2bcd8739ae039 = $850382ceb18dc2bd$var$MailIcon;




const $beb12c725a41a350$var$TemplateCopy = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "19",
            height: "19",
            viewBox: "0 0 19 19",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M3.5 15.025H3.975V15.5C3.975 16.1697 4.24103 16.8119 4.71456 17.2854C5.18809 17.759 5.83033 18.025 6.5 18.025H15.5C16.1697 18.025 16.8119 17.759 17.2854 17.2854C17.759 16.8119 18.025 16.1697 18.025 15.5V6.5C18.025 5.83033 17.759 5.18809 17.2854 4.71456C16.8119 4.24103 16.1697 3.975 15.5 3.975H15.025V3.5C15.025 2.83033 14.759 2.18808 14.2854 1.71456C13.8119 1.24103 13.1697 0.975 12.5 0.975H3.5C2.83033 0.975 2.18808 1.24103 1.71456 1.71456C1.24103 2.18808 0.975 2.83033 0.975 3.5V12.5C0.975 13.1697 1.24103 13.8119 1.71456 14.2854C2.18808 14.759 2.83033 15.025 3.5 15.025ZM15.5 5.025C15.8912 5.025 16.2664 5.1804 16.543 5.45702C16.8196 5.73363 16.975 6.10881 16.975 6.5V15.5C16.975 15.8912 16.8196 16.2664 16.543 16.543C16.2664 16.8196 15.8912 16.975 15.5 16.975H6.5C6.10881 16.975 5.73363 16.8196 5.45702 16.543C5.1804 16.2664 5.025 15.8912 5.025 15.5V15.025H12.5C13.1697 15.025 13.8119 14.759 14.2854 14.2854C14.759 13.8119 15.025 13.1697 15.025 12.5V5.025H15.5ZM2.025 3.5C2.025 3.10881 2.1804 2.73363 2.45702 2.45702C2.73363 2.1804 3.10881 2.025 3.5 2.025H12.5C12.8912 2.025 13.2664 2.1804 13.543 2.45702C13.8196 2.73363 13.975 3.10881 13.975 3.5V12.5C13.975 12.8912 13.8196 13.2664 13.543 13.543C13.2664 13.8196 12.8912 13.975 12.5 13.975H3.5C3.10881 13.975 2.73363 13.8196 2.45702 13.543C2.1804 13.2664 2.025 12.8912 2.025 12.5V3.5Z",
                fill: fill,
                stroke: "#545454",
                strokeWidth: "0.05"
            })
        })
    });
};
var $beb12c725a41a350$export$2e2bcd8739ae039 = $beb12c725a41a350$var$TemplateCopy;



/**
 * Represents the top navigation bar of a template builder application.
 * Handles saving and navigation logic, as well as displaying a confirmation dialog for unsaved changes.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.store - The store object used for saving the template.
 * @param {boolean} props.isStoreUpdated - Indicates whether the store has been updated.
 * @returns {JSX.Element} The top navigation bar component.
 */ const $d31b9bd88e5dcf67$var$buttonStyles = {
    maxWidth: "120px",
    minHeight: "40px",
    backgroundColor: "#fff",
    color: "var(--text-color)",
    border: "0.5px solid var(--border-color)",
    fontSize: "15px",
    fontWeight: "500"
};
const $d31b9bd88e5dcf67$var$progressStyles = {
    width: "20px",
    height: "20px",
    border: "2px solid var(--primary-color)"
};
const $d31b9bd88e5dcf67$var$TopNavigation = ({ store: store, createTemplateRoute: createTemplateRoute, isStoreUpdated: isStoreUpdated, setIsDuplication: setIsDuplication, olcTemplate: olcTemplate, designerTemplateQuery: designerTemplateQuery, onDuplicateTemplate: onDuplicateTemplate, onReturnAndNavigate: onReturnAndNavigate, onSubmit: onSubmit })=>{
    const [showNavigateDialog, setShowNavigateDialog] = (0, $lt6Ts$useState)(false);
    const [isShowModel, setIsShowModel] = (0, $lt6Ts$useState)({
        open: false,
        model: "",
        loading: false,
        inputValue: ""
    });
    const [downloadingProof, setDownloaingProof] = (0, $lt6Ts$useState)(false);
    const [downloadingEnvelope, setDownloaingEnvelope] = (0, $lt6Ts$useState)(false);
    const { id: id } = (0, $lt6Ts$useParams)();
    const dispatch = (0, $lt6Ts$useDispatch)();
    const navigate = (0, $lt6Ts$useNavigate)();
    const title = (0, $lt6Ts$useSelector)((state)=>state.templates.title);
    const product = (0, $lt6Ts$useSelector)((state)=>state.templates.product);
    const dynamicFields = (0, $lt6Ts$useSelector)((state)=>state.templates.dynamicFields);
    const defaultFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultDynamicFields);
    const defaultSenderFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultSenderFields);
    const customFields = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFields);
    const customFieldsV2 = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFieldsV2);
    const defaultPropertyFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultPropertyFields);
    const templateType = (0, $lt6Ts$useSelector)((state)=>state.templates.templateType);
    const envelopeType = (0, $lt6Ts$useSelector)((state)=>state.templates.envelopeType);
    const rosOfferPercentage = (0, $lt6Ts$useSelector)((state)=>state.templates.offerPercentage);
    const defaultMiscFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultMiscFields);
    (0, $lt6Ts$useEffect)(()=>{
        if (!id) {
            const formData = (0, $b66d61b9e6770b52$export$f92dfeb71e9bb569)("formData");
            if (formData && !title) dispatch((0, $dbaee5ca78364d67$export$e90ab51a767ad1d0)(formData));
            else handleSaveFormData();
        }
    }, [
        title
    ]);
    const handleSaveFormData = ()=>{
        const data = {
            title: title,
            product: product,
            templateType: templateType,
            envelopeType: envelopeType
        };
        (0, $b66d61b9e6770b52$export$8a8216c44337cd5)("formData", JSON.stringify(data));
    };
    const handleBackPress = ()=>{
        if (isStoreUpdated) setShowNavigateDialog(!showNavigateDialog);
        else handleNavigation(createTemplateRoute || "/create-template");
    };
    const closeDuplicateModal = ()=>{
        setIsShowModel((prev)=>({
                ...prev,
                open: false,
                model: "",
                inputValue: ""
            }));
    };
    const handleNavigation = async (route = "/")=>{
        handleClearFilters();
        if (templateType === "json" && product?.productType !== "Real Penned Letter") await store.history.clear();
        onReturnAndNavigate ? onReturnAndNavigate() : navigate(route);
    };
    const handleClearFilters = ()=>dispatch((0, $dbaee5ca78364d67$export$df7b8ffccf8fe273)());
    const handleViewProofWithLamda = async ()=>{
        try {
            setDownloaingProof(true);
            let flattenedFieldsV2 = [];
            if (customFieldsV2.length > 0) flattenedFieldsV2 = customFieldsV2?.flatMap((section)=>section.fields);
            const fields = [
                ...defaultFields,
                ...customFields,
                ...flattenedFieldsV2,
                ...Object.values(dynamicFields),
                ...defaultSenderFields,
                ...defaultPropertyFields,
                ...defaultMiscFields,
                {
                    value: "{{ROS.PROPERTY_OFFER}}",
                    key: "{{ROS.PROPERTY_OFFER}}",
                    defaultValue: "$123,456.00"
                }
            ];
            let json = store.toJSON();
            const jsonSize = new Blob([
                JSON.stringify(json)
            ]).size;
            if (jsonSize > 5242880) {
                dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SIZE_LIMIT_EXCEED));
                return;
            }
            if (product?.productType === "Real Penned Letter") {
                const removedUnsupportedBrackets = (0, $ad01ab85e9f42d02$export$d5a1fddcf19adead)(json);
                json = removedUnsupportedBrackets;
                let clonedJson = JSON.stringify(json).replace(/\(\(/g, "{{").replace(/\)\)/g, "}}");
                json = JSON.parse(clonedJson);
            }
            if (product.productType === "Snap Pack Mailers") {
                const updatedBoxes = (0, $ad01ab85e9f42d02$export$12a8f0948c807d25)(json);
                json = updatedBoxes;
            }
            let jsonString = JSON.stringify(json);
            fields.forEach(({ key: key, defaultValue: defaultValue, value: value })=>{
                const regex = new RegExp(key, "g");
                jsonString = jsonString.replace(regex, defaultValue || value);
            });
            const jsonWithDummyData = JSON.parse(jsonString);
            const response = await (0, $dbaee5ca78364d67$export$a2500560a97e8dba)({
                json: jsonWithDummyData
            });
            if (response.status === 200) {
                const binaryData = atob(response.data.data.base64);
                // Create a Uint8Array from the binary data
                const uint8Array = new Uint8Array(binaryData.length);
                for(let i = 0; i < binaryData.length; i++)uint8Array[i] = binaryData.charCodeAt(i);
                // Create a Blob from the Uint8Array
                const blob = new Blob([
                    uint8Array
                ], {
                    type: "application/pdf"
                });
                // Create an Object URL for the Blob
                const url = URL.createObjectURL(blob);
                (0, $ad01ab85e9f42d02$export$3c4ee5ffa62bdd4b)(title.substring(0, 20), url);
                dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)("Download Proof generated successfully"));
            } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(response?.data?.message || response?.message || (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).DOWNLOAD_ERROR));
        } catch (error) {
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(error?.response?.data?.message || error?.message || "Error while downloading proof"));
        } finally{
            setDownloaingProof(false);
        }
    };
    const handleEnvelopeProof = async ()=>{
        try {
            setDownloaingEnvelope(true);
            const response = await (0, $dbaee5ca78364d67$export$3242b03125b539ed)({
                productId: product.id
            });
            if (response.status === 200) {
                const binaryData = atob(response.data.data.base64);
                // Create a Uint8Array from the binary data
                const uint8Array = new Uint8Array(binaryData.length);
                for(let i = 0; i < binaryData.length; i++)uint8Array[i] = binaryData.charCodeAt(i);
                // Create a Blob from the Uint8Array
                const blob = new Blob([
                    uint8Array
                ], {
                    type: "application/pdf"
                });
                // Create an Object URL for the Blob
                const url = URL.createObjectURL(blob);
                (0, $ad01ab85e9f42d02$export$3c4ee5ffa62bdd4b)(title.substring(0, 20), url);
                dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)("Download Envelope Proof generated successfully"));
            } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(response?.data?.message || response?.message || (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).DOWNLOAD_ERROR));
        } catch (error) {
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(error?.response?.data?.message || error?.message || "Error while downloading envelope proof"));
        } finally{
            setDownloaingEnvelope(false);
        }
    };
    const handleSave = async ()=>{
        try {
            const formData = new FormData();
            const allFields = [
                ...defaultFields,
                ...customFields,
                ...Object.values(dynamicFields),
                ...defaultSenderFields,
                ...defaultPropertyFields,
                ...defaultMiscFields
            ];
            let selectedFields = [];
            if (templateType === "json") {
                let jsonData = store.toJSON();
                const jsonSize = new Blob([
                    JSON.stringify(jsonData)
                ]).size;
                if (jsonSize > 5242880) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SIZE_LIMIT_EXCEED));
                    return;
                }
                const hasEmoji = (0, $ad01ab85e9f42d02$export$a1da92a5104ba69f)(jsonData.pages);
                if (hasEmoji) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.EMOJI_NOT_ALLOWED));
                    return;
                }
                if (product?.productType === "Real Penned Letter") {
                    const removedUnsupportedBrackets = (0, $ad01ab85e9f42d02$export$d5a1fddcf19adead)(jsonData);
                    jsonData = removedUnsupportedBrackets;
                    let clonedJson = JSON.stringify(jsonData).replace(/\(\(/g, "{{").replace(/\)\)/g, "}}");
                    jsonData = JSON.parse(clonedJson);
                    await store.loadJSON(jsonData);
                }
                if (product.productType === "Snap Pack Mailers") {
                    const updatedBoxes = (0, $ad01ab85e9f42d02$export$12a8f0948c807d25)(jsonData);
                    jsonData = updatedBoxes;
                }
                // get all fonts family from json
                const fontFamilies = (0, $ad01ab85e9f42d02$export$464e4dcbf779d16c)(jsonData?.pages);
                // extract custom fonts and remove google fonts from that array
                const customFonts = fontFamilies.filter((item)=>!(0, (/*@__PURE__*/$parcel$interopDefault($6095227f2f4b1a81$exports))).includes(item));
                const availableBase64inJson = jsonData?.fonts?.map((font)=>font?.fontFamily);
                const unAvailableFonts = customFonts.filter((item)=>!availableBase64inJson?.includes(item));
                if (unAvailableFonts?.length) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(`Please upload ${unAvailableFonts[0]} font in My Fonts section.`));
                    return;
                }
                const isGsvValid = (0, $ad01ab85e9f42d02$export$235f8e1ceb01c6a5)(jsonData.pages);
                if (!isGsvValid) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.GSV_RESTRICT_ONE_PER_PAGE));
                    return;
                }
                const hasEmptyQR = !(0, $ad01ab85e9f42d02$export$fc87fb251908c0d1)(jsonData.pages);
                if (hasEmptyQR) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.EMPTY_QR_NOT_ALLOWED));
                    return;
                }
                setIsShowModel((prev)=>({
                        ...prev,
                        loading: true
                    }));
                const blob = await store.toBlob();
                if ((0, $ad01ab85e9f42d02$export$dc2daac47827fb7f).includes(product.productType)) {
                    const backJsonData = {
                        ...jsonData,
                        pages: [
                            jsonData.pages[1]
                        ]
                    };
                    await store.loadJSON(backJsonData);
                    await store.waitLoading();
                    const backBlob = await store.toBlob();
                    formData.append("backThumbnail", backBlob, "backLogo.png");
                    store.loadJSON(jsonData);
                }
                const jsonString = JSON.stringify(jsonData);
                const blobData = new Blob([
                    jsonString
                ], {
                    type: "application/json"
                });
                formData.append("json", blobData, "template.json");
                formData.append("thumbnail", blob, "logo.png");
                selectedFields = allFields.filter((field)=>jsonString.includes(field.key));
                jsonString.includes("ros_") || jsonString.includes("{{ROS.PROPERTY_OFFER}}") ? formData.append("rosOfferPercentage", rosOfferPercentage) : undefined;
            }
            formData.append("title", title);
            formData.append("productId", product?.id);
            selectedFields.length ? formData.append("fields", JSON.stringify(selectedFields)) : undefined;
            envelopeType.length ? formData.append("envelopeType", envelopeType) : undefined;
            if (onSubmit) {
                const saveTemplate = await onSubmit(formData);
                if (saveTemplate) // dispatch(success(olcTemplate ? 'Template Updated Successfully' : 'Template Created Successfully'));
                handleNavigation();
            } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)("Please add onSubmit handler via Props to save template"));
        } catch (error) {
            return error;
        } finally{
            setIsShowModel((prev)=>({
                    ...prev,
                    loading: false
                }));
        }
    };
    const handleChangeModel = (model = "", loading = null)=>{
        setIsShowModel((prev)=>({
                ...prev,
                open: !prev.open,
                loading: loading === "false" ? false : prev.loading,
                model: model
            }));
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: "top-navigation-container",
        children: [
            showNavigateDialog && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $b3fd558411fcaf23$export$2e2bcd8739ae039), {
                open: showNavigateDialog,
                handleClose: ()=>setShowNavigateDialog(false),
                handleNavigateAction: ()=>handleNavigation(createTemplateRoute || "/create-template")
            }),
            isShowModel?.open && isShowModel?.model === "edit" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $706ecd46c5fca617$export$2e2bcd8739ae039), {
                open: isShowModel?.open,
                handleClose: ()=>handleChangeModel()
            }),
            isShowModel.open && isShowModel.model === "save" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $f8816ee2d46ac0fb$export$2e2bcd8739ae039), {
                loading: isShowModel.loading,
                open: isShowModel.open,
                handleClose: ()=>handleChangeModel(),
                handleSave: handleSave
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f778f8c6113c048$export$2e2bcd8739ae039), {
                open: isShowModel.open && isShowModel.model === "duplicate",
                value: isShowModel.inputValue || "",
                onChange: (val)=>setIsShowModel((prev)=>({
                            ...prev,
                            inputValue: val
                        })),
                error: "",
                title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.TITLE,
                submitButtonText: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.SUBMIT_BUTTON,
                onCancel: closeDuplicateModal,
                onDuplicateTemplate: onDuplicateTemplate,
                setIsDuplication: setIsDuplication,
                icon: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $beb12c725a41a350$export$2e2bcd8739ae039), {
                    fill: "var(--primary-color)"
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $d020db196be2fc6a$export$cc55614734af2d87), {
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                        lg: 4,
                        md: 4,
                        sm: 0,
                        xs: 0
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                        lg: 3,
                        md: 2,
                        sm: 2,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            className: "middle",
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    onClick: ()=>handleChangeModel("edit"),
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $6612202931a08516$export$2e2bcd8739ae039), {
                                        fill: "var(--text-color)"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d020db196be2fc6a$export$9eb849b9b922d396), {
                        lg: 5,
                        md: 6,
                        sm: 9,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            className: "actionsBtnWrapper right",
                            children: [
                                olcTemplate && !designerTemplateQuery && onDuplicateTemplate && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "clone",
                                    onClick: ()=>setIsShowModel((prev)=>({
                                                ...prev,
                                                open: true,
                                                model: "duplicate",
                                                inputValue: ""
                                            })),
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $beb12c725a41a350$export$2e2bcd8739ae039), {
                                        fill: "#545454"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                    title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DUPLICATE_MODAL.TITLE,
                                    place: "bottom",
                                    anchorSelect: ".clone"
                                }),
                                product?.hasEnvelope && false,
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "download",
                                    onClick: handleViewProofWithLamda,
                                    children: downloadingProof ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $9d3950b100c0523a$export$2e2bcd8739ae039), {
                                        style: $d31b9bd88e5dcf67$var$progressStyles
                                    }) : /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $788118b6d825ecfe$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                    title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DOWNLOAD_PROOF_BUTTON,
                                    place: "bottom",
                                    anchorSelect: ".download"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                    style: {
                                        ...$d31b9bd88e5dcf67$var$buttonStyles,
                                        border: "0.5px solid var(--primary-color)",
                                        color: "var(--primary-color)"
                                    },
                                    onClick: ()=>handleBackPress(),
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CANCEL_BUTTON
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                    style: {
                                        ...$d31b9bd88e5dcf67$var$buttonStyles,
                                        border: "none",
                                        backgroundColor: "var(--primary-color)",
                                        color: "#fff"
                                    },
                                    onClick: ()=>handleChangeModel("save"),
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SUBMIT_BUTTON
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $d31b9bd88e5dcf67$export$2e2bcd8739ae039 = $d31b9bd88e5dcf67$var$TopNavigation;































const $21e11f889f8068bf$var$templateDefaultDesign = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "43",
        height: "47",
        viewBox: "0 0 43 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M38.8066 6.11206H38.249C39.312 4.38144 38.9195 2.05802 37.2134 0.792255C35.3753 -0.571453 32.763 -0.132489 31.4802 1.78456L28.5844 6.11215H3.70825C1.66351 6.11215 0 7.77566 0 9.82039V33.5287C0 35.5734 1.66351 37.2369 3.70825 37.2369H18.1122L17.0239 41.808H14.6749C13.144 41.808 11.8986 43.0534 11.8986 44.5843V45.164H9.00289C8.49591 45.164 8.08494 45.575 8.08494 46.0819C8.08494 46.5888 8.49591 46.9999 9.00289 46.9999H33.5121C34.0191 46.9999 34.43 46.5888 34.43 46.0819C34.43 45.575 34.0191 45.164 33.5121 45.164H30.6164V44.5843C30.6164 43.0534 29.3709 41.808 27.8401 41.808H25.4911L24.4028 37.2369H38.8067C40.8515 37.2369 42.515 35.5734 42.515 33.5287V28.312V9.8203C42.515 7.77557 40.8515 6.11206 38.8066 6.11206ZM25.6541 22.2495C24.2188 23.2542 21.5301 21.8886 18.9624 23.2587C18.3359 20.0041 18.7309 16.9432 21.9919 16.2676C22.4133 16.1798 22.8671 16.14 23.2533 16.1477C24.3571 16.9666 25.4735 17.7949 26.5741 18.6116C27.056 20.0131 26.8751 21.3948 25.6541 22.2495ZM26.5792 12.4102L29.1776 14.3381L27.1793 16.7744C26.3567 16.1641 25.6495 15.6394 24.8268 15.0289C24.9976 14.7737 26.423 12.6435 26.5792 12.4102ZM33.0061 2.8056C33.7014 1.76638 35.1193 1.5246 36.1195 2.26676C37.1201 3.00901 37.2993 4.43606 36.5064 5.40275C35.0997 7.11776 31.7552 11.1954 30.3431 12.917L27.6012 10.8826L33.0061 2.8056ZM28.7804 44.5843V45.164H13.7345V44.5843C13.7345 44.0658 14.1564 43.6439 14.6749 43.6439H27.84C28.3585 43.6439 28.7804 44.0658 28.7804 44.5843ZM23.6038 41.808H18.9111L19.9994 37.2369H22.5155L23.6038 41.808ZM40.6791 33.5287C40.6791 34.5611 39.8392 35.401 38.8067 35.401C37.3496 35.401 5.3467 35.401 3.70834 35.401C2.67592 35.401 1.83599 34.5611 1.83599 33.5287V29.2299H4.45913C4.96611 29.2299 5.37708 28.8189 5.37708 28.312C5.37708 27.8051 4.96611 27.394 4.45913 27.394H1.83581V9.8203C1.83581 8.78788 2.67573 7.94796 3.70815 7.94796H27.3559C26.4765 9.26219 23.911 13.0963 23.0983 14.3106C21.2994 14.3269 19.5034 14.9536 18.3277 16.3261C16.7278 18.1937 16.4467 21.1282 17.4923 25.048C17.671 25.7183 18.5074 25.9584 19.0134 25.475C21.387 23.2071 24.3431 25.6809 26.9904 23.5383C28.6064 22.2302 28.9888 20.1506 28.3795 18.2061C29.2031 17.2018 35.9676 8.95458 36.7932 7.94796H38.8066C39.839 7.94796 40.6789 8.78788 40.6789 9.8203V27.3939H11.8026C11.2956 27.3939 10.8846 27.805 10.8846 28.3119C10.8846 28.8188 11.2956 29.2298 11.8026 29.2298H40.6791V33.5287Z",
            fill: fill
        })
    });
};
var $21e11f889f8068bf$export$2e2bcd8739ae039 = $21e11f889f8068bf$var$templateDefaultDesign;



const $1175fdb41c6823d7$var$templateTextStyles = {
    color: `#000`,
    fontSize: `12px`,
    fontStyle: `normal`,
    fontWeight: `500`,
    lineHeight: `normal`,
    marginBottom: `16px`
};
const $1175fdb41c6823d7$var$SideBarSelction = (props)=>{
    const { selectedCategory: selectedCategory, templateCategories: templateCategories, currentTemplateType: currentTemplateType, templateTypes: templateTypes, search: search, searchApplied: searchApplied, loader: loader, platformName: platformName, myTemplates: myTemplates, teamTemplates: teamTemplates, olcTemplates: olcTemplates, setSearch: setSearch, handleSearch: handleSearch, removeSearchInput: removeSearchInput, searchKeyDown: searchKeyDown, setCurrentTemplateType: setCurrentTemplateType, setSelectedCategory: setSelectedCategory, handleLoadTemplateModel: handleLoadTemplateModel, handleDialogChange: handleDialogChange } = props;
    const uniqueCurrentTemplates = Array.from(new Map(olcTemplates.map((item)=>[
            item.id,
            item
        ])).values());
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
        className: "custom-template-section",
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "templateTabsWrapper",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    style: {
                        marginTop: "8px"
                    },
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f4ef87f7a4a530a$export$2e2bcd8739ae039), {
                        placeholder: "Template Types",
                        options: templateTypes,
                        setSelectedValue: setCurrentTemplateType,
                        selectedValue: currentTemplateType,
                        builderSelect: true,
                        search: false,
                        isError: false,
                        gallerySelect: false,
                        clearField: false
                    })
                }),
                currentTemplateType?.id === "3" && templateCategories?.length > 1 && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    style: {
                        marginTop: 8
                    },
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f4ef87f7a4a530a$export$2e2bcd8739ae039), {
                        placeholder: "Select Category",
                        options: templateCategories,
                        setSelectedValue: setSelectedCategory,
                        selectedValue: selectedCategory,
                        builderSelect: true,
                        clearField: true,
                        isError: false,
                        gallerySelect: false
                    })
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "searchWrapper",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                        type: "text",
                        value: search,
                        builderInput: true,
                        // @ts-ignore
                        onKeyDown: searchKeyDown,
                        onChange: (e)=>setSearch(e.target.value.trimStart()),
                        placeholder: "Search by template name",
                        inputIcon: true,
                        onClick: handleSearch,
                        searchApplied: searchApplied,
                        removeSearchInput: removeSearchInput
                    })
                }),
                loader ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "noTemplateText",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                        children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.LOADING_TEMPLATE
                    })
                }) : currentTemplateType?.id === "1" ? /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            className: "default-design",
                            onClick: ()=>handleDialogChange("design-own"),
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $21e11f889f8068bf$export$2e2bcd8739ae039), {
                                    fill: "var(--primary-color)"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                    style: $1175fdb41c6823d7$var$templateTextStyles,
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DESIGN_NEW
                                })
                            ]
                        }),
                        myTemplates.length ? myTemplates.map((template, i)=>/*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                className: "design-template",
                                onClick: ()=>handleLoadTemplateModel(template),
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("img", {
                                    src: template.thumbnailUrl,
                                    alt: template.title,
                                    onError: ({ currentTarget: currentTarget })=>{
                                        currentTarget.onerror = null; // prevents looping
                                        //@ts-ignore
                                        currentTarget.src = (0, $21e11f889f8068bf$export$2e2bcd8739ae039);
                                        currentTarget.classList.add("dummy-image");
                                    }
                                })
                            }, i)) : /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "noTemplateText",
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_MY_TEMPLATES
                            })
                        })
                    ]
                }) : currentTemplateType?.id === "2" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
                    children: teamTemplates.length ? teamTemplates?.map((template, i)=>/*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "design-template",
                            onClick: ()=>handleLoadTemplateModel(template),
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("img", {
                                src: template.thumbnailUrl,
                                alt: template.title,
                                onError: ({ currentTarget: currentTarget })=>{
                                    currentTarget.onerror = null; // prevents looping
                                    //@ts-ignore
                                    currentTarget.src = (0, $21e11f889f8068bf$export$2e2bcd8739ae039);
                                    currentTarget.classList.add("dummy-image");
                                }
                            })
                        }, i)) : /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                        className: "noTemplateText",
                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_TEAM_TEMPLATES
                        })
                    })
                }) : currentTemplateType?.id === "3" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
                    children: uniqueCurrentTemplates.length ? uniqueCurrentTemplates?.map((template, i)=>/*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "design-template",
                            onClick: ()=>handleLoadTemplateModel(template),
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("img", {
                                src: template.thumbnailUrl,
                                alt: template.title,
                                onError: ({ currentTarget: currentTarget })=>{
                                    currentTarget.onerror = null; // prevents looping
                                    //@ts-ignore
                                    currentTarget.src = (0, $21e11f889f8068bf$export$2e2bcd8739ae039);
                                    currentTarget.classList.add("dummy-image");
                                }
                            })
                        }, i)) : /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                        className: "noTemplateText",
                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: platformName ? `No ${platformName} Templates to show` : (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_OLC_TEMPLATES
                        })
                    })
                }) : null
            ]
        })
    });
};
var $1175fdb41c6823d7$export$2e2bcd8739ae039 = $1175fdb41c6823d7$var$SideBarSelction;











const $ce8e87d088f0277f$var$Dot = (props)=>{
    const { onClick: onClick, style: style } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "11",
            height: "11",
            viewBox: "0 0 11 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: onClick,
            style: style,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("circle", {
                cx: "5.30958",
                cy: "5.28224",
                r: "4.90333",
                style: style
            })
        })
    });
};
var $ce8e87d088f0277f$export$2e2bcd8739ae039 = $ce8e87d088f0277f$var$Dot;




const $e9ec2acf3005af0f$var$ArrowDown = (props)=>{
    const { onClick: onClick } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            color: "#fff",
            viewBox: "0 0 24 24",
            strokeWidth: 3.5,
            stroke: "currentColor",
            className: "size-6",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "m8.25 4.5 7.5 7.5-7.5 7.5"
            })
        })
    });
};
var $e9ec2acf3005af0f$export$2e2bcd8739ae039 = $e9ec2acf3005af0f$var$ArrowDown;





const $e294d074253deac6$var$TemplatesCard = (props)=>{
    const { templates: templates, loading: loading, handleLoadTemplateModel: handleLoadTemplateModel, platformName: platformName, currentTemplateType: currentTemplateType, product: product, searchApplied: searchApplied, primaryColorRGBA: primaryColorRGBA, designerQueryAmount: designerQueryAmount } = props;
    const [isFilpedIds, setIsFlipedIds] = (0, $lt6Ts$useState)([]);
    const singleSideProducts = [
        2,
        4,
        5,
        16
    ];
    // handler for Flip
    const handleFlip = (templateId)=>{
        const existingTemplateIds = isFilpedIds || [];
        let updatedIds;
        if (existingTemplateIds.includes(templateId)) updatedIds = existingTemplateIds.filter((item)=>item !== templateId);
        else updatedIds = [
            ...existingTemplateIds,
            templateId
        ];
        setIsFlipedIds(updatedIds);
    };
    // handler for setting color
    const colorSetter = (templateId, side)=>{
        const result = !isFilpedIds.includes(templateId) && side === "Front" ? {
            fill: "#FFFFFF"
        } : isFilpedIds.includes(templateId) && side === "Back" ? {
            fill: "#FFFFFF"
        } : {
            fill: "#878585"
        };
        return result;
    };
    // handler for setting rotation
    const transformSetter = (templateId)=>{
        const result = isFilpedIds.includes(templateId) ? {
            transform: "rotateY(0deg)",
            boxShadow: `inset 0 0 0 2px ${primaryColorRGBA}`
        } : {
            transform: "rotateY(360deg)",
            boxShadow: `inset 0 0 0 2px ${primaryColorRGBA}`
        };
        return result;
    };
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: loading ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: "noTemplateGallery",
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.LOADING_TEMPLATE
            })
        }) : templates.length ? templates.map((template, index)=>{
            return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                className: "templateCard",
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                        className: "templateImage",
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)("img", {
                                src: isFilpedIds.includes(template?.id) ? template.backThumbnailUrl : template.thumbnailUrl,
                                alt: "template",
                                style: transformSetter(template?.id),
                                loading: "lazy"
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                className: "tempButton",
                                onClick: ()=>handleLoadTemplateModel(template),
                                children: "Edit Template"
                            }),
                            !singleSideProducts.includes(Number(product?.id)) && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                className: "flipWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ce8e87d088f0277f$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleFlip(template?.id),
                                        style: colorSetter(template?.id, "Front")
                                    }),
                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ce8e87d088f0277f$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleFlip(template?.id),
                                        style: colorSetter(template?.id, "Back")
                                    }),
                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e9ec2acf3005af0f$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleLoadTemplateModel(template)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                        className: "templateName",
                        children: template?.title
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                        className: "templateID",
                        children: [
                            "Template ID: ",
                            template?.id
                        ]
                    })
                ]
            }, index);
        }) : currentTemplateType?.id === "1" ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: `${+product?.id === 5 && designerQueryAmount ? "noTemplateGallery more-visible" : product?.productType === "Professional Letters" ? "noTemplateGallery noTemplateProfessionalAndPersonal" : "noTemplateGallery"}`,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_MY_TEMPLATES
            })
        }) : currentTemplateType?.id === "2" ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: `${+product?.id === 5 && designerQueryAmount ? "noTemplateGallery more-visible" : "noTemplateGallery"}`,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_TEAM_TEMPLATES
            })
        }) : currentTemplateType?.id === "3" ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
            className: `${+product?.id === 5 && designerQueryAmount ? "noTemplateGallery more-visible" : product?.productType === "Professional Letters" ? "noTemplateGallery noTemplateProfessionalAndPersonal" : "noTemplateGallery"}`,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                children: platformName ? `No ${platformName} Templates to show` : (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.NO_OLC_TEMPLATES
            })
        }) : /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {})
    });
};
var $e294d074253deac6$export$2e2bcd8739ae039 = $e294d074253deac6$var$TemplatesCard;





const $d4e7e32e0a4b1e61$var$Tabs = ({ value: value, onChange: onChange, tabs: tabs, className: className, tabClassName: tabClassName, indicatorClassName: indicatorClassName })=>{
    const [indicatorStyle, setIndicatorStyle] = (0, $lt6Ts$useState)({});
    const tabRefs = (0, $lt6Ts$useRef)([]);
    const calculateIndicatorPosition = ()=>{
        const activeIndex = tabs.findIndex((tab)=>tab.id === value.id);
        if (tabRefs.current[activeIndex]) {
            const tabWidth = tabRefs.current[activeIndex]?.offsetWidth || 0;
            const tabLeft = tabRefs.current[activeIndex]?.offsetLeft || 0;
            let indicatorLeft;
            if (window.innerWidth < 768) {
                const indicatorWidth = tabWidth * 0.5;
                indicatorLeft = tabLeft + (tabWidth - indicatorWidth) / 2;
                setIndicatorStyle({
                    width: `${indicatorWidth}px`,
                    left: `${indicatorLeft}px`
                });
            } else {
                const indicatorWidth = 50;
                indicatorLeft = tabLeft + tabWidth / 2 - indicatorWidth / 2;
                setIndicatorStyle({
                    width: `${indicatorWidth}px`,
                    left: `${indicatorLeft}px`
                });
            }
        }
    };
    (0, $lt6Ts$useLayoutEffect)(()=>{
        calculateIndicatorPosition();
        window.addEventListener("resize", calculateIndicatorPosition);
        return ()=>{
            window.removeEventListener("resize", calculateIndicatorPosition);
        };
    }, [
        value,
        tabs.length
    ]);
    (0, $lt6Ts$useEffect)(()=>{
        if (tabs.length > 0 && !value.id) onChange(tabs[0]);
    }, [
        tabs,
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: `tabsWrapper ${className}`,
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                className: "tabsContainer",
                children: tabs.map((tab, index)=>/*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                        ref: (el)=>tabRefs.current[index] = el,
                        className: `tab ${tabClassName} ${value.id === tab.id ? "activeTab" : ""}`,
                        onClick: ()=>onChange(tab),
                        children: tab.label
                    }, index))
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                className: `tabsIndicator ${indicatorClassName}`,
                style: indicatorStyle
            })
        ]
    });
};
var $d4e7e32e0a4b1e61$export$2e2bcd8739ae039 = $d4e7e32e0a4b1e61$var$Tabs;









const $ffec28c5520dd7d5$var$Designer = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "48",
        height: "50",
        viewBox: "0 0 48 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M44.1017 9.0484H43.5498C44.6017 7.33581 44.2133 5.03658 42.5251 3.784C40.706 2.4345 38.121 2.86889 36.8515 4.76597L33.9859 9.04849H9.36884C7.3454 9.04849 5.69922 10.6947 5.69922 12.7181V36.1795C5.69922 38.2029 7.3454 39.8491 9.36884 39.8491H23.6227L22.5458 44.3726H20.2213C18.7064 44.3726 17.4739 45.605 17.4739 47.1199V47.6936H14.6083C14.1066 47.6936 13.7 48.1004 13.7 48.602C13.7 49.1036 14.1066 49.5104 14.6083 49.5104H38.8623C39.364 49.5104 39.7707 49.1036 39.7707 48.602C39.7707 48.1004 39.364 47.6936 38.8623 47.6936H35.9967V47.1199C35.9967 45.605 34.7642 44.3726 33.2493 44.3726H30.9248L29.8479 39.8491H44.1018C46.1252 39.8491 47.7714 38.2029 47.7714 36.1795V31.0171V12.718C47.7714 10.6946 46.1252 9.0484 44.1017 9.0484ZM31.0861 25.0178C29.6658 26.012 27.005 24.6606 24.4641 26.0165C23.8441 22.7958 24.235 19.7668 27.4621 19.0982C27.8791 19.0113 28.3281 18.9719 28.7104 18.9796C29.8026 19.7899 30.9074 20.6096 31.9966 21.4178C32.4734 22.8047 32.2944 24.172 31.0861 25.0178ZM32.0016 15.281L34.5729 17.1888L32.5955 19.5997C31.7814 18.9957 31.0815 18.4765 30.2674 17.8724C30.4365 17.6198 31.847 15.5118 32.0016 15.281ZM38.3616 5.77638C39.0496 4.74799 40.4528 4.50872 41.4425 5.24315C42.4327 5.97767 42.61 7.38986 41.8254 8.34648C40.4333 10.0436 37.1237 14.0788 35.7263 15.7825L33.013 13.7693L38.3616 5.77638ZM34.1799 47.1199V47.6936H19.2906V47.1199C19.2906 46.6069 19.7081 46.1894 20.2213 46.1894H33.2492C33.7624 46.1894 34.1799 46.6069 34.1799 47.1199ZM29.0572 44.3726H24.4133L25.4903 39.8491H27.9802L29.0572 44.3726ZM45.9546 36.1795C45.9546 37.2011 45.1234 38.0323 44.1018 38.0323C42.6598 38.0323 10.9902 38.0323 9.36893 38.0323C8.34727 38.0323 7.51609 37.2011 7.51609 36.1795V31.9255H10.1119C10.6136 31.9255 11.0203 31.5187 11.0203 31.0171C11.0203 30.5155 10.6136 30.1087 10.1119 30.1087H7.51591V12.718C7.51591 11.6964 8.34708 10.8652 9.36875 10.8652H32.7702C31.9 12.1657 29.3611 15.9599 28.5569 17.1616C26.7768 17.1777 24.9995 17.7978 23.836 19.1561C22.2528 21.0042 21.9747 23.9081 23.0093 27.7871C23.1862 28.4504 24.0138 28.6881 24.5146 28.2097C26.8634 25.9653 29.7888 28.4135 32.4085 26.2931C34.0076 24.9986 34.3861 22.9408 33.7831 21.0164C34.5982 20.0227 41.2922 11.8613 42.1092 10.8652H44.1016C45.1232 10.8652 45.9544 11.6964 45.9544 12.718V30.1086H17.3788C16.8771 30.1086 16.4705 30.5154 16.4705 31.017C16.4705 31.5186 16.8771 31.9254 17.3788 31.9254H45.9546V36.1795Z",
                fill: fill
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: fill
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("mask", {
                id: "mask0_8266_3818",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M0 0H20V20H0V0Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("g", {
                mask: "url(#mask0_8266_3818)",
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M10 1.63267C14.6137 1.63267 18.3673 5.38628 18.3673 10C18.3673 14.6137 14.6137 18.3673 10 18.3673C5.38628 18.3673 1.63267 14.6137 1.63267 10C1.63267 5.38628 5.38628 1.63267 10 1.63267ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47724 15.5228 0 10 0C4.47724 0 0 4.47724 0 10C0 15.5228 4.47724 20 10 20Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M9.83801 12.8416C9.21301 12.8416 8.58825 12.6034 7.78482 12.0085L6.68359 13.7343C7.42771 14.4039 8.48409 14.761 9.33213 14.8651V16.3529H10.9986V14.7757C12.5608 14.4039 13.3196 13.2732 13.3196 11.8298C13.3196 9.12199 9.4809 9.06243 9.4809 7.93154C9.4809 7.33644 9.7934 7.15777 10.4331 7.15777C10.9836 7.15777 11.4449 7.39576 11.9807 7.87199L13.2454 6.41389C12.65 5.78913 11.9358 5.31291 10.9986 5.16413V3.64648H9.33213V5.19379C7.88874 5.50629 7.0407 6.54772 7.0407 8.05066C7.0407 10.6543 10.8794 10.8181 10.8794 12.0085C10.8794 12.5887 10.5819 12.8416 9.83801 12.8416Z",
                fill: "white"
            })
        ]
    });
};
var $ffec28c5520dd7d5$export$2e2bcd8739ae039 = $ffec28c5520dd7d5$var$Designer;


const $889afc7f44cbd90b$var$galleryDialogStyles = {
    maxWidth: "1090px",
    minHeight: "calc(100% - 50px)"
};
const $889afc7f44cbd90b$var$ModalGallery = (props)=>{
    const { product: product, openGalleryModal: openGalleryModal, selectedCategory: selectedCategory, templateCategories: templateCategories, currentTemplateType: currentTemplateType, templateTypes: templateTypes, designerQueryAmount: designerQueryAmount, search: search, searchApplied: searchApplied, loader: loader, platformName: platformName, myTemplates: myTemplates, teamTemplates: teamTemplates, olcTemplates: olcTemplates, pagination: pagination, setSearch: setSearch, handleSearch: handleSearch, removeSearchInput: removeSearchInput, searchKeyDown: searchKeyDown, currentTemplateTypeRef: currentTemplateTypeRef, setSelectedCategory: setSelectedCategory, handleLoadTemplateModel: handleLoadTemplateModel, handleTabChange: handleTabChange, handleDialogChange: handleDialogChange, closeGalleryModal: closeGalleryModal, setOpenGalleryModal: setOpenGalleryModal, setHireDesignerModal: setHireDesignerModal } = props;
    const primaryColorExtract = getComputedStyle(document.documentElement).getPropertyValue("--primary-color").trim();
    const primaryColorRGBA = (0, $717432aee8737b76$export$9665a07d9187b414)(primaryColorExtract, 0.5);
    const currentTemplates = currentTemplateType?.id === "1" ? myTemplates : currentTemplateType?.id === "2" ? teamTemplates : currentTemplateType?.id === "3" ? olcTemplates : [];
    const uniqueCurrentTemplates = Array.from(new Map(currentTemplates.map((item)=>[
            item.id,
            item
        ])).values());
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
            customStyles: $889afc7f44cbd90b$var$galleryDialogStyles,
            open: openGalleryModal,
            handleClose: closeGalleryModal,
            title: product?.productType === "Postcards" ? `${product?.productType} (${product?.selectedSize || product?.paperSize})` : (0, $d60d8816d76b2b02$export$92e44ea1079b9ec6)?.find((item)=>item?.id === product?.id)?.title || product?.productType,
            isGallery: true,
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "topBar",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d4e7e32e0a4b1e61$export$2e2bcd8739ae039), {
                                value: currentTemplateType || {},
                                onChange: handleTabChange,
                                tabs: templateTypes || [],
                                className: "myCustomTabs",
                                tabClassName: "myTab",
                                indicatorClassName: "myIndicator"
                            })
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                                type: "text",
                                value: search,
                                // @ts-ignore
                                onKeyDown: searchKeyDown,
                                onChange: (e)=>setSearch(e.target.value.trimStart()),
                                placeholder: "Search templates by name or ID",
                                onClick: handleSearch,
                                searchApplied: searchApplied,
                                removeSearchInput: removeSearchInput,
                                inputIcon: true,
                                gellerySearch: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "selectBar",
                    children: [
                        currentTemplateType?.id === "3" && templateCategories?.length > 1 && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f4ef87f7a4a530a$export$2e2bcd8739ae039), {
                                placeholder: "Select Category",
                                options: templateCategories,
                                setSelectedValue: setSelectedCategory,
                                selectedValue: selectedCategory,
                                builderSelect: true,
                                gallerySelect: true,
                                clearField: true,
                                search: false,
                                isError: false
                            })
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: (0, $717432aee8737b76$export$c5a6b7b1e4535d31)(`${currentTemplates.length > 0 ? pagination.total : 0} templates`)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: `templatesContent ${currentTemplateType?.id === "3" && "heightOLC"}`,
                    style: {
                        justifyContent: loader || searchApplied ? "center" : "flex-start",
                        alignItems: searchApplied ? "center" : "flex-start",
                        height: searchApplied ? "calc(100vh - 300px)" : "auto",
                        overflowY: product?.productType === "Personal Letters" && currentTemplates.length === 0 ? "hidden" : "scroll"
                    },
                    children: [
                        !loader && !searchApplied && currentTemplateTypeRef.current?.id === "1" && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: `defaultDesign 
                      ${product?.id === "13" && product?.size?.find((product)=>product?.size === "4x6") || product?.paperSize === "4x6" ? "postcard-4x6" : product?.id === "15" && product?.size?.find((product)=>product?.size === "6x11") || product?.paperSize === "6x11" ? "postcard-6x11" : product?.id === "14" && product?.size?.find((product)=>product?.size === "6x9") || product?.paperSize === "6x9" ? "postcard-6x9" : product?.id === "5" || product?.id === "16" ? "personalLetter" : product?.id === "2" || product?.id === "4" || product?.id === "18" ? "professionalLetter" : product?.id === "9" ? "biFold" : product?.id === "11" ? "triFold" : null}`,
                                    onClick: ()=>handleDialogChange("design-own"),
                                    style: {
                                        boxShadow: `inset 0 0 0 2px ${primaryColorRGBA}`
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $21e11f889f8068bf$export$2e2bcd8739ae039), {
                                            fill: "var(--primary-color)"
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                            children: "Design Your Own"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                    className: "ownHeading",
                                    children: "Design Your Own"
                                })
                            ]
                        }),
                        !loader && !searchApplied && currentTemplateTypeRef.current?.id !== "2" && designerQueryAmount && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: `defaultDesign 
                      ${product?.id === "13" && product?.size?.find((product)=>product?.size === "4x6") || product?.paperSize === "4x6" ? "postcard-4x6" : product?.id === "15" && product?.size?.find((product)=>product?.size === "6x11") || product?.paperSize === "6x11" ? "postcard-6x11" : product?.id === "14" && product?.size?.find((product)=>product?.size === "6x9") || product?.paperSize === "6x9" ? "postcard-6x9" : product?.id === "5" || product?.id === "16" ? "personalLetter" : product?.id === "2" || product?.id === "4" || product?.id === "18" ? "professionalLetter" : product?.id === "9" ? "biFold" : product?.id === "11" ? "triFold" : null}`,
                                    onClick: ()=>{
                                        setOpenGalleryModal(false);
                                        setHireDesignerModal(true);
                                    },
                                    style: {
                                        boxShadow: `inset 0 0 0 2px ${primaryColorRGBA}`
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ffec28c5520dd7d5$export$2e2bcd8739ae039), {
                                            fill: "var(--primary-color)"
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                            children: "Hire a Designer"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                    className: "ownHeading",
                                    children: [
                                        "Hire a Designer +$",
                                        designerQueryAmount
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e294d074253deac6$export$2e2bcd8739ae039), {
                            templates: uniqueCurrentTemplates,
                            handleLoadTemplateModel: handleLoadTemplateModel,
                            loading: loader,
                            platformName: platformName,
                            currentTemplateType: currentTemplateType,
                            product: product,
                            searchApplied: searchApplied,
                            primaryColorRGBA: primaryColorRGBA,
                            designerQueryAmount: designerQueryAmount
                        })
                    ]
                })
            ]
        })
    });
};
var $889afc7f44cbd90b$export$2e2bcd8739ae039 = $889afc7f44cbd90b$var$ModalGallery;















/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:03
 * @FilePath: src/assets/images/hire-designer/pdf.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $f01fafd10961aacf$var$PDF = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "33",
            viewBox: "0 0 33 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M28.5492 31.7027H12.2346C10.1868 31.7027 8.52673 30.0426 8.52673 27.9948V5.00608C8.52673 2.95828 10.1868 1.29821 12.2346 1.29821H22.1241L32.2571 11.4312V27.9948C32.2571 30.0426 30.597 31.7027 28.5492 31.7027Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.6465",
                    width: "22.2472",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#D82042"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.6875 24.2862V18.084H5.89826C6.38079 18.084 6.78055 18.1718 7.09752 18.3475C7.4145 18.5231 7.65173 18.7634 7.80921 19.0682C7.96669 19.3711 8.04543 19.7123 8.04543 20.0918C8.04543 20.4734 7.96568 20.8166 7.80618 21.1215C7.6487 21.4244 7.41046 21.6646 7.09147 21.8423C6.77449 22.0179 6.37575 22.1058 5.89523 22.1058H4.37496V21.3123H5.81044C6.1153 21.3123 6.36262 21.2598 6.55241 21.1548C6.74219 21.0478 6.8815 20.9025 6.97033 20.7187C7.05916 20.535 7.10358 20.326 7.10358 20.0918C7.10358 19.8576 7.05916 19.6497 6.97033 19.468C6.8815 19.2863 6.74118 19.1439 6.54938 19.041C6.35959 18.938 6.10924 18.8865 5.79832 18.8865H4.62329V24.2862H3.6875Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M11.1503 24.2862H9.14248V18.084H11.2139C11.8216 18.084 12.3435 18.2082 12.7796 18.4565C13.2157 18.7028 13.5499 19.0571 13.7821 19.5195C14.0163 19.9798 14.1334 20.532 14.1334 21.176C14.1334 21.8221 14.0152 22.3773 13.779 22.8417C13.5448 23.306 13.2056 23.6634 12.7615 23.9137C12.3173 24.1621 11.7803 24.2862 11.1503 24.2862ZM10.0783 23.4686H11.0989C11.5713 23.4686 11.964 23.3797 12.2769 23.202C12.5899 23.0224 12.8241 22.7629 12.9795 22.4237C13.135 22.0825 13.2127 21.6666 13.2127 21.176C13.2127 20.6895 13.135 20.2766 12.9795 19.9374C12.8261 19.5982 12.5969 19.3408 12.2921 19.1651C11.9872 18.9895 11.6086 18.9017 11.1564 18.9017H10.0783V23.4686Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M15.297 24.2862V18.084H19.1431V18.8895H16.2328V20.7793H18.8676V21.5818H16.2328V24.2862H15.297Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $f01fafd10961aacf$export$2e2bcd8739ae039 = $f01fafd10961aacf$var$PDF;


/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:03
 * @FilePath: src/assets/images/hire-designer/png.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $b2749c73d161a8b7$var$PNG = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "33",
            viewBox: "0 0 33 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M28.5492 31.7027H12.2346C10.1868 31.7027 8.52673 30.0426 8.52673 27.9948V5.00608C8.52673 2.95828 10.1868 1.29821 12.2346 1.29821H22.1241L32.2571 11.4312V27.9948C32.2571 30.0426 30.597 31.7027 28.5492 31.7027Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.6465",
                    width: "22.2472",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#FFA674"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.10227 23.0455C2.96212 23.0455 2.84186 22.9953 2.74148 22.8949C2.6411 22.7945 2.59091 22.6742 2.59091 22.5341C2.59091 22.3939 2.6411 22.2737 2.74148 22.1733C2.84186 22.0729 2.96212 22.0227 3.10227 22.0227C3.24242 22.0227 3.36269 22.0729 3.46307 22.1733C3.56345 22.2737 3.61364 22.3939 3.61364 22.5341C3.61364 22.6269 3.58996 22.7121 3.54261 22.7898C3.49716 22.8674 3.43561 22.9299 3.35795 22.9773C3.2822 23.0227 3.19697 23.0455 3.10227 23.0455ZM4.81676 24.6364V18.6364H5.46449V19.3295H5.54403C5.59328 19.2538 5.66146 19.1572 5.74858 19.0398C5.83759 18.9205 5.96449 18.8144 6.12926 18.7216C6.29593 18.6269 6.52131 18.5795 6.8054 18.5795C7.17282 18.5795 7.49669 18.6714 7.77699 18.8551C8.05729 19.0388 8.27604 19.2992 8.43324 19.6364C8.59044 19.9735 8.66903 20.3712 8.66903 20.8295C8.66903 21.2917 8.59044 21.6922 8.43324 22.0312C8.27604 22.3684 8.05824 22.6297 7.77983 22.8153C7.50142 22.9991 7.1804 23.0909 6.81676 23.0909C6.53646 23.0909 6.31203 23.0445 6.14347 22.9517C5.97491 22.857 5.84517 22.75 5.75426 22.6307C5.66335 22.5095 5.59328 22.4091 5.54403 22.3295H5.48722V24.6364H4.81676ZM5.47585 20.8182C5.47585 21.1477 5.52415 21.4384 5.62074 21.6903C5.71733 21.9403 5.85843 22.1364 6.04403 22.2784C6.22964 22.4186 6.45691 22.4886 6.72585 22.4886C7.00616 22.4886 7.24006 22.4148 7.42756 22.267C7.61695 22.1174 7.759 21.9167 7.85369 21.6648C7.95028 21.411 7.99858 21.1288 7.99858 20.8182C7.99858 20.5114 7.95123 20.2348 7.85653 19.9886C7.76373 19.7405 7.62263 19.5445 7.43324 19.4006C7.24574 19.2547 7.00994 19.1818 6.72585 19.1818C6.45313 19.1818 6.22396 19.2509 6.03835 19.3892C5.85275 19.5256 5.71259 19.7169 5.6179 19.9631C5.5232 20.2074 5.47585 20.4924 5.47585 20.8182ZM10.3622 20.375V23H9.69176V18.6364H10.3395V19.3182H10.3963C10.4986 19.0966 10.6539 18.9186 10.8622 18.7841C11.0705 18.6477 11.3395 18.5795 11.669 18.5795C11.9645 18.5795 12.223 18.6402 12.4446 18.7614C12.6662 18.8807 12.8385 19.0625 12.9616 19.3068C13.0848 19.5492 13.1463 19.8561 13.1463 20.2273V23H12.4759V20.2727C12.4759 19.9299 12.3868 19.6629 12.2088 19.4716C12.0308 19.2784 11.7865 19.1818 11.4759 19.1818C11.2618 19.1818 11.0705 19.2282 10.902 19.321C10.7353 19.4138 10.6037 19.5492 10.5071 19.7273C10.4105 19.9053 10.3622 20.1212 10.3622 20.375ZM16.1328 24.7273C15.8089 24.7273 15.5305 24.6856 15.2976 24.6023C15.0646 24.5208 14.8705 24.4129 14.7152 24.2784C14.5618 24.1458 14.4396 24.0038 14.3487 23.8523L14.8828 23.4773C14.9434 23.5568 15.0201 23.6477 15.1129 23.75C15.2057 23.8542 15.3326 23.9441 15.4936 24.0199C15.6565 24.0975 15.8696 24.1364 16.1328 24.1364C16.4851 24.1364 16.7758 24.0511 17.005 23.8807C17.2341 23.7102 17.3487 23.4432 17.3487 23.0795V22.1932H17.2919C17.2427 22.2727 17.1726 22.3712 17.0817 22.4886C16.9927 22.6042 16.8639 22.7074 16.6953 22.7983C16.5286 22.8873 16.3033 22.9318 16.0192 22.9318C15.6669 22.9318 15.3506 22.8485 15.0703 22.6818C14.7919 22.5152 14.5713 22.2727 14.4084 21.9545C14.2474 21.6364 14.1669 21.25 14.1669 20.7955C14.1669 20.3485 14.2455 19.9593 14.4027 19.6278C14.5599 19.2945 14.7786 19.0369 15.0589 18.8551C15.3393 18.6714 15.6631 18.5795 16.0305 18.5795C16.3146 18.5795 16.54 18.6269 16.7067 18.7216C16.8752 18.8144 17.004 18.9205 17.093 19.0398C17.1839 19.1572 17.254 19.2538 17.3033 19.3295H17.3714V18.6364H18.0192V23.125C18.0192 23.5 17.9339 23.8049 17.7635 24.0398C17.5949 24.2765 17.3677 24.4498 17.0817 24.5597C16.7976 24.6714 16.4813 24.7273 16.1328 24.7273ZM16.1101 22.3295C16.379 22.3295 16.6063 22.268 16.7919 22.1449C16.9775 22.0218 17.1186 21.8447 17.2152 21.6136C17.3118 21.3826 17.3601 21.1061 17.3601 20.7841C17.3601 20.4697 17.3127 20.1922 17.218 19.9517C17.1233 19.7112 16.9832 19.5227 16.7976 19.3864C16.612 19.25 16.3828 19.1818 16.1101 19.1818C15.826 19.1818 15.5893 19.2538 15.3999 19.3977C15.2124 19.5417 15.0713 19.7348 14.9766 19.9773C14.8838 20.2197 14.8374 20.4886 14.8374 20.7841C14.8374 21.0871 14.8847 21.3551 14.9794 21.5881C15.076 21.8191 15.218 22.0009 15.4055 22.1335C15.5949 22.2642 15.8298 22.3295 16.1101 22.3295Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $b2749c73d161a8b7$export$2e2bcd8739ae039 = $b2749c73d161a8b7$var$PNG;


/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:01
 * @FilePath: src/assets/images/hire-designer/doc.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $55aa136d3e6acf97$var$DOC = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M32.2584 11.309V27.4382C32.2584 29.486 30.5984 31.1461 28.5506 31.1461H12.236C10.1882 31.1461 8.52809 29.486 8.52809 27.4382V4.44947C8.52809 2.40167 10.1882 0.741601 12.236 0.741601H21.691V6.11801C21.691 8.98492 24.0151 11.309 26.882 11.309H32.2584ZM31.2097 9.82587H26.882C24.8342 9.82587 23.1742 8.1658 23.1742 6.11801V1.79034L31.2097 9.82587Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.0899",
                    width: "22.2472",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#5235F6"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.10227 22.4893C2.96212 22.4893 2.84186 22.4391 2.74148 22.3387C2.6411 22.2384 2.59091 22.1181 2.59091 21.9779C2.59091 21.8378 2.6411 21.7175 2.74148 21.6171C2.84186 21.5168 2.96212 21.4666 3.10227 21.4666C3.24242 21.4666 3.36269 21.5168 3.46307 21.6171C3.56345 21.7175 3.61364 21.8378 3.61364 21.9779C3.61364 22.0707 3.58996 22.156 3.54261 22.2336C3.49716 22.3113 3.43561 22.3738 3.35795 22.4211C3.2822 22.4666 3.19697 22.4893 3.10227 22.4893ZM6.46449 22.5348C6.10085 22.5348 5.77983 22.4429 5.50142 22.2592C5.22301 22.0736 5.00521 21.8122 4.84801 21.4751C4.69081 21.1361 4.61222 20.7355 4.61222 20.2734C4.61222 19.8151 4.69081 19.4173 4.84801 19.0802C5.00521 18.7431 5.22396 18.4827 5.50426 18.299C5.78456 18.1152 6.10843 18.0234 6.47585 18.0234C6.75994 18.0234 6.98438 18.0707 7.14915 18.1654C7.31581 18.2582 7.44271 18.3643 7.52983 18.4836C7.61884 18.601 7.68797 18.6976 7.73722 18.7734H7.79403V16.6257H8.46449V22.4438H7.81676V21.7734H7.73722C7.68797 21.8529 7.6179 21.9533 7.52699 22.0745C7.43608 22.1938 7.30634 22.3009 7.13778 22.3956C6.96922 22.4884 6.74479 22.5348 6.46449 22.5348ZM6.5554 21.9325C6.82434 21.9325 7.05161 21.8624 7.23722 21.7223C7.42282 21.5802 7.56392 21.3842 7.66051 21.1342C7.7571 20.8823 7.8054 20.5916 7.8054 20.262C7.8054 19.9363 7.75805 19.6512 7.66335 19.4069C7.56866 19.1607 7.4285 18.9694 7.2429 18.8331C7.05729 18.6948 6.82813 18.6257 6.5554 18.6257C6.27131 18.6257 6.03456 18.6986 5.84517 18.8444C5.65767 18.9884 5.51657 19.1844 5.42188 19.4325C5.32907 19.6787 5.28267 19.9552 5.28267 20.262C5.28267 20.5726 5.33002 20.8548 5.42472 21.1086C5.52131 21.3605 5.66335 21.5613 5.85085 21.7109C6.04025 21.8586 6.27509 21.9325 6.5554 21.9325ZM11.5582 22.5348C11.1643 22.5348 10.8187 22.441 10.5213 22.2535C10.2259 22.066 9.99479 21.8037 9.82812 21.4666C9.66335 21.1295 9.58097 20.7355 9.58097 20.2848C9.58097 19.8302 9.66335 19.4334 9.82812 19.0944C9.99479 18.7554 10.2259 18.4921 10.5213 18.3046C10.8187 18.1171 11.1643 18.0234 11.5582 18.0234C11.9522 18.0234 12.2969 18.1171 12.5923 18.3046C12.8897 18.4921 13.1207 18.7554 13.2855 19.0944C13.4522 19.4334 13.5355 19.8302 13.5355 20.2848C13.5355 20.7355 13.4522 21.1295 13.2855 21.4666C13.1207 21.8037 12.8897 22.066 12.5923 22.2535C12.2969 22.441 11.9522 22.5348 11.5582 22.5348ZM11.5582 21.9325C11.8575 21.9325 12.1037 21.8558 12.2969 21.7024C12.4901 21.549 12.633 21.3473 12.7259 21.0973C12.8187 20.8473 12.8651 20.5764 12.8651 20.2848C12.8651 19.9931 12.8187 19.7213 12.7259 19.4694C12.633 19.2175 12.4901 19.0139 12.2969 18.8586C12.1037 18.7033 11.8575 18.6257 11.5582 18.6257C11.259 18.6257 11.0128 18.7033 10.8196 18.8586C10.6264 19.0139 10.4834 19.2175 10.3906 19.4694C10.2978 19.7213 10.2514 19.9931 10.2514 20.2848C10.2514 20.5764 10.2978 20.8473 10.3906 21.0973C10.4834 21.3473 10.6264 21.549 10.8196 21.7024C11.0128 21.8558 11.259 21.9325 11.5582 21.9325ZM16.3317 22.5348C15.9226 22.5348 15.5703 22.4382 15.2749 22.245C14.9794 22.0518 14.7521 21.7857 14.593 21.4467C14.4339 21.1077 14.3544 20.7204 14.3544 20.2848C14.3544 19.8416 14.4358 19.4505 14.5987 19.1115C14.7635 18.7706 14.9927 18.5045 15.2862 18.3132C15.5817 18.12 15.9264 18.0234 16.3203 18.0234C16.6271 18.0234 16.9036 18.0802 17.1499 18.1938C17.3961 18.3075 17.5978 18.4666 17.755 18.6711C17.9122 18.8757 18.0097 19.1143 18.0476 19.387H17.3771C17.326 19.1882 17.2124 19.012 17.0362 18.8586C16.862 18.7033 16.6271 18.6257 16.3317 18.6257C16.0703 18.6257 15.8411 18.6938 15.6442 18.8302C15.4491 18.9647 15.2966 19.155 15.1868 19.4012C15.0788 19.6456 15.0249 19.9325 15.0249 20.262C15.0249 20.5992 15.0779 20.8927 15.1839 21.1427C15.2919 21.3927 15.4434 21.5868 15.6385 21.7251C15.8355 21.8634 16.0665 21.9325 16.3317 21.9325C16.5059 21.9325 16.6641 21.9022 16.8061 21.8416C16.9482 21.781 17.0684 21.6938 17.1669 21.5802C17.2654 21.4666 17.3355 21.3302 17.3771 21.1711H18.0476C18.0097 21.4287 17.916 21.6607 17.7663 21.8671C17.6186 22.0717 17.4226 22.2346 17.1783 22.3558C16.9358 22.4751 16.6536 22.5348 16.3317 22.5348Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $55aa136d3e6acf97$export$2e2bcd8739ae039 = $55aa136d3e6acf97$var$DOC;


/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:01
 * @FilePath: src/assets/images/hire-designer/docx.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $61a736ecb908c109$var$DOCX = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M32.2584 11.309V27.4382C32.2584 29.486 30.5984 31.1461 28.5506 31.1461H12.236C10.1882 31.1461 8.52809 29.486 8.52809 27.4382V4.44947C8.52809 2.40167 10.1882 0.7416 12.236 0.7416H21.691V6.118C21.691 8.98492 24.0151 11.309 26.882 11.309H32.2584ZM31.2097 9.82587H26.882C24.8342 9.82587 23.1742 8.1658 23.1742 6.118V1.79034L31.2097 9.82587Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.0899",
                    width: "24.25",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#151312"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.10227 22.4893C2.96212 22.4893 2.84186 22.4391 2.74148 22.3387C2.6411 22.2384 2.59091 22.1181 2.59091 21.9779C2.59091 21.8378 2.6411 21.7175 2.74148 21.6171C2.84186 21.5168 2.96212 21.4666 3.10227 21.4666C3.24242 21.4666 3.36269 21.5168 3.46307 21.6171C3.56345 21.7175 3.61364 21.8378 3.61364 21.9779C3.61364 22.0707 3.58996 22.156 3.54261 22.2336C3.49716 22.3113 3.43561 22.3738 3.35795 22.4211C3.2822 22.4666 3.19697 22.4893 3.10227 22.4893ZM6.46449 22.5348C6.10085 22.5348 5.77983 22.4429 5.50142 22.2592C5.22301 22.0736 5.00521 21.8122 4.84801 21.4751C4.69081 21.1361 4.61222 20.7355 4.61222 20.2734C4.61222 19.8151 4.69081 19.4173 4.84801 19.0802C5.00521 18.7431 5.22396 18.4827 5.50426 18.299C5.78456 18.1152 6.10843 18.0234 6.47585 18.0234C6.75994 18.0234 6.98438 18.0707 7.14915 18.1654C7.31581 18.2582 7.44271 18.3643 7.52983 18.4836C7.61884 18.601 7.68797 18.6976 7.73722 18.7734H7.79403V16.6257H8.46449V22.4438H7.81676V21.7734H7.73722C7.68797 21.8529 7.6179 21.9533 7.52699 22.0745C7.43608 22.1938 7.30634 22.3009 7.13778 22.3956C6.96922 22.4884 6.74479 22.5348 6.46449 22.5348ZM6.5554 21.9325C6.82434 21.9325 7.05161 21.8624 7.23722 21.7223C7.42282 21.5802 7.56392 21.3842 7.66051 21.1342C7.7571 20.8823 7.8054 20.5916 7.8054 20.262C7.8054 19.9363 7.75805 19.6512 7.66335 19.4069C7.56866 19.1607 7.4285 18.9694 7.2429 18.8331C7.05729 18.6948 6.82813 18.6257 6.5554 18.6257C6.27131 18.6257 6.03456 18.6986 5.84517 18.8444C5.65767 18.9884 5.51657 19.1844 5.42188 19.4325C5.32907 19.6787 5.28267 19.9552 5.28267 20.262C5.28267 20.5726 5.33002 20.8548 5.42472 21.1086C5.52131 21.3605 5.66335 21.5613 5.85085 21.7109C6.04025 21.8586 6.27509 21.9325 6.5554 21.9325ZM11.5582 22.5348C11.1643 22.5348 10.8187 22.441 10.5213 22.2535C10.2259 22.066 9.99479 21.8037 9.82812 21.4666C9.66335 21.1295 9.58097 20.7355 9.58097 20.2848C9.58097 19.8302 9.66335 19.4334 9.82812 19.0944C9.99479 18.7554 10.2259 18.4921 10.5213 18.3046C10.8187 18.1171 11.1643 18.0234 11.5582 18.0234C11.9522 18.0234 12.2969 18.1171 12.5923 18.3046C12.8897 18.4921 13.1207 18.7554 13.2855 19.0944C13.4522 19.4334 13.5355 19.8302 13.5355 20.2848C13.5355 20.7355 13.4522 21.1295 13.2855 21.4666C13.1207 21.8037 12.8897 22.066 12.5923 22.2535C12.2969 22.441 11.9522 22.5348 11.5582 22.5348ZM11.5582 21.9325C11.8575 21.9325 12.1037 21.8558 12.2969 21.7024C12.4901 21.549 12.633 21.3473 12.7259 21.0973C12.8187 20.8473 12.8651 20.5764 12.8651 20.2848C12.8651 19.9931 12.8187 19.7213 12.7259 19.4694C12.633 19.2175 12.4901 19.0139 12.2969 18.8586C12.1037 18.7033 11.8575 18.6257 11.5582 18.6257C11.259 18.6257 11.0128 18.7033 10.8196 18.8586C10.6264 19.0139 10.4834 19.2175 10.3906 19.4694C10.2978 19.7213 10.2514 19.9931 10.2514 20.2848C10.2514 20.5764 10.2978 20.8473 10.3906 21.0973C10.4834 21.3473 10.6264 21.549 10.8196 21.7024C11.0128 21.8558 11.259 21.9325 11.5582 21.9325ZM16.3317 22.5348C15.9226 22.5348 15.5703 22.4382 15.2749 22.245C14.9794 22.0518 14.7521 21.7857 14.593 21.4467C14.4339 21.1077 14.3544 20.7204 14.3544 20.2848C14.3544 19.8416 14.4358 19.4505 14.5987 19.1115C14.7635 18.7706 14.9927 18.5045 15.2862 18.3132C15.5817 18.12 15.9264 18.0234 16.3203 18.0234C16.6271 18.0234 16.9036 18.0802 17.1499 18.1938C17.3961 18.3075 17.5978 18.4666 17.755 18.6711C17.9122 18.8757 18.0097 19.1143 18.0476 19.387H17.3771C17.326 19.1882 17.2124 19.012 17.0362 18.8586C16.862 18.7033 16.6271 18.6257 16.3317 18.6257C16.0703 18.6257 15.8411 18.6938 15.6442 18.8302C15.4491 18.9647 15.2966 19.155 15.1868 19.4012C15.0788 19.6456 15.0249 19.9325 15.0249 20.262C15.0249 20.5992 15.0779 20.8927 15.1839 21.1427C15.2919 21.3927 15.4434 21.5868 15.6385 21.7251C15.8355 21.8634 16.0665 21.9325 16.3317 21.9325C16.5059 21.9325 16.6641 21.9022 16.8061 21.8416C16.9482 21.781 17.0684 21.6938 17.1669 21.5802C17.2654 21.4666 17.3355 21.3302 17.3771 21.1711H18.0476C18.0097 21.4287 17.916 21.6607 17.7663 21.8671C17.6186 22.0717 17.4226 22.2346 17.1783 22.3558C16.9358 22.4751 16.6536 22.5348 16.3317 22.5348ZM19.4808 18.0802L20.5263 19.8643L21.5717 18.0802H22.3445L20.9354 20.262L22.3445 22.4438H21.5717L20.5263 20.7507L19.4808 22.4438H18.7081L20.0945 20.262L18.7081 18.0802H19.4808Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $61a736ecb908c109$export$2e2bcd8739ae039 = $61a736ecb908c109$var$DOCX;


/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:02
 * @FilePath: src/assets/images/hire-designer/jpg.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $2bdad7d91b78224f$var$JPG = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M32.2584 11.309V27.4382C32.2584 29.486 30.5984 31.1461 28.5506 31.1461H12.236C10.1882 31.1461 8.52809 29.486 8.52809 27.4382V4.44947C8.52809 2.40167 10.1882 0.741604 12.236 0.741604H21.691V6.11801C21.691 8.98492 24.0151 11.309 26.882 11.309H32.2584ZM31.2097 9.82587H26.882C24.8342 9.82587 23.1742 8.16581 23.1742 6.11801V1.79035L31.2097 9.82587Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.0899",
                    width: "19.25",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#06AFC9"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.10227 22.4893C2.96212 22.4893 2.84186 22.4391 2.74148 22.3387C2.6411 22.2384 2.59091 22.1181 2.59091 21.9779C2.59091 21.8378 2.6411 21.7175 2.74148 21.6171C2.84186 21.5168 2.96212 21.4666 3.10227 21.4666C3.24242 21.4666 3.36269 21.5168 3.46307 21.6171C3.56345 21.7175 3.61364 21.8378 3.61364 21.9779C3.61364 22.0707 3.58996 22.156 3.54261 22.2336C3.49716 22.3113 3.43561 22.3738 3.35795 22.4211C3.2822 22.4666 3.19697 22.4893 3.10227 22.4893ZM4.81676 18.0802H5.48722V22.762C5.48722 23.031 5.44081 23.2639 5.34801 23.4609C5.2571 23.6579 5.11884 23.8103 4.93324 23.9183C4.74953 24.0262 4.51752 24.0802 4.23722 24.0802C4.21449 24.0802 4.19176 24.0802 4.16903 24.0802C4.14631 24.0802 4.12358 24.0802 4.10085 24.0802V23.4552C4.12358 23.4552 4.14441 23.4552 4.16335 23.4552C4.18229 23.4552 4.20312 23.4552 4.22585 23.4552C4.4304 23.4552 4.58002 23.3946 4.67472 23.2734C4.76941 23.1541 4.81676 22.9836 4.81676 22.762V18.0802ZM5.14631 17.3529C5.01563 17.3529 4.90294 17.3084 4.80824 17.2194C4.71544 17.1304 4.66903 17.0234 4.66903 16.8984C4.66903 16.7734 4.71544 16.6664 4.80824 16.5774C4.90294 16.4884 5.01563 16.4438 5.14631 16.4438C5.27699 16.4438 5.38873 16.4884 5.48153 16.5774C5.57623 16.6664 5.62358 16.7734 5.62358 16.8984C5.62358 17.0234 5.57623 17.1304 5.48153 17.2194C5.38873 17.3084 5.27699 17.3529 5.14631 17.3529ZM6.7152 24.0802V18.0802H7.36293V18.7734H7.44247C7.49171 18.6976 7.5599 18.601 7.64702 18.4836C7.73603 18.3643 7.86293 18.2582 8.0277 18.1654C8.19437 18.0707 8.41974 18.0234 8.70384 18.0234C9.07126 18.0234 9.39512 18.1152 9.67543 18.299C9.95573 18.4827 10.1745 18.7431 10.3317 19.0802C10.4889 19.4173 10.5675 19.8151 10.5675 20.2734C10.5675 20.7355 10.4889 21.1361 10.3317 21.4751C10.1745 21.8122 9.95668 22.0736 9.67827 22.2592C9.39986 22.4429 9.07884 22.5348 8.7152 22.5348C8.4349 22.5348 8.21046 22.4884 8.0419 22.3956C7.87334 22.3009 7.74361 22.1938 7.6527 22.0745C7.56179 21.9533 7.49171 21.8529 7.44247 21.7734H7.38565V24.0802H6.7152ZM7.37429 20.262C7.37429 20.5916 7.42259 20.8823 7.51918 21.1342C7.61577 21.3842 7.75687 21.5802 7.94247 21.7223C8.12808 21.8624 8.35535 21.9325 8.62429 21.9325C8.90459 21.9325 9.13849 21.8586 9.32599 21.7109C9.51539 21.5613 9.65743 21.3605 9.75213 21.1086C9.84872 20.8548 9.89702 20.5726 9.89702 20.262C9.89702 19.9552 9.84967 19.6787 9.75497 19.4325C9.66217 19.1844 9.52107 18.9884 9.33168 18.8444C9.14418 18.6986 8.90838 18.6257 8.62429 18.6257C8.35156 18.6257 8.1224 18.6948 7.93679 18.8331C7.75118 18.9694 7.61103 19.1607 7.51634 19.4069C7.42164 19.6512 7.37429 19.9363 7.37429 20.262ZM13.3516 24.1711C13.0277 24.1711 12.7493 24.1295 12.5163 24.0461C12.2834 23.9647 12.0893 23.8567 11.9339 23.7223C11.7805 23.5897 11.6584 23.4476 11.5675 23.2961L12.1016 22.9211C12.1622 23.0007 12.2389 23.0916 12.3317 23.1938C12.4245 23.298 12.5514 23.388 12.7124 23.4637C12.8752 23.5414 13.0883 23.5802 13.3516 23.5802C13.7038 23.5802 13.9946 23.495 14.2237 23.3245C14.4529 23.1541 14.5675 22.887 14.5675 22.5234V21.637H14.5107C14.4614 21.7166 14.3913 21.8151 14.3004 21.9325C14.2114 22.048 14.0826 22.1512 13.9141 22.2421C13.7474 22.3312 13.522 22.3757 13.2379 22.3757C12.8857 22.3757 12.5694 22.2923 12.2891 22.1257C12.0107 21.959 11.79 21.7166 11.6271 21.3984C11.4661 21.0802 11.3857 20.6938 11.3857 20.2393C11.3857 19.7923 11.4643 19.4031 11.6214 19.0717C11.7786 18.7384 11.9974 18.4808 12.2777 18.299C12.558 18.1152 12.8819 18.0234 13.2493 18.0234C13.5334 18.0234 13.7588 18.0707 13.9254 18.1654C14.094 18.2582 14.2228 18.3643 14.3118 18.4836C14.4027 18.601 14.4728 18.6976 14.522 18.7734H14.5902V18.0802H15.2379V22.5688C15.2379 22.9438 15.1527 23.2488 14.9822 23.4836C14.8137 23.7204 14.5864 23.8937 14.3004 24.0035C14.0163 24.1152 13.7 24.1711 13.3516 24.1711ZM13.3288 21.7734C13.5978 21.7734 13.825 21.7118 14.0107 21.5887C14.1963 21.4656 14.3374 21.2885 14.4339 21.0575C14.5305 20.8264 14.5788 20.5499 14.5788 20.2279C14.5788 19.9135 14.5315 19.6361 14.4368 19.3956C14.3421 19.155 14.2019 18.9666 14.0163 18.8302C13.8307 18.6938 13.6016 18.6257 13.3288 18.6257C13.0447 18.6257 12.808 18.6976 12.6186 18.8416C12.4311 18.9855 12.29 19.1787 12.1953 19.4211C12.1025 19.6635 12.0561 19.9325 12.0561 20.2279C12.0561 20.531 12.1035 20.799 12.1982 21.0319C12.2947 21.263 12.4368 21.4448 12.6243 21.5774C12.8137 21.7081 13.0485 21.7734 13.3288 21.7734Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $2bdad7d91b78224f$export$2e2bcd8739ae039 = $2bdad7d91b78224f$var$JPG;


/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:02
 * @FilePath: src/assets/images/hire-designer/jpeg.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */ 

const $c45713fa02f26ab7$var$JPEG = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M32.2584 11.309V27.4382C32.2584 29.486 30.5984 31.1461 28.5506 31.1461H12.236C10.1882 31.1461 8.52809 29.486 8.52809 27.4382V4.44947C8.52809 2.40167 10.1882 0.741604 12.236 0.741604H21.691V6.11801C21.691 8.98492 24.0151 11.309 26.882 11.309H32.2584ZM31.2097 9.82587H26.882C24.8342 9.82587 23.1742 8.16581 23.1742 6.11801V1.79035L31.2097 9.82587Z",
                    fill: "#EEF1F7",
                    stroke: "#CBD0DC",
                    strokeWidth: "1.48315"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                    y: "14.0899",
                    width: "23.25",
                    height: "12.9775",
                    rx: "2.59551",
                    fill: "#0B6111"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M3.10227 22.4893C2.96212 22.4893 2.84186 22.4391 2.74148 22.3387C2.6411 22.2384 2.59091 22.1181 2.59091 21.9779C2.59091 21.8378 2.6411 21.7175 2.74148 21.6171C2.84186 21.5168 2.96212 21.4666 3.10227 21.4666C3.24242 21.4666 3.36269 21.5168 3.46307 21.6171C3.56345 21.7175 3.61364 21.8378 3.61364 21.9779C3.61364 22.0707 3.58996 22.156 3.54261 22.2336C3.49716 22.3113 3.43561 22.3738 3.35795 22.4211C3.2822 22.4666 3.19697 22.4893 3.10227 22.4893ZM4.81676 18.0802H5.48722V22.762C5.48722 23.031 5.44081 23.2639 5.34801 23.4609C5.2571 23.6579 5.11884 23.8103 4.93324 23.9183C4.74953 24.0262 4.51752 24.0802 4.23722 24.0802C4.21449 24.0802 4.19176 24.0802 4.16903 24.0802C4.14631 24.0802 4.12358 24.0802 4.10085 24.0802V23.4552C4.12358 23.4552 4.14441 23.4552 4.16335 23.4552C4.18229 23.4552 4.20312 23.4552 4.22585 23.4552C4.4304 23.4552 4.58002 23.3946 4.67472 23.2734C4.76941 23.1541 4.81676 22.9836 4.81676 22.762V18.0802ZM5.14631 17.3529C5.01563 17.3529 4.90294 17.3084 4.80824 17.2194C4.71544 17.1304 4.66903 17.0234 4.66903 16.8984C4.66903 16.7734 4.71544 16.6664 4.80824 16.5774C4.90294 16.4884 5.01563 16.4438 5.14631 16.4438C5.27699 16.4438 5.38873 16.4884 5.48153 16.5774C5.57623 16.6664 5.62358 16.7734 5.62358 16.8984C5.62358 17.0234 5.57623 17.1304 5.48153 17.2194C5.38873 17.3084 5.27699 17.3529 5.14631 17.3529ZM6.7152 24.0802V18.0802H7.36293V18.7734H7.44247C7.49171 18.6976 7.5599 18.601 7.64702 18.4836C7.73603 18.3643 7.86293 18.2582 8.0277 18.1654C8.19437 18.0707 8.41974 18.0234 8.70384 18.0234C9.07126 18.0234 9.39512 18.1152 9.67543 18.299C9.95573 18.4827 10.1745 18.7431 10.3317 19.0802C10.4889 19.4173 10.5675 19.8151 10.5675 20.2734C10.5675 20.7355 10.4889 21.1361 10.3317 21.4751C10.1745 21.8122 9.95668 22.0736 9.67827 22.2592C9.39986 22.4429 9.07884 22.5348 8.7152 22.5348C8.4349 22.5348 8.21046 22.4884 8.0419 22.3956C7.87334 22.3009 7.74361 22.1938 7.6527 22.0745C7.56179 21.9533 7.49171 21.8529 7.44247 21.7734H7.38565V24.0802H6.7152ZM7.37429 20.262C7.37429 20.5916 7.42259 20.8823 7.51918 21.1342C7.61577 21.3842 7.75687 21.5802 7.94247 21.7223C8.12808 21.8624 8.35535 21.9325 8.62429 21.9325C8.90459 21.9325 9.13849 21.8586 9.32599 21.7109C9.51539 21.5613 9.65743 21.3605 9.75213 21.1086C9.84872 20.8548 9.89702 20.5726 9.89702 20.262C9.89702 19.9552 9.84967 19.6787 9.75497 19.4325C9.66217 19.1844 9.52107 18.9884 9.33168 18.8444C9.14418 18.6986 8.90838 18.6257 8.62429 18.6257C8.35156 18.6257 8.1224 18.6948 7.93679 18.8331C7.75118 18.9694 7.61103 19.1607 7.51634 19.4069C7.42164 19.6512 7.37429 19.9363 7.37429 20.262ZM13.4197 22.5348C12.9993 22.5348 12.6366 22.442 12.3317 22.2563C12.0286 22.0688 11.7947 21.8075 11.63 21.4723C11.4671 21.1351 11.3857 20.7431 11.3857 20.2961C11.3857 19.8492 11.4671 19.4552 11.63 19.1143C11.7947 18.7715 12.0239 18.5045 12.3175 18.3132C12.6129 18.12 12.9576 18.0234 13.3516 18.0234C13.5788 18.0234 13.8033 18.0613 14.0249 18.137C14.2464 18.2128 14.4482 18.3359 14.63 18.5063C14.8118 18.6749 14.9567 18.8984 15.0646 19.1768C15.1726 19.4552 15.2266 19.798 15.2266 20.2052V20.4893H11.8629V19.9098H14.5447C14.5447 19.6635 14.4955 19.4438 14.397 19.2507C14.3004 19.0575 14.1622 18.905 13.9822 18.7933C13.8042 18.6815 13.594 18.6257 13.3516 18.6257C13.0845 18.6257 12.8535 18.692 12.6584 18.8245C12.4652 18.9552 12.3165 19.1257 12.2124 19.3359C12.1082 19.5461 12.0561 19.7715 12.0561 20.012V20.3984C12.0561 20.7279 12.1129 21.0073 12.2266 21.2365C12.3421 21.4637 12.5021 21.637 12.7067 21.7563C12.9112 21.8738 13.1489 21.9325 13.4197 21.9325C13.5959 21.9325 13.755 21.9079 13.897 21.8586C14.041 21.8075 14.165 21.7317 14.2692 21.6313C14.3733 21.5291 14.4538 21.4022 14.5107 21.2507L15.1584 21.4325C15.0902 21.6522 14.9756 21.8454 14.8146 22.012C14.6536 22.1768 14.4548 22.3056 14.218 22.3984C13.9813 22.4893 13.7152 22.5348 13.4197 22.5348ZM18.0078 24.1711C17.6839 24.1711 17.4055 24.1295 17.1726 24.0461C16.9396 23.9647 16.7455 23.8567 16.5902 23.7223C16.4368 23.5897 16.3146 23.4476 16.2237 23.2961L16.7578 22.9211C16.8184 23.0007 16.8951 23.0916 16.9879 23.1938C17.0807 23.298 17.2076 23.388 17.3686 23.4637C17.5315 23.5414 17.7446 23.5802 18.0078 23.5802C18.3601 23.5802 18.6508 23.495 18.88 23.3245C19.1091 23.1541 19.2237 22.887 19.2237 22.5234V21.637H19.1669C19.1177 21.7166 19.0476 21.8151 18.9567 21.9325C18.8677 22.048 18.7389 22.1512 18.5703 22.2421C18.4036 22.3312 18.1783 22.3757 17.8942 22.3757C17.5419 22.3757 17.2256 22.2923 16.9453 22.1257C16.6669 21.959 16.4463 21.7166 16.2834 21.3984C16.1224 21.0802 16.0419 20.6938 16.0419 20.2393C16.0419 19.7923 16.1205 19.4031 16.2777 19.0717C16.4349 18.7384 16.6536 18.4808 16.9339 18.299C17.2143 18.1152 17.5381 18.0234 17.9055 18.0234C18.1896 18.0234 18.415 18.0707 18.5817 18.1654C18.7502 18.2582 18.879 18.3643 18.968 18.4836C19.0589 18.601 19.129 18.6976 19.1783 18.7734H19.2464V18.0802H19.8942V22.5688C19.8942 22.9438 19.8089 23.2488 19.6385 23.4836C19.4699 23.7204 19.2427 23.8937 18.9567 24.0035C18.6726 24.1152 18.3563 24.1711 18.0078 24.1711ZM17.9851 21.7734C18.254 21.7734 18.4813 21.7118 18.6669 21.5887C18.8525 21.4656 18.9936 21.2885 19.0902 21.0575C19.1868 20.8264 19.2351 20.5499 19.2351 20.2279C19.2351 19.9135 19.1877 19.6361 19.093 19.3956C18.9983 19.155 18.8582 18.9666 18.6726 18.8302C18.487 18.6938 18.2578 18.6257 17.9851 18.6257C17.701 18.6257 17.4643 18.6976 17.2749 18.8416C17.0874 18.9855 16.9463 19.1787 16.8516 19.4211C16.7588 19.6635 16.7124 19.9325 16.7124 20.2279C16.7124 20.531 16.7597 20.799 16.8544 21.0319C16.951 21.263 17.093 21.4448 17.2805 21.5774C17.4699 21.7081 17.7048 21.7734 17.9851 21.7734Z",
                    fill: "white"
                })
            ]
        })
    });
};
var $c45713fa02f26ab7$export$2e2bcd8739ae039 = $c45713fa02f26ab7$var$JPEG;




const $e34361f171aec83d$var$CancelFile = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M12.59 6.5L10 9.09L7.41 6.5L6 7.91L8.59 10.5L6 13.09L7.41 14.5L10 11.91L12.59 14.5L14 13.09L11.41 10.5L14 7.91L12.59 6.5ZM10 0.5C4.47 0.5 0 4.97 0 10.5C0 16.03 4.47 20.5 10 20.5C15.53 20.5 20 16.03 20 10.5C20 4.97 15.53 0.5 10 0.5ZM10 18.5C5.59 18.5 2 14.91 2 10.5C2 6.09 5.59 2.5 10 2.5C14.41 2.5 18 6.09 18 10.5C18 14.91 14.41 18.5 10 18.5Z",
                fill: "#969696"
            })
        })
    });
};
var $e34361f171aec83d$export$2e2bcd8739ae039 = $e34361f171aec83d$var$CancelFile;




const $c3b0196bc11a0568$var$Add = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
            width: "25",
            height: "26",
            viewBox: "0 0 25 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M12.5 25.4727C19.1274 25.4727 24.5 20.1001 24.5 13.4727C24.5 6.84524 19.1274 1.47266 12.5 1.47266C5.87258 1.47266 0.5 6.84524 0.5 13.4727C0.5 20.1001 5.87258 25.4727 12.5 25.4727Z",
                    stroke: "var(--primary-color)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M7.35547 13.4727H17.6412",
                    stroke: "var(--primary-color)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                    d: "M12.5 8.33008V18.6158",
                    stroke: "var(--primary-color)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var $c3b0196bc11a0568$export$2e2bcd8739ae039 = $c3b0196bc11a0568$var$Add;



const $b96b298b3de60171$var$hireModalStyles = {
    maxWidth: "725px",
    minHeight: "760px"
};
const $b96b298b3de60171$var$hireModalButtonStyles = {
    fontWeight: "600",
    fontSize: "18px",
    maxWidth: "643px",
    minHeight: "55px"
};
const $b96b298b3de60171$var$errorStyles = {
    color: "var(--error-color)",
    fontWeight: "400",
    fontSize: "14px",
    margin: "0"
};
const $b96b298b3de60171$var$HireDesigner = (props)=>{
    const { open: open, onClose: onClose, onCreateCustomTemplateQuery: onCreateCustomTemplateQuery, productId: productId } = props;
    const [queryTitle, setQueryTitle] = (0, $lt6Ts$useState)("");
    const [queryEmail, setQueryEmail] = (0, $lt6Ts$useState)("");
    const [queryFile, setQueryFile] = (0, $lt6Ts$useState)([]);
    const [queryVideoUrl, setQueryVideoUrl] = (0, $lt6Ts$useState)("");
    const [queryComments, setQueryComments] = (0, $lt6Ts$useState)("");
    const [isLoading, setIsLoading] = (0, $lt6Ts$useState)(false);
    const [formErrors, setFormErrors] = (0, $lt6Ts$useState)({
        title: "",
        email: "",
        files: "",
        videoUrl: "",
        comments: ""
    });
    const dispatch = (0, $lt6Ts$useDispatch)();
    const designerFormStates = (0, $lt6Ts$useSelector)((state)=>state.templates.hireDesignerForm);
    const handleTitleChange = (event)=>{
        const newTitle = event.target.value;
        setQueryTitle(newTitle);
        setFormErrors((prevErrors)=>({
                ...prevErrors,
                title: newTitle.trim() && ""
            }));
        dispatch({
            type: "SET_HIRE_DESIGNER_FORM_FIELDS",
            payload: {
                queryTitle: newTitle
            }
        });
    };
    const handleEmailChange = (event)=>{
        const newEmail = event.target.value;
        setQueryEmail(newEmail);
        setFormErrors((prevErrors)=>({
                ...prevErrors,
                email: newEmail.trim() && ""
            }));
        dispatch({
            type: "SET_HIRE_DESIGNER_FORM_FIELDS",
            payload: {
                queryEmail: newEmail
            }
        });
    };
    const handleVideoUrlChange = (event)=>{
        const newVideoUrl = event.target.value;
        setQueryVideoUrl(newVideoUrl);
        setFormErrors((prevErrors)=>({
                ...prevErrors,
                videoUrl: newVideoUrl.trim() && ""
            }));
        dispatch({
            type: "SET_HIRE_DESIGNER_FORM_FIELDS",
            payload: {
                queryVideoUrl: newVideoUrl
            }
        });
    };
    const handleCommentsChange = (event)=>{
        const newComments = event.target.value;
        setQueryComments(newComments);
        setFormErrors((prevErrors)=>({
                ...prevErrors,
                comments: newComments.trim() && ""
            }));
        dispatch({
            type: "SET_HIRE_DESIGNER_FORM_FIELDS",
            payload: {
                queryComments: newComments
            }
        });
    };
    const saveFilesToLocalStorage = (files)=>{
        const fileData = files.map((file)=>({
                name: file.name,
                type: file.type,
                size: file.size,
                content: ""
            }));
        files.forEach((file, index)=>{
            const reader = new FileReader();
            reader.onload = ()=>{
                fileData[index].content = reader.result;
                if (index === files.length - 1) dispatch({
                    type: "SET_HIRE_DESIGNER_FORM_FIELDS",
                    payload: {
                        queryFiles: fileData
                    }
                });
            };
            reader.readAsDataURL(file);
        });
    };
    // Retrieve files from localStorage
    const getFilesFromLocalStorage = ()=>{
        const savedFiles = designerFormStates.queryFiles;
        if (!savedFiles) return [];
        const fileData = savedFiles;
        return fileData.map((file)=>{
            const blob = (0, $717432aee8737b76$export$76324c20bce07fe1)(file.content, file.type);
            return new File([
                blob
            ], file.name, {
                type: file.type
            });
        });
    };
    const handleFileChange = (event)=>{
        const newFilesArray = Array.from(event.target.files);
        const acceptableTypes = [
            "image/png",
            "image/jpeg",
            "image/jpg",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ];
        const validFiles = newFilesArray.filter((file)=>acceptableTypes.includes(file.type));
        const invalidFiles = newFilesArray.filter((file)=>!acceptableTypes.includes(file.type));
        if (invalidFiles.length > 0) {
            setFormErrors((prevErrors)=>({
                    ...prevErrors,
                    files: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.FILE_VALLIDATION
                }));
            setTimeout(()=>{
                setFormErrors((prevErrors)=>({
                        ...prevErrors,
                        files: ""
                    }));
            }, 6000);
        } else setFormErrors((prevErrors)=>({
                ...prevErrors,
                files: ""
            }));
        if (validFiles.length > 0) {
            setQueryFile((prevFiles)=>[
                    ...prevFiles,
                    ...validFiles
                ]);
            saveFilesToLocalStorage([
                ...queryFile,
                ...validFiles
            ]);
        }
        event.target.value = null;
    };
    const handleFileRemove = (file)=>{
        const updatedFiles = queryFile.filter((f)=>f.name !== file.name);
        setQueryFile(updatedFiles);
        updatedFiles.length ? saveFilesToLocalStorage([
            ...updatedFiles
        ]) : dispatch({
            type: "SET_HIRE_DESIGNER_FORM_FIELDS",
            payload: {
                queryFiles: []
            }
        });
    };
    const validateForm = (formData, setFormErrors)=>{
        const errors = {};
        if (!formData.queryTitle.trim()) errors.title = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.TITLE_REQUIRED;
        if (!formData.queryVideoUrl.trim()) errors.videoUrl = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.URL_REQUIRED;
        else if (!(0, $7ad22e5ca6c288ca$export$ace9493ddb576805).test(formData.queryVideoUrl.trim())) errors.videoUrl = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.URL_VAIDATION;
        if (!formData.queryComments.trim()) errors.comments = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.COMMENT_REQUIRED;
        if (!formData.queryEmail.trim()) errors.email = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.EMAIL_REQUIRED;
        else if (!(0, $7ad22e5ca6c288ca$export$7b7637218245c8a).test(formData.queryEmail.trim())) errors.email = (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.EMAIL_VALIDATION;
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const resetForm = ()=>{
        setQueryTitle("");
        setQueryEmail("");
        setQueryVideoUrl("");
        setQueryFile([]);
        setQueryComments("");
        setFormErrors({
            title: "",
            email: "",
            files: "",
            videoUrl: "",
            comments: ""
        });
        (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("hireDesignerFormState");
        (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("queryFiles");
        dispatch({
            type: "CLEAR_HIRE_DESIGNER_FORM_FIELDS"
        });
    };
    const handleSubmit = async (event)=>{
        try {
            event.preventDefault();
            const formData = {
                queryTitle: queryTitle,
                queryVideoUrl: queryVideoUrl,
                queryComments: queryComments,
                queryFile: queryFile,
                queryEmail: queryEmail
            };
            const isValid = validateForm(formData, setFormErrors);
            if (!isValid) return;
            setIsLoading(true);
            const form = new FormData();
            form.append("title", queryTitle);
            form.append("comments", queryComments);
            form.append("email", queryEmail);
            form.append("productId", productId);
            form.append("url", queryVideoUrl);
            queryFile.forEach((file)=>{
                form.append("files", file);
            });
            const response = await (0, $77d971be1e6bcd7c$export$299ba2dee77727e9)("/custom-template-queries/create", form);
            if (response && response.status === 200) {
                setIsLoading(false);
                closeHireModal();
                dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)(response.data.message));
                onCreateCustomTemplateQuery(response.data);
            } else throw new Error(`HTTP error! status: ${response.status}`);
        } catch (error) {
            return error;
        } finally{
            setIsLoading(false);
        }
    };
    const closeHireModal = ()=>{
        onClose();
        resetForm();
    };
    (0, $lt6Ts$useEffect)(()=>{
        setQueryTitle(designerFormStates.queryTitle);
        setQueryEmail(designerFormStates.queryEmail);
        setQueryVideoUrl(designerFormStates.queryVideoUrl);
        setQueryComments(designerFormStates.queryComments);
        const savedFiles = getFilesFromLocalStorage();
        setQueryFile(savedFiles);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
        open: open,
        customStyles: $b96b298b3de60171$var$hireModalStyles,
        handleClose: closeHireModal,
        isGallery: true,
        submitText: "Next",
        children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "designerFormWrapper",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.TITLE
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("form", {
                    className: "designerForm",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            placeholder: "Template Name",
                            label: "Template Name*",
                            value: queryTitle,
                            onChange: handleTitleChange,
                            error: formErrors.title
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            className: `input-layout`,
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                                    className: "basic-label",
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.UPLOAD_HEADING
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: "file-upload-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)("input", {
                                            type: "file",
                                            onChange: handleFileChange,
                                            multiple: true,
                                            accept: ".png, .jpg, .jpeg, .pdf, .doc, .docx",
                                            className: "file-input"
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                            className: "upload-area",
                                            children: [
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                    className: "upload-icon",
                                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c3b0196bc11a0568$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                                                    htmlFor: "fileInput",
                                                    className: "upload-text",
                                                    children: "Upload a File"
                                                }),
                                                " ",
                                                "or drag and drop",
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                    className: "upload-info",
                                                    children: "Supported formats: .png, .jpg, .jpeg, .pdf, .doc, .docx"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                formErrors.files && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                    variant: "p",
                                    style: $b96b298b3de60171$var$errorStyles,
                                    children: formErrors.files
                                }),
                                queryFile.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: "uploaded-files",
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)("h3", {
                                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.HIRE_DESIGNER.UPLOADED_TEXT
                                        }),
                                        queryFile.map((file, index)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                className: "file-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                        className: "file-icon",
                                                        children: file.type === "application/pdf" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $f01fafd10961aacf$export$2e2bcd8739ae039), {}) : file.type === "image/jpeg" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c45713fa02f26ab7$export$2e2bcd8739ae039), {}) : file.type === "image/png" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $b2749c73d161a8b7$export$2e2bcd8739ae039), {}) : file.type === "image/jpg" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $2bdad7d91b78224f$export$2e2bcd8739ae039), {}) : file.type === "application/msword" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $55aa136d3e6acf97$export$2e2bcd8739ae039), {}) : file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $61a736ecb908c109$export$2e2bcd8739ae039), {}) : null
                                                    }),
                                                    /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                        className: "file-details",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("p", {
                                                                className: "file-name",
                                                                children: file.name
                                                            }),
                                                            /*#__PURE__*/ (0, $lt6Ts$jsxs)("p", {
                                                                className: "file-size",
                                                                children: [
                                                                    (file.size / 1048576).toFixed(2),
                                                                    " MB"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                                        className: "file-remove",
                                                        onClick: ()=>handleFileRemove(file),
                                                        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e34361f171aec83d$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }, index))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            placeholder: "https://www.example.com",
                            label: "Video URL*",
                            videoTooltip: true,
                            value: queryVideoUrl,
                            onChange: handleVideoUrlChange,
                            error: formErrors.videoUrl
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "email",
                            placeholder: "Email",
                            label: "Email*",
                            value: queryEmail,
                            onChange: handleEmailChange,
                            error: formErrors.email
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "textarea",
                            placeholder: "Comments",
                            label: "Comments*",
                            value: queryComments,
                            onChange: handleCommentsChange,
                            error: formErrors.comments
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "button-container",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                        onClick: handleSubmit,
                        disabled: isLoading,
                        style: $b96b298b3de60171$var$hireModalButtonStyles,
                        children: isLoading ? /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "loading-container",
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                className: "loading-icon"
                            })
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
var $b96b298b3de60171$export$2e2bcd8739ae039 = $b96b298b3de60171$var$HireDesigner;




const $afa975ba1b70ddf3$var$CustomTemplate = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M4.125 18.5625H11C11.1823 18.5625 11.3572 18.6349 11.4861 18.7639C11.6151 18.8928 11.6875 19.0677 11.6875 19.25C11.6875 19.4323 11.6151 19.6072 11.4861 19.7361C11.3572 19.8651 11.1823 19.9375 11 19.9375H4.125C3.57799 19.9375 3.05339 19.7202 2.66659 19.3334C2.2798 18.9466 2.0625 18.422 2.0625 17.875V4.125C2.0625 3.57799 2.2798 3.05339 2.66659 2.66659C3.05339 2.2798 3.57799 2.0625 4.125 2.0625H17.875C18.422 2.0625 18.9466 2.2798 19.3334 2.66659C19.7202 3.05339 19.9375 3.57799 19.9375 4.125V4.8125C19.9375 4.99484 19.8651 5.1697 19.7361 5.29864C19.6072 5.42757 19.4323 5.5 19.25 5.5C19.0677 5.5 18.8928 5.42757 18.7639 5.29864C18.6349 5.1697 18.5625 4.99484 18.5625 4.8125V4.125C18.5625 3.94266 18.4901 3.7678 18.3611 3.63886C18.2322 3.50993 18.0573 3.4375 17.875 3.4375H4.125C3.94266 3.4375 3.7678 3.50993 3.63886 3.63886C3.50993 3.7678 3.4375 3.94266 3.4375 4.125V6.875H19.25C19.4323 6.875 19.6072 6.94743 19.7361 7.07636C19.8651 7.2053 19.9375 7.38016 19.9375 7.5625V17.875C19.9375 18.422 19.7202 18.9466 19.3334 19.3334C18.9466 19.7202 18.422 19.9375 17.875 19.9375H13.75C13.5677 19.9375 13.3928 19.8651 13.2639 19.7361C13.1349 19.6072 13.0625 19.4323 13.0625 19.25V8.25H3.4375V17.875C3.4375 18.0573 3.50993 18.2322 3.63886 18.3611C3.7678 18.4901 3.94266 18.5625 4.125 18.5625ZM14.4375 18.5625H17.875C18.0573 18.5625 18.2322 18.4901 18.3611 18.3611C18.4901 18.2322 18.5625 18.0573 18.5625 17.875V8.25H14.4375V18.5625Z",
                fill: fill
            })
        })
    });
};
var $afa975ba1b70ddf3$export$2e2bcd8739ae039 = $afa975ba1b70ddf3$var$CustomTemplate;




const $e8f6665471b594e0$var$designDialogStyles = {
    maxWidth: "430px",
    minHeight: "265px"
};
const $e8f6665471b594e0$var$loadDialogStyles = {
    maxWidth: "430px",
    minHeight: "300px"
};
const $e8f6665471b594e0$var$CustomTemplateSection = {
    name: "Templates",
    Tab: (0, $lt6Ts$observer)((props)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SectionTab), {
            name: "Templates",
            ...props,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $afa975ba1b70ddf3$export$2e2bcd8739ae039), {
                fill: "var(--text-color)"
            })
        })),
    Panel: (0, $lt6Ts$observer)(({ store: store, platformName: platformName, templateGalleryModal: templateGalleryModal, selectedSection: selectedSection, designerQueryAmount: designerQueryAmount, hireDesignerModal: hireDesignerModal, setHireDesignerModal: setHireDesignerModal, allowedTemplateSections: allowedTemplateSections, onCreateCustomTemplateQuery: onCreateCustomTemplateQuery, onGetOneTemplate: onGetOneTemplate, onGetTemplates: onGetTemplates })=>{
        const dispatch = (0, $lt6Ts$useDispatch)();
        const [openGalleryModal, setOpenGalleryModal] = (0, $lt6Ts$useState)(false);
        const [templateTypes, setTemplateTypes] = (0, $lt6Ts$useState)();
        const [currentTemplateType, setCurrentTemplateType] = (0, $lt6Ts$useState)();
        const [selectedCategory, setSelectedCategory] = (0, $lt6Ts$useState)(null);
        const [selectedRecord, setSelectedRecord] = (0, $lt6Ts$useState)(null);
        const [templateCategories, setTemplateCategories] = (0, $lt6Ts$useState)([]);
        const [myTemplates, setMyTemplates] = (0, $lt6Ts$useState)([]);
        const [teamTemplates, setTeamTemplates] = (0, $lt6Ts$useState)([]);
        const [olcTemplates, setOlcTemplates] = (0, $lt6Ts$useState)([]);
        const [searchApplied, setSearchApplied] = (0, $lt6Ts$useState)(false);
        const [search, setSearch] = (0, $lt6Ts$useState)("");
        const [loader, setLoader] = (0, $lt6Ts$useState)(false);
        const [pagination, setPagination] = (0, $lt6Ts$useState)({
            count: 0,
            currentPage: 0,
            perPage: 0,
            total: 0
        });
        const paginationRef = (0, $lt6Ts$useRef)(pagination);
        const searchRef = (0, $lt6Ts$useRef)(search);
        const currentTemplateTypeRef = (0, $lt6Ts$useRef)(currentTemplateType);
        const selectedCategoryRef = (0, $lt6Ts$useRef)(selectedCategory);
        const templates = (0, $lt6Ts$useSelector)((state)=>state.templates.templates);
        const template = (0, $lt6Ts$useSelector)((state)=>state.templates.template);
        const templatesPagination = (0, $lt6Ts$useSelector)((state)=>state.templates.templatesPagination);
        const product = (0, $lt6Ts$useSelector)((state)=>state.templates.product);
        const envelopeType = (0, $lt6Ts$useSelector)((state)=>state.templates.envelopeType);
        const templateLoading = (0, $lt6Ts$useSelector)((state)=>state.templates.templateLoading);
        const [isShowDialog, setIsShowDialog] = (0, $lt6Ts$useState)({
            open: false,
            model: ""
        });
        const handleLoadTemplateModel = (record)=>{
            setSelectedRecord(record);
            handleDialogChange("load-template");
        };
        const getTemplatesByTab = async (page = 1)=>{
            try {
                page === 1 && setLoader(true);
                const payload = {
                    tab: currentTemplateTypeRef.current?.id === "1" ? "my-templates" : currentTemplateTypeRef.current?.id === "2" ? "team-templates" : "olc-templates",
                    page: page,
                    pageSize: 10,
                    productId: product?.id
                };
                searchRef.current.length ? payload.search = searchRef.current : undefined;
                currentTemplateTypeRef.current?.id === "3" ? payload.categoryIds = selectedCategoryRef?.current?.id.split(",") : undefined;
                const isCustomTemplateType = currentTemplateTypeRef.current?.id === "1" || currentTemplateTypeRef.current?.id === "2";
                const templates = isCustomTemplateType && onGetTemplates ? await onGetTemplates(payload) : await (0, $dbaee5ca78364d67$export$99fb2aa3c6b824c3)(payload);
                if (templates?.rows) {
                    const newTemplates = templates.rows;
                    if (currentTemplateTypeRef.current?.id === "1") {
                        if (templates.currentPage === 1) setMyTemplates(newTemplates);
                        else setMyTemplates((prevTemplates)=>[
                                ...prevTemplates,
                                ...newTemplates
                            ]);
                    } else if (currentTemplateTypeRef.current?.id === "2") {
                        if (templates.currentPage === 1) setTeamTemplates(newTemplates);
                        else setTeamTemplates((prevTemplates)=>[
                                ...prevTemplates,
                                ...newTemplates
                            ]);
                    } else if (currentTemplateTypeRef.current?.id === "3") {
                        if (templates.currentPage === 1) setOlcTemplates(newTemplates);
                        else setOlcTemplates((prevTemplates)=>[
                                ...prevTemplates,
                                ...newTemplates
                            ]);
                    }
                    setPagination({
                        count: templates.count,
                        currentPage: templates.currentPage,
                        perPage: templates.perPage,
                        total: templates.total
                    });
                }
            } catch (error) {
                return error;
            } finally{
                setLoader(false);
            }
        };
        const getAllCategories = async ()=>{
            const categories = await dispatch((0, $dbaee5ca78364d67$export$202033b5492f87a7));
            if (categories?.status === 200) {
                if (categories?.data?.data) {
                    const allCategories = categories?.data?.data?.map((item)=>({
                            ...item,
                            label: item.title
                        }));
                    if (allCategories.length === 1) setSelectedCategory(allCategories[0]);
                    setTemplateCategories(allCategories.filter((item)=>item.totalTemplates > 0));
                }
            }
        };
        const closeGalleryModal = ()=>{
            let sideBar = document.getElementsByClassName("polotno-panel-container");
            const firstSideBar = sideBar[0];
            if (firstSideBar) //@ts-ignore
            firstSideBar.style.display = "block";
            setOpenGalleryModal(false);
            store.openSidePanel(selectedSection || "text");
            (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("currentTab");
            document.body.classList.remove("no-scroll");
        };
        const closeHireDesignerModal = ()=>{
            setHireDesignerModal(false);
            let sideBar = document.getElementsByClassName("polotno-panel-container");
            const firstSideBar = sideBar[0];
            if (firstSideBar) //@ts-ignore
            firstSideBar.style.display = "block";
            store.openSidePanel(selectedSection || "text");
            (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("currentTab");
            (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("hireDesignerFormState");
            (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("queryFiles");
            document.body.classList.remove("no-scroll");
        };
        const handleTabChange = (tab)=>{
            setCurrentTemplateType(tab);
            (0, $b66d61b9e6770b52$export$8a8216c44337cd5)("currentTab", JSON.stringify(tab));
        };
        const handleSearch = ()=>{
            if (search) {
                setSearchApplied(true);
                getTemplatesByTab();
            }
        };
        const removeSearchInput = ()=>{
            setSearch("");
        };
        const searchKeyDown = (event)=>{
            if (event.key === "Enter") handleSearch();
        };
        const handleLoadAllTemplate = (dynamicPagination = false, initialCall = false)=>{
            let page = dynamicPagination ? ++paginationRef.current.currentPage : paginationRef.current.currentPage;
            if (initialCall) page = 1;
            getTemplatesByTab(page);
        };
        const handleLoadTemplate = async (id, type = "copy")=>{
            if (onGetOneTemplate) try {
                const template = await onGetOneTemplate(id);
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                    payload: true
                });
                dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
                if (template) {
                    const workspaceElement = document.querySelector(".polotno-workspace-container");
                    if (workspaceElement) workspaceElement.classList.add("show-loader");
                    // @ts-ignore
                    const paperDimensions = template?.product?.paperSize.split("x");
                    store.setUnit({
                        unit: "in",
                        dpi: 96
                    });
                    store.setSize(+paperDimensions[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610), +paperDimensions[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610));
                    let jsonData = await (0, $ad01ab85e9f42d02$export$c706fc9cfb842dce)(template?.templateUrl);
                    if (template?.product?.productType === "Real Penned Letter") {
                        let clonedJson = JSON.stringify(jsonData).replace(/{{/g, "((").replace(/}}/g, "))");
                        jsonData = JSON.parse(clonedJson);
                    }
                    store.loadJSON(jsonData);
                    await store.waitLoading();
                    (0, $39231ae325c5aacf$export$b8070c2bd9d59c10)(template?.product?.id, store);
                    dispatch({
                        type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                        payload: false
                    });
                    if (workspaceElement) workspaceElement.classList.add("hide-loader");
                    if (templateGalleryModal) closeGalleryModal();
                }
            } catch (error) {
                return error;
            } finally{
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                    payload: false
                });
                handleDialogChange("");
            }
            else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)("Please provide onGetOneTemplate handler to load this template"));
        };
        const handleDialogChange = (model = "")=>{
            setIsShowDialog((prev)=>({
                    open: !prev.open,
                    model: model
                }));
        };
        const processPage = async (index, page)=>{
            return new Promise((resolve)=>{
                let pageNumber = page.children.find((el)=>el.custom?.name === "page-number");
                const text = index === 0 ? "Front" : "Back";
                if (pageNumber) {
                    pageNumber.set({
                        text: text
                    });
                    resolve();
                } else {
                    page.addElement({
                        type: "text",
                        custom: {
                            name: "page-number"
                        },
                        text: text,
                        width: store.width,
                        align: "center",
                        fontSize: 40,
                        x: -150,
                        y: -50,
                        selectable: false,
                        alwaysOnTop: true
                    });
                    resolve();
                }
            });
        };
        const checkPageNumbers = async ()=>{
            const promises = store.pages.map(async (page, index)=>{
                await processPage(index, page);
            });
            await Promise.all(promises); // Wait for all promises to resolve
        };
        const handleClearStore = ()=>{
            store.clear();
            dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
            let size = "";
            let isPostCards = false;
            let _product = product;
            if (template?.product) {
                size = template?.product?.paperSize;
                isPostCards = template.product.productType === "Postcards" || false;
                _product = template.product;
            } else if (product) {
                size = product.selectedSize;
                isPostCards = product.productType === "Postcards" || false;
            }
            store.setUnit({
                unit: "in",
                dpi: (0, $7ad22e5ca6c288ca$export$6032165a31897610)
            });
            size = size?.split("x");
            store.setSize(+size[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610), +size[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610));
            store.addPage();
            if ((0, $7ad22e5ca6c288ca$export$3e994a540f8ee57).includes(_product.productType)) {
                store.addPage();
                store.selectPage(store.pages[0].id);
            }
            (0, $ad01ab85e9f42d02$export$8029e38c28541a)(store, product, envelopeType);
            (0, $729142c3e2d905ee$export$4e7e1f53e01e76b7)(product.id, store);
            if (product.productType === "Real Penned Letter") (0, $14dc1102dd22ee0f$export$fac40f04596fc189)(store);
            handleDialogChange("");
            if (templateGalleryModal) closeGalleryModal();
        };
        const handleScroll = ()=>{
            const div = document.querySelector(".templatesContent") || document.querySelector(".polotno-panel-container");
            if (div) {
                const isAtBottom = div.scrollTop + div.clientHeight + 50 >= div.scrollHeight;
                const isNeedToLoadMore = paginationRef.current.currentPage * paginationRef.current.perPage < paginationRef.current.count;
                if (isAtBottom && !templatesPagination.loading && isNeedToLoadMore) handleLoadAllTemplate(true);
            }
        };
        (0, $lt6Ts$useEffect)(()=>{
            if (templateLoading !== null && templateLoading === false) {
                handleDialogChange("");
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                    payload: null
                });
            }
        }, [
            templateLoading
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            if (!search && searchApplied) {
                setSearchApplied(false);
                setSearch("");
                setTimeout(()=>{
                    getTemplatesByTab();
                }, 100);
            }
        }, [
            search
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            searchRef.current = search;
        }, [
            search
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            currentTemplateTypeRef.current = currentTemplateType;
        }, [
            currentTemplateType
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            selectedCategoryRef.current = selectedCategory;
        }, [
            selectedCategory
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            paginationRef.current = pagination;
        }, [
            pagination
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            const newTemplateType = {
                id: "3",
                label: platformName ? `${platformName} Templates` : "OLC Templates",
                value: "olc-templates"
            };
            if (onGetTemplates) {
                let filteredTemplateTypes = [
                    ...(0, $7ad22e5ca6c288ca$export$683d22caccc9d465),
                    newTemplateType
                ];
                if (Array.isArray(allowedTemplateSections) && allowedTemplateSections.length > 0) filteredTemplateTypes = filteredTemplateTypes.filter((type)=>allowedTemplateSections.includes(type.value));
                setTemplateTypes(filteredTemplateTypes);
                const lastSelectedTab = (0, $b66d61b9e6770b52$export$f92dfeb71e9bb569)("currentTab");
                if (lastSelectedTab) setCurrentTemplateType(JSON.parse(lastSelectedTab));
                else setCurrentTemplateType((0, $7ad22e5ca6c288ca$export$683d22caccc9d465)[0]);
            } else {
                setTemplateTypes([
                    newTemplateType
                ]);
                setCurrentTemplateType(newTemplateType);
            }
            getAllCategories();
            return ()=>{
                dispatch((0, $dbaee5ca78364d67$export$1e6ea60acfeb7da4)());
            };
        }, []);
        (0, $lt6Ts$useEffect)(()=>{
            if (currentTemplateType && Object.keys(currentTemplateType).length) getTemplatesByTab();
        }, [
            currentTemplateType
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            if (currentTemplateType && Object.keys(currentTemplateType).length && currentTemplateType?.id === "3" && templateCategories?.length >= 1) getTemplatesByTab();
        }, [
            selectedCategory
        ]);
        (0, $lt6Ts$useEffect)(()=>{
            const div = document.querySelector(".templatesContent") || document.querySelector(".polotno-panel-container");
            if (store.openedSidePanel === "Templates" && templateGalleryModal) {
                let sideBar = document.getElementsByClassName("polotno-panel-container");
                const firstSideBar = sideBar[0];
                if (firstSideBar) //@ts-ignore
                firstSideBar.style.display = "contents";
                setOpenGalleryModal(true);
                document.body.classList.add("no-scroll");
            }
            if (div) {
                div.removeEventListener("scroll", handleScroll);
                div.addEventListener("scroll", handleScroll);
            }
            return ()=>{
                div?.removeEventListener("scroll", handleScroll);
            };
        }, [
            templates
        ]);
        return /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
            children: [
                templateGalleryModal && !hireDesignerModal ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $889afc7f44cbd90b$export$2e2bcd8739ae039), {
                    product: product,
                    openGalleryModal: openGalleryModal,
                    pagination: pagination,
                    currentTemplateTypeRef: currentTemplateTypeRef,
                    selectedCategory: selectedCategory,
                    templateCategories: templateCategories,
                    currentTemplateType: currentTemplateType,
                    templateTypes: templateTypes,
                    search: search,
                    searchApplied: searchApplied,
                    loader: loader,
                    platformName: platformName,
                    myTemplates: myTemplates,
                    teamTemplates: teamTemplates,
                    olcTemplates: olcTemplates,
                    designerQueryAmount: designerQueryAmount,
                    setHireDesignerModal: setHireDesignerModal,
                    setSearch: setSearch,
                    handleSearch: handleSearch,
                    removeSearchInput: removeSearchInput,
                    searchKeyDown: searchKeyDown,
                    setCurrentTemplateType: setCurrentTemplateType,
                    setSelectedCategory: setSelectedCategory,
                    handleLoadTemplateModel: handleLoadTemplateModel,
                    handleDialogChange: handleDialogChange,
                    handleTabChange: handleTabChange,
                    closeGalleryModal: closeGalleryModal,
                    setOpenGalleryModal: setOpenGalleryModal
                }) : !hireDesignerModal && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $1175fdb41c6823d7$export$2e2bcd8739ae039), {
                    selectedCategory: selectedCategory,
                    templateCategories: templateCategories,
                    currentTemplateType: currentTemplateType,
                    templateTypes: templateTypes,
                    search: search,
                    searchApplied: searchApplied,
                    loader: loader,
                    platformName: platformName,
                    myTemplates: myTemplates,
                    teamTemplates: teamTemplates,
                    olcTemplates: olcTemplates,
                    setSearch: setSearch,
                    handleSearch: handleSearch,
                    removeSearchInput: removeSearchInput,
                    searchKeyDown: searchKeyDown,
                    setCurrentTemplateType: setCurrentTemplateType,
                    setSelectedCategory: setSelectedCategory,
                    handleLoadTemplateModel: handleLoadTemplateModel,
                    handleDialogChange: handleDialogChange
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "custom-template-section",
                    children: [
                        isShowDialog.open && isShowDialog.model === "design-own" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $8c59b172071542b8$export$2e2bcd8739ae039), {}),
                            title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DESIGN_YOUR_OWN.TITLE,
                            subHeading: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DESIGN_YOUR_OWN.HEADING,
                            description: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.DESIGN_YOUR_OWN.PARAGRAPH,
                            open: isShowDialog.open,
                            handleClose: ()=>handleDialogChange(""),
                            onCancel: ()=>handleDialogChange(""),
                            onSubmit: handleClearStore,
                            customStyles: $e8f6665471b594e0$var$designDialogStyles,
                            cancelText: "Cancel",
                            submitText: "OK"
                        }),
                        hireDesignerModal && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $b96b298b3de60171$export$2e2bcd8739ae039), {
                            open: hireDesignerModal,
                            onCreateCustomTemplateQuery: onCreateCustomTemplateQuery,
                            productId: product?.id,
                            onClose: closeHireDesignerModal
                        }),
                        isShowDialog.open && isShowDialog.model === "load-template" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c8f7718e9f3db339$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $8c59b172071542b8$export$2e2bcd8739ae039), {}),
                            title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SELECT_TEMPLATE.TITLE,
                            subHeading: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SELECT_TEMPLATE.HEADING,
                            description: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.SELECT_TEMPLATE.PARAGRAPH,
                            open: isShowDialog.open,
                            handleClose: ()=>handleDialogChange(""),
                            onCancel: ()=>handleDialogChange(""),
                            onSubmit: ()=>handleLoadTemplate(selectedRecord?.id),
                            customStyles: $e8f6665471b594e0$var$loadDialogStyles,
                            loading: templateLoading || false,
                            cancelText: "Cancel",
                            submitText: "OK"
                        })
                    ]
                })
            ]
        });
    })
};
var $e8f6665471b594e0$export$2e2bcd8739ae039 = $e8f6665471b594e0$var$CustomTemplateSection;















const $e06bdfe75163a118$var$contentCopyIcon = (props)=>{
    const { className: className = {} } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        width: "19",
        className: className,
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            d: "M3.5 15.025H3.975V15.5C3.975 16.1697 4.24103 16.8119 4.71456 17.2854C5.18809 17.759 5.83033 18.025 6.5 18.025H15.5C16.1697 18.025 16.8119 17.759 17.2854 17.2854C17.759 16.8119 18.025 16.1697 18.025 15.5V6.5C18.025 5.83033 17.759 5.18809 17.2854 4.71456C16.8119 4.24103 16.1697 3.975 15.5 3.975H15.025V3.5C15.025 2.83033 14.759 2.18808 14.2854 1.71456C13.8119 1.24103 13.1697 0.975 12.5 0.975H3.5C2.83033 0.975 2.18808 1.24103 1.71456 1.71456C1.24103 2.18808 0.975 2.83033 0.975 3.5V12.5C0.975 13.1697 1.24103 13.8119 1.71456 14.2854C2.18808 14.759 2.83033 15.025 3.5 15.025ZM15.5 5.025C15.8912 5.025 16.2664 5.1804 16.543 5.45702C16.8196 5.73363 16.975 6.10881 16.975 6.5V15.5C16.975 15.8912 16.8196 16.2664 16.543 16.543C16.2664 16.8196 15.8912 16.975 15.5 16.975H6.5C6.10881 16.975 5.73363 16.8196 5.45702 16.543C5.1804 16.2664 5.025 15.8912 5.025 15.5V15.025H12.5C13.1697 15.025 13.8119 14.759 14.2854 14.2854C14.759 13.8119 15.025 13.1697 15.025 12.5V5.025H15.5ZM2.025 3.5C2.025 3.10881 2.1804 2.73363 2.45702 2.45702C2.73363 2.1804 3.10881 2.025 3.5 2.025H12.5C12.8912 2.025 13.2664 2.1804 13.543 2.45702C13.8196 2.73363 13.975 3.10881 13.975 3.5V12.5C13.975 12.8912 13.8196 13.2664 13.543 13.543C13.2664 13.8196 12.8912 13.975 12.5 13.975H3.5C3.10881 13.975 2.73363 13.8196 2.45702 13.543C2.1804 13.2664 2.025 12.8912 2.025 12.5V3.5Z",
            fill: "",
            stroke: "",
            strokeWidth: "0.05"
        })
    });
};
var $e06bdfe75163a118$export$2e2bcd8739ae039 = $e06bdfe75163a118$var$contentCopyIcon;




const $c63ab7ca46bc9f98$var$Field = (props)=>{
    const { fill: fill } = props;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M20.3047 5.21094H18.5078C18.0116 5.21094 17.6094 5.61317 17.6094 6.10938C17.6094 6.60558 18.0116 7.00781 18.5078 7.00781H20.3047C20.8001 7.00781 21.2031 7.41085 21.2031 7.90625V15.0938C21.2031 15.5891 20.8001 15.9922 20.3047 15.9922H18.5078C18.0116 15.9922 17.6094 16.3944 17.6094 16.8906C17.6094 17.3868 18.0116 17.7891 18.5078 17.7891H20.3047C21.7909 17.7891 23 16.5799 23 15.0938V7.90625C23 6.42005 21.7909 5.21094 20.3047 5.21094Z",
                fill: fill
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M4.49219 10.6016H5.39062V13.2969C5.39062 13.7931 5.79286 14.1953 6.28906 14.1953C6.78527 14.1953 7.1875 13.7931 7.1875 13.2969V10.6016H8.08594C8.58214 10.6016 8.98438 10.1993 8.98438 9.70312C8.98438 9.20692 8.58214 8.80469 8.08594 8.80469H4.49219C3.99598 8.80469 3.59375 9.20692 3.59375 9.70312C3.59375 10.1993 3.99598 10.6016 4.49219 10.6016Z",
                fill: fill
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M2.69531 17.7891H14.0156V19.5859H13.1172C12.621 19.5859 12.2188 19.9882 12.2188 20.4844C12.2188 20.9806 12.621 21.3828 13.1172 21.3828H16.7109C17.2071 21.3828 17.6094 20.9806 17.6094 20.4844C17.6094 19.9882 17.2071 19.5859 16.7109 19.5859H15.8125V3.41406H16.7109C17.2071 3.41406 17.6094 3.01183 17.6094 2.51562C17.6094 2.01942 17.2071 1.61719 16.7109 1.61719H13.1172C12.621 1.61719 12.2188 2.01942 12.2188 2.51562C12.2188 3.01183 12.621 3.41406 13.1172 3.41406H14.0156V5.21094H2.69531C1.20912 5.21094 0 6.42005 0 7.90625V15.0938C0 16.5799 1.20912 17.7891 2.69531 17.7891ZM1.79688 7.90625C1.79688 7.41085 2.19991 7.00781 2.69531 7.00781H14.0156V15.9922H2.69531C2.19991 15.9922 1.79688 15.5891 1.79688 15.0938V7.90625Z",
                fill: fill
            })
        ]
    });
};
var $c63ab7ca46bc9f98$export$2e2bcd8739ae039 = $c63ab7ca46bc9f98$var$Field;



const $d0a2370b36372b2d$var$iconButtonStyles = {
    backgroundColor: "transparent"
};
const $d0a2370b36372b2d$var$CustomFieldSection = {
    name: "Fields",
    Tab: (0, $lt6Ts$observer)((props)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SectionTab), {
            name: "Fields",
            ...props,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $c63ab7ca46bc9f98$export$2e2bcd8739ae039), {
                fill: "var(--text-color)"
            })
        })),
    Panel: (0, $lt6Ts$observer)(({ store: store, onGetCustomFields: onGetCustomFields, allowSenderFields: allowSenderFields, excludedFields: excludedFields, allowPropertyFields: allowPropertyFields, platformName: platformName })=>{
        const [isShowDialog, setIsShowDialog] = (0, $lt6Ts$useState)(false);
        const [search, setSearch] = (0, $lt6Ts$useState)("");
        const [filteredDynamicFields, setFilteredDynamicFields] = (0, $lt6Ts$useState)([]);
        const [filteredCustomFields, setFilteredCustomFields] = (0, $lt6Ts$useState)([]);
        const [filteredMiscFields, setFilteredMiscFields] = (0, $lt6Ts$useState)([]);
        const [filteredPropertyFields, setFilteredPropertyFields] = (0, $lt6Ts$useState)([]);
        const [filteredCustomFieldsV2, setFilteredCustomFieldsV2] = (0, $lt6Ts$useState)([]);
        const [filteredSenderFields, setFilteredSenderFields] = (0, $lt6Ts$useState)([]);
        const [filteredPlatformFields, setFilteredPlatformFields] = (0, $lt6Ts$useState)([]);
        const dispatch = (0, $lt6Ts$useDispatch)();
        const customFields = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFields);
        const customFieldsV2 = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFieldsV2);
        const platformFields = (0, $lt6Ts$useSelector)((state)=>state.customFields.platformFields);
        const defaultDynamicFields = (0, $lt6Ts$useSelector)((state)=>state.customFields.defaultDynamicFields);
        const defaultSenderFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultSenderFields);
        const defaultPropertyFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultPropertyFields);
        const defaultMiscFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultMiscFields);
        const product = (0, $lt6Ts$useSelector)((state)=>state.templates.product);
        const currentTemplateType = product?.productType;
        const handleShowDialog = ()=>{
            setIsShowDialog((prev)=>!prev);
        };
        const fetchCustomFields = async ()=>{
            if (onGetCustomFields) {
                const allCustomFields = await onGetCustomFields();
                const platformFields = [];
                const customFields = [];
                if (allCustomFields?.version === "v2") {
                    const flattenedFields = allCustomFields.customFields.flatMap((section)=>section.fields);
                    for (const field of flattenedFields)(field.isPlatformField ? platformFields : customFields).push(field);
                    const filteredCustomFields = allCustomFields?.customFields.map((customField)=>({
                            ...customField,
                            fields: customField.fields.filter((field)=>customFields.includes(field))
                        })).filter((section)=>section.fields.length > 0);
                    if (allCustomFields?.customFields?.length) {
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                            payload: []
                        });
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$1586317d794739fb),
                            payload: filteredCustomFields
                        });
                    } else {
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                            payload: []
                        });
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$1586317d794739fb),
                            payload: []
                        });
                    }
                    if (platformFields.length) dispatch({
                        type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                        payload: platformFields
                    });
                    else dispatch({
                        type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                        payload: []
                    });
                } else {
                    for (const field of allCustomFields)(field.isPlatformField ? platformFields : customFields).push(field);
                    if (customFields.length) dispatch({
                        type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                        payload: customFields
                    });
                    else dispatch({
                        type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                        payload: []
                    });
                    if (platformFields.length) dispatch({
                        type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                        payload: platformFields
                    });
                    else dispatch({
                        type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                        payload: []
                    });
                }
            }
        };
        const copyCustomFieldText = (key, value = "")=>{
            if (currentTemplateType === "Real Penned Letter") {
                let modifiedString = key.replace(/{{/g, "((").replace(/}}/g, "))");
                (0, $717432aee8737b76$export$2cdf1b96a9f86d16)(modifiedString);
                dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)(`${value} Copied`));
            } else {
                (0, $717432aee8737b76$export$2cdf1b96a9f86d16)(key);
                dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)(`${value} Copied`));
            }
        };
        (0, $lt6Ts$useEffect)(()=>{
            fetchCustomFields();
        }, []);
        (0, $lt6Ts$useEffect)(()=>{
            setFilteredDynamicFields(defaultDynamicFields?.filter(({ key: key })=>!excludedFields?.includes(key)).filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())));
            setFilteredMiscFields(defaultMiscFields.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())));
            setFilteredPropertyFields(allowPropertyFields ? defaultPropertyFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())) : []);
            setFilteredSenderFields(allowSenderFields ? defaultSenderFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())) : []);
            setFilteredPlatformFields(platformFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())));
            setFilteredCustomFields(customFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())));
            if (customFieldsV2.length) {
                const newFilteredData = customFieldsV2.map((section)=>({
                        ...section,
                        fields: section.fields.filter((field)=>field.value?.toLowerCase().includes(search?.toLowerCase()))
                    })).filter((section)=>section?.fields?.length > 0);
                setFilteredCustomFieldsV2(newFilteredData);
            } else setFilteredDynamicFields(defaultDynamicFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.filter(({ value: value })=>value?.toLowerCase().includes(search?.toLowerCase())));
        }, [
            search,
            defaultSenderFields,
            platformFields,
            customFields,
            defaultDynamicFields,
            customFieldsV2
        ]);
        return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "bp5-input-group fields-search",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                            "aria-hidden": "true",
                            className: "bp5-icon bp5-icon-search",
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
                                "data-icon": "search",
                                height: "16",
                                role: "img",
                                viewBox: "0 0 16 16",
                                width: "16",
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                                    d: "M15.55 13.43l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
                                    fillRule: "evenodd"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("input", {
                            type: "search",
                            placeholder: "Search...",
                            className: "bp5-input",
                            onChange: (e)=>setSearch(e.target.value),
                            value: search
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "dynamic-content",
                    children: [
                        filteredDynamicFields.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "dynamic-content__top",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "title",
                                                children: "Contact Fields"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                fill: "var(--primary-color)",
                                                className: "infoIcon"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                anchorSelect: ".infoIcon",
                                                place: "bottom",
                                                className: "contact-info-tooltip",
                                                title: "Merge fields allow you to personalize your mailer with contact information."
                                            })
                                        ]
                                    })
                                }),
                                filteredDynamicFields?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_contact"))
                            ]
                        }),
                        allowPropertyFields && filteredPropertyFields.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "dynamic-content__top",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "title",
                                                children: "Property Address"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                fill: "var(--primary-color)",
                                                className: "property"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                anchorSelect: ".property",
                                                place: "bottom",
                                                title: "You can add property fields to your template."
                                            })
                                        ]
                                    })
                                }),
                                filteredPropertyFields?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_property"))
                            ]
                        }),
                        allowSenderFields && filteredSenderFields.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "dynamic-content__top",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "title",
                                                children: "Sender Fields"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                fill: "var(--primary-color)",
                                                className: "sender"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                anchorSelect: ".sender",
                                                place: "bottom",
                                                title: "You can add sender fields to your template."
                                            })
                                        ]
                                    })
                                }),
                                filteredSenderFields?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_sender"))
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                            anchorSelect: ".copy",
                            place: "bottom",
                            title: "Copy"
                        }),
                        onGetCustomFields && platformFields?.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: "dynamic-content__top",
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                    className: "title",
                                                    children: platformName ? `${platformName} Fields` : "OLC Fields"
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                    fill: "var(--primary-color)",
                                                    className: "platform"
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                    anchorSelect: ".platform",
                                                    place: "bottom",
                                                    title: `You can add ${platformName ? `${platformName} Fields` : "OLC Fields"} to your template.`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                            onClick: handleShowDialog
                                        })
                                    ]
                                }),
                                filteredPlatformFields?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_platform"))
                            ]
                        }),
                        onGetCustomFields && filteredCustomFieldsV2.length > 0 ? filteredCustomFieldsV2.map((section, index)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                        className: "divider"
                                    }),
                                    /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        className: "dynamic-content__top",
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                        className: "title",
                                                        children: section?.section
                                                    }),
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                        fill: "var(--primary-color)",
                                                        className: section?.section?.toLowerCase().replace(/[^a-z0-9\s]/g, "").trim().replace(/\s+/g, "-")
                                                    }),
                                                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                        anchorSelect: `.${section?.section?.toLowerCase().replace(/[^a-z0-9\s]/g, "").trim().replace(/\s+/g, "-")}`,
                                                        place: "bottom",
                                                        title: `You can add ${section?.section} to your template.`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                onClick: handleShowDialog
                                            })
                                        ]
                                    }),
                                    section.fields.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                    className: "contact-element",
                                                    onClick: ()=>copyCustomFieldText(key, value),
                                                    children: value
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                    style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                    onClick: ()=>copyCustomFieldText(key, value),
                                                    backdrop: false,
                                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                        className: "copy"
                                                    })
                                                })
                                            ]
                                        }, i + value))
                                ]
                            }, index + "custom-section")) : onGetCustomFields && customFields?.length > 0 && filteredCustomFields.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                    className: "dynamic-content__top",
                                    children: [
                                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                    className: "title",
                                                    children: "Custom Fields"
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                    fill: "var(--primary-color)",
                                                    className: "custom"
                                                }),
                                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                    anchorSelect: ".custom",
                                                    place: "bottom",
                                                    title: "You can add custom fields to your template."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                            onClick: handleShowDialog
                                        })
                                    ]
                                }),
                                filteredCustomFields?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_custom"))
                            ]
                        }),
                        defaultMiscFields && filteredMiscFields.length > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("hr", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "dynamic-content__top",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "title",
                                                children: "Miscellaneous Fields"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                                fill: "var(--primary-color)",
                                                className: "miscellaneous"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                                anchorSelect: ".miscellaneous",
                                                place: "bottom",
                                                title: "You can add miscellaneous fields to your template."
                                            })
                                        ]
                                    })
                                }),
                                filteredMiscFields?.filter(({ key: key })=>!excludedFields?.includes(key))?.map(({ key: key, value: value }, i)=>/*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                                className: "contact-element",
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                                style: $d0a2370b36372b2d$var$iconButtonStyles,
                                                onClick: ()=>copyCustomFieldText(key, value),
                                                backdrop: false,
                                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                                    className: "copy"
                                                })
                                            })
                                        ]
                                    }, i + "_property"))
                            ]
                        }),
                        filteredDynamicFields.length <= 0 && filteredCustomFieldsV2.length <= 0 && filteredPropertyFields.length <= 0 && filteredSenderFields.length <= 0 && filteredPlatformFields.length <= 0 && filteredCustomFields.length <= 0 && filteredMiscFields.length <= 0 && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            className: "no-result",
                            children: "No results"
                        })
                    ]
                })
            ]
        });
    })
};
var $d0a2370b36372b2d$export$2e2bcd8739ae039 = $d0a2370b36372b2d$var$CustomFieldSection;














const $cbaa6f4fedaf2643$export$5ae59fe729a6c81c = (0, $lt6Ts$observer)(({ store: store })=>{
    const [images, setImages] = (0, $lt6Ts$useState)([]);
    const [isUploading, setUploading] = (0, $lt6Ts$useState)(false);
    const [isLoading, setLoading] = (0, $lt6Ts$useState)(false);
    const dispatch = (0, $lt6Ts$useDispatch)();
    const uploadedImages = (0, $lt6Ts$useSelector)((state)=>state.templates.uploadedImages);
    const load = async ()=>{
        if (uploadedImages) {
            setLoading(true);
            setImages(uploadedImages);
            setLoading(false);
        }
    };
    const validateFile = (file)=>{
        if (!file || !(0, $7ad22e5ca6c288ca$export$abbaea9002634c0c).includes(file?.type)) {
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_UPLOAD_SECTION.TYPE_VALIDATION));
            return false;
        }
        if (file.size >= 7300000) {
            // 5MB limit
            dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_UPLOAD_SECTION.SIZE_VALIDATION));
            return false;
        }
        return true;
    };
    const handleFileInput = async (e)=>{
        try {
            const { target: target } = e;
            for (const file of target.files){
                const type = (0, $717432aee8737b76$export$e2b5c5db9e2009fd)(file);
                const validate = validateFile(file);
                if (!validate) {
                    target.value = null;
                    return;
                }
                setUploading(true);
                const uploadedFile = await (0, $dbaee5ca78364d67$export$a5575dbeeffdad98)(file);
                const allImages = [
                    ...images,
                    {
                        url: uploadedFile,
                        type: type
                    }
                ];
                setImages(allImages);
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$855a5c0ee315c6e1),
                    payload: allImages
                });
            }
            setUploading(false);
            target.value = null;
        } catch (error) {
            return error;
        } finally{
            setUploading(false);
        }
    };
    (0, $lt6Ts$useEffect)(()=>{
        load();
    }, []);
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                style: {
                    height: "40px",
                    paddingTop: "5px"
                },
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_UPLOAD_SECTION.HEADING
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                style: {
                    height: "35px"
                },
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("strong", {
                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_UPLOAD_SECTION.ACCEPTED_FORMATS
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                style: {
                    height: "35px",
                    paddingBottom: "15px"
                },
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("strong", {
                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_UPLOAD_SECTION.MAX_SIZE
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                style: {
                    marginBottom: "20px"
                },
                children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("label", {
                    htmlFor: "input-file",
                    children: [
                        isUploading ? /*#__PURE__*/ (0, $lt6Ts$jsx)("button", {
                            type: "button",
                            className: "bp5-button bp5-disabled bp5-loading bp5-intent-primary",
                            style: {
                                width: "100%",
                                backgroundColor: "rgb(246, 247, 249)",
                                boxShadow: "rgba(17, 20, 24, 0.2) 0px 0px 0px 1px inset, rgba(17, 20, 24, 0.1) 0px 1px 2px",
                                color: "rgb(28, 33, 39)"
                            },
                            disabled: true,
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                "aria-label": "loading",
                                className: "bp5-spinner bp5-button-spinner",
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                                    className: "bp5-spinner-animation",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
                                        width: "20",
                                        height: "20",
                                        strokeWidth: "16",
                                        viewBox: "-3 -3 106 106",
                                        children: [
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                                                className: "bp5-spinner-track",
                                                d: "M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90"
                                            }),
                                            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                                                className: "bp5-spinner-head",
                                                d: "M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90",
                                                pathLength: "280",
                                                strokeDasharray: "280 280",
                                                strokeDashoffset: "210"
                                            })
                                        ]
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $lt6Ts$jsxs)("button", {
                            type: "button",
                            className: "custom-upload-image-btn bp5-button bp5-intent-primary",
                            style: {
                                width: "100%",
                                backgroundColor: "#f6f7f9",
                                boxShadow: "inset 0 0 0 1px #11141833, 0 1px 2px #1114181a",
                                color: "#1c2127"
                            },
                            onClick: ()=>document.getElementById("input-file")?.click(),
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
                                    "data-icon": "upload",
                                    width: "16",
                                    height: "16",
                                    role: "img",
                                    viewBox: "0 0 16 16",
                                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                                        d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 8c-.28 0-.53-.11-.71-.29L9 6.41V12c0 .55-.45 1-1 1s-1-.45-1-1V6.41l-1.29 1.3a1.003 1.003 0 01-1.42-1.42l3-3C7.47 3.11 7.72 3 8 3s.53.11.71.29l3 3A1.003 1.003 0 0111 8z",
                                        fillRule: "evenodd"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                    className: "bp5-button-text",
                                    children: " Upload Image"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("input", {
                            type: "file",
                            id: "input-file",
                            style: {
                                display: "none"
                            },
                            onChange: handleFileInput,
                            multiple: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$ImagesGrid), {
                images: images,
                getPreview: (image)=>image?.url,
                crossOrigin: undefined,
                isLoading: isLoading,
                onSelect: async (item, pos, element)=>{
                    const image = item?.url;
                    const type = item?.type;
                    let { width: width, height: height } = await (0, $lt6Ts$getImageSize)(image);
                    if (element && element.type === "svg" && element.contentEditable && type === "image") {
                        element.set({
                            maskSrc: image
                        });
                        return;
                    }
                    if (element && element.type === "image" && element.contentEditable && type == "image") {
                        const crop = (0, $lt6Ts$getCrop)(element, {
                            width: width,
                            height: height
                        });
                        element.set({
                            src: image,
                            ...crop
                        });
                        return;
                    }
                    const scale = Math.min(store.width / width, store.height / height, 1);
                    width = width * scale;
                    height = height * scale;
                    const x = (pos?.x || store.width / 2) - width / 2;
                    const y = (pos?.y || store.height / 2) - height / 2;
                    store.activePage?.addElement({
                        type: type,
                        src: image,
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    });
                }
            })
        ]
    });
});
(0, $lt6Ts$UploadSection).Panel = $cbaa6f4fedaf2643$export$5ae59fe729a6c81c;
var $cbaa6f4fedaf2643$export$2e2bcd8739ae039 = $cbaa6f4fedaf2643$export$5ae59fe729a6c81c;


















const $6b0ed1002bdc4a9f$var$CustomAddOnIcon = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("title", {
                children: "ic_fluent_apps_add_in_24_filled"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("desc", {
                children: "Created with Sketch."
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("g", {
                id: "\uD83D\uDD0D-Product-Icons",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)("g", {
                    id: "ic_fluent_apps_add_in_24_filled",
                    fill: "#212121",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                        d: "M10.5,3 C11.8807119,3 13,4.11928813 13,5.5 L13,11 L18.5,11 C19.8807119,11 21,12.1192881 21,13.5 L21,18.5 C21,19.8807119 19.8807119,21 18.5,21 L5.5,21 C4.11928813,21 3,19.8807119 3,18.5 L3,5.5 C3,4.11928813 4.11928813,3 5.5,3 L10.5,3 Z M11,13 L5,13 L5,18.5 C5,18.7761424 5.22385763,19 5.5,19 L11,19 L11,13 Z M18.5,13 L13,13 L13,19 L18.5,19 C18.7761424,19 19,18.7761424 19,18.5 L19,13.5 C19,13.2238576 18.7761424,13 18.5,13 Z M10.5,5 L5.5,5 C5.22385763,5 5,5.22385763 5,5.5 L5,11 L11,11 L11,5.5 C11,5.22385763 10.7761424,5 10.5,5 Z M17.8833789,2.00672773 L18,2 C18.5128358,2 18.9355072,2.38604019 18.9932723,2.88337887 L19,3 L19,5 L21,5 C21.5128358,5 21.9355072,5.38604019 21.9932723,5.88337887 L22,6 C22,6.51283584 21.6139598,6.93550716 21.1166211,6.99327227 L21,7 L19,7 L19,9 C19,9.51283584 18.6139598,9.93550716 18.1166211,9.99327227 L18,10 C17.4871642,10 17.0644928,9.61395981 17.0067277,9.11662113 L17,9 L17,7 L15,7 C14.4871642,7 14.0644928,6.61395981 14.0067277,6.11662113 L14,6 C14,5.48716416 14.3860402,5.06449284 14.8833789,5.00672773 L15,5 L17,5 L17,3 C17,2.48716416 17.3860402,2.06449284 17.8833789,2.00672773 L18,2 L17.8833789,2.00672773 Z",
                        id: "\uD83C\uDFA8-Color"
                    })
                })
            })
        ]
    });
};
var $6b0ed1002bdc4a9f$export$2e2bcd8739ae039 = $6b0ed1002bdc4a9f$var$CustomAddOnIcon;






const $7906a010f67a4ff0$var$GSV = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        width: "685",
        height: "497",
        viewBox: "0 0 685 497",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("circle", {
                cx: "285.5",
                cy: "146.5",
                r: "56",
                stroke: "black",
                strokeWidth: "23"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("rect", {
                x: "12.5",
                y: "12.5",
                width: "660",
                height: "472",
                rx: "28.5",
                stroke: "black",
                strokeWidth: "25"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                d: "M13 316L126.663 218.694C138.981 208.149 157.344 208.878 168.787 220.366L275.5 327.5M275.5 327.5L124 482M275.5 327.5L467.765 137.481C479.819 125.568 499.206 125.542 511.29 137.424L668 291.5",
                stroke: "black",
                strokeWidth: "24"
            })
        ]
    });
};
var $7906a010f67a4ff0$export$2e2bcd8739ae039 = $7906a010f67a4ff0$var$GSV;




const $394f63d6507afbac$var$EPO = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 66.9 66.8",
        fill: "#7f7f7f",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M44.3,15.7c0,.9-.7,1.6-1.6,1.6s-1.6-.7-1.6-1.6.7-1.6,1.6-1.6,1.6.7,1.6,1.6ZM39.1,15.7c0,2,1.6,3.7,3.6,3.7s3.6-1.6,3.6-3.7-1.6-3.7-3.6-3.7-3.6,1.6-3.6,3.7Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M16.9,61.6c0,.1,0,.3,0,.4,0,.1-.1.2-.2.3,0,0-.2.2-.3.2-.1,0-.3,0-.4,0s-.3,0-.4,0c-.1,0-.2-.1-.3-.2,0,0-.2-.2-.2-.3,0-.1,0-.3,0-.4s0-.3,0-.4c0-.1.1-.2.2-.3,0,0,.2-.2.3-.2s.3,0,.4,0,.3,0,.4,0,.2.1.3.2c0,0,.2.2.2.3,0,.1,0,.3,0,.4Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M41.9,2.5c.5-.5,1.3-.5,1.8,0l13.7,15.1v14.6c.5-.2,1.2-.4,1.9-.4h.2v-11.9l3.4,3.8c.4.4,1,.5,1.5,0,.4-.4.5-1,0-1.5L45.1,1.1c-.6-.7-1.5-1.1-2.4-1.1s-1.8.4-2.4,1.1l-9.8,10.8c.7.3,1.3.6,1.9,1,0,0,9.3-10.4,9.4-10.4Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M26.2,15.1c4,0,7.3,3.3,7.3,7.3s-3.2,7.3-7.3,7.3-7.3-3.3-7.3-7.3,3.3-7.3,7.3-7.3ZM26.2,31.9c5.2,0,9.3-4.2,9.3-9.4s-4.2-9.4-9.3-9.4-9.3,4.2-9.3,9.4,4.2,9.4,9.3,9.4Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M25.8,23.6h.7c.4,0,.7.2.7.5s0,.5-.7.5h-2c-.6,0-1,.5-1,1s.5,1,1,1h1v.5c0,.6.5,1,1,1s1-.5,1-1v-.7c1.1-.4,1.7-1.5,1.7-2.4s-.9-2.6-2.8-2.6h-.7c-.2,0-.4,0-.5-.2-.1-.1-.2-.2-.2-.4s.1-.5.7-.5h2c.6,0,1-.5,1-1s-.5-1-1-1h-.2v-.6c0-.6-.5-1-1-1s-1,.5-1,1v.6c-1.6.1-2.5,1.4-2.5,2.6s.9,2.6,2.7,2.6Z"
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
                className: "st0",
                d: "M66.6,34.7c-.3-.5-.9-.8-1.6-.8h-5.6c-.6,0-1.1.2-1.5.4-.5.2-1.2.7-2.9,3.1l-1.3,1.7h-4.6v-12c0-.6-.5-1-1-1h-10.4c-.6,0-1,.5-1,1v6.7h2.1v-5.6h8.4v6.8c1.3,1,2.1,2.6,2.1,4.3v1.8h5.1c.3,0,.6-.2.8-.4l1.6-2.1c1.6-2.1,2-2.4,2.1-2.4.3-.1.5-.2.7-.2h5.2l-3.3,7.7c-.2.4-.7,1-1.1,1.3l-11.4,7.4c-.2.1-.5.3-1.7.3h-21.8c-.3,0-.5.1-.7.3l-2.7,2.6-12.2-12.2,7.3-6.9c.3-.3.9-.5,1.4-.5h11.2c.5,0,1.4.2,1.9.4l2.6,1c.7.3,1.9.5,2.7.5h6.9c.7,0,1.4.6,1.4,1.4v3.7c0,.8-.6,1.4-1.4,1.4h-13.9c-.6,0-1,.5-1,1s.5,1,1,1h13.8c1.9,0,3.4-1.6,3.4-3.4v-3.7c0-1.9-1.6-3.4-3.4-3.4h-6.9c-.5,0-1.4-.2-1.9-.4l-2.6-1c-.7-.3-1.9-.5-2.7-.5h-11.1c-.9,0-2.1.5-2.8,1.1l-7.3,6.9c-1.5-1.5-3.8-1.7-5.1-.6l-2.6,2.1c-.5.4-.5,1-.2,1.5.4.5,1,.5,1.5.2l2.6-2.1c.5-.4,1.6-.3,2.4.5l14.4,14.4c.7.7.7,1.9,0,2.6l-4.3,4.5c-.4.4-.4,1.1,0,1.5.4.4,1.1.4,1.5,0l4.3-4.5c.7-.7,1.1-1.7,1.1-2.7s-.2-1.5-.6-2.1l2.5-2.3h21.4c.9,0,2.1,0,2.9-.6l11.4-7.4c.7-.5,1.6-1.4,1.9-2.2l3.4-8c.3-.6.3-1.2,0-1.7Z"
            })
        ]
    });
};
var $394f63d6507afbac$export$2e2bcd8739ae039 = $394f63d6507afbac$var$EPO;



const $52be5db9307c4332$var$iconButtonStyles = {
    backgroundColor: "transparent",
    marginLeft: "70%",
    marginTop: "-40%",
    position: "absolute"
};
// define the new custom section
const $52be5db9307c4332$var$CustomAddOns = {
    name: "CustomAddOns",
    Tab: (0, $lt6Ts$observer)((props)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SectionTab), {
            name: "Add On's",
            ...props,
            iconSize: 20,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $6b0ed1002bdc4a9f$export$2e2bcd8739ae039), {})
        })),
    // we need observer to update component automatically on any store changes
    Panel: (0, $lt6Ts$observer)(({ store: store, allowedAddOns: allowedAddOns })=>{
        const [customRosValue, setCustomRosValue] = (0, $lt6Ts$useState)("");
        const currentTemplate = (0, $lt6Ts$useSelector)((state)=>state.templates.template);
        const currentOfferPercentage = (0, $lt6Ts$useSelector)((state)=>state.templates.offerPercentage);
        const dispatch = (0, $lt6Ts$useDispatch)();
        const googleStreetViewSrc = ((0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "local" || (0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "staging" ? (0, $7ad22e5ca6c288ca$export$dc8c2e2c228d4170) : (0, $717432aee8737b76$export$d97320b3491da14)() ? (0, $7ad22e5ca6c288ca$export$31ebffddc71c8253) : (0, $7ad22e5ca6c288ca$export$79361813a10e9e28)) + (0, $7ad22e5ca6c288ca$export$75535718f1551e4f);
        const propertyOfferGeneratorURL = ((0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "local" || (0, $717432aee8737b76$export$4bd44a2aa29d3d6e)() === "staging" ? (0, $7ad22e5ca6c288ca$export$a8a46befcad8f726) : (0, $717432aee8737b76$export$d97320b3491da14)() ? (0, $7ad22e5ca6c288ca$export$66a57f3cad8824dd) : (0, $7ad22e5ca6c288ca$export$7f8ff6b96b8eb54b)) + `?apiKey=${(0, $717432aee8737b76$export$46af023db2483081)()}`;
        const PropertyOfferfieldValue = "{{ROS.PROPERTY_OFFER}}";
        const handleAddElementOnScreen = (event, value, type)=>{
            event.preventDefault();
            const currentPage = store.activePage.toJSON();
            if (type === "gsv") {
                if (currentPage?.children?.length && currentPage.children.find((item)=>item.id === `gsv-image_${store.activePage.id}`)) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.GSV_RESTRICT_ONE_PER_PAGE));
                    return;
                }
                store.activePage?.addElement({
                    id: `gsv-image_${store.activePage.id}`,
                    type: "image",
                    src: googleStreetViewSrc,
                    width: 287,
                    height: 188,
                    contentEditable: false,
                    keepRatio: true,
                    opacity: 1,
                    custom: {
                        elementType: value
                    }
                });
            } else if (type === "rpo") {
                const randomizedId = Math.random().toString(36).substring(2, 7);
                store.activePage.addElement({
                    id: `ros_${randomizedId}`,
                    type: "text",
                    x: 100,
                    y: 100,
                    text: value,
                    width: 175,
                    contentEditable: false
                });
            } else if (type === "custom_rpo") {
                if (!customRosValue) {
                    percentageRequired();
                    return;
                }
                if (!validCustomRosRange()) return false;
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$ec8156c566eb37cd),
                    payload: customRosValue
                });
                const randomizedId = Math.random().toString(36).substring(2, 7);
                store.activePage.addElement({
                    id: `ros_${randomizedId}`,
                    type: "text",
                    x: 100,
                    y: 100,
                    text: value,
                    width: 175,
                    contentEditable: false,
                    custom: {
                        ros_custom_value: customRosValue
                    }
                });
            }
        };
        const percentageRequired = ()=>dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(`Please enter the offer percentage`));
        const validCustomRosRange = ()=>{
            if (+customRosValue < 1 || +customRosValue > 100) {
                dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(`Please enter an offer percentage between 1 and 100`));
                return false;
            }
            return true;
        };
        const copyPropertyOfferField = (e)=>{
            e.stopPropagation();
            (0, $717432aee8737b76$export$2cdf1b96a9f86d16)(PropertyOfferfieldValue);
            dispatch({
                type: (0, $e496cac0faa1ff17$export$ec8156c566eb37cd),
                payload: customRosValue
            });
            dispatch((0, $6ca040a325a745aa$export$fe7c49d056ea1d88)(`ROS Property Offer Copied`));
        };
        (0, $lt6Ts$useEffect)(()=>{
            if (currentTemplate?.meta?.rosOfferPercentage && !currentOfferPercentage) setCustomRosValue(currentTemplate.meta.rosOfferPercentage);
            else if (currentOfferPercentage) setCustomRosValue(currentOfferPercentage);
        }, []);
        return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
            className: "dynamic-content",
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "dynamic-content__top",
                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)("span", {
                                className: "title",
                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.TITLE
                            }),
                            " ",
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $10fe05b81a81fb3f$export$2e2bcd8739ae039), {
                                fill: "var(--primary-color)",
                                className: "infoIcon"
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                                anchorSelect: ".infoIcon",
                                place: "bottom",
                                className: "custom-add-on-tooltip",
                                title: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.DESCRIPTION
                            })
                        ]
                    })
                }),
                (!allowedAddOns || allowedAddOns?.includes("gsv")) && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "addonBox",
                    onClick: (event)=>handleAddElementOnScreen(event, "GOOGLE_STREET_VIEW", "gsv"),
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7906a010f67a4ff0$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.GSV.TITLE
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.GSV.DESCRIPTION
                        })
                    ]
                }),
                allowedAddOns?.includes("property_offer") && /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    children: /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                        className: "addonBox",
                        onClick: (event)=>handleAddElementOnScreen(event, PropertyOfferfieldValue, "rpo"),
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                                style: $52be5db9307c4332$var$iconButtonStyles,
                                onClick: copyPropertyOfferField,
                                backdrop: false,
                                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                    className: "copy"
                                })
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $394f63d6507afbac$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.TITLE
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                className: "no-margin",
                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.DESCRIPTION
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.PRICE
                            })
                        ]
                    })
                }),
                allowedAddOns?.includes("custom_property_offer") && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "addonBox",
                    onClick: (event)=>handleAddElementOnScreen(event, PropertyOfferfieldValue, "custom_rpo"),
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $468b2e43c10c77f3$export$2e2bcd8739ae039), {
                            style: $52be5db9307c4332$var$iconButtonStyles,
                            onClick: customRosValue ? copyPropertyOfferField : percentageRequired,
                            backdrop: false,
                            className: "custom-po",
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e06bdfe75163a118$export$2e2bcd8739ae039), {
                                className: "copy"
                            })
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $394f63d6507afbac$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.CUSTOM.TITLE
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            variant: "h3",
                            className: "no-margin s-font",
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.CUSTOM.DESCRIPTION
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                            style: {
                                margin: "12px"
                            },
                            className: "plain-text",
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)("a", {
                                    href: propertyOfferGeneratorURL,
                                    target: "_blank",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                    },
                                    children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.CUSTOM.CLICK
                                }),
                                " ",
                                (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.CUSTOM.CSV_IMPORT
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                            className: "no-margin s-font",
                            children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.PROPERTY_OFFER.CUSTOM.CUSTOM_PRICE
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                            onClick: (e)=>e.stopPropagation(),
                            style: {
                                width: "18rem",
                                marginBottom: "15px"
                            },
                            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                                type: "number",
                                placeholder: "Type in a Number between 1-100",
                                qrField: true,
                                value: customRosValue,
                                onChange: (e)=>{
                                    setCustomRosValue(e.target.value);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                    className: "no-result-addOns",
                    children: !allowedAddOns || allowedAddOns?.length === 0 && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                        children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.CUSTOM_ADD_ONS.NO_RESULT
                    })
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $7d1ce187c1ab3d01$export$2e2bcd8739ae039), {
                    anchorSelect: ".copy",
                    place: "bottom",
                    title: "Copy"
                })
            ]
        });
    })
};
var $52be5db9307c4332$export$2e2bcd8739ae039 = $52be5db9307c4332$var$CustomAddOns;


















const $14c82a2ac1882346$var$CustomQRIcon = ()=>{
    return /*#__PURE__*/ (0, $lt6Ts$jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        version: "1.1",
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)("path", {
            fill: "#000000",
            d: "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
        })
    });
};
var $14c82a2ac1882346$export$2e2bcd8739ae039 = $14c82a2ac1882346$var$CustomQRIcon;


// define the new custom section
const $34a18093efad5ac0$var$CustomQRCode = {
    name: "QR-Section",
    Tab: (props)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SectionTab), {
            name: "QR",
            ...props,
            iconSize: 20,
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $14c82a2ac1882346$export$2e2bcd8739ae039), {})
        }),
    // we need observer to update component automatically on any store changes
    Panel: (0, $lt6Ts$observer)(({ store: store, allowSenderFields: allowSenderFields, allowPropertyFields: allowPropertyFields, excludedFields: excludedFields })=>{
        const url = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.url);
        const utmSource = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.utmSource);
        const utmMedium = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.utmMedium);
        const utmCampaignName = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.utmCampaignName);
        const customUtms = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.customUtms);
        const isQR = (0, $lt6Ts$useSelector)((state)=>state.customQRCode.isQR);
        const dispatch = (0, $lt6Ts$useDispatch)();
        const defaultFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultDynamicFields);
        const defaultSenderFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultSenderFields);
        const customFields = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFields);
        const customFieldsV2 = (0, $lt6Ts$useSelector)((state)=>state.customFields.customFieldsV2);
        const defaultPropertyFields = (0, $lt6Ts$useSelector)((state)=>state.templates.defaultPropertyFields);
        const excludedLabels = [
            "utm_c_first_name c_last_name"
        ];
        let flattenedFieldsV2 = [];
        if (customFieldsV2.length > 0) flattenedFieldsV2 = customFieldsV2?.flatMap((section)=>section.fields);
        const allFields = [
            ...defaultFields,
            ...customFields,
            ...flattenedFieldsV2,
            ...allowSenderFields ? defaultSenderFields : [],
            ...allowPropertyFields ? defaultPropertyFields : [],
            ...allowPropertyFields ? [
                {
                    value: "ROS.PROPERTY_OFFER",
                    key: "{{ROS.PROPERTY_OFFER}}",
                    defaultValue: "$123,456.00"
                }
            ] : []
        ].filter(({ key: key })=>!excludedFields?.includes(key));
        const utmFields = allFields.map(({ key: key })=>({
                label: `utm_${key?.toLowerCase().replaceAll(".", "_").replaceAll(/[{}]/g, "")}`
            })).filter((utmField)=>!excludedLabels.includes(utmField.label));
        const utms = [
            "custom_utm_1",
            "custom_utm_2",
            "custom_utm_3"
        ];
        const el = store.selectedElements[0];
        const clearQRFields = ()=>{
            store.selectElements([]);
            dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
        };
        const appendUtmParameters = (utmField, defaultValue)=>{
            let result = "";
            const field = (0, $7ad22e5ca6c288ca$export$30a03ee31713ef75).find((field)=>field.key === utmField);
            if (field) result = `${field.value}=${defaultValue}`;
            return result;
        };
        const validateQRCode = ()=>{
            const validations = [
                {
                    value: utmSource,
                    label: "UTM Source"
                },
                {
                    value: utmMedium,
                    label: "UTM Medium"
                },
                {
                    value: utmCampaignName,
                    label: "UTM Campaign"
                }
            ];
            for (const { value: value, label: label } of validations){
                if (value.length >= 150) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(`${label} must be less than 150 characters`));
                    return false;
                }
                if ((0, $7ad22e5ca6c288ca$export$668f6b29ff2ac480).test(value)) {
                    dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)(`Emoji are not allowed in ${label}`));
                    return false;
                }
            }
            return true;
        };
        const containsDisallowedDomains = (str)=>{
            return (0, $7ad22e5ca6c288ca$export$f2ea9ed4b68e82d5).some((substring)=>str.includes(substring));
        };
        // create svg image for QR code for input text
        const getQR = (text)=>{
            return new Promise((resolve)=>{
                (0, $lt6Ts$qrcode).toString(text || "no-data", {
                    type: "svg",
                    margin: 0,
                    color: {
                        dark: "#000000",
                        light: "#0000"
                    }
                }, (err, string)=>{
                    resolve($lt6Ts$svgToURL(string));
                });
            });
        };
        const createCustomizeURL = (url)=>{
            let customURL = url;
            let params = [];
            if (utmSource) params.push(`utm_source=${utmSource.replace(/ /g, "_")}`);
            if (utmMedium) params.push(`utm_medium=${utmMedium.replace(/ /g, "_")}`);
            if (utmCampaignName) params.push(`utm_campaign=${utmCampaignName.replace(/ /g, "_")}`);
            if (customUtms[utms[0]]?.label) {
                const orignalField = `{{${customUtms[utms[0]]?.label.replace("utm_", "").replace("_", ".").toUpperCase()}}}`;
                const defaultValue = allFields.find((field)=>field.key === orignalField)?.defaultValue;
                const attachUtmKeys = appendUtmParameters(orignalField, defaultValue);
                const mergeUtmParams = attachUtmKeys && orignalField == "{{C.PHONE_NUMBER}}" ? encodeURIComponent(`${customUtms[utms[0]]?.label}=${defaultValue}&${attachUtmKeys}`).replace(/[\s\(\)]/g, "") : attachUtmKeys ? `${customUtms[utms[0]]?.label}=${defaultValue}&${attachUtmKeys}` : `${customUtms[utms[0]]?.label}=${defaultValue}`;
                params.push(mergeUtmParams);
            }
            if (customUtms[utms[1]]?.label) {
                const orignalField = `{{${customUtms[utms[1]]?.label.replace("utm_", "").replace("_", ".").toUpperCase()}}}`;
                const defaultValue = allFields.find((field)=>field.key === orignalField)?.defaultValue;
                const attachUtmKeys = appendUtmParameters(orignalField, defaultValue);
                const mergeUtmParams = attachUtmKeys && orignalField == "{{C.PHONE_NUMBER}}" ? encodeURIComponent(`${customUtms[utms[1]]?.label}=${defaultValue}&${attachUtmKeys}`).replace(/[\s\(\)]/g, "") : attachUtmKeys ? `${customUtms[utms[1]]?.label}=${defaultValue}&${attachUtmKeys}` : `${customUtms[utms[1]]?.label}=${defaultValue}`;
                params.push(mergeUtmParams);
            }
            if (customUtms[utms[2]]?.label) {
                const orignalField = `{{${customUtms[utms[2]]?.label.replace("utm_", "").replace("_", ".").toUpperCase()}}}`;
                const defaultValue = allFields.find((field)=>field.key === orignalField)?.defaultValue;
                const attachUtmKeys = appendUtmParameters(orignalField, defaultValue);
                const mergeUtmParams = attachUtmKeys && orignalField == "{{C.PHONE_NUMBER}}" ? encodeURIComponent(`${customUtms[utms[2]]?.label}=${defaultValue}&${attachUtmKeys}`).replace(/[\s\(\)]/g, "") : attachUtmKeys ? `${customUtms[utms[2]]?.label}=${defaultValue}&${attachUtmKeys}` : `${customUtms[utms[2]]?.label}=${defaultValue}`;
                params.push(mergeUtmParams);
            }
            if (params.length > 0) customURL += `/?${params.join("&")}`;
            return encodeURI(customURL);
        };
        const addNewQRCode = async ()=>{
            if (url) {
                if ((0, $717432aee8737b76$export$c6f1a4382426409f)(url) && !containsDisallowedDomains(url)) {
                    const isValidQR = validateQRCode();
                    if (!isValidQR) return false;
                    const randomizedId = Math.random().toString(36).substring(2, 7);
                    const customQRUrl = createCustomizeURL(url);
                    const src = await getQR(customQRUrl);
                    store.activePage.addElement({
                        id: `qr-${randomizedId}`,
                        type: "svg",
                        name: "qr",
                        x: 50,
                        y: 50,
                        width: 100,
                        height: 100,
                        blurRadius: 0,
                        keepRatio: true,
                        src: src,
                        custom: {
                            url: url,
                            utm_source: utmSource,
                            utm_medium: utmMedium,
                            utm_campaign_name: utmCampaignName,
                            custom_utms: customUtms
                        }
                    });
                    clearQRFields();
                } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.INVALID_URL));
            } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.EMPTY_QR));
        };
        // if selection is changed we need to update input value
        const updateQRCode = async ()=>{
            if (el?.name === "qr" && url) {
                if ((0, $717432aee8737b76$export$c6f1a4382426409f)(url) && !containsDisallowedDomains(url)) {
                    const isValidQR = validateQRCode();
                    if (!isValidQR) return false;
                    const customQRUrl = createCustomizeURL(url);
                    const src = await getQR(customQRUrl);
                    el.set({
                        src: src,
                        custom: {
                            url: url,
                            utm_source: utmSource,
                            utm_medium: utmMedium,
                            utm_campaign_name: utmCampaignName,
                            custom_utms: customUtms
                        }
                    });
                    clearQRFields();
                } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.INVALID_URL));
            } else dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)((0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.EMPTY_QR));
        };
        // Handler to update dropdown values
        const handleSelect = (utmKey, value)=>{
            const updatedUtms = {
                ...customUtms
            };
            if (value === null) delete updatedUtms[utmKey];
            else updatedUtms[utmKey] = value;
            dispatch((0, $bbef8ecdaaf79b6e$export$428b90966bc4ddbf)(updatedUtms));
        };
        // if selection is changed we need to update input value
        (0, $lt6Ts$useEffect)(()=>{
            if (el?.name === "qr") {
                dispatch((0, $bbef8ecdaaf79b6e$export$ff1a9ff6320ab5ac)(el?.name === "qr"));
                dispatch((0, $bbef8ecdaaf79b6e$export$c48cc906ecded6a0)(el?.custom?.url || el?.custom?.value || ""));
                dispatch((0, $bbef8ecdaaf79b6e$export$8903335f45df5147)(el?.custom?.utm_source || "direct mail"));
                dispatch((0, $bbef8ecdaaf79b6e$export$7c509f1febbfc2e0)(el?.custom?.utm_medium || "QR Code"));
                dispatch((0, $bbef8ecdaaf79b6e$export$2b7a28e427492e80)(el?.custom?.utm_campaign_name || ""));
                if (Object.values(el?.custom?.custom_utms || {}).length) dispatch((0, $bbef8ecdaaf79b6e$export$428b90966bc4ddbf)(el?.custom?.custom_utms));
                else dispatch((0, $bbef8ecdaaf79b6e$export$428b90966bc4ddbf)({}));
            } else if (isQR && el?.name !== "qr") dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
        }, [
            isQR,
            el
        ]);
        return /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
            children: [
                /*#__PURE__*/ (0, $lt6Ts$jsx)("button", {
                    className: "qr-submit-btn",
                    onClick: isQR ? updateQRCode : addNewQRCode,
                    children: isQR ? (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.UPDATE_BUTTON : (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.SUBMIT_BUTTON
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "qr-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                            children: "QR URL:"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            onChange: (e)=>{
                                dispatch((0, $bbef8ecdaaf79b6e$export$c48cc906ecded6a0)(e.target.value));
                            },
                            placeholder: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE.QR_SECTION.QR_PLACEHOLDER,
                            value: url,
                            qrField: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "qr-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                            children: "UTM Source:"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            onChange: (e)=>{
                                dispatch((0, $bbef8ecdaaf79b6e$export$8903335f45df5147)(e.target.value));
                            },
                            placeholder: "Enter UTM Source",
                            value: utmSource,
                            qrField: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "qr-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                            children: "UTM Medium:"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            onChange: (e)=>{
                                dispatch((0, $bbef8ecdaaf79b6e$export$7c509f1febbfc2e0)(e.target.value));
                            },
                            placeholder: "Enter UTM Medium",
                            value: utmMedium,
                            qrField: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "qr-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)("label", {
                            children: "UTM Campaign Name:"
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $ec73244cd7283520$export$2e2bcd8739ae039), {
                            type: "text",
                            onChange: (e)=>{
                                dispatch((0, $bbef8ecdaaf79b6e$export$2b7a28e427492e80)(e.target.value));
                            },
                            placeholder: "Enter UTM Campaign Name",
                            value: utmCampaignName,
                            qrField: true
                        })
                    ]
                }),
                utms?.map((utm, idx)=>{
                    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                        className: "qr-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $lt6Ts$jsxs)("label", {
                                children: [
                                    utm.toUpperCase().replace(/\_/g, " "),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $3f4ef87f7a4a530a$export$2e2bcd8739ae039), {
                                placeholder: `Select Custom UTM ${idx + 1}`,
                                options: utmFields,
                                setSelectedValue: (value)=>handleSelect(utm, value),
                                selectedValue: customUtms[utm] || null,
                                builderSelect: true,
                                clearField: true,
                                search: true,
                                qrField: true,
                                isError: false,
                                gallerySelect: false
                            })
                        ]
                    }, idx);
                })
            ]
        });
    })
};
var $34a18093efad5ac0$export$2e2bcd8739ae039 = $34a18093efad5ac0$var$CustomQRCode;


const $d303f0b433a1814c$var$SidePanel = (props)=>{
    const [hireDesignerModal, setHireDesignerModal] = (0, $lt6Ts$useState)(false);
    const sections = props.currentTemplateType === "Real Penned Letter" ? (0, $lt6Ts$DEFAULT_SECTIONS).filter((section)=>section.name === "") : (0, $lt6Ts$DEFAULT_SECTIONS).filter((section)=>![
            "photos",
            "size",
            "templates"
        ].includes(section.name));
    return /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SidePanelWrap), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$SidePanel), {
            store: props.store,
            sections: [
                {
                    ...(0, $e8f6665471b594e0$export$2e2bcd8739ae039),
                    Panel: (panelProps)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $e8f6665471b594e0$export$2e2bcd8739ae039).Panel, {
                            ...panelProps,
                            platformName: props.platformName,
                            templateGalleryModal: props.templateGalleryModal,
                            designerQueryAmount: props.designerQueryAmount,
                            selectedSection: props.selectedSection,
                            allowedTemplateSections: props.allowedTemplateSections,
                            hireDesignerModal: hireDesignerModal,
                            setHireDesignerModal: setHireDesignerModal,
                            onCreateCustomTemplateQuery: props.onCreateCustomTemplateQuery,
                            onGetTemplates: props.onGetTemplates,
                            onGetOneTemplate: props.onGetOneTemplate
                        })
                },
                ...sections,
                {
                    ...(0, $d0a2370b36372b2d$export$2e2bcd8739ae039),
                    ...(0, $cbaa6f4fedaf2643$export$2e2bcd8739ae039),
                    Panel: (panelProps)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d0a2370b36372b2d$export$2e2bcd8739ae039).Panel, {
                            ...panelProps,
                            onGetCustomFields: props.onGetCustomFields,
                            allowSenderFields: props.allowSenderFields,
                            excludedFields: props.excludedFields,
                            allowPropertyFields: props.allowPropertyFields,
                            platformName: props.platformName
                        })
                },
                ...props.currentTemplateType !== "Real Penned Letter" ? [
                    {
                        ...(0, $34a18093efad5ac0$export$2e2bcd8739ae039),
                        Panel: (panelProps)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $34a18093efad5ac0$export$2e2bcd8739ae039).Panel, {
                                ...panelProps,
                                allowSenderFields: props.allowSenderFields,
                                allowPropertyFields: props.allowPropertyFields,
                                excludedFields: props.excludedFields
                            })
                    },
                    {
                        ...(0, $52be5db9307c4332$export$2e2bcd8739ae039),
                        Panel: (panelProps)=>/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $52be5db9307c4332$export$2e2bcd8739ae039).Panel, {
                                ...panelProps,
                                allowedAddOns: props.allowedAddOns
                            })
                    }
                ] : []
            ],
            defaultSection: "text"
        })
    });
};
var $d303f0b433a1814c$export$2e2bcd8739ae039 = $d303f0b433a1814c$var$SidePanel;





const $6248df0c26b0b2d9$var$TemplateBuilder = ({ store: store, platformName: platformName, templateGalleryModal: templateGalleryModal, createTemplateRoute: createTemplateRoute, designerTemplateQuery: designerTemplateQuery, olcTemplate: olcTemplate, allowSenderFields: allowSenderFields, excludedFields: excludedFields, designerQueryAmount: designerQueryAmount, allowPropertyFields: allowPropertyFields, allowedAddOns: allowedAddOns, allowedTemplateSections: allowedTemplateSections, onCreateCustomTemplateQuery: onCreateCustomTemplateQuery, onReturnAndNavigate: onReturnAndNavigate, onGetOneTemplate: onGetOneTemplate, onGetCustomFields: onGetCustomFields, onDuplicateTemplate: onDuplicateTemplate, onGetTemplates: onGetTemplates, onSubmit: onSubmit })=>{
    const [isStoreUpdated, setIsStoreUpdated] = (0, $lt6Ts$useState)(false);
    const [isDuplication, setIsDuplication] = (0, $lt6Ts$useState)(false);
    const [switchTabCount, setSwitchTabCount] = (0, $lt6Ts$useState)(1);
    const [selectedSection, setSelectedSection] = (0, $lt6Ts$useState)("text");
    const { id: id } = (0, $lt6Ts$useParams)();
    const dispatch = (0, $lt6Ts$useDispatch)();
    const navigate = (0, $lt6Ts$useNavigate)();
    const template = (0, $lt6Ts$useSelector)((state)=>state.templates.template);
    const product = (0, $lt6Ts$useSelector)((state)=>state.templates.product);
    const envelopeType = (0, $lt6Ts$useSelector)((state)=>state.templates.envelopeType);
    const allProducts = (0, $lt6Ts$useSelector)((state)=>state.templates.products);
    const currentTemplateType = product?.productType;
    const containerStyle = {
        width: "100vw",
        height: "90vh",
        position: "relative"
    };
    (0, $lt6Ts$useEffect)(()=>{
        if (olcTemplate) handleLoadTemplate();
    }, [
        olcTemplate
    ]);
    (0, $lt6Ts$useEffect)(()=>{
        if (designerTemplateQuery) setTimeout(()=>{
            handleLoadDesignerTemplate();
        }, 100);
    }, [
        designerTemplateQuery
    ]);
    // Event listener for visibility change
    (0, $lt6Ts$useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.hidden) setSwitchTabCount((prev)=>prev + 1);
        };
        const handleClick = (event)=>{
            if (event.target instanceof Element && event.target.closest(".polotno-side-tabs-container") && store?.openedSidePanel !== "Templates") setSelectedSection(store?.openedSidePanel);
        };
        document.addEventListener("click", handleClick);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            document.removeEventListener("click", handleClick);
        };
    }, []);
    (0, $lt6Ts$useEffect)(()=>{
        (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("hireDesignerFormState");
        (0, $b66d61b9e6770b52$export$fe2d9b4e03920b4c)("queryFiles");
    }, []);
    (0, $lt6Ts$useEffect)(()=>{
        if (!product && !olcTemplate && !id && !designerTemplateQuery) navigate(createTemplateRoute || "/create-template");
    }, []);
    // @ts-ignore
    (0, $lt6Ts$useEffect)(()=>{
        if (product || id && onGetOneTemplate) {
            (0, $lt6Ts$setGoogleFonts)((0, (/*@__PURE__*/$parcel$interopDefault($6095227f2f4b1a81$exports))));
            if (id && onGetOneTemplate) try {
                onGetOneTemplate(id).then((template)=>{
                    if (template) {
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$1c6648626b31f20d),
                            payload: {
                                data: template
                            }
                        });
                        (0, $39231ae325c5aacf$export$b8070c2bd9d59c10)(template?.product?.id, store);
                        dispatch({
                            type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                            payload: true
                        });
                    } else {
                        dispatch((0, $6ca040a325a745aa$export$af2dba6db4e9e1f0)("Unable to load the Template"));
                        setTimeout(()=>{
                            navigate(createTemplateRoute || "/create-template");
                        }, 1000);
                    }
                });
            } catch (error) {
                return error;
            } finally{
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                    payload: false
                });
            }
            else if (store.pages.length === 0 && !olcTemplate) createInitialPage();
            fetchCustomFields();
            const handleChange = ()=>{
                if (!isStoreUpdated) {
                    setIsStoreUpdated(true);
                    setIsDuplication(false);
                }
            };
            const off = store.on("change", handleChange);
            return ()=>{
                store.history.clear();
                store.clear();
                dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
                off();
            };
        }
    }, []);
    (0, $lt6Ts$useEffect)(()=>{
        if (!id && !olcTemplate && product && store.pages.length === 0) createInitialPage();
    }, [
        product
    ]);
    (0, $lt6Ts$useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            const message = "Are you sure you want to leave?";
            event.returnValue = message;
            return message;
        };
        const addBeforeUnloadListener = ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.addEventListener("beforeunload", handleBeforeUnload);
        };
        const removeBeforeUnloadListener = ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
        if (isStoreUpdated && !isDuplication) addBeforeUnloadListener();
        return ()=>{
            removeBeforeUnloadListener();
        };
    }, [
        isStoreUpdated,
        isDuplication
    ]);
    const fetchCustomFields = async ()=>{
        if (onGetCustomFields) {
            const allCustomFields = await onGetCustomFields();
            const platformFields = [];
            const customFields = [];
            if (allCustomFields?.version === "v2") {
                const flattenedFields = allCustomFields.customFields.flatMap((section)=>section.fields);
                for (const field of flattenedFields)(field.isPlatformField ? platformFields : customFields).push(field);
                const filteredCustomFields = allCustomFields?.customFields.map((customField)=>({
                        ...customField,
                        fields: customField.fields.filter((field)=>customFields.includes(field))
                    })).filter((section)=>section.fields.length > 0);
                if (allCustomFields?.customFields?.length) {
                    dispatch({
                        type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                        payload: []
                    });
                    dispatch({
                        type: (0, $e496cac0faa1ff17$export$1586317d794739fb),
                        payload: filteredCustomFields
                    });
                } else {
                    dispatch({
                        type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                        payload: []
                    });
                    dispatch({
                        type: (0, $e496cac0faa1ff17$export$1586317d794739fb),
                        payload: []
                    });
                }
                if (platformFields.length) dispatch({
                    type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                    payload: platformFields
                });
                else dispatch({
                    type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                    payload: []
                });
            } else {
                for (const field of allCustomFields)(field.isPlatformField ? platformFields : customFields).push(field);
                if (customFields.length) dispatch({
                    type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                    payload: customFields
                });
                else dispatch({
                    type: (0, $e496cac0faa1ff17$export$958a4de996e717f9),
                    payload: []
                });
                if (platformFields.length) dispatch({
                    type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                    payload: platformFields
                });
                else dispatch({
                    type: (0, $e496cac0faa1ff17$export$ecdfc6694e0b4b09),
                    payload: []
                });
            }
        }
    };
    const createInitialPage = async ()=>{
        if (product) {
            store.openSidePanel("text");
            store.addPage();
            const paperSize = product?.selectedSize?.split("x");
            store.setUnit({
                unit: "in",
                dpi: (0, $7ad22e5ca6c288ca$export$6032165a31897610)
            });
            store.setSize(+paperSize[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610), +paperSize[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610));
            if ((0, $7ad22e5ca6c288ca$export$3e994a540f8ee57).includes(product.productType)) {
                store.addPage();
                store.selectPage(store.pages[0].id);
            }
            //@ts-ignore
            (0, $ad01ab85e9f42d02$export$8029e38c28541a)(store, product, envelopeType);
            (0, $729142c3e2d905ee$export$4e7e1f53e01e76b7)(product.id, store);
            if (currentTemplateType === "Real Penned Letter") handleRealPennedLetters();
            dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
            store.history.clear();
        }
        setIsStoreUpdated(false);
    };
    const handleRealPennedLetters = async ()=>{
        try {
            // Load Lexi Regular Fonts Into Store
            store.addFont({
                fontFamily: "lexi Regular",
                url: (0, (/*@__PURE__*/$parcel$interopDefault($a2deb1c64dec179a$exports)))
            });
            (0, $14dc1102dd22ee0f$export$fac40f04596fc189)(store);
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($a2deb1c64dec179a$exports))));
            const blob = await response.blob();
            const reader = new FileReader();
            // Load Lexi Regular Base64 into JSON
            reader.onloadend = ()=>{
                store.addFont({
                    fontFamily: "lexi Regular",
                    url: reader.result
                });
            };
            reader.readAsDataURL(blob);
        } catch (error) {
            console.error("Error loading the font file:", error);
        }
    };
    const handleLoadDesignerTemplate = async ()=>{
        if (designerTemplateQuery?.title && designerTemplateQuery?.product) {
            const flatProducts = allProducts.flatMap((product)=>product.size.map((sizeItem)=>({
                        id: sizeItem.id || product.id,
                        title: product.title,
                        productType: product.productType,
                        size: [
                            {
                                id: sizeItem.id || product.id,
                                size: sizeItem.size
                            }
                        ],
                        ...product.windowed !== undefined && {
                            windowed: product.windowed
                        }
                    })));
            const selectedProduct = flatProducts.find((product)=>product.id === designerTemplateQuery?.product?.id);
            if (selectedProduct) {
                dispatch({
                    type: (0, $e496cac0faa1ff17$export$f632fb3a4986e34d)
                });
                store.clear();
                store.history.clear();
                dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("title", designerTemplateQuery?.title));
                if (selectedProduct.productType === "Professional Letters") {
                    let selectedEnvelope = selectedProduct.id == 2 ? "#10 Double-Window" : "#10 Grey";
                    dispatch((0, $dbaee5ca78364d67$export$c7c994d6f1f97f07)("envelopeType", selectedEnvelope));
                }
                dispatch((0, $dbaee5ca78364d67$export$f8e6fdbf45160f24)(selectedProduct));
                return;
            }
        }
        onReturnAndNavigate ? onReturnAndNavigate() : navigate(createTemplateRoute || "/");
    };
    const handleLoadTemplate = async ()=>{
        const existingTemplate = olcTemplate;
        if (existingTemplate) {
            dispatch({
                type: (0, $e496cac0faa1ff17$export$1c6648626b31f20d),
                payload: {
                    data: existingTemplate
                }
            });
            const workspaceElement = document.querySelector(".polotno-workspace-container");
            if (workspaceElement) workspaceElement.classList.add("show-loader");
            // @ts-ignore
            const paperDimensions = existingTemplate?.product?.paperSize.split("x");
            store.setUnit({
                unit: "in",
                dpi: 96
            });
            store.setSize(+paperDimensions[1] * (0, $7ad22e5ca6c288ca$export$6032165a31897610), +paperDimensions[0] * (0, $7ad22e5ca6c288ca$export$6032165a31897610));
            let jsonData = await (0, $ad01ab85e9f42d02$export$c706fc9cfb842dce)(existingTemplate?.templateUrl);
            if (existingTemplate?.product?.productType === "Real Penned Letter") {
                let clonedJson = JSON.stringify(jsonData).replace(/{{/g, "((").replace(/}}/g, "))");
                jsonData = JSON.parse(clonedJson);
            }
            store.loadJSON(jsonData);
            await store.waitLoading();
            dispatch((0, $bbef8ecdaaf79b6e$export$7cdbec44919c75ac)());
            setIsStoreUpdated(false);
            (0, $39231ae325c5aacf$export$b8070c2bd9d59c10)(existingTemplate?.product?.id, store);
            dispatch({
                type: (0, $e496cac0faa1ff17$export$a3d810d0d7a98880),
                payload: false
            });
            if (workspaceElement) workspaceElement.classList.add("hide-loader");
        }
    };
    // Incase of Real Penned Letters hide tooltip
    const Tooltip = ()=>null;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Fragment), {
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $5a8c8921b86c6a58$export$2e2bcd8739ae039), {
                className: "hideTemplateBuilder",
                children: (0, $0b51cdcdcd2b1339$export$af7faffe10421f14).TEMPLATE_MESSAGE_ON_SMALL_SCREEN
            }),
            /*#__PURE__*/ (0, $lt6Ts$jsx)("div", {
                className: "polotno-container",
                children: switchTabCount > 0 && /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
                    className: "builder-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d31b9bd88e5dcf67$export$2e2bcd8739ae039), {
                            store: store,
                            isStoreUpdated: isStoreUpdated,
                            olcTemplate: olcTemplate,
                            designerTemplateQuery: designerTemplateQuery,
                            onDuplicateTemplate: onDuplicateTemplate,
                            setIsDuplication: setIsDuplication,
                            onReturnAndNavigate: onReturnAndNavigate,
                            onSubmit: onSubmit
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$PolotnoContainer), {
                            style: containerStyle,
                            children: [
                                /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $d303f0b433a1814c$export$2e2bcd8739ae039), {
                                    store: store,
                                    currentTemplateType: currentTemplateType,
                                    platformName: platformName,
                                    templateGalleryModal: templateGalleryModal,
                                    allowSenderFields: allowSenderFields,
                                    allowPropertyFields: allowPropertyFields,
                                    excludedFields: excludedFields,
                                    designerQueryAmount: designerQueryAmount,
                                    allowedAddOns: allowedAddOns,
                                    allowedTemplateSections: allowedTemplateSections,
                                    onGetTemplates: onGetTemplates,
                                    onGetOneTemplate: onGetOneTemplate,
                                    onGetCustomFields: onGetCustomFields,
                                    selectedSection: selectedSection,
                                    onCreateCustomTemplateQuery: onCreateCustomTemplateQuery
                                }),
                                /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$WorkspaceWrap), {
                                    children: [
                                        currentTemplateType !== "Real Penned Letter" && /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Toolbar), {
                                            store: store,
                                            downloadButtonEnabled: false
                                        }),
                                        currentTemplateType !== "Real Penned Letter" ? /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Workspace), {
                                            store: store,
                                            pageControlsEnabled: false
                                        }) : /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Workspace), {
                                            store: store,
                                            pageControlsEnabled: false,
                                            components: {
                                                Tooltip: Tooltip
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$ZoomButtons), {
                                            store: store
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $49857baad0b39325$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
var $6248df0c26b0b2d9$export$2e2bcd8739ae039 = $6248df0c26b0b2d9$var$TemplateBuilder;




// Initialize Plotno Store
const $edeafd00018ca857$var$initializeStore = (secretKey)=>{
    return (0, $lt6Ts$createStore)({
        key: secretKey,
        // you can hide back-link on a paid license
        // but it will be good if you can keep it for Polotno project support
        showCredit: false
    });
};
const $edeafd00018ca857$var$App = ({ secretKey: secretKey, platformName: platformName, templateGalleryModal: templateGalleryModal, createTemplateRoute: createTemplateRoute, templateBuilderRoute: templateBuilderRoute, olcTemplate: olcTemplate, designerTemplateQuery: designerTemplateQuery, allowSenderFields: allowSenderFields, excludedFields: excludedFields, designerQueryAmount: designerQueryAmount, allowPropertyFields: allowPropertyFields, allowedAddOns: allowedAddOns, allowedTemplateSections: allowedTemplateSections, restrictedProducts: restrictedProducts, styles: styles, onReturnAndNavigate: onReturnAndNavigate, onCreateCustomTemplateQuery: onCreateCustomTemplateQuery, onGetOneTemplate: onGetOneTemplate, onGetCustomFields: onGetCustomFields, onDuplicateTemplate: onDuplicateTemplate, onGetTemplates: onGetTemplates, onSubmit: onSubmit })=>{
    const [store, setStore] = (0, $lt6Ts$useState)($edeafd00018ca857$var$initializeStore(secretKey));
    const currentPath = window?.location?.pathname;
    (0, $lt6Ts$useEffect)(()=>{
        if (currentPath === createTemplateRoute || currentPath === "/create-template" || designerTemplateQuery) {
            const newStore = $edeafd00018ca857$var$initializeStore(secretKey);
            setStore(newStore);
        }
    }, [
        currentPath
    ]);
    const GlobalStyle = styles && Object.keys(styles).length ? (0, $lt6Ts$createGlobalStyle)`
        :root {
        ${styles ? Object.entries(styles.root).map(([key, value])=>`${key}: ${value};`).join(" ") : ""}
          }
        ` : (0, $lt6Ts$createGlobalStyle)`<></>`;
    return /*#__PURE__*/ (0, $lt6Ts$jsxs)("div", {
        className: "builder-wrapper",
        children: [
            /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $49857baad0b39325$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $lt6Ts$jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0, $lt6Ts$jsxs)((0, $lt6Ts$Routes), {
                children: [
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Route), {
                        path: createTemplateRoute || "/create-template",
                        element: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $dd071d7635be500b$export$2e2bcd8739ae039), {
                            createTemplateRoute: createTemplateRoute,
                            templateBuilderRoute: templateBuilderRoute,
                            restrictedProducts: restrictedProducts,
                            onReturnAndNavigate: onReturnAndNavigate
                        })
                    }),
                    /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Route), {
                        path: templateBuilderRoute || "/template-builder/:id?",
                        element: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $6248df0c26b0b2d9$export$2e2bcd8739ae039), {
                            store: store,
                            olcTemplate: olcTemplate,
                            designerTemplateQuery: designerTemplateQuery,
                            platformName: platformName,
                            templateGalleryModal: templateGalleryModal,
                            allowSenderFields: allowSenderFields,
                            excludedFields: excludedFields,
                            designerQueryAmount: designerQueryAmount,
                            allowPropertyFields: allowPropertyFields,
                            createTemplateRoute: createTemplateRoute,
                            allowedAddOns: allowedAddOns,
                            allowedTemplateSections: allowedTemplateSections,
                            onReturnAndNavigate: onReturnAndNavigate,
                            onCreateCustomTemplateQuery: onCreateCustomTemplateQuery,
                            onGetOneTemplate: onGetOneTemplate,
                            onGetTemplates: onGetTemplates,
                            onGetCustomFields: onGetCustomFields,
                            onDuplicateTemplate: onDuplicateTemplate,
                            onSubmit: onSubmit
                        })
                    })
                ]
            })
        ]
    });
};
var $edeafd00018ca857$export$2e2bcd8739ae039 = $edeafd00018ca857$var$App;








const $23c375345222aadb$export$31499a9cd224b78c = "1.9.0";


const $24075a5d702d64b3$var$TemplateBuilder = ({ container: container, secretKey: secretKey, publicApiKey: publicApiKey, platformName: platformName, templateGalleryModal: templateGalleryModal = true, createTemplateRoute: createTemplateRoute, templateBuilderRoute: templateBuilderRoute, olcTemplate: olcTemplate, designerTemplateQuery: designerTemplateQuery, sandbox: sandbox, allowSenderFields: allowSenderFields, allowPropertyFields: allowPropertyFields, excludedFields: excludedFields, designerQueryAmount: designerQueryAmount, allowedAddOns: allowedAddOns, allowedTemplateSections: allowedTemplateSections, env: env, restrictedProducts: restrictedProducts, onReturnAndNavigate: onReturnAndNavigate, onCreateCustomTemplateQuery: onCreateCustomTemplateQuery, onGetOneTemplate: onGetOneTemplate, onGetTemplates: onGetTemplates, onGetCustomFields: onGetCustomFields, onDuplicateTemplate: onDuplicateTemplate, onSubmit: onSubmit, styles: styles })=>{
    if (!container) throw new Error("Root element not found");
    if (!secretKey) throw new Error("secretKey not found");
    if (!publicApiKey) throw new Error("publicApiKey not found");
    if (sandbox) (0, $717432aee8737b76$export$ba225133fb4a45c3)(sandbox);
    if (env && (0, $23c375345222aadb$export$31499a9cd224b78c).includes("beta")) (0, $717432aee8737b76$export$84bc02d3c7a6b55f)(env);
    (0, $717432aee8737b76$export$527e3e4d00b88329)(publicApiKey);
    const root = (0, $lt6Ts$reactdomclient).createRoot(container);
    root.render(/*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Fragment), {
        children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$Provider), {
            store: (0, $ad568a7ac4136873$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $lt6Ts$BrowserRouter), {
                children: /*#__PURE__*/ (0, $lt6Ts$jsx)((0, $edeafd00018ca857$export$2e2bcd8739ae039), {
                    secretKey: secretKey,
                    styles: styles,
                    olcTemplate: olcTemplate,
                    designerTemplateQuery: designerTemplateQuery,
                    platformName: platformName,
                    templateGalleryModal: templateGalleryModal,
                    createTemplateRoute: createTemplateRoute,
                    templateBuilderRoute: templateBuilderRoute,
                    allowSenderFields: allowSenderFields,
                    allowPropertyFields: allowPropertyFields,
                    excludedFields: excludedFields,
                    designerQueryAmount: designerQueryAmount,
                    allowedAddOns: allowedAddOns,
                    allowedTemplateSections: allowedTemplateSections,
                    restrictedProducts: restrictedProducts,
                    onReturnAndNavigate: onReturnAndNavigate,
                    onCreateCustomTemplateQuery: onCreateCustomTemplateQuery,
                    onGetOneTemplate: onGetOneTemplate,
                    onGetTemplates: onGetTemplates,
                    onGetCustomFields: onGetCustomFields,
                    onDuplicateTemplate: onDuplicateTemplate,
                    onSubmit: onSubmit
                })
            })
        })
    }));
    //@ts-ignore
    return {
        destroy () {
            console.log("React template builder destroyed");
            root.unmount();
        }
    };
};
var $24075a5d702d64b3$export$2e2bcd8739ae039 = $24075a5d702d64b3$var$TemplateBuilder;


export {$24075a5d702d64b3$export$2e2bcd8739ae039 as default};
